import { Loader, Header, FormComposer, Toast, Card, CardText, StatusTable, Row, SubmitBar, Banner, RadioButtons, Dropdown, InfoBannerIcon, Localities, ResponseComposer, Modal, KeyNote, OTPInput, CardLabelError, FormStep, UploadFile, CardSubHeader, PDFSvg, LabelFieldPair, CardLabel, MultiUploadWrapper, CardHeader, CardSectionHeader, CheckBox, TextInput, LinkButton, Close as Close$7, BreakLine, Table, TelePhone, DisplayPhotos, CheckPoint, ConnectingCheckPoints, ActionBar, Menu, ButtonSelector, AppContainer, BackButton, PrivateRoute, BreadCrumb, DeleteIcon, MobileNumber, RadioOrSelect, TextArea, SearchForm, SearchField, DetailsCard, TickMark, PropertyHouse, EmployeeModuleCard, CitizenHomeCard, PTIcon } from '@egovernments/digit-ui-react-components';
import React, { useState, useEffect, useLayoutEffect, useMemo, useRef, Fragment as Fragment$1, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory, useRouteMatch, Switch, Route, Link, useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { useForm, Controller } from 'react-hook-form';

const newConfig = [{
  "head": "PT_ASSEMBLY_DET",
  "body": [{
    "type": "component",
    "route": "property-type",
    "isMandatory": true,
    "component": "CPTPropertyAssemblyDetails",
    "texts": {
      "headerCaption": "",
      "header": "PT_ASSEMBLY_DET",
      "cardText": "",
      "submitBarLabel": "PT_COMMONS_NEXT"
    },
    "nextStep": {
      "COMMON_PROPTYPE_BUILTUP_INDEPENDENTPROPERTY": "landarea",
      "COMMON_PROPTYPE_BUILTUP_SHAREDPROPERTY": "PtUnits",
      "COMMON_PROPTYPE_VACANT": "area"
    },
    "key": "assemblyDet",
    "withoutLabel": true
  }]
}, {
  "head": "PT_LOCATION_DETAILS",
  "body": [{
    "type": "component",
    "route": "property-type",
    "isMandatory": true,
    "component": "CPTPropertyLocationDetails",
    "texts": {
      "headerCaption": "",
      "header": "PT_LOCATION_DETAILS",
      "cardText": "",
      "submitBarLabel": "PT_COMMONS_NEXT"
    },
    "nextStep": {
      "COMMON_PROPTYPE_BUILTUP_INDEPENDENTPROPERTY": "landarea",
      "COMMON_PROPTYPE_BUILTUP_SHAREDPROPERTY": "PtUnits",
      "COMMON_PROPTYPE_VACANT": "area"
    },
    "key": "locationDet",
    "withoutLabel": true
  }]
}, {
  "head": "PT_OWNERSHIP_DETAILS",
  "body": [{
    "type": "component",
    "route": "institutional-owner-address",
    "isMandatory": true,
    "component": "CPTPropertyOwnerDetails",
    "texts": {
      "headerCaption": "PT_OWNERS_DETAILS",
      "header": "PT_OWNERS_ADDRESS",
      "cardText": "",
      "submitBarLabel": "PT_COMMON_NEXT"
    },
    "key": "owners",
    "withoutLabel": true,
    "nextStep": "institutional-proof-of-identity",
    "hideInEmployee": true
  }]
}];

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lodash = createCommonjsModule(function (module, exports) {
  (function () {
    var undefined$1;
    var VERSION = '4.17.21';
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = '__lodash_placeholder__';
    var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';
    var HOT_COUNT = 800,
      HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
    var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';
    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
    var reApos = RegExp(rsApos, 'g');
    var reComboMark = RegExp(rsCombo, 'g');
    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');
    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      '\xc0': 'A',
      '\xc1': 'A',
      '\xc2': 'A',
      '\xc3': 'A',
      '\xc4': 'A',
      '\xc5': 'A',
      '\xe0': 'a',
      '\xe1': 'a',
      '\xe2': 'a',
      '\xe3': 'a',
      '\xe4': 'a',
      '\xe5': 'a',
      '\xc7': 'C',
      '\xe7': 'c',
      '\xd0': 'D',
      '\xf0': 'd',
      '\xc8': 'E',
      '\xc9': 'E',
      '\xca': 'E',
      '\xcb': 'E',
      '\xe8': 'e',
      '\xe9': 'e',
      '\xea': 'e',
      '\xeb': 'e',
      '\xcc': 'I',
      '\xcd': 'I',
      '\xce': 'I',
      '\xcf': 'I',
      '\xec': 'i',
      '\xed': 'i',
      '\xee': 'i',
      '\xef': 'i',
      '\xd1': 'N',
      '\xf1': 'n',
      '\xd2': 'O',
      '\xd3': 'O',
      '\xd4': 'O',
      '\xd5': 'O',
      '\xd6': 'O',
      '\xd8': 'O',
      '\xf2': 'o',
      '\xf3': 'o',
      '\xf4': 'o',
      '\xf5': 'o',
      '\xf6': 'o',
      '\xf8': 'o',
      '\xd9': 'U',
      '\xda': 'U',
      '\xdb': 'U',
      '\xdc': 'U',
      '\xf9': 'u',
      '\xfa': 'u',
      '\xfb': 'u',
      '\xfc': 'u',
      '\xdd': 'Y',
      '\xfd': 'y',
      '\xff': 'y',
      '\xc6': 'Ae',
      '\xe6': 'ae',
      '\xde': 'Th',
      '\xfe': 'th',
      '\xdf': 'ss',
      '\u0100': 'A',
      '\u0102': 'A',
      '\u0104': 'A',
      '\u0101': 'a',
      '\u0103': 'a',
      '\u0105': 'a',
      '\u0106': 'C',
      '\u0108': 'C',
      '\u010a': 'C',
      '\u010c': 'C',
      '\u0107': 'c',
      '\u0109': 'c',
      '\u010b': 'c',
      '\u010d': 'c',
      '\u010e': 'D',
      '\u0110': 'D',
      '\u010f': 'd',
      '\u0111': 'd',
      '\u0112': 'E',
      '\u0114': 'E',
      '\u0116': 'E',
      '\u0118': 'E',
      '\u011a': 'E',
      '\u0113': 'e',
      '\u0115': 'e',
      '\u0117': 'e',
      '\u0119': 'e',
      '\u011b': 'e',
      '\u011c': 'G',
      '\u011e': 'G',
      '\u0120': 'G',
      '\u0122': 'G',
      '\u011d': 'g',
      '\u011f': 'g',
      '\u0121': 'g',
      '\u0123': 'g',
      '\u0124': 'H',
      '\u0126': 'H',
      '\u0125': 'h',
      '\u0127': 'h',
      '\u0128': 'I',
      '\u012a': 'I',
      '\u012c': 'I',
      '\u012e': 'I',
      '\u0130': 'I',
      '\u0129': 'i',
      '\u012b': 'i',
      '\u012d': 'i',
      '\u012f': 'i',
      '\u0131': 'i',
      '\u0134': 'J',
      '\u0135': 'j',
      '\u0136': 'K',
      '\u0137': 'k',
      '\u0138': 'k',
      '\u0139': 'L',
      '\u013b': 'L',
      '\u013d': 'L',
      '\u013f': 'L',
      '\u0141': 'L',
      '\u013a': 'l',
      '\u013c': 'l',
      '\u013e': 'l',
      '\u0140': 'l',
      '\u0142': 'l',
      '\u0143': 'N',
      '\u0145': 'N',
      '\u0147': 'N',
      '\u014a': 'N',
      '\u0144': 'n',
      '\u0146': 'n',
      '\u0148': 'n',
      '\u014b': 'n',
      '\u014c': 'O',
      '\u014e': 'O',
      '\u0150': 'O',
      '\u014d': 'o',
      '\u014f': 'o',
      '\u0151': 'o',
      '\u0154': 'R',
      '\u0156': 'R',
      '\u0158': 'R',
      '\u0155': 'r',
      '\u0157': 'r',
      '\u0159': 'r',
      '\u015a': 'S',
      '\u015c': 'S',
      '\u015e': 'S',
      '\u0160': 'S',
      '\u015b': 's',
      '\u015d': 's',
      '\u015f': 's',
      '\u0161': 's',
      '\u0162': 'T',
      '\u0164': 'T',
      '\u0166': 'T',
      '\u0163': 't',
      '\u0165': 't',
      '\u0167': 't',
      '\u0168': 'U',
      '\u016a': 'U',
      '\u016c': 'U',
      '\u016e': 'U',
      '\u0170': 'U',
      '\u0172': 'U',
      '\u0169': 'u',
      '\u016b': 'u',
      '\u016d': 'u',
      '\u016f': 'u',
      '\u0171': 'u',
      '\u0173': 'u',
      '\u0174': 'W',
      '\u0175': 'w',
      '\u0176': 'Y',
      '\u0177': 'y',
      '\u0178': 'Y',
      '\u0179': 'Z',
      '\u017b': 'Z',
      '\u017d': 'Z',
      '\u017a': 'z',
      '\u017c': 'z',
      '\u017e': 'z',
      '\u0132': 'IJ',
      '\u0133': 'ij',
      '\u0152': 'Oe',
      '\u0153': 'oe',
      '\u0149': "'n",
      '\u017f': 's'
    };
    var htmlEscapes = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    var htmlUnescapes = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'"
    };
    var stringEscapes = {
      '\\': '\\',
      "'": "'",
      '\n': 'n',
      '\r': 'r',
      '\u2028': 'u2028',
      '\u2029': 'u2029'
    };
    var freeParseFloat = parseFloat,
      freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function('return this')();
    var freeExports =  exports && !exports.nodeType && exports;
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function () {
      try {
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
        length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty('length');
    function asciiToArray(string) {
      return string.split('');
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function (value, key, collection) {
        if (predicate(value, key, collection)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index = fromIndex - 1,
        length = array.length;
      while (++index < length) {
        if (comparator(array[index], value)) {
          return index;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function (object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function (key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function (value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result,
        index = -1,
        length = array.length;
      while (++index < length) {
        var current = iteratee(array[index]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function (key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function (key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1,
        length = strSymbols.length;
      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;
      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }
    function countHolders(array, placeholder) {
      var length = array.length,
        result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return '\\' + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data,
        result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1,
        length = array.length;
      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return index;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {}
      return index;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
      var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;
      var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;
      var coreJsData = context['__core-js_shared__'];
      var funcToString = funcProto.toString;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function () {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object);
      var oldDash = root._;
      var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
      var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;
      var defineProperty = function () {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');
      var metaMap = WeakMap && new WeakMap();
      var realNames = {};
      var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);
      var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash(value) {
        if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, '__wrapped__')) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function () {
        function object() {}
        return function (proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object();
          object.prototype = undefined$1;
          return result;
        };
      }();
      function baseLodash() {}
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash.templateSettings = {
        'escape': reEscape,
        'evaluate': reEvaluate,
        'interpolate': reInterpolate,
        'variable': '',
        'imports': {
          '_': lodash
        }
      };
      lodash.prototype = baseLodash.prototype;
      lodash.prototype.constructor = lodash;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result = new LazyWrapper(this.__wrapped__);
        result.__actions__ = copyArray(this.__actions__);
        result.__dir__ = this.__dir__;
        result.__filtered__ = this.__filtered__;
        result.__iteratees__ = copyArray(this.__iteratees__);
        result.__takeCount__ = this.__takeCount__;
        result.__views__ = copyArray(this.__views__);
        return result;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result = new LazyWrapper(this);
          result.__dir__ = -1;
          result.__filtered__ = true;
        } else {
          result = this.clone();
          result.__dir__ *= -1;
        }
        return result;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : start - 1,
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result = [];
        outer: while (length-- && resIndex < takeCount) {
          index += dir;
          var iterIndex = -1,
            value = array[index];
          while (++iterIndex < iterLength) {
            var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);
            if (type == LAZY_MAP_FLAG) {
              value = computed;
            } else if (!computed) {
              if (type == LAZY_FILTER_FLAG) {
                continue outer;
              } else {
                break outer;
              }
            }
          }
          result[resIndex++] = value;
        }
        return result;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined$1 : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        return index < 0 ? undefined$1 : data[index][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          'hash': new Hash(),
          'map': new (Map || ListCache)(),
          'string': new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
          size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values) {
        var index = -1,
          length = values == null ? 0 : values.length;
        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values[index]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__,
          result = data['delete'](key);
        this.size = data.size;
        return result;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || isIndex(key, length)))) {
            result.push(key);
          }
        }
        return result;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function (value, key, collection) {
          setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;
        while (++index < length) {
          result[index] = skip ? undefined$1 : get(object, paths[index]);
        }
        return result;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== undefined$1) {
          return result;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);
        if (isSet(value)) {
          value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function (subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }
          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }
      function baseConforms(source) {
        var props = keys(source);
        return function (object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (length--) {
          var key = props[length],
            predicate = source[key],
            value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return setTimeout(function () {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;
        if (!length) {
          return result;
        }
        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }
        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee == null ? value : iteratee(value);
          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }
            result.push(value);
          } else if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }
        return result;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result = true;
        baseEach(collection, function (value, index, collection) {
          result = !!predicate(value, index, collection);
          return result;
        });
        return result;
      }
      function baseExtremum(array, iteratee, comparator) {
        var index = -1,
          length = array.length;
        while (++index < length) {
          var value = array[index],
            current = iteratee(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
            var computed = current,
              result = value;
          }
        }
        return result;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result = [];
        baseEach(collection, function (value, index, collection) {
          if (predicate(value, index, collection)) {
            result.push(value);
          }
        });
        return result;
      }
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
          length = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);
        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }
      function baseForOwnRight(object, iteratee) {
        return object && baseForRight(object, iteratee, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function (key) {
          return isFunction(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0,
          length = path.length;
        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return index && index == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee) {
            array = arrayMap(array, baseUnary(iteratee));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index = -1,
          seen = caches[0];
        outer: while (++index < length && result.length < maxLength) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while (--othIndex) {
              var cache = caches[othIndex];
              if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                continue outer;
              }
            }
            if (seen) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }
      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function (value, key, object) {
          setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length,
          length = index,
          noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (index--) {
          var data = matchData[index];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index < length) {
          data = matchData[index];
          var key = data[0],
            objValue = object[key],
            srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == 'function') {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == 'object') {
          return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }
        return result;
      }
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object),
          result = [];
        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee) {
        var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value, key, collection) {
          result[++index] = iteratee(value, key, collection);
        });
        return result;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function (object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function (object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function (srcValue, key) {
          stack || (stack = new Stack());
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function (iteratee) {
            if (isArray(iteratee)) {
              return function (value) {
                return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
              };
            }
            return iteratee;
          });
        } else {
          iteratees = [identity];
        }
        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result = baseMap(collection, function (value, key, collection) {
          var criteria = arrayMap(iteratees, function (iteratee) {
            return iteratee(value);
          });
          return {
            'criteria': criteria,
            'index': ++index,
            'value': value
          };
        });
        return baseSortBy(result, function (object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function (value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index = -1,
          length = paths.length,
          result = {};
        while (++index < length) {
          var path = paths[index],
            value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }
        return result;
      }
      function basePropertyDeep(path) {
        return function (object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values, iteratee, comparator) {
        var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;
        if (array === values) {
          values = copyArray(values);
        }
        if (iteratee) {
          seen = arrayMap(array, baseUnary(iteratee));
        }
        while (++index < length) {
          var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;
          while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0,
          lastIndex = length - 1;
        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);
        while (length--) {
          result[fromRight ? length : ++index] = start;
          start += step;
        }
        return result;
      }
      function baseRepeat(string, n) {
        var result = '';
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result;
        }
        do {
          if (n % 2) {
            result += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;
        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
            newValue = value;
          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return object;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function (func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function (func, string) {
        return defineProperty(func, 'toString', {
          'configurable': true,
          'enumerable': false,
          'value': constant(string),
          'writable': true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index = -1,
          length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result = Array(length);
        while (++index < length) {
          result[index] = array[index + start];
        }
        return result;
      }
      function baseSome(collection, predicate) {
        var result;
        baseEach(collection, function (value, index, collection) {
          result = predicate(value, index, collection);
          return !result;
        });
        return !!result;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0,
          high = array == null ? low : array.length;
        if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1,
              computed = array[mid];
            if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee, retHighest) {
        var low = 0,
          high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee(value);
        var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee) {
        var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result;
      }
      function baseToNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == 'string') {
          return value;
        }
        if (isArray(value)) {
          return arrayMap(value, baseToString) + '';
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }
      function baseUniq(array, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;
        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set = iteratee ? null : createSet(array);
          if (set) {
            return setToArray(set);
          }
          isCommon = false;
          includes = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee ? [] : result;
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }
            if (iteratee) {
              seen.push(computed);
            }
            result.push(value);
          } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length,
          index = fromRight ? length : -1;
        while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
        return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
      }
      function baseWrapperValue(value, actions) {
        var result = value;
        if (result instanceof LazyWrapper) {
          result = result.value();
        }
        return arrayReduce(actions, function (result, action) {
          return action.func.apply(action.thisArg, arrayPush([result], action.args));
        }, result);
      }
      function baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1,
          result = Array(length);
        while (++index < length) {
          var array = arrays[index],
            othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index) {
              result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result, 1), iteratee, comparator);
      }
      function baseZipObject(props, values, assignFunc) {
        var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};
        while (++index < length) {
          var value = index < valsLength ? values[index] : undefined$1;
          assignFunc(result, props[index], value);
        }
        return result;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == 'function' ? value : identity;
      }
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout = ctxClearTimeout || function (id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;
        while (++index < length) {
          var result = compareAscending(objCriteria[index], othCriteria[index]);
          if (result) {
            if (index >= ordersLength) {
              return result;
            }
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result[leftIndex++] = args[argsIndex++];
        }
        return result;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result;
      }
      function copyArray(source, array) {
        var index = -1,
          length = source.length;
        array || (array = Array(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1,
          length = props.length;
        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function (collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function (collection, iteratee) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }
          var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);
          while (fromRight ? index-- : ++index < length) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function (object, iteratee, keysFunc) {
          var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function (string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function (string) {
          return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
        };
      }
      function createCtor(Ctor) {
        return function () {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);
          return isObject(result) ? result : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);
          while (index--) {
            args[index] = arguments[index];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length);
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function (collection, predicate, fromIndex) {
          var iterable = Object(collection);
          if (!isArrayLike(collection)) {
            var iteratee = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function (key) {
              return iteratee(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function (funcs) {
          var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length;
          while (++index < length) {
            func = funcs[index];
            var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function () {
            var args = arguments,
              value = args[0];
            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }
            var index = 0,
              result = length ? funcs[index].apply(this, args) : value;
            while (++index < length) {
              result = funcs[index].call(this, result);
            }
            return result;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length;
          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
          }
          var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary < length) {
            args.length = ary;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function (object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function (value, other) {
          var result;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result = value;
          }
          if (other !== undefined$1) {
            if (result === undefined$1) {
              return other;
            }
            if (typeof value == 'string' || typeof other == 'string') {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result = operator(value, other);
          }
          return result;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function (iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function (args) {
            var thisArg = this;
            return arrayFunc(iteratees, function (iteratee) {
              return apply(iteratee, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? ' ' : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function (start, end, step) {
          if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function (value, other) {
          if (!(typeof value == 'string' && typeof other == 'string')) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
        var result = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result, newData);
        }
        result.placeholder = placeholder;
        return setWrapToString(result, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math[methodName];
        return function (number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = (toString(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
        return new Set(values);
      };
      function createToPairs(keysFunc) {
        return function (object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials,
            holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result = createPartial(func, bitmask, thisArg, partials);
        } else {
          result = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack['delete'](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1,
          result = true,
          seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index < arrLength) {
          var arrValue = array[index],
            othValue = other[index];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function (othValue, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
          }
        }
        stack['delete'](array);
        stack['delete'](other);
        return result;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + '';
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key],
            othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
          }
          skipCtor || (skipCtor = key == 'constructor');
        }
        if (result && !skipCtor) {
          var objCtor = object.constructor,
            othCtor = other.constructor;
          if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
          }
        }
        stack['delete'](object);
        stack['delete'](other);
        return result;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + '');
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop : function (func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result = func.name + '',
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
        while (length--) {
          var data = array[length],
            otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result;
      }
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result = lodash.iteratee || iteratee;
        result = result === iteratee ? baseIteratee : result;
        return arguments.length ? result(arguments[0], arguments[1]) : result;
      }
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
      }
      function getMatchData(object) {
        var result = keys(object),
          length = result.length;
        while (length--) {
          var key = result[length],
            value = object[key];
          result[length] = [key, value, isStrictComparable(value)];
        }
        return result;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
        if (object == null) {
          return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function (symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
        var result = [];
        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }
        return result;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function (value) {
          var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result;
        };
      }
      function getView(start, end, transforms) {
        var index = -1,
          length = transforms.length;
        while (++index < length) {
          var data = transforms[index],
            size = data.size;
          switch (data.type) {
            case 'drop':
              start += size;
              break;
            case 'dropRight':
              end -= size;
              break;
            case 'take':
              end = nativeMin(end, start + size);
              break;
            case 'takeRight':
              start = nativeMax(start, end - size);
              break;
          }
        }
        return {
          'start': start,
          'end': end
        };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          result = false;
        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index != length) {
          return result;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length,
          result = new array.constructor(length);
        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }
      function initCloneObject(object) {
        return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
      }
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
      }
      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index;
        if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
          return eq(object[index], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func),
          other = lodash[funcName];
        if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor,
          proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function (object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object(object));
        };
      }
      function memoizeCapped(func) {
        var result = memoize(func, function (key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result.cache;
        return result;
      }
      function mergeData(data, source) {
        var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);
          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);
        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === 'constructor' && typeof object[key] === 'function') {
          return;
        }
        if (key == '__proto__') {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout = ctxSetTimeout || function (func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0,
          lastCalled = 0;
        return function () {
          var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size) {
        var index = -1,
          length = array.length,
          lastIndex = length - 1;
        size = size === undefined$1 ? length : size;
        while (++index < size) {
          var rand = baseRandom(index, lastIndex),
            value = array[rand];
          array[rand] = array[index];
          array[index] = value;
        }
        array.length = size;
        return array;
      }
      var stringToPath = memoizeCapped(function (string) {
        var result = [];
        if (string.charCodeAt(0) === 46) {
          result.push('');
        }
        string.replace(rePropName, function (match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
      });
      function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) {
          return value;
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}
          try {
            return func + '';
          } catch (e) {}
        }
        return '';
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function (pair) {
          var value = '_.' + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = copyArray(wrapper.__actions__);
        result.__index__ = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
      }
      function chunk(array, size, guard) {
        if (guard ? isIterateeCall(array, size, guard) : size === undefined$1) {
          size = 1;
        } else {
          size = nativeMax(toInteger(size), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) {
          return [];
        }
        var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));
        while (index < length) {
          result[resIndex++] = baseSlice(array, index, index += size);
        }
        return result;
      }
      function compact(array) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array(length - 1),
          array = arguments[0],
          index = length;
        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function (array, values) {
        var iteratee = last(values);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
      });
      var differenceWith = baseRest(function (array, values) {
        var comparator = last(values);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};
        while (++index < length) {
          var pair = pairs[index];
          result[pair[0]] = pair[1];
        }
        return result;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array, value, index);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function (arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function (arrays) {
        var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee === last(mapped)) {
          iteratee = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
      });
      var intersectionWith = baseRest(function (arrays) {
        var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? '' : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values) {
        return array && array.length && values && values.length ? basePullAll(array, values) : array;
      }
      function pullAllBy(array, values, iteratee) {
        return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
      }
      function pullAllWith(array, values, comparator) {
        return array && array.length && values && values.length ? basePullAll(array, values, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function (array, indexes) {
        var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function (index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));
        return result;
      });
      function remove(array, predicate) {
        var result = [];
        if (!(array && array.length)) {
          return result;
        }
        var index = -1,
          indexes = [],
          length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
          }
        }
        basePullAt(array, indexes);
        return result;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value);
          if (index < length && eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function (arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function (arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
      });
      var unionWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function (group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function (index) {
          return arrayMap(array, baseProperty(index));
        });
      }
      function unzipWith(array, iteratee) {
        if (!(array && array.length)) {
          return [];
        }
        var result = unzip(array);
        if (iteratee == null) {
          return result;
        }
        return arrayMap(result, function (group) {
          return apply(iteratee, undefined$1, group);
        });
      }
      var without = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, values) : [];
      });
      var xor = baseRest(function (arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function (arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
      });
      var xorWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values) {
        return baseZipObject(props || [], values || [], assignValue);
      }
      function zipObjectDeep(props, values) {
        return baseZipObject(props || [], values || [], baseSet);
      }
      var zipWith = baseRest(function (arrays) {
        var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
        return unzipWith(arrays, iteratee);
      });
      function chain(value) {
        var result = lodash(value);
        result.__chain__ = true;
        return result;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function (paths) {
        var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function (object) {
            return baseAt(object, paths);
          };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          'func': thru,
          'args': [interceptor],
          'thisArg': undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function (array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];
        return {
          'done': done,
          'value': value
        };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result,
          parent = this;
        while (parent instanceof baseLodash) {
          var clone = wrapperClone(parent);
          clone.__index__ = 0;
          clone.__values__ = undefined$1;
          if (result) {
            previous.__wrapped__ = clone;
          } else {
            result = clone;
          }
          var previous = clone;
          parent = parent.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            'func': thru,
            'args': [reverse],
            'thisArg': undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          ++result[key];
        } else {
          baseAssignValue(result, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), 1);
      }
      function flatMapDeep(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), INFINITY);
      }
      function flatMapDepth(collection, iteratee, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee), depth);
      }
      function forEach(collection, iteratee) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee, 3));
      }
      function forEachRight(collection, iteratee) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee, 3));
      }
      var groupBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          result[key].push(value);
        } else {
          baseAssignValue(result, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function (collection, path, args) {
        var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value) {
          result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result;
      });
      var keyBy = createAggregator(function (result, value, key) {
        baseAssignValue(result, key, value);
      });
      function map(collection, iteratee) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function (result, value, key) {
        result[key ? 0 : 1].push(value);
      }, function () {
        return [[], []];
      });
      function reduce(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function (collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function () {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function () {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function () {
          if (--n > 0) {
            result = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result;
        };
      }
      var bind = baseRest(function (func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function (object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curry.placeholder;
        return result;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curryRight.placeholder;
        return result;
      }
      function debounce(func, wait, options) {
        var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs,
            thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout(timerExpired, wait);
          return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result : trailingEdge(now());
        }
        function debounced() {
          var time = now(),
            isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function (func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function (func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function () {
          var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function () {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function (func, transforms) {
        transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function (args) {
          var index = -1,
            length = nativeMin(args.length, funcsLength);
          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function (func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function (args) {
          var array = args[start],
            otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = 'leading' in options ? !!options.leading : leading;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          'leading': leading,
          'maxWait': wait,
          'trailing': trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray(value) ? value : [value];
      }
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function (value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (value) {
        return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
      };
      var isArray = Array.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer = nativeIsBuffer || stubFalse;
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        var result = customizer ? customizer(value, other) : undefined$1;
        return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
      }
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
      }
      function isFinite(value) {
        return typeof value == 'number' && nativeIsFinite(value);
      }
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == 'number' && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }
      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN(value) {
        return isNumber(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber(value) {
        return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString(value) {
        return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function (value, other) {
        return value <= other;
      });
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value),
          func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result = toFinite(value),
          remainder = result % 1;
        return result === result ? remainder ? result - remainder : result : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString(value) {
        return value == null ? '' : baseToString(value);
      }
      var assign = createAssigner(function (object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function (object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result = baseCreate(prototype);
        return properties == null ? result : baseAssign(result, properties);
      }
      var defaults = baseRest(function (object, sources) {
        object = Object(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function (args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee) {
        return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
      }
      function forInRight(object, iteratee) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
      }
      function forOwn(object, iteratee) {
        return object && baseForOwn(object, getIteratee(iteratee, 3));
      }
      function forOwnRight(object, iteratee) {
        return object && baseForOwnRight(object, getIteratee(iteratee, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result = object == null ? undefined$1 : baseGet(object, path);
        return result === undefined$1 ? defaultValue : result;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }
        result[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty.call(result, value)) {
          result[value].push(key);
        } else {
          result[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, iteratee(value, key, object), value);
        });
        return result;
      }
      function mapValues(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, key, iteratee(value, key, object));
        });
        return result;
      }
      var merge = createAssigner(function (object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function (object, paths) {
        var result = {};
        if (object == null) {
          return result;
        }
        var isDeep = false;
        paths = arrayMap(paths, function (path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);
        if (isDeep) {
          result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result, paths[length]);
        }
        return result;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function (object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function (prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function (value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index = -1,
          length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index])];
          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee, accumulator) {
        var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee = getIteratee(iteratee, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
          return iteratee(accumulator, value, index, object);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == 'boolean') {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == 'boolean') {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function (result, word, index) {
        word = word.toLowerCase();
        return result + (index ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
      }
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
      }
      var kebabCase = createCompounder(function (result, word, index) {
        return result + (index ? '-' : '') + word.toLowerCase();
      });
      var lowerCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst('toLowerCase');
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
      }
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString(string), n);
      }
      function replace() {
        var args = arguments,
          string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function (result, word, index) {
        return result + (index ? '_' : '') + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);
        var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";
        var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
        var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
        string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index = offset + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty.call(options, 'variable') && options.variable;
        if (!variable) {
          source = 'with (obj) {\n' + source + '\n}\n';
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
        source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
        var result = attempt(function () {
          return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined$1, importsValues);
        });
        result.source = source;
        if (isError(result)) {
          throw result;
        }
        return result;
      }
      function toLower(value) {
        return toString(value).toLowerCase();
      }
      function toUpper(value) {
        return toString(value).toUpperCase();
      }
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join('');
      }
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join('');
      }
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, '');
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join('');
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? toInteger(options.length) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
        if (separator === undefined$1) {
          return result + omission;
        }
        if (strSymbols) {
          end += result.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match,
              substring = result;
            if (!separator.global) {
              separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index = result.lastIndexOf(separator);
          if (index > -1) {
            result = result.slice(0, index);
          }
        }
        return result + omission;
      }
      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toUpperCase();
      });
      var upperFirst = createCaseFirst('toUpperCase');
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function (func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error(e);
        }
      });
      var bindAll = flatRest(function (object, methodNames) {
        arrayEach(methodNames, function (key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function (pair) {
          if (typeof pair[1] != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function (args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function () {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function (path, args) {
        return function (object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function (object, args) {
        return function (path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys(source),
          methodNames = baseFunctions(source, props);
        if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);
        arrayEach(methodNames, function (methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function () {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);
                actions.push({
                  'func': func,
                  'args': arguments,
                  'thisArg': object
                });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop() {}
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function (args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function (path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return '';
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee = getIteratee(iteratee);
        n -= MAX_ARRAY_LENGTH;
        var result = baseTimes(length, iteratee);
        while (++index < n) {
          iteratee(index);
        }
        return result;
      }
      function toPath(value) {
        if (isArray(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }
      var add = createMathOperation(function (augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound('ceil');
      var divide = createMathOperation(function (dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound('floor');
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee) {
        return baseMean(array, getIteratee(iteratee, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function (multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound('round');
      var subtract = createMathOperation(function (minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee) {
        return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
      }
      lodash.after = after;
      lodash.ary = ary;
      lodash.assign = assign;
      lodash.assignIn = assignIn;
      lodash.assignInWith = assignInWith;
      lodash.assignWith = assignWith;
      lodash.at = at;
      lodash.before = before;
      lodash.bind = bind;
      lodash.bindAll = bindAll;
      lodash.bindKey = bindKey;
      lodash.castArray = castArray;
      lodash.chain = chain;
      lodash.chunk = chunk;
      lodash.compact = compact;
      lodash.concat = concat;
      lodash.cond = cond;
      lodash.conforms = conforms;
      lodash.constant = constant;
      lodash.countBy = countBy;
      lodash.create = create;
      lodash.curry = curry;
      lodash.curryRight = curryRight;
      lodash.debounce = debounce;
      lodash.defaults = defaults;
      lodash.defaultsDeep = defaultsDeep;
      lodash.defer = defer;
      lodash.delay = delay;
      lodash.difference = difference;
      lodash.differenceBy = differenceBy;
      lodash.differenceWith = differenceWith;
      lodash.drop = drop;
      lodash.dropRight = dropRight;
      lodash.dropRightWhile = dropRightWhile;
      lodash.dropWhile = dropWhile;
      lodash.fill = fill;
      lodash.filter = filter;
      lodash.flatMap = flatMap;
      lodash.flatMapDeep = flatMapDeep;
      lodash.flatMapDepth = flatMapDepth;
      lodash.flatten = flatten;
      lodash.flattenDeep = flattenDeep;
      lodash.flattenDepth = flattenDepth;
      lodash.flip = flip;
      lodash.flow = flow;
      lodash.flowRight = flowRight;
      lodash.fromPairs = fromPairs;
      lodash.functions = functions;
      lodash.functionsIn = functionsIn;
      lodash.groupBy = groupBy;
      lodash.initial = initial;
      lodash.intersection = intersection;
      lodash.intersectionBy = intersectionBy;
      lodash.intersectionWith = intersectionWith;
      lodash.invert = invert;
      lodash.invertBy = invertBy;
      lodash.invokeMap = invokeMap;
      lodash.iteratee = iteratee;
      lodash.keyBy = keyBy;
      lodash.keys = keys;
      lodash.keysIn = keysIn;
      lodash.map = map;
      lodash.mapKeys = mapKeys;
      lodash.mapValues = mapValues;
      lodash.matches = matches;
      lodash.matchesProperty = matchesProperty;
      lodash.memoize = memoize;
      lodash.merge = merge;
      lodash.mergeWith = mergeWith;
      lodash.method = method;
      lodash.methodOf = methodOf;
      lodash.mixin = mixin;
      lodash.negate = negate;
      lodash.nthArg = nthArg;
      lodash.omit = omit;
      lodash.omitBy = omitBy;
      lodash.once = once;
      lodash.orderBy = orderBy;
      lodash.over = over;
      lodash.overArgs = overArgs;
      lodash.overEvery = overEvery;
      lodash.overSome = overSome;
      lodash.partial = partial;
      lodash.partialRight = partialRight;
      lodash.partition = partition;
      lodash.pick = pick;
      lodash.pickBy = pickBy;
      lodash.property = property;
      lodash.propertyOf = propertyOf;
      lodash.pull = pull;
      lodash.pullAll = pullAll;
      lodash.pullAllBy = pullAllBy;
      lodash.pullAllWith = pullAllWith;
      lodash.pullAt = pullAt;
      lodash.range = range;
      lodash.rangeRight = rangeRight;
      lodash.rearg = rearg;
      lodash.reject = reject;
      lodash.remove = remove;
      lodash.rest = rest;
      lodash.reverse = reverse;
      lodash.sampleSize = sampleSize;
      lodash.set = set;
      lodash.setWith = setWith;
      lodash.shuffle = shuffle;
      lodash.slice = slice;
      lodash.sortBy = sortBy;
      lodash.sortedUniq = sortedUniq;
      lodash.sortedUniqBy = sortedUniqBy;
      lodash.split = split;
      lodash.spread = spread;
      lodash.tail = tail;
      lodash.take = take;
      lodash.takeRight = takeRight;
      lodash.takeRightWhile = takeRightWhile;
      lodash.takeWhile = takeWhile;
      lodash.tap = tap;
      lodash.throttle = throttle;
      lodash.thru = thru;
      lodash.toArray = toArray;
      lodash.toPairs = toPairs;
      lodash.toPairsIn = toPairsIn;
      lodash.toPath = toPath;
      lodash.toPlainObject = toPlainObject;
      lodash.transform = transform;
      lodash.unary = unary;
      lodash.union = union;
      lodash.unionBy = unionBy;
      lodash.unionWith = unionWith;
      lodash.uniq = uniq;
      lodash.uniqBy = uniqBy;
      lodash.uniqWith = uniqWith;
      lodash.unset = unset;
      lodash.unzip = unzip;
      lodash.unzipWith = unzipWith;
      lodash.update = update;
      lodash.updateWith = updateWith;
      lodash.values = values;
      lodash.valuesIn = valuesIn;
      lodash.without = without;
      lodash.words = words;
      lodash.wrap = wrap;
      lodash.xor = xor;
      lodash.xorBy = xorBy;
      lodash.xorWith = xorWith;
      lodash.zip = zip;
      lodash.zipObject = zipObject;
      lodash.zipObjectDeep = zipObjectDeep;
      lodash.zipWith = zipWith;
      lodash.entries = toPairs;
      lodash.entriesIn = toPairsIn;
      lodash.extend = assignIn;
      lodash.extendWith = assignInWith;
      mixin(lodash, lodash);
      lodash.add = add;
      lodash.attempt = attempt;
      lodash.camelCase = camelCase;
      lodash.capitalize = capitalize;
      lodash.ceil = ceil;
      lodash.clamp = clamp;
      lodash.clone = clone;
      lodash.cloneDeep = cloneDeep;
      lodash.cloneDeepWith = cloneDeepWith;
      lodash.cloneWith = cloneWith;
      lodash.conformsTo = conformsTo;
      lodash.deburr = deburr;
      lodash.defaultTo = defaultTo;
      lodash.divide = divide;
      lodash.endsWith = endsWith;
      lodash.eq = eq;
      lodash.escape = escape;
      lodash.escapeRegExp = escapeRegExp;
      lodash.every = every;
      lodash.find = find;
      lodash.findIndex = findIndex;
      lodash.findKey = findKey;
      lodash.findLast = findLast;
      lodash.findLastIndex = findLastIndex;
      lodash.findLastKey = findLastKey;
      lodash.floor = floor;
      lodash.forEach = forEach;
      lodash.forEachRight = forEachRight;
      lodash.forIn = forIn;
      lodash.forInRight = forInRight;
      lodash.forOwn = forOwn;
      lodash.forOwnRight = forOwnRight;
      lodash.get = get;
      lodash.gt = gt;
      lodash.gte = gte;
      lodash.has = has;
      lodash.hasIn = hasIn;
      lodash.head = head;
      lodash.identity = identity;
      lodash.includes = includes;
      lodash.indexOf = indexOf;
      lodash.inRange = inRange;
      lodash.invoke = invoke;
      lodash.isArguments = isArguments;
      lodash.isArray = isArray;
      lodash.isArrayBuffer = isArrayBuffer;
      lodash.isArrayLike = isArrayLike;
      lodash.isArrayLikeObject = isArrayLikeObject;
      lodash.isBoolean = isBoolean;
      lodash.isBuffer = isBuffer;
      lodash.isDate = isDate;
      lodash.isElement = isElement;
      lodash.isEmpty = isEmpty;
      lodash.isEqual = isEqual;
      lodash.isEqualWith = isEqualWith;
      lodash.isError = isError;
      lodash.isFinite = isFinite;
      lodash.isFunction = isFunction;
      lodash.isInteger = isInteger;
      lodash.isLength = isLength;
      lodash.isMap = isMap;
      lodash.isMatch = isMatch;
      lodash.isMatchWith = isMatchWith;
      lodash.isNaN = isNaN;
      lodash.isNative = isNative;
      lodash.isNil = isNil;
      lodash.isNull = isNull;
      lodash.isNumber = isNumber;
      lodash.isObject = isObject;
      lodash.isObjectLike = isObjectLike;
      lodash.isPlainObject = isPlainObject;
      lodash.isRegExp = isRegExp;
      lodash.isSafeInteger = isSafeInteger;
      lodash.isSet = isSet;
      lodash.isString = isString;
      lodash.isSymbol = isSymbol;
      lodash.isTypedArray = isTypedArray;
      lodash.isUndefined = isUndefined;
      lodash.isWeakMap = isWeakMap;
      lodash.isWeakSet = isWeakSet;
      lodash.join = join;
      lodash.kebabCase = kebabCase;
      lodash.last = last;
      lodash.lastIndexOf = lastIndexOf;
      lodash.lowerCase = lowerCase;
      lodash.lowerFirst = lowerFirst;
      lodash.lt = lt;
      lodash.lte = lte;
      lodash.max = max;
      lodash.maxBy = maxBy;
      lodash.mean = mean;
      lodash.meanBy = meanBy;
      lodash.min = min;
      lodash.minBy = minBy;
      lodash.stubArray = stubArray;
      lodash.stubFalse = stubFalse;
      lodash.stubObject = stubObject;
      lodash.stubString = stubString;
      lodash.stubTrue = stubTrue;
      lodash.multiply = multiply;
      lodash.nth = nth;
      lodash.noConflict = noConflict;
      lodash.noop = noop;
      lodash.now = now;
      lodash.pad = pad;
      lodash.padEnd = padEnd;
      lodash.padStart = padStart;
      lodash.parseInt = parseInt;
      lodash.random = random;
      lodash.reduce = reduce;
      lodash.reduceRight = reduceRight;
      lodash.repeat = repeat;
      lodash.replace = replace;
      lodash.result = result;
      lodash.round = round;
      lodash.runInContext = runInContext;
      lodash.sample = sample;
      lodash.size = size;
      lodash.snakeCase = snakeCase;
      lodash.some = some;
      lodash.sortedIndex = sortedIndex;
      lodash.sortedIndexBy = sortedIndexBy;
      lodash.sortedIndexOf = sortedIndexOf;
      lodash.sortedLastIndex = sortedLastIndex;
      lodash.sortedLastIndexBy = sortedLastIndexBy;
      lodash.sortedLastIndexOf = sortedLastIndexOf;
      lodash.startCase = startCase;
      lodash.startsWith = startsWith;
      lodash.subtract = subtract;
      lodash.sum = sum;
      lodash.sumBy = sumBy;
      lodash.template = template;
      lodash.times = times;
      lodash.toFinite = toFinite;
      lodash.toInteger = toInteger;
      lodash.toLength = toLength;
      lodash.toLower = toLower;
      lodash.toNumber = toNumber;
      lodash.toSafeInteger = toSafeInteger;
      lodash.toString = toString;
      lodash.toUpper = toUpper;
      lodash.trim = trim;
      lodash.trimEnd = trimEnd;
      lodash.trimStart = trimStart;
      lodash.truncate = truncate;
      lodash.unescape = unescape;
      lodash.uniqueId = uniqueId;
      lodash.upperCase = upperCase;
      lodash.upperFirst = upperFirst;
      lodash.each = forEach;
      lodash.eachRight = forEachRight;
      lodash.first = head;
      mixin(lodash, function () {
        var source = {};
        baseForOwn(lodash, function (func, methodName) {
          if (!hasOwnProperty.call(lodash.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), {
        'chain': false
      });
      lodash.VERSION = VERSION;
      arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
        lodash[methodName].placeholder = lodash;
      });
      arrayEach(['drop', 'take'], function (methodName, index) {
        LazyWrapper.prototype[methodName] = function (n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
          if (result.__filtered__) {
            result.__takeCount__ = nativeMin(n, result.__takeCount__);
          } else {
            result.__views__.push({
              'size': nativeMin(n, MAX_ARRAY_LENGTH),
              'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
            });
          }
          return result;
        };
        LazyWrapper.prototype[methodName + 'Right'] = function (n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
        var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function (iteratee) {
          var result = this.clone();
          result.__iteratees__.push({
            'iteratee': getIteratee(iteratee, 3),
            'type': type
          });
          result.__filtered__ = result.__filtered__ || isFilter;
          return result;
        };
      });
      arrayEach(['head', 'last'], function (methodName, index) {
        var takeName = 'take' + (index ? 'Right' : '');
        LazyWrapper.prototype[methodName] = function () {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(['initial', 'tail'], function (methodName, index) {
        var dropName = 'drop' + (index ? '' : 'Right');
        LazyWrapper.prototype[methodName] = function () {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function () {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function (predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function (predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
        if (typeof path == 'function') {
          return new LazyWrapper(this);
        }
        return this.map(function (value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function (predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function (start, end) {
        start = toInteger(start);
        var result = this;
        if (result.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result);
        }
        if (start < 0) {
          result = result.takeRight(-start);
        } else if (start) {
          result = result.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result = end < 0 ? result.dropRight(-end) : result.take(end - start);
        }
        return result;
      };
      LazyWrapper.prototype.takeRightWhile = function (predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function () {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash.prototype[methodName] = function () {
          var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);
          var interceptor = function (value) {
            var result = lodashFunc.apply(lodash, arrayPush([value], args));
            return isTaker && chainAll ? result[0] : result;
          };
          if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result = func.apply(value, args);
            result.__actions__.push({
              'func': thru,
              'args': [interceptor],
              'thisArg': undefined$1
            });
            return new LodashWrapper(result, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
        };
      });
      arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
        var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash.prototype[methodName] = function () {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray(value) ? value : [], args);
          }
          return this[chainName](function (value) {
            return func.apply(isArray(value) ? value : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var lodashFunc = lodash[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + '';
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({
            'name': methodName,
            'func': lodashFunc
          });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        'name': 'wrapper',
        'func': undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash.prototype.at = wrapperAt;
      lodash.prototype.chain = wrapperChain;
      lodash.prototype.commit = wrapperCommit;
      lodash.prototype.next = wrapperNext;
      lodash.prototype.plant = wrapperPlant;
      lodash.prototype.reverse = wrapperReverse;
      lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
      lodash.prototype.first = lodash.prototype.head;
      if (symIterator) {
        lodash.prototype[symIterator] = wrapperToIterator;
      }
      return lodash;
    };
    var _ = runInContext();
    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root._ = _;
    }
  }).call(commonjsGlobal);
});

const CreatePropertyForm = ({
  config,
  onSelect,
  value,
  userType,
  redirectUrl
}) => {
  var _Digit$Hooks$pt$useTe;
  const [showToast, setShowToast] = useState(null);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const tenants = Digit.Hooks.pt.useTenants();
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const [canSubmit, setCanSubmit] = useState(false);
  const defaultValues = {
    ...value
  };
  const history = useHistory();
  const match = useRouteMatch();
  sessionStorage.setItem("VisitedCommonPTSearch", true);
  const isMobile = window.Digit.Utils.browser.isMobile();
  const allCities = (_Digit$Hooks$pt$useTe = Digit.Hooks.pt.useTenants()) === null || _Digit$Hooks$pt$useTe === void 0 ? void 0 : _Digit$Hooks$pt$useTe.sort((a, b) => {
    var _a$i18nKey, _a$i18nKey$localeComp;
    return a === null || a === void 0 ? void 0 : (_a$i18nKey = a.i18nKey) === null || _a$i18nKey === void 0 ? void 0 : (_a$i18nKey$localeComp = _a$i18nKey.localeCompare) === null || _a$i18nKey$localeComp === void 0 ? void 0 : _a$i18nKey$localeComp.call(_a$i18nKey, b === null || b === void 0 ? void 0 : b.i18nKey);
  });
  const [formValue, setFormValue] = useState("");
  const [cityCode, setCityCode] = useState("");
  let enableSkip = userType == "employee" ? false : (config === null || config === void 0 ? void 0 : config.isSkipEnabled) || sessionStorage.getItem("skipenabled");
  const [mutationHappened, setMutationHappened, clear] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_HAPPENED", false);
  const [successData, setsuccessData, clearSuccessData] = Digit.Hooks.useSessionStorage("EMPLOYEE_MUTATION_SUCCESS_DATA", {});
  const {
    data: commonFields,
    isLoading
  } = Digit.Hooks.pt.useMDMS(Digit.ULBService.getStateId(), "PropertyTax", "CommonFieldsConfig");
  useEffect(() => {
    setMutationHappened(false);
    clearSuccessData();
  }, []);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const onSubmit = async () => {
    var _formValue$owners, _formValue$owners$, _formValue$owners$$ow, _formValue$owners2;
    if (formValue !== null && formValue !== void 0 && (_formValue$owners = formValue.owners) !== null && _formValue$owners !== void 0 && (_formValue$owners$ = _formValue$owners[0]) !== null && _formValue$owners$ !== void 0 && (_formValue$owners$$ow = _formValue$owners$.ownershipCategory) !== null && _formValue$owners$$ow !== void 0 && _formValue$owners$$ow.includes("MULTIPLEOWNERS") && (formValue === null || formValue === void 0 ? void 0 : (_formValue$owners2 = formValue.owners) === null || _formValue$owners2 === void 0 ? void 0 : _formValue$owners2.length) == 1) {
      setShowToast({
        key: true,
        label: "PT_COMMON_ONE_MORE_OWNER_INFROMATION_REQUIRED"
      });
    } else {
      if (onSelect) {
        onSelect('cptNewProperty', {
          property: formValue
        });
      } else {
        if (userType === 'employee') {
          history.push(`${match.path}/save-property?redirectToUrl=${redirectUrl}`, {
            data: formValue,
            prevState: {
              ...(location === null || location === void 0 ? void 0 : location.state)
            }
          });
        } else {
          var _formValue$owners3, _formValue$owners3$;
          history.replace(`/digit-ui/citizen/commonPt/property/citizen-otp`, {
            mobileNumber: formValue === null || formValue === void 0 ? void 0 : (_formValue$owners3 = formValue.owners) === null || _formValue$owners3 === void 0 ? void 0 : (_formValue$owners3$ = _formValue$owners3[0]) === null || _formValue$owners3$ === void 0 ? void 0 : _formValue$owners3$.mobileNumber,
            redirectBackTo: '/digit-ui/citizen/commonPt/property/new-application/save-property',
            redirectData: formValue
          });
        }
      }
    }
  };
  const onSkip = () => {
    onSelect("isSkip", true);
  };
  const onFormValueChange = (setValue, data, formState) => {
    if (!lodash.isEqual(data, formValue)) {
      setFormValue(data);
    }
    if (data.assemblyDet && data.locationDet && data.owners && !Object.keys(formState === null || formState === void 0 ? void 0 : formState.errors).length) {
      setCanSubmit(true);
    } else {
      setCanSubmit(false);
    }
  };
  const getHeaderLabel = () => {
    var _url$split, _url$split$, _url$split$$split;
    let url = window.location.href;
    let moduleName = url === null || url === void 0 ? void 0 : (_url$split = url.split("=")) === null || _url$split === void 0 ? void 0 : (_url$split$ = _url$split[1]) === null || _url$split$ === void 0 ? void 0 : (_url$split$$split = _url$split$.split("/")) === null || _url$split$$split === void 0 ? void 0 : _url$split$$split[3];
    if (moduleName) return t(`ES_COMMON_CREATE_PROPERTY_HEADER_${moduleName === null || moduleName === void 0 ? void 0 : moduleName.toUpperCase()}`);else return t('ES_COMMON_CREATE_PROPERTY_HEADER');
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "12px"
    }
  }, /*#__PURE__*/React.createElement(Header, {
    styles: window.location.href.includes("citizen") ? {
      paddingLeft: "0px",
      marginLeft: "0px"
    } : {}
  }, t(getHeaderLabel()))), /*#__PURE__*/React.createElement(FormComposer, {
    onSkip: onSkip,
    showSkip: enableSkip,
    skipStyle: isMobile ? {} : {
      textAlign: "right",
      marginRight: "55px"
    },
    sectionHeadStyle: {
      marginBottom: "16px"
    },
    onSubmit: onSubmit,
    noBoxShadow: true,
    inline: true,
    config: newConfig,
    label: t('SUBMIT'),
    isDisabled: !canSubmit,
    defaultValues: defaultValues,
    onFormValueChange: onFormValueChange
  }), showToast && /*#__PURE__*/React.createElement(Toast, {
    error: showToast.key,
    label: t(showToast.label),
    onClose: () => {
      setShowToast(null);
    }
  }));
};

const setAddressDetailsLW = data => {
  var _locationDet$cityCode, _locationDet$locality;
  let {
    locationDet
  } = data;
  let propAddress = {
    city: locationDet === null || locationDet === void 0 ? void 0 : (_locationDet$cityCode = locationDet.cityCode) === null || _locationDet$cityCode === void 0 ? void 0 : _locationDet$cityCode.name,
    doorNo: locationDet === null || locationDet === void 0 ? void 0 : locationDet.houseDoorNo,
    buildingName: locationDet === null || locationDet === void 0 ? void 0 : locationDet.buildingColonyName,
    landmark: locationDet === null || locationDet === void 0 ? void 0 : locationDet.landmarkName,
    locality: {
      code: (locationDet === null || locationDet === void 0 ? void 0 : (_locationDet$locality = locationDet.locality) === null || _locationDet$locality === void 0 ? void 0 : _locationDet$locality.code) || "NA"
    }
  };
  data.address = propAddress;
  return data;
};
const setOwnerDetailsLW = data => {
  var _data$owners, _data$owners$ownershi, _data$owners2, _data$owners2$ownersh, _data$owners3, _data$owners3$ownersh;
  const {
    locationDet,
    owners
  } = data;
  let institution = {},
    owner = [],
    document = [];
  data.ownershipCategory = data === null || data === void 0 ? void 0 : (_data$owners = data.owners) === null || _data$owners === void 0 ? void 0 : (_data$owners$ownershi = _data$owners.ownershipCategory) === null || _data$owners$ownershi === void 0 ? void 0 : _data$owners$ownershi.value;
  if ((data === null || data === void 0 ? void 0 : (_data$owners2 = data.owners) === null || _data$owners2 === void 0 ? void 0 : (_data$owners2$ownersh = _data$owners2.ownershipCategory) === null || _data$owners2$ownersh === void 0 ? void 0 : _data$owners2$ownersh.value) === "INSTITUTIONALPRIVATE" || (data === null || data === void 0 ? void 0 : (_data$owners3 = data.owners) === null || _data$owners3 === void 0 ? void 0 : (_data$owners3$ownersh = _data$owners3.ownershipCategory) === null || _data$owners3$ownersh === void 0 ? void 0 : _data$owners3$ownersh.value) === "INSTITUTIONALGOVERNMENT") {
    var _locationDet$city, _owners$inistitutetyp, _owners$ownerType;
    institution.designation = owners === null || owners === void 0 ? void 0 : owners.designation;
    institution.name = owners === null || owners === void 0 ? void 0 : owners.inistitutionName;
    institution.nameOfAuthorizedPerson = owners === null || owners === void 0 ? void 0 : owners.name;
    institution.tenantId = locationDet === null || locationDet === void 0 ? void 0 : (_locationDet$city = locationDet.city) === null || _locationDet$city === void 0 ? void 0 : _locationDet$city.code;
    institution.type = owners === null || owners === void 0 ? void 0 : (_owners$inistitutetyp = owners.inistitutetype) === null || _owners$inistitutetyp === void 0 ? void 0 : _owners$inistitutetyp.value;
    owner.push({
      altContactNumber: owners === null || owners === void 0 ? void 0 : owners.altContactNumber,
      permanentAddress: owners === null || owners === void 0 ? void 0 : owners.permanentAddress,
      designation: owners === null || owners === void 0 ? void 0 : owners.designation,
      emailId: owners === null || owners === void 0 ? void 0 : owners.emailId,
      sameAsPropertyAddress: owners === null || owners === void 0 ? void 0 : owners.isCorrespondenceAddress,
      mobileNumber: owners === null || owners === void 0 ? void 0 : owners.mobileNumber,
      name: owners === null || owners === void 0 ? void 0 : owners.name,
      ownerType: (owners === null || owners === void 0 ? void 0 : (_owners$ownerType = owners.ownerType) === null || _owners$ownerType === void 0 ? void 0 : _owners$ownerType.code) || "NONE",
      documents: document
    });
    data.institution = institution;
    data.owners = owner;
  } else {
    owners.map(own => {
      var _own$gender, _own$ownerType, _own$relationship;
      owner.push({
        emailId: own === null || own === void 0 ? void 0 : own.emailId,
        fatherOrHusbandName: own === null || own === void 0 ? void 0 : own.fatherOrHusbandName,
        gender: own === null || own === void 0 ? void 0 : (_own$gender = own.gender) === null || _own$gender === void 0 ? void 0 : _own$gender.value,
        sameAsPropertyAddress: own === null || own === void 0 ? void 0 : own.isCorrespondenceAddress,
        mobileNumber: own === null || own === void 0 ? void 0 : own.mobileNumber,
        name: own === null || own === void 0 ? void 0 : own.name,
        ownerType: (own === null || own === void 0 ? void 0 : (_own$ownerType = own.ownerType) === null || _own$ownerType === void 0 ? void 0 : _own$ownerType.code) || "NONE",
        permanentAddress: own === null || own === void 0 ? void 0 : own.permanentAddress,
        relationship: own === null || own === void 0 ? void 0 : (_own$relationship = own.relationship) === null || _own$relationship === void 0 ? void 0 : _own$relationship.code,
        documents: document
      });
    });
    data.owners = owner;
  }
  return data;
};
const getUsageTypeLW = data => {
  var _data$isResdential;
  if ((data === null || data === void 0 ? void 0 : (_data$isResdential = data.isResdential) === null || _data$isResdential === void 0 ? void 0 : _data$isResdential.code) == "RESIDENTIAL") {
    var _data$isResdential2;
    return data === null || data === void 0 ? void 0 : (_data$isResdential2 = data.isResdential) === null || _data$isResdential2 === void 0 ? void 0 : _data$isResdential2.code;
  } else {
    var _data$usageCategory;
    return data === null || data === void 0 ? void 0 : (_data$usageCategory = data.usageCategory) === null || _data$usageCategory === void 0 ? void 0 : _data$usageCategory.code;
  }
};
const setPropertyDetailsLW = data => {
  var _assemblyDet$Building;
  let propertyDetails = {};
  const {
    assemblyDet
  } = data;
  propertyDetails = {
    propertyType: assemblyDet === null || assemblyDet === void 0 ? void 0 : (_assemblyDet$Building = assemblyDet.BuildingType) === null || _assemblyDet$Building === void 0 ? void 0 : _assemblyDet$Building.code,
    usageCategory: getUsageTypeLW(assemblyDet),
    landArea: parseInt(assemblyDet === null || assemblyDet === void 0 ? void 0 : assemblyDet.floorarea),
    superBuiltUpArea: parseInt(assemblyDet === null || assemblyDet === void 0 ? void 0 : assemblyDet.constructionArea)
  };
  data.propertyDetails = propertyDetails;
  return data;
};
const convertToPropertyLightWeight = (data = {}) => {
  var _data, _data$owners4, _data$owners4$, _data2, _data2$assemblyDet, _data2$assemblyDet$us;
  let propertyType = data.PropertyType;
  let noOfFloors = 1;
  let ownershipCategory = (_data = data) === null || _data === void 0 ? void 0 : (_data$owners4 = _data.owners) === null || _data$owners4 === void 0 ? void 0 : (_data$owners4$ = _data$owners4[0]) === null || _data$owners4$ === void 0 ? void 0 : _data$owners4$.ownershipCategory;
  data = setOwnerDetailsLW(data);
  data = setAddressDetailsLW(data);
  data = setPropertyDetailsLW(data);
  const formdata = {
    Property: {
      tenantId: data.tenantId,
      address: data.address,
      propertyType: propertyType,
      ...data.propertyDetails,
      ownershipCategory: ownershipCategory,
      usageCategory: (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data2$assemblyDet = _data2.assemblyDet) === null || _data2$assemblyDet === void 0 ? void 0 : (_data2$assemblyDet$us = _data2$assemblyDet.usageCategoryMajor) === null || _data2$assemblyDet$us === void 0 ? void 0 : _data2$assemblyDet$us.code,
      owners: data.owners,
      noOfFloors: noOfFloors,
      additionalDetails: {
        isRainwaterHarvesting: false
      },
      creationReason: "CREATE",
      source: "MUNICIPAL_RECORDS",
      channel: "SYSTEM"
    }
  };
  return formdata;
};
const convertToUpdatePropertyLightWeight = (data = {}) => {
  var _data3, _formdata$Property, _data4, _formdata$Property3;
  let propertyType = data.PropertyType;
  let noOfFloors = 1;
  data = setOwnerDetailsLW(data);
  data = setAddressDetailsLW(data);
  data = setPropertyDetailsLW(data);
  const formdata = {
    Property: {
      id: data.id,
      accountId: data.accountId,
      acknowldgementNumber: data.acknowldgementNumber,
      propertyId: data.propertyId,
      status: data.status || "INWORKFLOW",
      tenantId: data.tenantId,
      address: data.address,
      propertyType: propertyType,
      ownershipCategory: (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.ownershipCategory,
      owners: data.owners,
      noOfFloors: noOfFloors,
      additionalDetails: {
        isRainwaterHarvesting: false
      },
      ...data.propertyDetails,
      creationReason: getCreationReason(data),
      source: "MUNICIPAL_RECORDS",
      channel: "CITIZEN",
      workflow: getWorkflow(data)
    }
  };
  let propertyInitialObject = JSON.parse(sessionStorage.getItem("propertyInitialObject"));
  if (checkArrayLength(propertyInitialObject === null || propertyInitialObject === void 0 ? void 0 : propertyInitialObject.units) && checkIsAnArray((_formdata$Property = formdata.Property) === null || _formdata$Property === void 0 ? void 0 : _formdata$Property.units) && (_data4 = data) !== null && _data4 !== void 0 && _data4.isEditProperty) {
    var _formdata$Property2;
    propertyInitialObject.units = propertyInitialObject.units.filter(unit => unit.active);
    let oldUnits = propertyInitialObject.units.map(unit => {
      return {
        ...unit,
        active: false
      };
    });
    (_formdata$Property2 = formdata.Property) === null || _formdata$Property2 === void 0 ? void 0 : _formdata$Property2.units.push(...oldUnits);
  }
  if (checkArrayLength(propertyInitialObject === null || propertyInitialObject === void 0 ? void 0 : propertyInitialObject.owners) && checkIsAnArray((_formdata$Property3 = formdata.Property) === null || _formdata$Property3 === void 0 ? void 0 : _formdata$Property3.owners)) {
    formdata.Property.owners = [...propertyInitialObject.owners];
  }
  if (propertyInitialObject !== null && propertyInitialObject !== void 0 && propertyInitialObject.auditDetails) {
    formdata.Property["auditDetails"] = {
      ...propertyInitialObject.auditDetails
    };
  }
  return formdata;
};
const stringReplaceAll = (str = "", searcher = "", replaceWith = "") => {
  if (searcher == "") return str;
  while (str.includes(searcher)) {
    str = str.replace(searcher, replaceWith);
  }
  return str;
};

const GetActionMessage = props => {
  const {
    t
  } = useTranslation();
  if (props.isSuccess) {
    return !window.location.href.includes("edit-application") ? t("CS_PROPERTY_APPLICATION_SUCCESS") : t("CS_PROPERTY_UPDATE_APPLICATION_SUCCESS");
  } else if (props.isLoading) {
    return !window.location.href.includes("edit-application") ? t("CS_PROPERTY_APPLICATION_PENDING") : t("CS_PROPERTY_UPDATE_APPLICATION_PENDING");
  } else if (!props.isSuccess) {
    return !window.location.href.includes("edit-application") ? t("CS_PROPERTY_APPLICATION_FAILED") : t("CS_PROPERTY_UPDATE_APPLICATION_FAILED");
  }
};
const rowContainerStyle = {
  padding: "4px 0px",
  justifyContent: "space-between"
};
const BannerPicker = props => {
  var _props$data;
  return /*#__PURE__*/React.createElement(Banner, {
    message: GetActionMessage(props),
    applicationNumber: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.Properties[0].acknowldgementNumber,
    info: props.isSuccess ? props.t("PT_APPLICATION_NO") : "",
    successful: props.isSuccess
  });
};
const PTAcknowledgement = ({
  onSuccess,
  onSelect,
  formData,
  redirectUrl,
  userType
}) => {
  var _location$state, _mdmsConfig$PropertyT, _data, _data$locationDet, _data$locationDet2, _data$locationDet2$ci, _data2, _data2$locationDet, _data$locationDet3, _data$locationDet3$ci, _mutation$data4, _mutation$data4$Prope;
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const stateId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const history = useHistory();
  let data = location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.data;
  if (onSelect) {
    var _formData$cptNewPrope;
    data = formData === null || formData === void 0 ? void 0 : (_formData$cptNewPrope = formData.cptNewProperty) === null || _formData$cptNewPrope === void 0 ? void 0 : _formData$cptNewPrope.property;
  }
  let createNUpdate = false;
  let {
    data: mdmsConfig,
    isLoading
  } = Digit.Hooks.pt.useMDMS(stateId, "PropertyTax", "PTWorkflow");
  ((mdmsConfig === null || mdmsConfig === void 0 ? void 0 : (_mdmsConfig$PropertyT = mdmsConfig.PropertyTax) === null || _mdmsConfig$PropertyT === void 0 ? void 0 : _mdmsConfig$PropertyT.PTWorkfow) || []).forEach(data => {
    if (data.enable) {
      if (data.businessService.includes("WNS")) {
        createNUpdate = true;
      }
    }
  });
  const mutation = Digit.Hooks.pt.usePropertyAPI((_data = data) !== null && _data !== void 0 && (_data$locationDet = _data.locationDet) !== null && _data$locationDet !== void 0 && _data$locationDet.city ? (_data$locationDet2 = data.locationDet) === null || _data$locationDet2 === void 0 ? void 0 : (_data$locationDet2$ci = _data$locationDet2.city) === null || _data$locationDet2$ci === void 0 ? void 0 : _data$locationDet2$ci.code : tenantId, true);
  const mutationForUpdate = Digit.Hooks.pt.usePropertyAPI((_data2 = data) !== null && _data2 !== void 0 && (_data2$locationDet = _data2.locationDet) !== null && _data2$locationDet !== void 0 && _data2$locationDet.city ? (_data$locationDet3 = data.locationDet) === null || _data$locationDet3 === void 0 ? void 0 : (_data$locationDet3$ci = _data$locationDet3.city) === null || _data$locationDet3$ci === void 0 ? void 0 : _data$locationDet3$ci.code : tenantId, false);
  const {
    data: storeData
  } = Digit.Hooks.useStore.getInitData();
  useEffect(() => {
    try {
      var _data3, _data3$locationDet, _data3$locationDet$ci, _formdata$Property;
      let tenant = userType === "employee" ? tenantId : (_data3 = data) === null || _data3 === void 0 ? void 0 : (_data3$locationDet = _data3.locationDet) === null || _data3$locationDet === void 0 ? void 0 : (_data3$locationDet$ci = _data3$locationDet.cityCode) === null || _data3$locationDet$ci === void 0 ? void 0 : _data3$locationDet$ci.code;
      data.tenantId = tenant;
      let formdata = convertToPropertyLightWeight(data);
      formdata.Property.tenantId = (formdata === null || formdata === void 0 ? void 0 : (_formdata$Property = formdata.Property) === null || _formdata$Property === void 0 ? void 0 : _formdata$Property.tenantId) || tenant;
      mutation.mutate(formdata, {
        onSuccess
      });
      if (!createNUpdate) {
        if (!(mutation.isLoading && mutation.isIdle)) {
          if (mutation.isSuccess) {
            setTimeout(() => {
              if (redirectUrl) {
                var _mutation$data, _mutation$data$Proper, _location$state2;
                history.push(`${redirectUrl}?propertyId=${mutation === null || mutation === void 0 ? void 0 : (_mutation$data = mutation.data) === null || _mutation$data === void 0 ? void 0 : (_mutation$data$Proper = _mutation$data.Properties[0]) === null || _mutation$data$Proper === void 0 ? void 0 : _mutation$data$Proper.propertyId}&tenantId=${formdata.Property.tenantId}`, {
                  ...(location === null || location === void 0 ? void 0 : (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.prevState)
                });
                setTimeout(() => window.scrollTo(0, 1600), 400);
                return;
              }
            }, 3000);
          }
        }
      }
    } catch (err) {}
  }, []);
  useEffect(() => {
    var _data4, _data4$locationDet, _data4$locationDet$ci;
    let tenant = userType === "employee" ? tenantId : (_data4 = data) === null || _data4 === void 0 ? void 0 : (_data4$locationDet = _data4.locationDet) === null || _data4$locationDet === void 0 ? void 0 : (_data4$locationDet$ci = _data4$locationDet.city) === null || _data4$locationDet$ci === void 0 ? void 0 : _data4$locationDet$ci.code;
    if (mutation.isSuccess) {
      setTimeout(() => {
        if (redirectUrl) {
          var _mutation$data2, _mutation$data2$Prope, _location$state3;
          history.push(`${redirectUrl}?propertyId=${mutation === null || mutation === void 0 ? void 0 : (_mutation$data2 = mutation.data) === null || _mutation$data2 === void 0 ? void 0 : (_mutation$data2$Prope = _mutation$data2.Properties[0]) === null || _mutation$data2$Prope === void 0 ? void 0 : _mutation$data2$Prope.propertyId}&tenantId=${tenant}`, {
            ...(location === null || location === void 0 ? void 0 : (_location$state3 = location.state) === null || _location$state3 === void 0 ? void 0 : _location$state3.prevState)
          });
          setTimeout(() => window.scrollTo(0, 1600), 400);
          return;
        }
      }, 3000);
    }
  }, [mutation]);
  useEffect(() => {
    if (mutation.isSuccess && createNUpdate) {
      try {
        var _data5, _data5$locationDet, _data5$locationDet$ci, _formdata$Property2;
        let tenant = userType === "employee" ? tenantId : (_data5 = data) === null || _data5 === void 0 ? void 0 : (_data5$locationDet = _data5.locationDet) === null || _data5$locationDet === void 0 ? void 0 : (_data5$locationDet$ci = _data5$locationDet.city) === null || _data5$locationDet$ci === void 0 ? void 0 : _data5$locationDet$ci.code;
        data.tenantId = tenant;
        let formdata = convertToUpdatePropertyLightWeight(data);
        formdata.Property.tenantId = (formdata === null || formdata === void 0 ? void 0 : (_formdata$Property2 = formdata.Property) === null || _formdata$Property2 === void 0 ? void 0 : _formdata$Property2.tenantId) || tenant;
        mutationForUpdate.mutate(formdata, {
          onSuccess
        });
        if (mutationForUpdate.isSuccess) {
          setTimeout(() => {
            if (redirectUrl) {
              var _mutationForUpdate$da, _mutationForUpdate$da2, _mutationForUpdate$da3, _mutationForUpdate$da4, _location$state4;
              history.push(`${redirectUrl}?propertyId=${mutationForUpdate === null || mutationForUpdate === void 0 ? void 0 : (_mutationForUpdate$da = mutationForUpdate.data) === null || _mutationForUpdate$da === void 0 ? void 0 : (_mutationForUpdate$da2 = _mutationForUpdate$da.Properties[0]) === null || _mutationForUpdate$da2 === void 0 ? void 0 : _mutationForUpdate$da2.propertyId}&tenantId=${mutationForUpdate === null || mutationForUpdate === void 0 ? void 0 : (_mutationForUpdate$da3 = mutationForUpdate.data) === null || _mutationForUpdate$da3 === void 0 ? void 0 : (_mutationForUpdate$da4 = _mutationForUpdate$da3.Properties[0]) === null || _mutationForUpdate$da4 === void 0 ? void 0 : _mutationForUpdate$da4.tenantId}`, {
                ...(location === null || location === void 0 ? void 0 : (_location$state4 = location.state) === null || _location$state4 === void 0 ? void 0 : _location$state4.prevState)
              });
              setTimeout(() => window.scrollTo(0, 1600), 400);
              return;
            }
          }, 3000);
        }
      } catch (er) {}
    }
  }, [mutation.isSuccess]);
  const onNext = () => {
    if (onSelect) {
      if (mutation.isSuccess) {
        var _mutation$data3;
        onSelect("cpt", {
          details: mutation === null || mutation === void 0 ? void 0 : (_mutation$data3 = mutation.data) === null || _mutation$data3 === void 0 ? void 0 : _mutation$data3.Properties[0]
        });
      }
    }
  };
  return mutation.isLoading || mutation.isIdle ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(BannerPicker, {
    t: t,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isIdle || mutation.isLoading
  }), mutation.isSuccess && /*#__PURE__*/React.createElement(CardText, null, t("CS_FILE_PROPERTY_RESPONSE")), !mutation.isSuccess && /*#__PURE__*/React.createElement(CardText, null, t("CS_FILE_PROPERTY_FAILED_RESPONSE")), /*#__PURE__*/React.createElement(StatusTable, null, mutation.isSuccess && /*#__PURE__*/React.createElement(Row, {
    rowContainerStyle: rowContainerStyle,
    last: true,
    label: t("PT_COMMON_TABLE_COL_PT_ID"),
    text: mutation === null || mutation === void 0 ? void 0 : (_mutation$data4 = mutation.data) === null || _mutation$data4 === void 0 ? void 0 : (_mutation$data4$Prope = _mutation$data4.Properties[0]) === null || _mutation$data4$Prope === void 0 ? void 0 : _mutation$data4$Prope.propertyId,
    textStyle: {
      whiteSpace: "pre",
      width: "200%"
    }
  })), mutation.isSuccess && window.location.href.includes("/citizen/") && (onSelect ? /*#__PURE__*/React.createElement(SubmitBar, {
    label: t("CS_COMMON_PROCEED"),
    onSubmit: onNext
  }) : /*#__PURE__*/React.createElement(SubmitBar, {
    label: t("CS_COMMON_PROCEED"),
    onSubmit: () => {
      if (redirectUrl) {
        var _mutationForUpdate$da5, _mutationForUpdate$da6, _mutationForUpdate$da7, _mutationForUpdate$da8, _location$state5;
        history.push(`${redirectUrl}?propertyId=${mutationForUpdate === null || mutationForUpdate === void 0 ? void 0 : (_mutationForUpdate$da5 = mutationForUpdate.data) === null || _mutationForUpdate$da5 === void 0 ? void 0 : (_mutationForUpdate$da6 = _mutationForUpdate$da5.Properties[0]) === null || _mutationForUpdate$da6 === void 0 ? void 0 : _mutationForUpdate$da6.propertyId}&tenantId=${mutationForUpdate === null || mutationForUpdate === void 0 ? void 0 : (_mutationForUpdate$da7 = mutationForUpdate.data) === null || _mutationForUpdate$da7 === void 0 ? void 0 : (_mutationForUpdate$da8 = _mutationForUpdate$da7.Properties[0]) === null || _mutationForUpdate$da8 === void 0 ? void 0 : _mutationForUpdate$da8.tenantId}`, {
          ...(location === null || location === void 0 ? void 0 : (_location$state5 = location.state) === null || _location$state5 === void 0 ? void 0 : _location$state5.prevState)
        });
      }
    }
  })));
};

const CreateProperty = ({
  parentRoute,
  onSelect
}) => {
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    t
  } = useTranslation();
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("PT_CREATE_PROPERTY", {});
  let {
    data: commonFields,
    isLoading
  } = Digit.Hooks.pt.useMDMS(stateId, "PropertyTax", "CommonFieldsConfig");
  const search = useLocation().search;
  const redirectUrl = new URLSearchParams(search).get('redirectUrl');
  const createProperty = async () => {
    history.push(`${match.path}/acknowledgement`);
  };
  const onSuccess = () => {
    clearParams();
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: `${match.path}`
  }, /*#__PURE__*/React.createElement(CreatePropertyForm, {
    onSubmit: createProperty,
    value: params,
    userType: "citizen"
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: `${match.path}/save-property`
  }, /*#__PURE__*/React.createElement(PTAcknowledgement, {
    data: params,
    onSuccess: onSuccess,
    redirectUrl: redirectUrl,
    userType: "citizen"
  })));
};

const config = [{
  texts: {
    header: "SEARCH_PROPERTY",
    submitButtonLabel: "PT_HOME_SEARCH_RESULTS_BUTTON_SEARCH",
    text: ""
  },
  inputs: [{
    label: "Owner Mobile Number",
    type: "mobileNumber",
    name: "mobileNumber",
    validation: {
      pattern: {
        value: /[6789][0-9]{9}/,
        message: "CORE_COMMON_MOBILE_ERROR"
      }
    },
    error: "CORE_COMMON_MOBILE_ERROR"
  }, {
    label: "Property ID",
    description: "CS_PROPERTY_ID_FORMAT_MUST_BE",
    type: "text",
    name: "propertyIds",
    error: "ERR_INVALID_PROPERTY_ID",
    validation: {
      pattern: {
        value: "[A-Za-z]{2}\-[A-Za-z]{2}\-[0-9]{4}\-[0-9]{2}\-[0-9]{2}\-[0-9]{6}",
        message: "ERR_INVALID_PROPERTY_ID"
      }
    }
  }, {
    label: "Old Property ID",
    type: "text",
    name: "oldPropertyId",
    error: "ERR_INVALID_PROPERTY_ID",
    validation: {
      pattern: {
        value: "[A-Za-z]{2}\-[A-Za-z]{2}\-[0-9]{4}\-[0-9]{2}\-[0-9]{2}\-[0-9]{6}",
        message: "ERR_INVALID_PROPERTY_ID"
      }
    }
  }, {
    label: "Consumer Name",
    type: "text",
    name: "name",
    validation: {
      pattern: {
        value: "[A-Za-z .`'-]{3,63}",
        message: "PAYMENT_INVALID_NAME"
      }
    },
    error: "PAYMENT_INVALID_NAME"
  }, {
    label: "Door Number",
    type: "text",
    name: "doorNumber",
    validation: {
      pattern: {
        value: "[A-Za-z0-9#,/ -()]{1,63}",
        message: "ERR_INVALID_DOOR_NO"
      }
    },
    error: "ERR_INVALID_DOOR_NO"
  }]
}];

var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t$1 = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t$1:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t$1;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
var isConcurrentMode = A;
var isContextConsumer = function (a) {
  return z(a) === k;
};
var isContextProvider = function (a) {
  return z(a) === h;
};
var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function (a) {
  return z(a) === n;
};
var isFragment = function (a) {
  return z(a) === e;
};
var isLazy = function (a) {
  return z(a) === t$1;
};
var isMemo = function (a) {
  return z(a) === r;
};
var isPortal = function (a) {
  return z(a) === d;
};
var isProfiler = function (a) {
  return z(a) === g;
};
var isStrictMode = function (a) {
  return z(a) === f;
};
var isSuspense = function (a) {
  return z(a) === p;
};
var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function () {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims();
  }
});

const description = {
  description: "(or)",
  descriptionStyles: {
    fontWeight: "300",
    color: "#505A5F",
    marginTop: "0px",
    textAlign: "center"
  }
};
const SearchProperty = ({
  config: propsConfig,
  onSelect,
  redirectToUrl
}) => {
  var _Digit$Hooks$pt$useTe, _Digit$Hooks$tl$useTe;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    action = 0
  } = Digit.Hooks.useQueryParams();
  const [searchData, setSearchData] = useState({});
  const [showToast, setShowToast] = useState(null);
  sessionStorage.setItem("VisitedCommonPTSearch", true);
  let allCities = (_Digit$Hooks$pt$useTe = Digit.Hooks.pt.useTenants()) === null || _Digit$Hooks$pt$useTe === void 0 ? void 0 : _Digit$Hooks$pt$useTe.sort((a, b) => {
    var _a$i18nKey, _a$i18nKey$localeComp;
    return a === null || a === void 0 ? void 0 : (_a$i18nKey = a.i18nKey) === null || _a$i18nKey === void 0 ? void 0 : (_a$i18nKey$localeComp = _a$i18nKey.localeCompare) === null || _a$i18nKey$localeComp === void 0 ? void 0 : _a$i18nKey$localeComp.call(_a$i18nKey, b === null || b === void 0 ? void 0 : b.i18nKey);
  });
  allCities = allCities ? allCities : (_Digit$Hooks$tl$useTe = Digit.Hooks.tl.useTenants()) === null || _Digit$Hooks$tl$useTe === void 0 ? void 0 : _Digit$Hooks$tl$useTe.sort((a, b) => {
    var _a$i18nKey2, _a$i18nKey2$localeCom;
    return a === null || a === void 0 ? void 0 : (_a$i18nKey2 = a.i18nKey) === null || _a$i18nKey2 === void 0 ? void 0 : (_a$i18nKey2$localeCom = _a$i18nKey2.localeCompare) === null || _a$i18nKey2$localeCom === void 0 ? void 0 : _a$i18nKey2$localeCom.call(_a$i18nKey2, b === null || b === void 0 ? void 0 : b.i18nKey);
  });
  const [cityCode, setCityCode] = useState();
  const [formValue, setFormValue] = useState();
  const {
    data: propertyData,
    isLoading: propertyDataLoading,
    error,
    isSuccess,
    billData
  } = Digit.Hooks.pt.usePropertySearchWithDue({
    tenantId: searchData === null || searchData === void 0 ? void 0 : searchData.city,
    filters: searchData === null || searchData === void 0 ? void 0 : searchData.filters,
    auth: true,
    configs: {
      enabled: Object.keys(searchData).length > 0,
      retry: false,
      retryOnMount: false,
      staleTime: Infinity
    }
  });
  useEffect(() => {
    showToast && setShowToast(null);
  }, [action, propertyDataLoading]);
  useLayoutEffect(() => {
    const getActionBar = () => {
      let el = document.querySelector("div.action-bar-wrap");
      if (el) {
        el.style.position = "static";
        el.style.padding = "8px 0";
        el.style.boxShadow = "none";
        el.style.marginBottom = "16px";
      } else {
        setTimeout(() => {
          getActionBar();
        }, 100);
      }
    };
    getActionBar();
  }, []);
  const {
    data: ptSearchConfig,
    isLoading
  } = Digit.Hooks.pt.useMDMS(Digit.ULBService.getStateId(), "DIGIT-UI", "HelpText", {
    select: data => {
      var _data$DIGITUI, _data$DIGITUI$HelpTex, _data$DIGITUI$HelpTex2;
      return data === null || data === void 0 ? void 0 : (_data$DIGITUI = data["DIGIT-UI"]) === null || _data$DIGITUI === void 0 ? void 0 : (_data$DIGITUI$HelpTex = _data$DIGITUI["HelpText"]) === null || _data$DIGITUI$HelpTex === void 0 ? void 0 : (_data$DIGITUI$HelpTex2 = _data$DIGITUI$HelpTex[0]) === null || _data$DIGITUI$HelpTex2 === void 0 ? void 0 : _data$DIGITUI$HelpTex2.PT;
    }
  });
  const [mobileNumber, property, oldProperty, name, doorNumber] = propsConfig.inputs;
  const config = [{
    body: [{
      type: "custom",
      populators: {
        name: "addParam",
        defaultValue: {
          code: 0,
          name: t('PT_KNOW_PTID')
        },
        customProps: {
          t,
          isMandatory: true,
          optionsKey: "name",
          options: [{
            code: 0,
            name: t('PT_KNOW_PTID')
          }, {
            code: 1,
            name: t('PT_SEARCH_DOOR_NO')
          }]
        },
        component: (props, customProps) => /*#__PURE__*/React.createElement(RadioButtons, Object.assign({}, customProps, {
          selectedOption: props.value,
          onSelect: d => {
            props === null || props === void 0 ? void 0 : props.setValue("city", {});
            props === null || props === void 0 ? void 0 : props.setValue("locality", {});
            props === null || props === void 0 ? void 0 : props.setValue("mobileNumber", "");
            props === null || props === void 0 ? void 0 : props.setValue("propertyIds", "");
            props === null || props === void 0 ? void 0 : props.setValue("doorNumber", "");
            props === null || props === void 0 ? void 0 : props.setValue("oldPropertyId", "");
            props === null || props === void 0 ? void 0 : props.setValue("name", "");
            history.replace(`${history.location.pathname}?action=${action == 0 ? 1 : 0}`);
          }
        }))
      }
    }, {
      label: "PT_SELECT_CITY",
      isMandatory: true,
      type: "custom",
      populators: {
        name: "city",
        defaultValue: null,
        rules: {
          required: true
        },
        customProps: {
          t,
          isMandatory: true,
          option: [...allCities],
          optionKey: "i18nKey"
        },
        component: (props, customProps) => /*#__PURE__*/React.createElement(Dropdown, Object.assign({}, customProps, {
          selected: props.value,
          select: d => {
            var _props$value, _props$value2;
            Digit.LocalizationService.getLocale({
              modules: [`rainmaker-${props === null || props === void 0 ? void 0 : (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.code}`],
              locale: Digit.StoreData.getCurrentLanguage(),
              tenantId: `${props === null || props === void 0 ? void 0 : (_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.code}`
            });
            if (d.code !== cityCode) props.setValue("locality", null);
            props.onChange(d);
          }
        }))
      }
    }, {
      label: t("PT_PROVIDE_ONE_MORE_PARAM"),
      isInsideBox: true,
      placementinbox: 0,
      isSectionText: true
    }, {
      label: mobileNumber.label,
      type: mobileNumber.type,
      populators: {
        defaultValue: "",
        name: mobileNumber.name,
        validation: mobileNumber === null || mobileNumber === void 0 ? void 0 : mobileNumber.validation
      },
      ...description,
      isMandatory: false,
      isInsideBox: true,
      placementinbox: 1
    }, {
      label: "",
      labelChildren: /*#__PURE__*/React.createElement("div", {
        className: "tooltip"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: "0 4px"
        }
      }, /*#__PURE__*/React.createElement("h2", null, property.label), /*#__PURE__*/React.createElement(InfoBannerIcon, {
        fill: "#0b0c0c"
      }), /*#__PURE__*/React.createElement("span", {
        className: "tooltiptext",
        style: {
          position: "absolute",
          width: "100%",
          marginLeft: "50%",
          fontSize: "medium"
        }
      }, t(property.description) + " " + (ptSearchConfig === null || ptSearchConfig === void 0 ? void 0 : ptSearchConfig.propertyIdFormat)))),
      type: property.type,
      populators: {
        name: property.name,
        defaultValue: "",
        validation: property === null || property === void 0 ? void 0 : property.validation
      },
      ...description,
      isMandatory: false,
      isInsideBox: true,
      placementinbox: 1
    }, {
      label: oldProperty.label,
      type: oldProperty.type,
      populators: {
        name: oldProperty.name,
        defaultValue: "",
        validation: oldProperty === null || oldProperty === void 0 ? void 0 : oldProperty.validation
      },
      isMandatory: false,
      isInsideBox: true,
      placementinbox: 2
    }],
    body1: [{
      type: "custom",
      populators: {
        name: "addParam1",
        defaultValue: {
          code: 1,
          name: t('PT_SEARCH_DOOR_NO')
        },
        customProps: {
          t,
          isMandatory: true,
          optionsKey: "name",
          options: [{
            code: 0,
            name: t('PT_KNOW_PTID')
          }, {
            code: 1,
            name: t('PT_SEARCH_DOOR_NO')
          }]
        },
        component: (props, customProps) => /*#__PURE__*/React.createElement(RadioButtons, Object.assign({}, customProps, {
          selectedOption: props.value,
          onSelect: d => {
            props === null || props === void 0 ? void 0 : props.setValue("city", {});
            props === null || props === void 0 ? void 0 : props.setValue("locality", {});
            props === null || props === void 0 ? void 0 : props.setValue("mobileNumber", "");
            props === null || props === void 0 ? void 0 : props.setValue("propertyIds", "");
            props === null || props === void 0 ? void 0 : props.setValue("doorNumber", "");
            props === null || props === void 0 ? void 0 : props.setValue("oldPropertyId", "");
            props === null || props === void 0 ? void 0 : props.setValue("name", "");
            history.replace(`${history.location.pathname}?action=${action == 0 ? 1 : 0}`);
          }
        }))
      }
    }, {
      label: "PT_SELECT_CITY",
      isMandatory: true,
      type: "custom",
      populators: {
        name: "city",
        defaultValue: null,
        rules: {
          required: true
        },
        customProps: {
          t,
          isMandatory: true,
          option: [...allCities],
          optionKey: "i18nKey"
        },
        component: (props, customProps) => /*#__PURE__*/React.createElement(Dropdown, Object.assign({}, customProps, {
          selected: props.value,
          select: d => {
            var _props$value3, _props$value4;
            Digit.LocalizationService.getLocale({
              modules: [`rainmaker-${props === null || props === void 0 ? void 0 : (_props$value3 = props.value) === null || _props$value3 === void 0 ? void 0 : _props$value3.code}`],
              locale: Digit.StoreData.getCurrentLanguage(),
              tenantId: `${props === null || props === void 0 ? void 0 : (_props$value4 = props.value) === null || _props$value4 === void 0 ? void 0 : _props$value4.code}`
            });
            if (d.code !== cityCode) props.setValue("locality", null);
            props.onChange(d);
          }
        }))
      }
    }, {
      label: "PT_SELECT_LOCALITY",
      type: "custom",
      isMandatory: true,
      populators: {
        name: "locality",
        defaultValue: "",
        rules: {
          required: true
        },
        customProps: {},
        component: (props, customProps) => /*#__PURE__*/React.createElement(Localities, {
          selectLocality: d => {
            props.onChange(d);
          },
          tenantId: cityCode,
          boundaryType: "revenue",
          keepNull: false,
          optionCardStyles: {
            height: "600px",
            overflow: "auto",
            zIndex: "10"
          },
          selected: formValue === null || formValue === void 0 ? void 0 : formValue.locality,
          disable: !cityCode,
          disableLoader: true
        })
      }
    }, {
      label: t("PT_PROVIDE_ONE_MORE_PARAM"),
      isInsideBox: true,
      placementinbox: 0,
      isSectionText: true
    }, {
      label: doorNumber.label,
      type: doorNumber.type,
      populators: {
        defaultValue: "",
        name: doorNumber.name,
        validation: doorNumber === null || doorNumber === void 0 ? void 0 : doorNumber.validation
      },
      isMandatory: false,
      isInsideBox: true,
      placementinbox: 1
    }, {
      label: name.label,
      type: name.type,
      populators: {
        defaultValue: "",
        name: name.name,
        validation: name === null || name === void 0 ? void 0 : name.validation
      },
      isMandatory: false,
      isInsideBox: true,
      placementinbox: 2
    }]
  }];
  const onPropertySearch = async data => {
    var _data$city;
    if (!(data !== null && data !== void 0 && (_data$city = data.city) !== null && _data$city !== void 0 && _data$city.code)) {
      setShowToast({
        error: true,
        label: "ERR_PT_FILL_VALID_FIELDS"
      });
      return;
    }
    if (action == 0) {
      var _data$mobileNumber, _mobileNumber$validat, _mobileNumber$validat2, _data$propertyIds, _property$validation, _property$validation$, _data$oldPropertyId, _oldProperty$validati, _oldProperty$validati2;
      if (!(data !== null && data !== void 0 && data.mobileNumber || data !== null && data !== void 0 && data.propertyIds || data !== null && data !== void 0 && data.oldPropertyId)) {
        setShowToast({
          error: true,
          label: "ERR_PT_FILL_VALID_FIELDS"
        });
        return;
      }
      if (data !== null && data !== void 0 && data.mobileNumber && !((_data$mobileNumber = data.mobileNumber) !== null && _data$mobileNumber !== void 0 && _data$mobileNumber.match(mobileNumber === null || mobileNumber === void 0 ? void 0 : (_mobileNumber$validat = mobileNumber.validation) === null || _mobileNumber$validat === void 0 ? void 0 : (_mobileNumber$validat2 = _mobileNumber$validat.pattern) === null || _mobileNumber$validat2 === void 0 ? void 0 : _mobileNumber$validat2.value))) {
        var _mobileNumber$validat3, _mobileNumber$validat4;
        setShowToast({
          error: true,
          label: mobileNumber === null || mobileNumber === void 0 ? void 0 : (_mobileNumber$validat3 = mobileNumber.validation) === null || _mobileNumber$validat3 === void 0 ? void 0 : (_mobileNumber$validat4 = _mobileNumber$validat3.pattern) === null || _mobileNumber$validat4 === void 0 ? void 0 : _mobileNumber$validat4.message
        });
        return;
      }
      if (data !== null && data !== void 0 && data.propertyIds && !((_data$propertyIds = data.propertyIds) !== null && _data$propertyIds !== void 0 && _data$propertyIds.match(property === null || property === void 0 ? void 0 : (_property$validation = property.validation) === null || _property$validation === void 0 ? void 0 : (_property$validation$ = _property$validation.pattern) === null || _property$validation$ === void 0 ? void 0 : _property$validation$.value))) {
        var _property$validation2, _property$validation3;
        setShowToast({
          error: true,
          label: property === null || property === void 0 ? void 0 : (_property$validation2 = property.validation) === null || _property$validation2 === void 0 ? void 0 : (_property$validation3 = _property$validation2.pattern) === null || _property$validation3 === void 0 ? void 0 : _property$validation3.message
        });
        return;
      }
      if (data !== null && data !== void 0 && data.oldPropertyId && !((_data$oldPropertyId = data.oldPropertyId) !== null && _data$oldPropertyId !== void 0 && _data$oldPropertyId.match(oldProperty === null || oldProperty === void 0 ? void 0 : (_oldProperty$validati = oldProperty.validation) === null || _oldProperty$validati === void 0 ? void 0 : (_oldProperty$validati2 = _oldProperty$validati.pattern) === null || _oldProperty$validati2 === void 0 ? void 0 : _oldProperty$validati2.value))) {
        var _oldProperty$validati3, _oldProperty$validati4;
        setShowToast({
          error: true,
          label: oldProperty === null || oldProperty === void 0 ? void 0 : (_oldProperty$validati3 = oldProperty.validation) === null || _oldProperty$validati3 === void 0 ? void 0 : (_oldProperty$validati4 = _oldProperty$validati3.pattern) === null || _oldProperty$validati4 === void 0 ? void 0 : _oldProperty$validati4.message
        });
        return;
      }
    } else {
      var _data$locality, _data$name, _name$validation, _name$validation$patt, _data$doorNumber, _doorNumber$validatio, _doorNumber$validatio2;
      if (!(data !== null && data !== void 0 && (_data$locality = data.locality) !== null && _data$locality !== void 0 && _data$locality.code)) {
        setShowToast({
          error: true,
          label: "ERR_PT_FILL_VALID_FIELDS"
        });
        return;
      }
      if (!(data !== null && data !== void 0 && data.doorNumber || data !== null && data !== void 0 && data.name)) {
        setShowToast({
          error: true,
          label: "ERR_PT_FILL_VALID_FIELDS"
        });
        return;
      }
      if (data !== null && data !== void 0 && data.name && !((_data$name = data.name) !== null && _data$name !== void 0 && _data$name.match(name === null || name === void 0 ? void 0 : (_name$validation = name.validation) === null || _name$validation === void 0 ? void 0 : (_name$validation$patt = _name$validation.pattern) === null || _name$validation$patt === void 0 ? void 0 : _name$validation$patt.value))) {
        var _name$validation2, _name$validation2$pat;
        setShowToast({
          error: true,
          label: name === null || name === void 0 ? void 0 : (_name$validation2 = name.validation) === null || _name$validation2 === void 0 ? void 0 : (_name$validation2$pat = _name$validation2.pattern) === null || _name$validation2$pat === void 0 ? void 0 : _name$validation2$pat.message
        });
        return;
      }
      if (data !== null && data !== void 0 && data.doorNumber && !((_data$doorNumber = data.doorNumber) !== null && _data$doorNumber !== void 0 && _data$doorNumber.match(doorNumber === null || doorNumber === void 0 ? void 0 : (_doorNumber$validatio = doorNumber.validation) === null || _doorNumber$validatio === void 0 ? void 0 : (_doorNumber$validatio2 = _doorNumber$validatio.pattern) === null || _doorNumber$validatio2 === void 0 ? void 0 : _doorNumber$validatio2.value))) {
        var _doorNumber$validatio3, _doorNumber$validatio4;
        setShowToast({
          error: true,
          label: doorNumber === null || doorNumber === void 0 ? void 0 : (_doorNumber$validatio3 = doorNumber.validation) === null || _doorNumber$validatio3 === void 0 ? void 0 : (_doorNumber$validatio4 = _doorNumber$validatio3.pattern) === null || _doorNumber$validatio4 === void 0 ? void 0 : _doorNumber$validatio4.message
        });
        return;
      }
    }
    setShowToast(null);
    let tempObject = Object.keys(data).filter(k => data[k]).reduce((acc, key) => ({
      ...acc,
      [key]: typeof data[key] === "object" ? data[key].code : data[key]
    }), {});
    let city = tempObject.city;
    delete tempObject.addParam;
    delete tempObject.addParam1;
    delete tempObject.city;
    setSearchData({
      city: city,
      filters: tempObject
    });
    return;
  };
  const onFormValueChange = (setValue, data, formState) => {
    const city = data === null || data === void 0 ? void 0 : data.city;
    const locality = data === null || data === void 0 ? void 0 : data.locality;
    if ((city === null || city === void 0 ? void 0 : city.code) !== cityCode) {
      setCityCode(city === null || city === void 0 ? void 0 : city.code);
    }
    if (!lodash.isEqual(data, formValue)) {
      setFormValue(data);
    }
    if (!locality || !city) {
      return;
    }
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (propertyData && !propertyDataLoading && !error) {
    var _searchData$filters, _propertyDataLoading$;
    let qs = {};
    qs = {
      ...searchData.filters,
      city: searchData.city
    };
    if (ptSearchConfig !== null && ptSearchConfig !== void 0 && ptSearchConfig.ptSearchCount && searchData !== null && searchData !== void 0 && (_searchData$filters = searchData.filters) !== null && _searchData$filters !== void 0 && _searchData$filters.locality && propertyDataLoading && propertyDataLoading !== null && propertyDataLoading !== void 0 && (_propertyDataLoading$ = propertyDataLoading.Properties) !== null && _propertyDataLoading$ !== void 0 && _propertyDataLoading$.length && propertyDataLoading.Properties.length > ptSearchConfig.ptSearchCount) {
      !showToast && setShowToast({
        error: true,
        label: "PT_MODIFY_SEARCH_CRITERIA"
      });
    } else if (propsConfig.action === "MUTATION") {
      onSelect(propsConfig.key, qs, null, null, null, {
        queryParams: {
          ...qs
        }
      });
    } else {
      if (redirectToUrl || window.location.href.includes("digit-ui/citizen/commonpt/property/citizen-search")) {
        history.push(`/digit-ui/citizen/commonPt/property/search-results?${Object.keys(qs).map(key => `${key}=${qs[key]}`).join("&")}${redirectToUrl ? `&redirectToUrl=${redirectToUrl}` : ''}`);
      } else {
        var _qs, _qs2, _qs3, _qs4, _qs5, _qs6, _qs7, _qs8;
        let SearchParams = {};
        if (action == 0) SearchParams = {
          city: (_qs = qs) === null || _qs === void 0 ? void 0 : _qs.city,
          mobileNumber: ((_qs2 = qs) === null || _qs2 === void 0 ? void 0 : _qs2.mobileNumber) || "",
          propertyIds: ((_qs3 = qs) === null || _qs3 === void 0 ? void 0 : _qs3.propertyIds) || "",
          oldPropertyIds: ((_qs4 = qs) === null || _qs4 === void 0 ? void 0 : _qs4.oldPropertyIds) || "",
          locality: "",
          doorNo: "",
          name: ""
        };else SearchParams = {
          city: (_qs5 = qs) === null || _qs5 === void 0 ? void 0 : _qs5.city,
          locality: ((_qs6 = qs) === null || _qs6 === void 0 ? void 0 : _qs6.locality) || "",
          doorNo: ((_qs7 = qs) === null || _qs7 === void 0 ? void 0 : _qs7.doorNumber) || "",
          name: ((_qs8 = qs) === null || _qs8 === void 0 ? void 0 : _qs8.name) || "",
          mobileNumber: "",
          propertyIds: "",
          oldPropertyIds: ""
        };
        onSelect('cptSearchQuery', SearchParams, null, null, null, {
          queryParams: {
            ...SearchParams
          }
        });
      }
    }
  }
  if (error) {
    var _error$response, _error$response$data, _error$response$data$, _error$response$data$2;
    !showToast && setShowToast({
      error: true,
      label: (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.Errors) === null || _error$response$data$ === void 0 ? void 0 : (_error$response$data$2 = _error$response$data$[0]) === null || _error$response$data$2 === void 0 ? void 0 : _error$response$data$2.code) || error
    });
  }
  if (action == 1) {
    config[0].body = [...config[0].body1];
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "16px",
      marginBottom: "16px",
      backgroundColor: "white"
    }
  }, /*#__PURE__*/React.createElement(FormComposer, {
    onSubmit: onPropertySearch,
    noBoxShadow: true,
    inline: true,
    config: config,
    label: propsConfig.texts.submitButtonLabel,
    heading: t(propsConfig.texts.header),
    text: t(propsConfig.texts.text),
    headingStyle: {
      fontSize: "32px",
      marginBottom: "16px",
      fontFamily: "Roboto Condensed,sans-serif"
    },
    onFormValueChange: onFormValueChange,
    cardStyle: {
      marginBottom: "0"
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "link",
    style: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: "16px"
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: window.location.href.includes("/tl/tradelicence/") ? "/digit-ui/citizen/tl/tradelicence/new-application/create-property" : "/digit-ui/citizen/commonpt/property/new-application"
  }, t("CPT_REG_NEW_PROPERTY"))), showToast && /*#__PURE__*/React.createElement(Toast, {
    isDleteBtn: true,
    error: showToast.error,
    warning: showToast.warning,
    label: t(showToast.label),
    onClose: () => {
      setShowToast(null);
    }
  }));
};
SearchProperty.propTypes = {
  loginParams: propTypes.any
};
SearchProperty.defaultProps = {
  loginParams: null
};

const SearchProperty$1 = ({
  onSelect
}) => {
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  const search = useLocation().search;
  const redirectToUrl = new URLSearchParams(search).get('redirectToUrl');
  const params = useMemo(() => config.map(step => {
    const texts = {};
    for (const key in step.texts) {
      texts[key] = t(step.texts[key]);
    }
    return {
      ...step,
      texts
    };
  }, [config]));
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: `${path}`,
    exact: true
  }, /*#__PURE__*/React.createElement(SearchProperty, {
    config: params[0],
    onSelect: onSelect,
    redirectToUrl: redirectToUrl
  })));
};

const config$1 = [{
  texts: {
    header: "CS_SEARCH_RESULTS",
    actionButtonLabel: "Select"
  },
  labels: [{
    label: "Amount Due",
    key: "total_due",
    noteStyle: {
      fontSize: "24px",
      fontWeight: "bold"
    },
    notePrefix: "₹ "
  }, {
    label: "Property ID",
    key: "property_id"
  }, {
    label: "Owner's Name",
    key: "owner_name"
  }, {
    label: "Address",
    key: "property_address"
  }, {
    label: "Status",
    key: "status"
  }]
}];

const TYPE_LOGIN$1 = {
  type: "login"
};
const DEFAULT_REDIRECT_URL = "/digit-ui/citizen";
const PropertySearchResults = ({
  template,
  header,
  actionButtonLabel,
  isMutation,
  onSelect,
  config,
  clearParams: _clearParams = () => {},
  stateCode,
  redirectToUrl,
  searchQuery
}) => {
  var _result$data, _result$data$Properti, _paymentDetails$data, _paymentDetails$data$, _result$data3, _result$data3$Propert, _result$data4, _modalData$total_due;
  const {
    t
  } = useTranslation();
  const modalRef = useRef();
  const {
    mobileNumber,
    propertyIds,
    oldPropertyIds,
    locality,
    city,
    doorNo,
    name
  } = Digit.Hooks.useQueryParams();
  const filters = {};
  const [modalData, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };
  Digit.Hooks.useClickOutside(modalRef, closeModal, modalData);
  if (mobileNumber || searchQuery && searchQuery.mobileNumber) filters.mobileNumber = mobileNumber ? mobileNumber : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.mobileNumber;
  if (propertyIds || searchQuery && searchQuery.propertyIds) filters.propertyIds = propertyIds ? propertyIds : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.propertyIds;
  if (oldPropertyIds || searchQuery && searchQuery.oldPropertyIds) filters.oldPropertyIds = oldPropertyIds ? oldPropertyIds : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.oldPropertyIds;
  if (locality || searchQuery && searchQuery.locality) filters.locality = locality ? locality : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.locality;
  if (doorNo || searchQuery && searchQuery.doorNo) filters.doorNo = doorNo ? doorNo : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.doorNo;
  if (name || searchQuery && searchQuery.name) filters.name = name ? name : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.name;
  const [owners, setOwners, clearOwners] = Digit.Hooks.useSessionStorage("PT_MUTATE_MULTIPLE_OWNERS", null);
  const [lastPath, setLastPath, clearLastPath] = Digit.Hooks.useSessionStorage("PT_MUTATE_MULTIPLE_OWNERS_LAST_PATH", null);
  const {
    path,
    url
  } = useRouteMatch();
  const searchParams = Digit.Hooks.useQueryParams();
  useEffect(() => {
    setOwners([]);
    _clearParams();
    setLastPath("");
  }, []);
  const auth = true;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const scity = city ? city : searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.city;
  const searchArgs = scity ? {
    tenantId: scity,
    filters,
    auth
  } : {
    filters,
    auth
  };
  const result = Digit.Hooks.pt.usePropertySearch(searchArgs);
  const consumerCode = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$Properti = _result$data.Properties) === null || _result$data$Properti === void 0 ? void 0 : _result$data$Properti.map(a => a.propertyId).join(",");
  const fetchBillParams = mobileNumber ? {
    mobileNumber,
    consumerCode
  } : {
    consumerCode
  };
  const paymentDetails = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: "PT",
    ...fetchBillParams,
    tenantId: scity
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const history = useHistory();
  const proceedToPay = data => {
    history.push(`/digit-ui/citizen/payment/my-bills/PT/${data.property_id}`, {
      tenantId
    });
  };
  if (paymentDetails.isLoading || result.isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (result.error || !consumerCode) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: "150px"
      }
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
      }
    }, t("CS_PT_NO_PROPERTIES_FOUND")));
  }
  const payment = {};
  paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$data = paymentDetails.data) === null || _paymentDetails$data === void 0 ? void 0 : (_paymentDetails$data$ = _paymentDetails$data.Bill) === null || _paymentDetails$data$ === void 0 ? void 0 : _paymentDetails$data$.forEach(element => {
    if (element !== null && element !== void 0 && element.consumerCode) {
      payment[element === null || element === void 0 ? void 0 : element.consumerCode] = {
        total_due: element === null || element === void 0 ? void 0 : element.totalAmount,
        bil_due__date: new Date(element === null || element === void 0 ? void 0 : element.billDate).toDateString()
      };
    }
  });
  const arr = isMutation ? result === null || result === void 0 ? void 0 : (_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : (_result$data3$Propert = _result$data3.Properties) === null || _result$data3$Propert === void 0 ? void 0 : _result$data3$Propert.filter(e => e.status === "ACTIVE") : result === null || result === void 0 ? void 0 : (_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.Properties;
  const searchResults = arr === null || arr === void 0 ? void 0 : arr.map(property => {
    var _, _addr$locality, _payment$property$pro, _payment$property$pro2, _2;
    let addr = (property === null || property === void 0 ? void 0 : property.address) || {};
    return {
      property_id: property === null || property === void 0 ? void 0 : property.propertyId,
      owner_name: (_ = ((property === null || property === void 0 ? void 0 : property.owners) || [])[0]) === null || _ === void 0 ? void 0 : _.name,
      property_address: [addr.doorNo || "", addr.buildingName || "", addr.street || "", ((_addr$locality = addr.locality) === null || _addr$locality === void 0 ? void 0 : _addr$locality.name) || "", addr.city || ""].filter(a => a).join(", "),
      total_due: ((_payment$property$pro = payment[property === null || property === void 0 ? void 0 : property.propertyId]) === null || _payment$property$pro === void 0 ? void 0 : _payment$property$pro.total_due) || 0,
      bil_due__date: ((_payment$property$pro2 = payment[property === null || property === void 0 ? void 0 : property.propertyId]) === null || _payment$property$pro2 === void 0 ? void 0 : _payment$property$pro2.bil_due__date) || t("N/A"),
      status: property.status,
      owner_mobile: (_2 = ((property === null || property === void 0 ? void 0 : property.owners) || [])[0]) === null || _2 === void 0 ? void 0 : _2.mobileNumber
    };
  });
  const getUserType = () => Digit.UserService.getType();
  const getFromLocation = (state, searchParams) => {
    return (state === null || state === void 0 ? void 0 : state.from) || (searchParams === null || searchParams === void 0 ? void 0 : searchParams.from) || DEFAULT_REDIRECT_URL;
  };
  const sendOtpToUser = async record => {
    if (onSelect) {
      onSelect("cptId", {
        id: record.property_id
      });
    } else {
      const data = {
        mobileNumber: record === null || record === void 0 ? void 0 : record.owner_mobile,
        tenantId: stateCode,
        userType: getUserType()
      };
      const [res, err] = await sendOtp({
        otp: {
          ...data,
          ...TYPE_LOGIN$1
        }
      });
      if (!err) {
        let redirectUrl = "/digit-ui/citizen/commonPt/property/link-success/" + record.property_id;
        if (redirectToUrl) {
          redirectUrl = redirectToUrl + "?propertyId=" + record.property_id + "&tenantId=" + tenantId;
        }
        history.replace(`/digit-ui/citizen/commonPt/property/citizen-otp`, {
          from: getFromLocation(location.state, searchParams),
          mobileNumber: record.owner_mobile,
          redirectBackTo: redirectUrl
        });
        return;
      } else {
        history.push(`/digit-ui/citizen`, {
          from: getFromLocation(location.state, searchParams),
          data: data
        });
      }
    }
  };
  const sendOtp = async data => {
    try {
      const res = await Digit.UserService.sendOtp(data, stateCode);
      return [res, null];
    } catch (err) {
      return [null, err];
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "static",
    style: {
      marginTop: "16px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "static-wrapper"
  }, header && /*#__PURE__*/React.createElement(Header, {
    style: {
      marginLeft: "8px"
    }
  }, t(header), " (", searchResults === null || searchResults === void 0 ? void 0 : searchResults.length, ")"), /*#__PURE__*/React.createElement(ResponseComposer, {
    data: searchResults,
    template: template,
    actionButtonLabel: actionButtonLabel,
    onSubmit: sendOtpToUser
  })), modalData ? /*#__PURE__*/React.createElement(Modal, {
    hideSubmit: true,
    isDisabled: false,
    popupStyles: {
      width: "319px",
      height: "250px",
      margin: "auto"
    },
    formId: "modal-action"
  }, /*#__PURE__*/React.createElement("div", {
    ref: modalRef
  }, /*#__PURE__*/React.createElement(KeyNote, {
    keyValue: t("PT_AMOUNT_DUE"),
    note: `₹ ${modalData === null || modalData === void 0 ? void 0 : (_modalData$total_due = modalData.total_due) === null || _modalData$total_due === void 0 ? void 0 : _modalData$total_due.toLocaleString("en-IN")}`,
    noteStyle: {
      fontSize: "24px",
      fontWeight: "bold"
    }
  }), /*#__PURE__*/React.createElement("p", null, t("PT_YOU_HAVE") + " " + "₹" + " " + (modalData === null || modalData === void 0 ? void 0 : modalData.total_due.toLocaleString("en-IN")) + " " + t("PT_PENDING_AMOUNT") + " " + t("PT_INORDER_TO_TRANSFER")), /*#__PURE__*/React.createElement(SubmitBar, {
    submit: false,
    onSubmit: () => proceedToPay(modalData),
    style: {
      marginTop: "14px",
      width: "100%"
    },
    label: t("PT_PROCEED_PAYMENT")
  }))) : null);
};
PropertySearchResults.propTypes = {
  template: propTypes.any,
  header: propTypes.string,
  actionButtonLabel: propTypes.string
};
PropertySearchResults.defaultProps = {
  template: [],
  header: null,
  actionButtonLabel: null
};

const loginSteps = [{
  texts: {
    header: "CS_LOGIN_PROVIDE_MOBILE_NUMBER",
    cardText: "CS_LOGIN_TEXT",
    nextText: "CS_COMMONS_NEXT",
    submitBarLabel: "CS_COMMONS_NEXT"
  },
  inputs: [{
    label: "CORE_COMMON_MOBILE_NUMBER",
    type: "text",
    name: "mobileNumber",
    error: "ERR_HRMS_INVALID_MOB_NO",
    validation: {
      required: true,
      minLength: 10,
      maxLength: 10
    }
  }]
}, {
  texts: {
    header: "CS_LOGIN_OTP",
    cardText: "CS_LOGIN_OTP_TEXT",
    nextText: "CS_COMMONS_NEXT",
    submitBarLabel: "CS_COMMONS_NEXT"
  }
}, {
  texts: {
    header: "CS_LOGIN_PROVIDE_NAME",
    cardText: "CS_LOGIN_NAME_TEXT",
    nextText: "CS_COMMONS_NEXT",
    submitBarLabel: "CS_COMMONS_NEXT"
  },
  inputs: [{
    label: "CORE_COMMON_NAME",
    type: "text",
    name: "name",
    error: "CORE_COMMON_NAME_VALIDMSG",
    validation: {
      required: true,
      minLength: 1,
      pattern: /^[^{0-9}^\$\"<>?\\\\~!@#$%^()+={}\[\]*,/_:;“”‘’]{1,50}$/i
    }
  }]
}];

const SearchResultsComponent = props => {
  const {
    config: propConfig,
    onSelect,
    clearParams,
    formData,
    stateCode
  } = props;
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  const search = useLocation().search;
  const redirectToUrl = new URLSearchParams(search).get('redirectToUrl');
  let config = config$1;
  const params = useMemo(() => {
    var _config$map;
    return config === null || config === void 0 ? void 0 : (_config$map = config.map) === null || _config$map === void 0 ? void 0 : _config$map.call(config, step => {
      const texts = {};
      for (const key in step.texts) {
        texts[key] = t(step.texts[key]);
      }
      return {
        ...step,
        texts
      };
    });
  }, [config]);
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: `${path}`,
    exact: true
  }, /*#__PURE__*/React.createElement(PropertySearchResults, {
    template: params[0].labels,
    header: params[0].texts.header,
    actionButtonLabel: params[0].texts.actionButtonLabel,
    t: t,
    isMutation: (propConfig === null || propConfig === void 0 ? void 0 : propConfig.action) === "MUTATION",
    onSelect: onSelect,
    config: propConfig,
    clearParams: clearParams,
    stateCode: stateCode,
    redirectToUrl: redirectToUrl,
    searchQuery: formData === null || formData === void 0 ? void 0 : formData.cptSearchQuery
  })));
};

const PropertyLinkSuccess = ({
  onSelect
}) => {
  const {
    t
  } = useTranslation();
  const {
    propertyIds
  } = useParams();
  const history = useHistory();
  const onSubmit = () => {
    if (onSelect) {
      onSelect('propertyId', propertyIds);
    }
  };
  const {
    isLoading,
    isError,
    error,
    data
  } = Digit.Hooks.pt.usePropertySearch({
    filters: {
      propertyIds
    }
  }, {
    filters: {
      propertyIds
    }
  });
  const [property, setProperty] = useState(() => (data === null || data === void 0 ? void 0 : data.Properties[0]) || " ");
  useEffect(() => {
    if (data) {
      setProperty(data === null || data === void 0 ? void 0 : data.Properties[0]);
    }
  }, [data]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, t("PT_PROPERTY_DETAILS")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement(Row, {
    label: t("PT_PROPERTY_PTUID"),
    text: `${property.propertyId || t("CS_NA")}`,
    textStyle: {
      whiteSpace: "pre"
    }
  })), onSelect ? /*#__PURE__*/React.createElement(SubmitBar, {
    submit: false,
    label: t("CS_COMMONS_NEXT"),
    onSubmit: onSubmit
  }) : /*#__PURE__*/React.createElement(SubmitBar, {
    submit: false,
    label: t("PT_PROPERTY_CREATE"),
    onSubmit: () => history.push('/digit-ui/citizen/commonPt/property/new-application')
  }))));
};

function useInterval(callback, delay) {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const timer = setInterval(tick, delay);
      return () => clearInterval(timer);
    }
  }, [delay]);
}

const SelectOtp = ({
  config,
  otp,
  onOtpChange,
  onResend,
  onSelect,
  t,
  error,
  userType: _userType = "citizen"
}) => {
  const [timeLeft, setTimeLeft] = useState(30);
  useInterval(() => {
    setTimeLeft(timeLeft - 1);
  }, timeLeft > 0 ? 1000 : null);
  const handleResendOtp = () => {
    onResend();
    setTimeLeft(2);
  };
  if (_userType === "employee") {
    return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(OTPInput, {
      length: 6,
      onChange: onOtpChange,
      value: otp
    }), timeLeft > 0 ? /*#__PURE__*/React.createElement(CardText, null, `${t("CS_RESEND_ANOTHER_OTP")} ${timeLeft} ${t("CS_RESEND_SECONDS")}`) : /*#__PURE__*/React.createElement("p", {
      className: "card-text-button",
      onClick: handleResendOtp
    }, t("CS_RESEND_OTP")), !error && /*#__PURE__*/React.createElement(CardLabelError, null, t("CS_INVALID_OTP")));
  }
  return /*#__PURE__*/React.createElement(FormStep, {
    onSelect: onSelect,
    config: config,
    t: t,
    isDisabled: (otp === null || otp === void 0 ? void 0 : otp.length) !== 6
  }, /*#__PURE__*/React.createElement(OTPInput, {
    length: 6,
    onChange: onOtpChange,
    value: otp
  }), timeLeft > 0 ? /*#__PURE__*/React.createElement(CardText, null, `${t("CS_RESEND_ANOTHER_OTP")} ${timeLeft} ${t("CS_RESEND_SECONDS")}`) : /*#__PURE__*/React.createElement("p", {
    className: "card-text-button",
    onClick: handleResendOtp
  }, t("CS_RESEND_OTP")), !error && /*#__PURE__*/React.createElement(CardLabelError, null, t("CS_INVALID_OTP")));
};

const CitizenOtp = props => {
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const [params1, setParmas1] = useState({
    mobileNumber: location.state.mobileNumber,
    otp: ''
  });
  const [isOtpValid, setIsOtpValid] = useState(true);
  const getUserType = () => Digit.UserService.getType();
  const selectOtp = async () => {
    try {
      var _location$state;
      setIsOtpValid(true);
      const {
        mobileNumber,
        otp,
        name
      } = params1;
      const requestData = {
        username: mobileNumber,
        password: otp,
        tenantId: props.stateCode,
        userType: getUserType()
      };
      const {
        ResponseInfo,
        UserRequest: info,
        ...tokens
      } = await Digit.UserService.authenticate(requestData);
      if ((_location$state = location.state) !== null && _location$state !== void 0 && _location$state.redirectBackTo) {
        var _location$state2, _location$state3;
        history.replace((_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.redirectBackTo, {
          data: (_location$state3 = location.state) === null || _location$state3 === void 0 ? void 0 : _location$state3.redirectData
        });
      } else {
        history.replace('digit-ui/citizen');
      }
    } catch (err) {
      setIsOtpValid(false);
    }
  };
  const resendOtp = async () => {
    const {
      mobileNumber
    } = params1;
    const data = {
      mobileNumber,
      tenantId: props.stateCode,
      userType: getUserType()
    };
    const [res, err] = await sendOtp({
      otp: {
        ...data,
        ...TYPE_LOGIN
      }
    });
  };
  const stepItems = useMemo(() => loginSteps.map(step => {
    const texts = {};
    for (const key in step.texts) {
      texts[key] = t(step.texts[key]);
    }
    return {
      ...step,
      texts
    };
  }, [loginSteps]));
  const handleOtpChange = otp => {
    setParmas1({
      ...params1,
      otp
    });
  };
  return /*#__PURE__*/React.createElement(SelectOtp, {
    config: {
      ...stepItems[1],
      texts: {
        ...stepItems[1].texts,
        cardText: `${stepItems[1].texts.cardText} ${params1.mobileNumber || ""}`
      }
    },
    onOtpChange: handleOtpChange,
    onResend: resendOtp,
    onSelect: selectOtp,
    otp: params1.otp,
    error: isOtpValid,
    t: t
  });
};

const configPTApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService
}) => {
  var _action$assigneeRoles;
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "ES_PT_COMMON_CANCEL"
    },
    form: [{
      body: [{
        label: action.isTerminateState || (action === null || action === void 0 ? void 0 : action.action) === "SENDBACKTOCITIZEN" ? null : t(assigneeLabel || `WF_ROLE_${(_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : _action$assigneeRoles[0]}`),
        type: "dropdown",
        populators: action.isTerminateState || (action === null || action === void 0 ? void 0 : action.action) === "SENDBACKTOCITIZEN" ? null : /*#__PURE__*/React.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("ES_PT_ACTION_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("ES_PT_ATTACH_FILE")}${action.docUploadRequired ? " *" : ""}`,
        populators: /*#__PURE__*/React.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          showHint: true,
          hintText: t("PT_ATTACH_RESTRICTIONS_SIZE"),
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`ES_PT_ACTION_NO_FILEUPLOADED`)
        })
      }]
    }]
  };
};

const configPTAssessProperty = ({
  t,
  action,
  financialYears,
  selectedFinancialYear,
  setSelectedFinancialYear
}) => {
  return {
    label: {
      heading: `WF_${action.action}_APPLICATION`,
      submit: `WF_PT.CREATE_${action.action}`,
      cancel: "ES_PT_COMMON_CANCEL"
    },
    form: [{
      body: [{
        label: t("ES_PT_FINANCIAL_YEARS"),
        isMandatory: true,
        type: "radio",
        populators: /*#__PURE__*/React.createElement(RadioButtons, {
          options: financialYears,
          optionsKey: "name",
          onSelect: setSelectedFinancialYear,
          selectedOption: selectedFinancialYear
        })
      }]
    }]
  };
};

const configTLApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService
}) => {
  let checkCondtions = true;
  if ((action === null || action === void 0 ? void 0 : action.action) == "SENDBACKTOCITIZEN" || (action === null || action === void 0 ? void 0 : action.action) == "APPROVE") checkCondtions = false;
  if (action.isTerminateState) checkCondtions = false;
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "WF_EMPLOYEE_NEWTL_CANCEL"
    },
    form: [{
      body: [{
        label: !checkCondtions ? null : t("WF_ASSIGNEE_NAME_LABEL"),
        placeholder: !checkCondtions ? null : t("WF_ASSIGNEE_NAME_PLACEHOLDER"),
        type: "dropdown",
        populators: !checkCondtions ? null : /*#__PURE__*/React.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: t("TL_APPROVAL_CHECKLIST_BUTTON_UP_FILE"),
        populators: /*#__PURE__*/React.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)
        })
      }]
    }]
  };
};

const configBPAREGApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "WF_EMPLOYEE_BPAREG_CANCEL"
    },
    form: [{
      body: [{
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        populators: {
          name: "comments"
        }
      }, {
        label: t("BPA_APPROVAL_CHECKLIST_BUTTON_UP_FILE"),
        populators: /*#__PURE__*/React.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const configBPAApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  let isCommentRequired = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "REVOCATE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT") {
    isCommentRequired = true;
  }
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "BPA_CITIZEN_CANCEL_BUTTON"
    },
    form: [{
      body: [{
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        isMandatory: isCommentRequired,
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("WF_APPROVAL_UPLOAD_HEAD")}`,
        populators: /*#__PURE__*/React.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const configNOCApproverApplication = ({
  t,
  action,
  approvers,
  selectedApprover,
  setSelectedApprover,
  selectFile,
  uploadedFile,
  setUploadedFile,
  assigneeLabel,
  businessService,
  error
}) => {
  var _action$assigneeRoles;
  let isCommentRequired = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "REVOCATE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT") {
    isCommentRequired = true;
  }
  let isRejectOrRevocate = false;
  if ((action === null || action === void 0 ? void 0 : action.action) == "APPROVE" || (action === null || action === void 0 ? void 0 : action.action) == "REJECT" || action.action == "AUTO_APPROVE" || action.action == "AUTO_REJECT") {
    isRejectOrRevocate = true;
  }
  return {
    label: {
      heading: `WF_${action === null || action === void 0 ? void 0 : action.action}_APPLICATION`,
      submit: `WF_${businessService}_${action === null || action === void 0 ? void 0 : action.action}`,
      cancel: "CORE_LOGOUTPOPUP_CANCEL"
    },
    form: [{
      body: [{
        label: action.isTerminateState || isRejectOrRevocate ? null : t(assigneeLabel || `WF_ROLE_${(_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : _action$assigneeRoles[0]}`),
        type: "dropdown",
        populators: action.isTerminateState || isRejectOrRevocate ? null : /*#__PURE__*/React.createElement(Dropdown, {
          option: approvers,
          autoComplete: "off",
          optionKey: "name",
          id: "fieldInspector",
          select: setSelectedApprover,
          selected: selectedApprover
        })
      }, {
        label: t("WF_COMMON_COMMENTS"),
        type: "textarea",
        isMandatory: isCommentRequired,
        populators: {
          name: "comments"
        }
      }, {
        label: `${t("WF_APPROVAL_UPLOAD_HEAD")}`,
        populators: /*#__PURE__*/React.createElement(UploadFile, {
          id: "workflow-doc",
          onUpload: selectFile,
          onDelete: () => {
            setUploadedFile(null);
          },
          showHint: true,
          message: uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`),
          accept: "image/*, .pdf, .png, .jpeg, .jpg",
          iserror: error
        })
      }]
    }]
  };
};

const Heading = props => {
  return /*#__PURE__*/React.createElement("h1", {
    className: "heading-m"
  }, props.label);
};
const Close = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Close, null));
};
const ActionModal = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const {
    isLoading: financialYearsLoading,
    data: financialYearsData
  } = Digit.Hooks.pt.useMDMS(tenantId, businessService, "FINANCIAL_YEARLS", {}, {
    details: {
      tenantId: Digit.ULBService.getStateId(),
      moduleDetails: [{
        moduleName: "egf-master",
        masterDetails: [{
          name: "FinancialYear",
          filter: "[?(@.module == 'PT')]"
        }]
      }]
    }
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState(null);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const [disableActionSubmit, setDisableActionSubmit] = useState(false);
  useEffect(() => {
    if (financialYearsData && financialYearsData["egf-master"]) {
      var _financialYearsData$e;
      setFinancialYears((_financialYearsData$e = financialYearsData["egf-master"]) === null || _financialYearsData$e === void 0 ? void 0 : _financialYearsData$e["FinancialYear"]);
    }
  }, [financialYearsData]);
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    if (!(action !== null && action !== void 0 && action.showFinancialYearsModal)) {
      let workflow = {
        action: action === null || action === void 0 ? void 0 : action.action,
        comments: data === null || data === void 0 ? void 0 : data.comments,
        businessService,
        moduleName: moduleCode
      };
      workflow["assignes"] = action !== null && action !== void 0 && action.isTerminateState || !selectedApprover ? [] : [selectedApprover];
      if (uploadedFile) workflow["documents"] = [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }];
      submitAction({
        Property: {
          ...applicationData,
          workflow
        }
      });
    } else {
      submitAction({
        customFunctionToExecute: action === null || action === void 0 ? void 0 : action.customFunctionToExecute,
        Assessment: {
          financialYear: selectedFinancialYear === null || selectedFinancialYear === void 0 ? void 0 : selectedFinancialYear.name,
          propertyId: applicationData === null || applicationData === void 0 ? void 0 : applicationData.propertyId,
          tenantId,
          source: applicationData === null || applicationData === void 0 ? void 0 : applicationData.source,
          channel: applicationData === null || applicationData === void 0 ? void 0 : applicationData.channel,
          assessmentDate: Date.now()
        }
      });
    }
  }
  useEffect(() => {
    if (action) {
      if (action !== null && action !== void 0 && action.showFinancialYearsModal) {
        setConfig(configPTAssessProperty({
          t,
          action,
          financialYears,
          selectedFinancialYear,
          setSelectedFinancialYear
        }));
      } else {
        setConfig(configPTApproverApplication({
          t,
          action,
          approvers,
          selectedApprover,
          setSelectedApprover,
          selectFile,
          uploadedFile,
          setUploadedFile,
          businessService
        }));
      }
    }
  }, [action, approvers, financialYears, selectedFinancialYear, uploadedFile]);
  return action && config.form ? /*#__PURE__*/React.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React.createElement(Heading, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React.createElement(CloseBtn, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    isDisabled: !action.showFinancialYearsModal ? PTALoading || (action === null || action === void 0 ? void 0 : action.docUploadRequired) && !uploadedFile : !selectedFinancialYear,
    formId: "modal-action"
  }, financialYearsLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormComposer, {
    config: config.form,
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React.createElement(Loader, null);
};

const Heading$1 = props => {
  return /*#__PURE__*/React.createElement("h1", {
    className: "heading-m"
  }, props.label);
};
const Close$1 = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$1 = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Close$1, null));
};
const ActionModal$1 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const {
    isLoading: financialYearsLoading,
    data: financialYearsData
  } = Digit.Hooks.pt.useMDMS(tenantId, businessService, "FINANCIAL_YEARLS", {}, {
    details: {
      tenantId: Digit.ULBService.getStateId(),
      moduleDetails: [{
        moduleName: "egf-master",
        masterDetails: [{
          name: "FinancialYear",
          filter: "[?(@.module == 'TL')]"
        }]
      }]
    }
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  useEffect(() => {
    if (financialYearsData && financialYearsData["egf-master"]) {
      var _financialYearsData$e;
      setFinancialYears((_financialYearsData$e = financialYearsData["egf-master"]) === null || _financialYearsData$e === void 0 ? void 0 : _financialYearsData$e["FinancialYear"]);
    }
  }, [financialYearsData]);
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    applicationData = {
      ...applicationData,
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    submitAction({
      Licenses: [applicationData]
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configTLApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService
      }));
    }
  }, [action, approvers, financialYears, selectedFinancialYear, uploadedFile]);
  return action && config.form ? /*#__PURE__*/React.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React.createElement(Heading$1, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React.createElement(CloseBtn$1, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action"
  }, financialYearsLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormComposer, {
    config: config.form,
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React.createElement(Loader, null);
};

const Heading$2 = props => {
  return /*#__PURE__*/React.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$2 = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$2 = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Close$2, null));
};
const ActionModal$2 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    applicationData = {
      ...applicationData,
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    submitAction({
      Licenses: [applicationData]
    }, false, {
      isStakeholder: true,
      bpa: false
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAREGApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        error
      }));
    }
  }, [action, approvers, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React.createElement(Heading$2, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React.createElement(CloseBtn$2, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      height: "45px",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      height: "45px",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React.createElement(Loader, null);
};

const Heading$3 = props => {
  return /*#__PURE__*/React.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$3 = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$3 = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Close$3, null));
};
const ActionModal$3 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationDetails,
  applicationData,
  businessService,
  moduleCode,
  workflowDetails
}) => {
  var _applicationData, _applicationData$land, _applicationData$land2, _applicationData2, _applicationData2$lan, _applicationData2$lan2, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _applicationData4;
  const mutation1 = Digit.Hooks.obps.useObpsAPI((_applicationData = applicationData) !== null && _applicationData !== void 0 && (_applicationData$land = _applicationData.landInfo) !== null && _applicationData$land !== void 0 && (_applicationData$land2 = _applicationData$land.address) !== null && _applicationData$land2 !== void 0 && _applicationData$land2.city ? (_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$lan = _applicationData2.landInfo) === null || _applicationData2$lan === void 0 ? void 0 : (_applicationData2$lan2 = _applicationData2$lan.address) === null || _applicationData2$lan2 === void 0 ? void 0 : _applicationData2$lan2.city : tenantId, false);
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.initialActionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.filter(ele => (ele === null || ele === void 0 ? void 0 : ele.action) == (action === null || action === void 0 ? void 0 : action.action))) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4[0]) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.assigneeRoles) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map(role => ({
      code: role
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map((doc, ind) => {
      refinedDocs.push({
        "documentType": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        "fileStoreId": doc.fileStoreId,
        "fileStore": doc.fileStoreId,
        "fileName": "",
        "dropDownValues": {
          "value": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        "remarks": data[`Remarks_${i}`],
        "question": data === null || data === void 0 ? void 0 : data.questionList[i].question,
        "value": data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai, _data$additionalDetai2;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.fieldinspection_pending) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.length) > 0) {
      var _data$additionalDetai3;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map((ob, ind) => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };
  const getDocuments = applicationData => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata.map(doc => {
      var _doc$uploadedDocument, _doc$uploadedDocument2, _doc$uploadedDocument3, _doc$uploadedDocument4, _doc$uploadedDocument5, _doc$newUploadedDocs;
      if ((doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : (_doc$uploadedDocument2 = _doc$uploadedDocument[0]) === null || _doc$uploadedDocument2 === void 0 ? void 0 : (_doc$uploadedDocument3 = _doc$uploadedDocument2.values) === null || _doc$uploadedDocument3 === void 0 ? void 0 : _doc$uploadedDocument3.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument4 = doc.uploadedDocuments) === null || _doc$uploadedDocument4 === void 0 ? void 0 : (_doc$uploadedDocument5 = _doc$uploadedDocument4[0]) === null || _doc$uploadedDocument5 === void 0 ? void 0 : _doc$uploadedDocument5.values)];
      if ((doc === null || doc === void 0 ? void 0 : (_doc$newUploadedDocs = doc.newUploadedDocs) === null || _doc$newUploadedDocs === void 0 ? void 0 : _doc$newUploadedDocs.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : doc.newUploadedDocs)];
    });
    return documentList;
  };
  const getPendingApprovals = () => {
    var _result;
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals === null || approvals === void 0 ? void 0 : approvals.reduce((acc, approval) => approval !== null && approval !== void 0 && approval.checked ? acc.push(approval === null || approval === void 0 ? void 0 : approval.label) && acc : acc, []);
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval === null || approval === void 0 ? void 0 : approval.label) : []);
    return result;
  };
  function submit(data) {
    var _applicationData3, _data$comments, _data$comments2, _applicationDetails$n;
    applicationData = {
      ...applicationData,
      documents: getDocuments(),
      additionalDetails: {
        ...((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals()
      },
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        comments: (data === null || data === void 0 ? void 0 : (_data$comments2 = data.comments) === null || _data$comments2 === void 0 ? void 0 : _data$comments2.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        assignes: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        varificationDocuments: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const nocDetails = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$n = applicationDetails.nocData) === null || _applicationDetails$n === void 0 ? void 0 : _applicationDetails$n.map(noc => {
      const uploadedDocuments = Digit.SessionStorage.get(noc === null || noc === void 0 ? void 0 : noc.nocType) || [];
      return {
        Noc: {
          ...noc,
          documents: [...(noc !== null && noc !== void 0 && noc.documents ? noc === null || noc === void 0 ? void 0 : noc.documents : []), ...(uploadedDocuments ? uploadedDocuments : [])]
        }
      };
    });
    let nocData = [];
    if (nocDetails) {
      nocDetails.map(noc => {
        var _noc$Noc, _noc$Noc$applicationS, _noc$Noc2, _noc$Noc2$application, _noc$Noc3, _noc$Noc3$application, _noc$Noc4, _noc$Noc4$application, _noc$Noc5, _noc$Noc5$application;
        if ((noc === null || noc === void 0 ? void 0 : (_noc$Noc = noc.Noc) === null || _noc$Noc === void 0 ? void 0 : (_noc$Noc$applicationS = _noc$Noc.applicationStatus) === null || _noc$Noc$applicationS === void 0 ? void 0 : _noc$Noc$applicationS.toUpperCase()) != "APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc2 = noc.Noc) === null || _noc$Noc2 === void 0 ? void 0 : (_noc$Noc2$application = _noc$Noc2.applicationStatus) === null || _noc$Noc2$application === void 0 ? void 0 : _noc$Noc2$application.toUpperCase()) != "AUTO_APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc3 = noc.Noc) === null || _noc$Noc3 === void 0 ? void 0 : (_noc$Noc3$application = _noc$Noc3.applicationStatus) === null || _noc$Noc3$application === void 0 ? void 0 : _noc$Noc3$application.toUpperCase()) != "REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc4 = noc.Noc) === null || _noc$Noc4 === void 0 ? void 0 : (_noc$Noc4$application = _noc$Noc4.applicationStatus) === null || _noc$Noc4$application === void 0 ? void 0 : _noc$Noc4$application.toUpperCase()) != "AUTO_REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc5 = noc.Noc) === null || _noc$Noc5 === void 0 ? void 0 : (_noc$Noc5$application = _noc$Noc5.applicationStatus) === null || _noc$Noc5$application === void 0 ? void 0 : _noc$Noc5$application.toUpperCase()) != "VOIDED") {
          nocData.push(noc);
        }
      });
    }
    submitAction({
      BPA: applicationData
    }, (nocData === null || nocData === void 0 ? void 0 : nocData.length) > 0 ? nocData : false, {
      isStakeholder: false,
      bpa: true
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, selectedFinancialYear, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React.createElement(Heading$3, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React.createElement(CloseBtn$3, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      minHeight: "45px",
      height: "auto",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      minHeight: "45px",
      height: "auto",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {},
    isDisabled: ((_applicationData4 = applicationData) === null || _applicationData4 === void 0 ? void 0 : _applicationData4.status) === "UPLOAD_DIGI_SIGN_LETTER" && file === null ? true : false
  }, PTALoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React.createElement(Loader, null);
};

const Heading$4 = props => {
  return /*#__PURE__*/React.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$4 = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$4 = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Close$4, null));
};
const ActionModal$4 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationDetails,
  applicationData,
  businessService,
  moduleCode,
  workflowDetails
}) => {
  var _applicationData, _applicationData$land, _applicationData$land2, _applicationData2, _applicationData2$lan, _applicationData2$lan2, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6;
  const mutation1 = Digit.Hooks.obps.useObpsAPI((_applicationData = applicationData) !== null && _applicationData !== void 0 && (_applicationData$land = _applicationData.landInfo) !== null && _applicationData$land !== void 0 && (_applicationData$land2 = _applicationData$land.address) !== null && _applicationData$land2 !== void 0 && _applicationData$land2.city ? (_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : (_applicationData2$lan = _applicationData2.landInfo) === null || _applicationData2$lan === void 0 ? void 0 : (_applicationData2$lan2 = _applicationData2$lan.address) === null || _applicationData2$lan2 === void 0 ? void 0 : _applicationData2$lan2.city : tenantId, false);
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.initialActionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.filter(ele => (ele === null || ele === void 0 ? void 0 : ele.action) == (action === null || action === void 0 ? void 0 : action.action))) === null || _workflowDetails$data4 === void 0 ? void 0 : (_workflowDetails$data5 = _workflowDetails$data4[0]) === null || _workflowDetails$data5 === void 0 ? void 0 : (_workflowDetails$data6 = _workflowDetails$data5.assigneeRoles) === null || _workflowDetails$data6 === void 0 ? void 0 : _workflowDetails$data6.map(role => ({
      code: role
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getInspectionDocs = docs => {
    let refinedDocs = [];
    docs && docs.map((doc, ind) => {
      refinedDocs.push({
        "documentType": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
        "fileStoreId": doc.fileStoreId,
        "fileStore": doc.fileStoreId,
        "fileName": "",
        "dropDownValues": {
          "value": (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", ".")
        }
      });
    });
    return refinedDocs;
  };
  const getQuestion = data => {
    let refinedQues = [];
    var i;
    for (i = 0; i < (data === null || data === void 0 ? void 0 : data.questionLength); i++) {
      var _data;
      refinedQues.push({
        "remarks": data[`Remarks_${i}`],
        "question": data === null || data === void 0 ? void 0 : data.questionList[i].question,
        "value": data === null || data === void 0 ? void 0 : (_data = data[`question_${i}`]) === null || _data === void 0 ? void 0 : _data.code
      });
    }
    return refinedQues;
  };
  const getfeildInspection = data => {
    var _data$additionalDetai, _data$additionalDetai2;
    let formdata = [],
      inspectionOb = [];
    if ((data === null || data === void 0 ? void 0 : (_data$additionalDetai = data.additionalDetails) === null || _data$additionalDetai === void 0 ? void 0 : (_data$additionalDetai2 = _data$additionalDetai.fieldinspection_pending) === null || _data$additionalDetai2 === void 0 ? void 0 : _data$additionalDetai2.length) > 0) {
      var _data$additionalDetai3;
      inspectionOb = data === null || data === void 0 ? void 0 : (_data$additionalDetai3 = data.additionalDetails) === null || _data$additionalDetai3 === void 0 ? void 0 : _data$additionalDetai3.fieldinspection_pending;
    }
    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      var _formdata;
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      ((_formdata = formdata) === null || _formdata === void 0 ? void 0 : _formdata.length) > 0 && formdata.map((ob, ind) => {
        inspectionOb.push({
          docs: getInspectionDocs(ob.Documents),
          date: ob.InspectionDate,
          questions: getQuestion(ob),
          time: ob === null || ob === void 0 ? void 0 : ob.InspectionTime
        });
      });
      inspectionOb = inspectionOb.filter(ob => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }
    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };
  const getDocuments = applicationData => {
    let documentsformdata = JSON.parse(sessionStorage.getItem("BPA_DOCUMENTS"));
    let documentList = [];
    documentsformdata.map(doc => {
      var _doc$uploadedDocument, _doc$uploadedDocument2, _doc$uploadedDocument3, _doc$uploadedDocument4, _doc$uploadedDocument5, _doc$newUploadedDocs;
      if ((doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : (_doc$uploadedDocument2 = _doc$uploadedDocument[0]) === null || _doc$uploadedDocument2 === void 0 ? void 0 : (_doc$uploadedDocument3 = _doc$uploadedDocument2.values) === null || _doc$uploadedDocument3 === void 0 ? void 0 : _doc$uploadedDocument3.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument4 = doc.uploadedDocuments) === null || _doc$uploadedDocument4 === void 0 ? void 0 : (_doc$uploadedDocument5 = _doc$uploadedDocument4[0]) === null || _doc$uploadedDocument5 === void 0 ? void 0 : _doc$uploadedDocument5.values)];
      if ((doc === null || doc === void 0 ? void 0 : (_doc$newUploadedDocs = doc.newUploadedDocs) === null || _doc$newUploadedDocs === void 0 ? void 0 : _doc$newUploadedDocs.length) > 0) documentList = [...documentList, ...(doc === null || doc === void 0 ? void 0 : doc.newUploadedDocs)];
    });
    return documentList;
  };
  const getPendingApprovals = () => {
    var _result;
    const approvals = Digit.SessionStorage.get("OBPS_APPROVAL_CHECKS");
    const newApprovals = Digit.SessionStorage.get("OBPS_NEW_APPROVALS");
    let result = approvals === null || approvals === void 0 ? void 0 : approvals.reduce((acc, approval) => approval !== null && approval !== void 0 && approval.checked ? acc.push(approval === null || approval === void 0 ? void 0 : approval.label) && acc : acc, []);
    result = (_result = result) === null || _result === void 0 ? void 0 : _result.concat(newApprovals !== null ? newApprovals.filter(ob => ob.label !== "").map(approval => approval === null || approval === void 0 ? void 0 : approval.label) : []);
    return result;
  };
  function submit(data) {
    var _applicationData3, _data$comments, _data$comments2, _applicationDetails$n;
    applicationData = {
      ...applicationData,
      documents: getDocuments(),
      additionalDetails: {
        ...((_applicationData3 = applicationData) === null || _applicationData3 === void 0 ? void 0 : _applicationData3.additionalDetails),
        fieldinspection_pending: getfeildInspection(applicationData),
        pendingapproval: getPendingApprovals()
      },
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        comments: (data === null || data === void 0 ? void 0 : (_data$comments2 = data.comments) === null || _data$comments2 === void 0 ? void 0 : _data$comments2.length) > 0 ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        assignes: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        varificationDocuments: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      action: action === null || action === void 0 ? void 0 : action.action,
      comment: data === null || data === void 0 ? void 0 : data.comments,
      assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
      wfDocuments: uploadedFile ? [{
        documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
        fileName: file === null || file === void 0 ? void 0 : file.name,
        fileStoreId: uploadedFile
      }] : null
    };
    const nocDetails = applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$n = applicationDetails.nocData) === null || _applicationDetails$n === void 0 ? void 0 : _applicationDetails$n.map(noc => {
      const uploadedDocuments = Digit.SessionStorage.get(noc === null || noc === void 0 ? void 0 : noc.nocType) || [];
      return {
        Noc: {
          ...noc,
          documents: [...(noc !== null && noc !== void 0 && noc.documents ? noc === null || noc === void 0 ? void 0 : noc.documents : []), ...(uploadedDocuments ? uploadedDocuments : [])]
        }
      };
    });
    if (nocDetails) {
      nocDetails.map(noc => {
        var _noc$Noc, _noc$Noc$applicationS, _noc$Noc2, _noc$Noc2$application, _noc$Noc3, _noc$Noc3$application, _noc$Noc4, _noc$Noc4$application, _noc$Noc5, _noc$Noc5$application;
        if ((noc === null || noc === void 0 ? void 0 : (_noc$Noc = noc.Noc) === null || _noc$Noc === void 0 ? void 0 : (_noc$Noc$applicationS = _noc$Noc.applicationStatus) === null || _noc$Noc$applicationS === void 0 ? void 0 : _noc$Noc$applicationS.toUpperCase()) != "APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc2 = noc.Noc) === null || _noc$Noc2 === void 0 ? void 0 : (_noc$Noc2$application = _noc$Noc2.applicationStatus) === null || _noc$Noc2$application === void 0 ? void 0 : _noc$Noc2$application.toUpperCase()) != "AUTO_APPROVED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc3 = noc.Noc) === null || _noc$Noc3 === void 0 ? void 0 : (_noc$Noc3$application = _noc$Noc3.applicationStatus) === null || _noc$Noc3$application === void 0 ? void 0 : _noc$Noc3$application.toUpperCase()) != "REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc4 = noc.Noc) === null || _noc$Noc4 === void 0 ? void 0 : (_noc$Noc4$application = _noc$Noc4.applicationStatus) === null || _noc$Noc4$application === void 0 ? void 0 : _noc$Noc4$application.toUpperCase()) != "AUTO_REJECTED" && (noc === null || noc === void 0 ? void 0 : (_noc$Noc5 = noc.Noc) === null || _noc$Noc5 === void 0 ? void 0 : (_noc$Noc5$application = _noc$Noc5.applicationStatus) === null || _noc$Noc5$application === void 0 ? void 0 : _noc$Noc5$application.toUpperCase()) != "VOIDED") ;
      });
    }
    submitAction({
      PermissionOfSubdivision: applicationData
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configBPAApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, selectedFinancialYear, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React.createElement(Heading$4, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React.createElement(CloseBtn$4, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      minHeight: "45px",
      height: "auto",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      minHeight: "45px",
      height: "auto",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React.createElement(Loader, null);
};

const Heading$5 = props => {
  return /*#__PURE__*/React.createElement("h1", {
    style: {
      marginLeft: "22px"
    },
    className: "heading-m BPAheading-m"
  }, props.label);
};
const Close$5 = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$5 = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Close$5, null));
};
const ActionModal$5 = ({
  t,
  action,
  tenantId,
  state,
  id,
  closeModal,
  submitAction,
  actionData,
  applicationData,
  businessService,
  moduleCode
}) => {
  var _action$assigneeRoles, _action$assigneeRoles2;
  const {
    data: approverData,
    isLoading: PTALoading
  } = Digit.Hooks.useEmployeeSearch(tenantId, {
    roles: action === null || action === void 0 ? void 0 : (_action$assigneeRoles = action.assigneeRoles) === null || _action$assigneeRoles === void 0 ? void 0 : (_action$assigneeRoles2 = _action$assigneeRoles.map) === null || _action$assigneeRoles2 === void 0 ? void 0 : _action$assigneeRoles2.call(_action$assigneeRoles, e => ({
      code: e
    })),
    isActive: true
  }, {
    enabled: !(action !== null && action !== void 0 && action.isTerminateState)
  });
  const queryClient = useQueryClient();
  const [config, setConfig] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [approvers, setApprovers] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState({});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const mobileView = Digit.Utils.browser.isMobile() ? true : false;
  const history = useHistory();
  useEffect(() => {
    var _approverData$Employe;
    setApprovers(approverData === null || approverData === void 0 ? void 0 : (_approverData$Employe = approverData.Employees) === null || _approverData$Employe === void 0 ? void 0 : _approverData$Employe.map(employee => {
      var _employee$user;
      return {
        uuid: employee === null || employee === void 0 ? void 0 : employee.uuid,
        name: employee === null || employee === void 0 ? void 0 : (_employee$user = employee.user) === null || _employee$user === void 0 ? void 0 : _employee$user.name
      };
    }));
  }, [approverData]);
  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage("NOC", file, Digit.ULBService.getStateId() || (tenantId === null || tenantId === void 0 ? void 0 : tenantId.split(".")[0]));
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  function submit(data) {
    var _applicationData, _applicationData$docu, _applicationData2;
    let enteredDocs = JSON.parse(sessionStorage.getItem("NewNOCDocs"));
    let newDocs = ((_applicationData = applicationData) === null || _applicationData === void 0 ? void 0 : (_applicationData$docu = _applicationData.documents) === null || _applicationData$docu === void 0 ? void 0 : _applicationData$docu.length) > 0 ? [...((_applicationData2 = applicationData) === null || _applicationData2 === void 0 ? void 0 : _applicationData2.documents)] : [];
    enteredDocs.map((d, index) => {
      newDocs.push(d);
    });
    applicationData = {
      ...applicationData,
      workflow: {
        action: action === null || action === void 0 ? void 0 : action.action,
        comment: data !== null && data !== void 0 && data.comments ? data === null || data === void 0 ? void 0 : data.comments : null,
        assignee: !(selectedApprover !== null && selectedApprover !== void 0 && selectedApprover.uuid) ? null : [selectedApprover === null || selectedApprover === void 0 ? void 0 : selectedApprover.uuid],
        documents: uploadedFile ? [{
          documentType: (action === null || action === void 0 ? void 0 : action.action) + " DOC",
          fileName: file === null || file === void 0 ? void 0 : file.name,
          fileStoreId: uploadedFile
        }] : null
      },
      documents: newDocs
    };
    submitAction({
      Noc: applicationData
    }, false, {
      isNoc: true
    });
  }
  useEffect(() => {
    if (action) {
      setConfig(configNOCApproverApplication({
        t,
        action,
        approvers,
        selectedApprover,
        setSelectedApprover,
        selectFile,
        uploadedFile,
        setUploadedFile,
        businessService,
        assigneeLabel: "WF_ASSIGNEE_NAME_LABEL",
        error
      }));
    }
  }, [action, approvers, uploadedFile, error]);
  return action && config.form ? /*#__PURE__*/React.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React.createElement(Heading$5, {
      label: t(config.label.heading)
    }),
    headerBarEnd: /*#__PURE__*/React.createElement(CloseBtn$5, {
      onClick: closeModal
    }),
    actionCancelLabel: t(config.label.cancel),
    actionCancelOnSubmit: closeModal,
    actionSaveLabel: t(config.label.submit),
    actionSaveOnSubmit: () => {},
    formId: "modal-action",
    isOBPSFlow: true,
    popupStyles: mobileView ? {
      width: "720px"
    } : {},
    style: !mobileView ? {
      height: "45px",
      width: "107px",
      paddingLeft: "0px",
      paddingRight: "0px"
    } : {
      height: "45px",
      width: "44%"
    },
    popupModuleMianStyles: mobileView ? {
      paddingLeft: "5px"
    } : {}
  }, PTALoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(FormComposer, {
    config: config.form,
    cardStyle: {
      marginLeft: "0px",
      marginRight: "0px",
      marginTop: "-25px"
    },
    className: "BPAemployeeCard",
    noBoxShadow: true,
    inline: true,
    childrenAtTheBottom: true,
    onSubmit: submit,
    defaultValues: defaultValues,
    formId: "modal-action"
  })) : /*#__PURE__*/React.createElement(Loader, null);
};

const ActionModal$6 = props => {
  if (props !== null && props !== void 0 && props.businessService.includes("PT")) {
    return /*#__PURE__*/React.createElement(ActionModal, props);
  }
  if (props !== null && props !== void 0 && props.businessService.includes("NewTL") || props !== null && props !== void 0 && props.businessService.includes("TL") || props !== null && props !== void 0 && props.businessService.includes("EDITRENEWAL") || props !== null && props !== void 0 && props.businessService.includes("DIRECTRENEWAL")) {
    return /*#__PURE__*/React.createElement(ActionModal$1, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPAREG")) {
    return /*#__PURE__*/React.createElement(ActionModal$2, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPA")) {
    return /*#__PURE__*/React.createElement(ActionModal$3, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("NOC")) {
    return /*#__PURE__*/React.createElement(ActionModal$5, props);
  }
  if (props !== null && props !== void 0 && props.moduleCode.includes("BPA_FORM11")) {
    return /*#__PURE__*/React.createElement(ActionModal$4, props);
  }
};

function DocumentsPreview({
  documents,
  svgStyles = {},
  isSendBackFlow = false,
  isHrLine = false,
  titleStyles
}) {
  const {
    t
  } = useTranslation();
  const isStakeholderApplication = window.location.href.includes("stakeholder");
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "19px"
    }
  }, !isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React.createElement(CardSubHeader, {
      style: titleStyles ? titleStyles : {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start"
      }
    }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
      var _value$documentType;
      return /*#__PURE__*/React.createElement("a", {
        target: "_",
        href: value === null || value === void 0 ? void 0 : value.url,
        style: {
          minWidth: "80px",
          marginRight: "10px",
          maxWidth: "100px",
          height: "auto",
          minWidth: "100px"
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PDFSvg, null)), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: "8px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#505A5F"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), isSendBackFlow ? value !== null && value !== void 0 && (_value$documentType = value.documentType) !== null && _value$documentType !== void 0 && _value$documentType.includes("NOC") ? /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType.split(".")[1])) : /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType)) : "");
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))), isHrLine && (documents === null || documents === void 0 ? void 0 : documents.length) != index + 1 ? /*#__PURE__*/React.createElement("hr", {
      style: {
        color: "#D6D5D4",
        backgroundColor: "#D6D5D4",
        height: "2px",
        marginTop: "20px",
        marginBottom: "20px"
      }
    }) : null);
  })), isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values2;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React.createElement("div", null, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values2 = document.values) === null || _document$values2 === void 0 ? void 0 : _document$values2.map((value, index) => /*#__PURE__*/React.createElement("a", {
      target: "_",
      href: value === null || value === void 0 ? void 0 : value.url,
      style: {
        minWidth: svgStyles !== null && svgStyles !== void 0 && svgStyles.minWidth ? svgStyles === null || svgStyles === void 0 ? void 0 : svgStyles.minWidth : "160px",
        marginRight: "20px"
      },
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: "940px",
        padding: "8px",
        borderRadius: "4px",
        border: "1px solid #D6D5D4",
        background: "#FAFAFA"
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: "8px",
        fontWeight: "bold",
        marginBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title)), value !== null && value !== void 0 && value.docInfo ? /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "12px",
        color: "#505A5F",
        fontWeight: 400,
        lineHeight: "15px",
        marginBottom: "10px"
      }
    }, `${t(value === null || value === void 0 ? void 0 : value.docInfo)}`) : null, /*#__PURE__*/React.createElement(PDFSvg, null), /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: "8px",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#505A5F",
        fontWeight: "400",
        textAlign: "center",
        color: "#505A5F"
      }
    }, `${t(value === null || value === void 0 ? void 0 : value.title)}`)))) : !window.location.href.includes("citizen") && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })));
}

const BPADocuments = ({
  t,
  formData,
  applicationData,
  docs,
  bpaActionsDetails
}) => {
  var _bpaActionsDetails$da, _formData$documents;
  const applicationStatus = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) || "";
  const actions = (bpaActionsDetails === null || bpaActionsDetails === void 0 ? void 0 : (_bpaActionsDetails$da = bpaActionsDetails.data) === null || _bpaActionsDetails$da === void 0 ? void 0 : _bpaActionsDetails$da.nextActions) || [];
  const stateId = Digit.ULBService.getStateId();
  const [documents, setDocuments] = useState((formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.documents) || []);
  const [error, setError] = useState(null);
  const [bpaTaxDocuments, setBpaTaxDocuments] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(true);
  const [checkRequiredFields, setCheckRequiredFields] = useState(false);
  const [checkEnablingDocs, setCheckEnablingDocs] = useState(false);
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
  useEffect(() => {
    var _bpaDocs$BPA, _filtredBpaDocs, _filtredBpaDocs$, _filtredBpaDocs$$docT;
    let filtredBpaDocs = [];
    if (bpaDocs !== null && bpaDocs !== void 0 && (_bpaDocs$BPA = bpaDocs.BPA) !== null && _bpaDocs$BPA !== void 0 && _bpaDocs$BPA.DocTypeMapping) {
      var _bpaDocs$BPA2, _bpaDocs$BPA2$DocType;
      filtredBpaDocs = bpaDocs === null || bpaDocs === void 0 ? void 0 : (_bpaDocs$BPA2 = bpaDocs.BPA) === null || _bpaDocs$BPA2 === void 0 ? void 0 : (_bpaDocs$BPA2$DocType = _bpaDocs$BPA2.DocTypeMapping) === null || _bpaDocs$BPA2$DocType === void 0 ? void 0 : _bpaDocs$BPA2$DocType.filter(data => {
        var _applicationData$addi, _applicationData$addi2;
        return data.WFState == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) ? applicationData === null || applicationData === void 0 ? void 0 : applicationData.status :  data.RiskType == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.riskType) && data.ServiceType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi = applicationData.additionalDetails) === null || _applicationData$addi === void 0 ? void 0 : _applicationData$addi.serviceType) && data.applicationType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi2 = applicationData.additionalDetails) === null || _applicationData$addi2 === void 0 ? void 0 : _applicationData$addi2.applicationType);
      });
    }
    let documentsList = [];
    (_filtredBpaDocs = filtredBpaDocs) === null || _filtredBpaDocs === void 0 ? void 0 : (_filtredBpaDocs$ = _filtredBpaDocs[0]) === null || _filtredBpaDocs$ === void 0 ? void 0 : (_filtredBpaDocs$$docT = _filtredBpaDocs$.docTypes) === null || _filtredBpaDocs$$docT === void 0 ? void 0 : _filtredBpaDocs$$docT.forEach(doc => {
      var _commonDocs$commonMa, _commonDocs$commonMa$, _docs$, _docs$$values;
      let code = doc.code;
      doc.dropdownData = [];
      doc.uploadedDocuments = [];
      commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : (_commonDocs$commonMa$ = _commonDocs$commonMa.DocumentType) === null || _commonDocs$commonMa$ === void 0 ? void 0 : _commonDocs$commonMa$.forEach(value => {
        let values = value.code.slice(0, code.length);
        if (code === values) {
          doc.hasDropdown = true;
          value.i18nKey = value.code;
          doc.dropdownData.push(value);
        }
      });
      doc.uploadedDocuments[0] = {};
      doc.uploadedDocuments[0].values = [];
      docs === null || docs === void 0 ? void 0 : (_docs$ = docs[0]) === null || _docs$ === void 0 ? void 0 : (_docs$$values = _docs$.values) === null || _docs$$values === void 0 ? void 0 : _docs$$values.map(upDocs => {
        if (code === (upDocs === null || upDocs === void 0 ? void 0 : upDocs.documentType)) {
          doc.uploadedDocuments[0].values.push(upDocs);
        }
      });
      documentsList.push(doc);
    });
    sessionStorage.setItem("BPA_DOCUMENTS", JSON.stringify(documentsList));
    setBpaTaxDocuments(documentsList);
  }, [!bpaDocsLoading, !commonDocsLoading]);
  useEffect(() => {
    let count = 0;
    bpaTaxDocuments.map(doc => {
      let isRequired = false;
      documents.map(data => {
        if (doc.required && doc.code == `${data.documentType.split('.')[0]}.${data.documentType.split('.')[1]}`) {
          isRequired = true;
        }
      });
      if (!isRequired && doc.required) {
        count = count + 1;
      }
    });
    if ((count == "0" || count == 0) && documents.length > 0) setEnableSubmit(false);else setEnableSubmit(true);
  }, [documents, checkRequiredFields]);
  useEffect(() => {
    if (applicationStatus === "DOC_VERIFICATION_INPROGRESS" && (actions === null || actions === void 0 ? void 0 : actions.length) > 0) setCheckEnablingDocs(true);else setCheckEnablingDocs(false);
  }, [applicationData, bpaActionsDetails]);
  return /*#__PURE__*/React.createElement("div", null, bpaTaxDocuments === null || bpaTaxDocuments === void 0 ? void 0 : bpaTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectDocument, {
      key: index,
      index: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setDocuments: setDocuments,
      documents: documents,
      setCheckRequiredFields: setCheckRequiredFields,
      applicationStatus: applicationStatus,
      actions: actions,
      bpaTaxDocuments: bpaTaxDocuments,
      checkEnablingDocs: checkEnablingDocs
    }));
  }));
};
function SelectDocument({
  t,
  document: doc,
  setDocuments,
  error,
  setError,
  documents,
  setCheckRequiredFields,
  index,
  applicationStatus,
  actions,
  bpaTaxDocuments,
  checkEnablingDocs
}) {
  var _doc$dropdownData, _doc$uploadedDocument;
  const filteredDocument = documents === null || documents === void 0 ? void 0 : documents.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0];
  const tenantId = Digit.ULBService.getStateId();
  const [selectedDocument, setSelectedDocument] = useState(filteredDocument ? {
    ...filteredDocument,
    active: true,
    code: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType,
    i18nKey: filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.documentType
  } : (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData = doc.dropdownData) === null || _doc$dropdownData === void 0 ? void 0 : _doc$dropdownData.length) === 1 ? doc === null || doc === void 0 ? void 0 : doc.dropdownData[0] : {});
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  const [selectArrayFiles, SetSelectArrayFiles] = useState([]);
  const handleSelectDocument = value => setSelectedDocument(value);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfiles(e) {
    e && setFile(e.file);
  }
  useEffect(() => {
    if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
      setDocuments(prev => {
        var _documents$find;
        const filteredDocumentsByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => (item === null || item === void 0 ? void 0 : item.documentType) !== (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code));
        if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) return filteredDocumentsByDocumentType;
        const filteredDocumentsByFileStoreId = filteredDocumentsByDocumentType === null || filteredDocumentsByDocumentType === void 0 ? void 0 : filteredDocumentsByDocumentType.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
        return [...filteredDocumentsByFileStoreId, {
          documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
          fileStoreId: uploadedFile,
          documentUid: uploadedFile,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || "",
          id: documents ? (_documents$find = documents.find(x => x.documentType === (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code))) === null || _documents$find === void 0 ? void 0 : _documents$find.id : undefined
        }];
      });
    }
  }, [uploadedFile, selectedDocument]);
  useEffect(() => {
    (async () => {
      if (selectArrayFiles.length > 0) {
        sessionStorage.removeItem("BPA_DOCUMENTS");
        doc.newUploadedDocs = [];
        selectArrayFiles.map(newDoc => {
          if (selectedDocument !== null && selectedDocument !== void 0 && selectedDocument.code) {
            var _newDoc$fileStoreId, _newDoc$fileStoreId2, _newDoc$fileStoreId3;
            doc.newUploadedDocs.push({
              documentType: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.code,
              fileStoreId: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId = newDoc.fileStoreId) === null || _newDoc$fileStoreId === void 0 ? void 0 : _newDoc$fileStoreId.fileStoreId,
              documentUid: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId2 = newDoc.fileStoreId) === null || _newDoc$fileStoreId2 === void 0 ? void 0 : _newDoc$fileStoreId2.fileStoreId,
              tenantId: newDoc === null || newDoc === void 0 ? void 0 : (_newDoc$fileStoreId3 = newDoc.fileStoreId) === null || _newDoc$fileStoreId3 === void 0 ? void 0 : _newDoc$fileStoreId3.tenantId
            });
          }
        });
        bpaTaxDocuments[index] = doc;
        sessionStorage.setItem("BPA_DOCUMENTS", JSON.stringify(bpaTaxDocuments));
      }
    })();
  }, [selectArrayFiles, selectedDocument]);
  useEffect(() => {
  }, [file]);
  const getData = (index, state) => {
    let data = Object.fromEntries(state);
    let newArr = Object.values(data);
    if (Object.keys(data).length !== 0) SetSelectArrayFiles(newArr);
    selectfiles(newArr[newArr.length - 1]);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "24px",
      maxWidth: "950px",
      minWidth: "280px",
      background: "#FAFAFA",
      borderRadius: "4px",
      border: "1px solid #D6D5D4",
      padding: "8px"
    }
  }, /*#__PURE__*/React.createElement(CardSubHeader, {
    style: {
      marginBottom: "8px",
      paddingBottom: "9px",
      color: "#0B0C0C",
      fontSize: "16px",
      lineHeight: "19px"
    }
  }, `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), (doc === null || doc === void 0 ? void 0 : (_doc$uploadedDocument = doc.uploadedDocuments) === null || _doc$uploadedDocument === void 0 ? void 0 : _doc$uploadedDocument.length) && /*#__PURE__*/React.createElement(DocumentsPreview, {
    documents: doc === null || doc === void 0 ? void 0 : doc.uploadedDocuments,
    svgStyles: {
      width: "100px",
      height: "100px",
      viewBox: "0 0 25 25",
      minWidth: "100px"
    }
  }), checkEnablingDocs ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "20px"
    }
  }, "]]      ", /*#__PURE__*/React.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(CardLabel, {
    style: {
      marginTop: "-10px",
      width: "100%"
    }
  }, doc !== null && doc !== void 0 && doc.required ? `${t(doc === null || doc === void 0 ? void 0 : doc.code)}* ` : `${t(doc === null || doc === void 0 ? void 0 : doc.code)}`), /*#__PURE__*/React.createElement(Dropdown, {
    className: "form-field",
    t: t,
    isMandatory: false,
    option: doc === null || doc === void 0 ? void 0 : doc.dropdownData,
    selected: selectedDocument,
    optionKey: "i18nKey",
    select: handleSelectDocument,
    style: {
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement(LabelFieldPair, {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(CardLabel, {
    className: "card-label-smaller",
    style: {
      width: "100%"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(MultiUploadWrapper, {
    module: "BPA",
    tenantId: tenantId,
    getFormState: e => getData(index, e),
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  })))) : null);
}

const getDocuments = fiDocuments => {
  const returnDocuments = [{
    title: "BPA_DOCUMENT_DETAILS_LABEL",
    values: fiDocuments === null || fiDocuments === void 0 ? void 0 : fiDocuments.map(doc => {
      var _doc$documentType;
      return {
        title: doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replaceAll('.', '_'),
        documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
        documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
        fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
        id: doc === null || doc === void 0 ? void 0 : doc.id,
        url: doc === null || doc === void 0 ? void 0 : doc.url
      };
    })
  }];
  return returnDocuments;
};
function InspectionReport({
  fiReport,
  isCitizen = false
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, isCitizen ? /*#__PURE__*/React.createElement(CardHeader, {
    style: {
      fontSize: "24px"
    }
  }, `${t(`BPA_FI_REPORT`)}`) : /*#__PURE__*/React.createElement(CardSectionHeader, {
    style: {
      fontSize: "24px"
    }
  }, `${t(`BPA_FI_REPORT`)}`), fiReport.map((fiData, index) => {
    var _fiData$date, _fiData$date2, _fiData$date3, _fiData$questions, _fiData$questions2;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "950px",
        minWidth: "280px",
        marginBottom: "24px"
      }
    }, /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement(CardSectionHeader, {
      style: {
        fontSize: "20px"
      }
    }, (fiReport === null || fiReport === void 0 ? void 0 : fiReport.length) == 1 ? `${t(`BPA_FI_REPORT`)}` : `${t(`BPA_FI_REPORT`)} - ${index + 1}`), /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_FI_DATE_LABEL`)}`,
      text: fiData !== null && fiData !== void 0 && fiData.date ? fiData.date.includes("-") ? `${(_fiData$date = fiData.date) === null || _fiData$date === void 0 ? void 0 : _fiData$date.split("-")[2]}/${(_fiData$date2 = fiData.date) === null || _fiData$date2 === void 0 ? void 0 : _fiData$date2.split("-")[1]}/${(_fiData$date3 = fiData.date) === null || _fiData$date3 === void 0 ? void 0 : _fiData$date3.split("-")[0]}` : fiData === null || fiData === void 0 ? void 0 : fiData.date : "NA"
    }), /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_FI_TIME_LABEL`)}`,
      text: fiData !== null && fiData !== void 0 && fiData.time ? fiData === null || fiData === void 0 ? void 0 : fiData.time : "NA"
    }), (fiData === null || fiData === void 0 ? void 0 : (_fiData$questions = fiData.questions) === null || _fiData$questions === void 0 ? void 0 : _fiData$questions.length) && (fiData === null || fiData === void 0 ? void 0 : (_fiData$questions2 = fiData.questions) === null || _fiData$questions2 === void 0 ? void 0 : _fiData$questions2.map(qstn => /*#__PURE__*/React.createElement("div", {
      style: {
        background: "white",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        marginTop: "10px"
      }
    }, /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      label: `${t(`${qstn.question}`)}`,
      text: qstn !== null && qstn !== void 0 && qstn.value ? qstn === null || qstn === void 0 ? void 0 : qstn.value : "NA"
    }), /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      label: `${t(`BPA_ENTER_REMARKS`)}`,
      text: qstn.remarks ? qstn.remarks : "NA"
    })))), /*#__PURE__*/React.createElement(DocumentsPreview, {
      documents: getDocuments(fiData === null || fiData === void 0 ? void 0 : fiData.docs),
      svgStyles: {
        width: "100px",
        height: "100px",
        viewBox: "0 0 25 25",
        minWidth: "100px"
      }
    })));
  })));
}

function SelectDocument$1({
  t,
  document: doc,
  setNocDocuments,
  setError,
  nocDocuments
}) {
  const filteredDocument = nocDocuments === null || nocDocuments === void 0 ? void 0 : nocDocuments.filter(item => {
    var _item$documentType;
    return item === null || item === void 0 ? void 0 : (_item$documentType = item.documentType) === null || _item$documentType === void 0 ? void 0 : _item$documentType.includes(doc === null || doc === void 0 ? void 0 : doc.code);
  })[0];
  const tenantId = Digit.ULBService.getStateId();
  const [selectedDocument, setSelectedDocument] = useState();
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(() => (filteredDocument === null || filteredDocument === void 0 ? void 0 : filteredDocument.fileStoreId) || null);
  const allowedFileTypes = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
  function selectfile(e) {
    e && setFile(e.file);
  }
  useEffect(() => {
    var _doc$dropdownData, _doc$dropdownData$;
    if (doc !== null && doc !== void 0 && (_doc$dropdownData = doc.dropdownData) !== null && _doc$dropdownData !== void 0 && (_doc$dropdownData$ = _doc$dropdownData[0]) !== null && _doc$dropdownData$ !== void 0 && _doc$dropdownData$.code) {
      setNocDocuments(prev => {
        var _doc$dropdownData3;
        const filteredDocumentsByDocumentType = prev === null || prev === void 0 ? void 0 : prev.filter(item => {
          var _doc$dropdownData2, _doc$dropdownData2$;
          return (item === null || item === void 0 ? void 0 : item.documentType) !== (doc === null || doc === void 0 ? void 0 : (_doc$dropdownData2 = doc.dropdownData) === null || _doc$dropdownData2 === void 0 ? void 0 : (_doc$dropdownData2$ = _doc$dropdownData2[0]) === null || _doc$dropdownData2$ === void 0 ? void 0 : _doc$dropdownData2$.code);
        });
        if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) === 0 || uploadedFile === null) {
          return filteredDocumentsByDocumentType;
        }
        const filteredDocumentsByFileStoreId = filteredDocumentsByDocumentType === null || filteredDocumentsByDocumentType === void 0 ? void 0 : filteredDocumentsByDocumentType.filter(item => (item === null || item === void 0 ? void 0 : item.fileStoreId) !== uploadedFile);
        return [...filteredDocumentsByFileStoreId, {
          documentType: doc === null || doc === void 0 ? void 0 : (_doc$dropdownData3 = doc.dropdownData) === null || _doc$dropdownData3 === void 0 ? void 0 : _doc$dropdownData3[0].code,
          fileStoreId: uploadedFile,
          documentUid: uploadedFile,
          fileName: (file === null || file === void 0 ? void 0 : file.name) || ""
        }];
      });
    }
  }, [uploadedFile]);
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file !== null && file !== void 0 && file.type && !allowedFileTypesRegex.test(file === null || file === void 0 ? void 0 : file.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            var _response$data, _response$data$files;
            setUploadedFile(null);
            const response = await Digit.UploadServices.Filestorage("PT", file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              setUploadedFile(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  const getData = state => {
    let data = Object.fromEntries(state);
    let newArr = Object.values(data);
    selectfile(newArr[newArr.length - 1]);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {}
  }, /*#__PURE__*/React.createElement(LabelFieldPair, {
    style: {
      width: "98%",
      marginRight: "10px"
    }
  }, /*#__PURE__*/React.createElement(CardLabel, {
    style: {
      width: "100%"
    }
  }, doc !== null && doc !== void 0 && doc.required ? `${t("TL_BUTTON_UPLOAD FILE")}*` : `${t("TL_BUTTON_UPLOAD FILE")}`), /*#__PURE__*/React.createElement("div", {
    className: "field",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(MultiUploadWrapper, {
    module: "NOC",
    tenantId: tenantId,
    getFormState: e => getData(e),
    t: t,
    allowedFileTypesRegex: allowedFileTypes,
    allowedMaxSizeInMB: 5,
    acceptFiles: "image/*, .pdf, .png, .jpeg, .jpg"
  }))));
}
const NOCDocuments = ({
  t,
  noc,
  docs,
  isNoc,
  applicationData,
  NOCdata,
  bpaActionsDetails
}) => {
  var _bpaActionsDetails$da;
  const tenantId = Digit.ULBService.getStateId();
  const stateId = Digit.ULBService.getStateId();
  const bpaApplicationStatus = (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) || "";
  const actions = (bpaActionsDetails === null || bpaActionsDetails === void 0 ? void 0 : (_bpaActionsDetails$da = bpaActionsDetails.data) === null || _bpaActionsDetails$da === void 0 ? void 0 : _bpaActionsDetails$da.nextActions) || [];
  const {
    isLoading: nocDocsLoading,
    data: nocDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "NOC", ["DocumentTypeMapping"], {
    enabled: isNoc
  });
  const {
    isLoading: bpaDocsLoading,
    data: bpaDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"], {
    enabled: !isNoc
  });
  const {
    isLoading: commonDocsLoading,
    data: commonDocs
  } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
  const [commonDocMaping, setCommonDocMaping] = useState([]);
  const [nocTaxDocuments, setNocTaxDocuments] = useState([]);
  const [checkEnablingDocs, setCheckEnablingDocs] = useState(false);
  const [nocDocuments, setNocDocuments] = Digit.Hooks.useSessionStorage(noc === null || noc === void 0 ? void 0 : noc.nocType, []);
  const [error, setError] = useState(null);
  const isEmployee = window.location.href.includes("/employee/");
  useEffect(() => {
    var _commonDocs$commonMa;
    setCommonDocMaping(commonDocs === null || commonDocs === void 0 ? void 0 : (_commonDocs$commonMa = commonDocs["common-masters"]) === null || _commonDocs$commonMa === void 0 ? void 0 : _commonDocs$commonMa.DocumentType);
  }, [commonDocs]);
  useEffect(() => {
    var _filteredData, _filteredData$, _filteredData$$docTyp;
    let documents = [];
    let filteredData;
    if (isNoc) {
      var _nocDocs$NOC, _nocDocs$NOC$Document;
      filteredData = nocDocs === null || nocDocs === void 0 ? void 0 : (_nocDocs$NOC = nocDocs.NOC) === null || _nocDocs$NOC === void 0 ? void 0 : (_nocDocs$NOC$Document = _nocDocs$NOC.DocumentTypeMapping) === null || _nocDocs$NOC$Document === void 0 ? void 0 : _nocDocs$NOC$Document.filter(data => {
        return (data === null || data === void 0 ? void 0 : data.applicationType) === (noc === null || noc === void 0 ? void 0 : noc.applicationType) && (data === null || data === void 0 ? void 0 : data.nocType) === (noc === null || noc === void 0 ? void 0 : noc.nocType);
      });
    } else {
      var _bpaDocs$BPA, _bpaDocs$BPA$DocTypeM;
      filteredData = bpaDocs === null || bpaDocs === void 0 ? void 0 : (_bpaDocs$BPA = bpaDocs.BPA) === null || _bpaDocs$BPA === void 0 ? void 0 : (_bpaDocs$BPA$DocTypeM = _bpaDocs$BPA.DocTypeMapping) === null || _bpaDocs$BPA$DocTypeM === void 0 ? void 0 : _bpaDocs$BPA$DocTypeM.filter(data => {
        var _applicationData$addi, _applicationData$addi2;
        return data.WFState == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status) && data.RiskType == (applicationData === null || applicationData === void 0 ? void 0 : applicationData.riskType) && data.ServiceType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi = applicationData.additionalDetails) === null || _applicationData$addi === void 0 ? void 0 : _applicationData$addi.serviceType) && data.applicationType == (applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$addi2 = applicationData.additionalDetails) === null || _applicationData$addi2 === void 0 ? void 0 : _applicationData$addi2.applicationType);
      });
    }
    if ((_filteredData = filteredData) !== null && _filteredData !== void 0 && (_filteredData$ = _filteredData[0]) !== null && _filteredData$ !== void 0 && (_filteredData$$docTyp = _filteredData$.docTypes) !== null && _filteredData$$docTyp !== void 0 && _filteredData$$docTyp[0]) {
      filteredData[0].docTypes[0].nocType = filteredData[0].nocType;
      filteredData[0].docTypes[0].additionalDetails = {
        submissionDetails: noc === null || noc === void 0 ? void 0 : noc.additionalDetails,
        applicationStatus: noc === null || noc === void 0 ? void 0 : noc.applicationStatus,
        appNumberLink: noc === null || noc === void 0 ? void 0 : noc.applicationNo,
        nocNo: noc === null || noc === void 0 ? void 0 : noc.nocNo
      };
      documents.push(filteredData[0].docTypes[0]);
    }
    let documentsList = [];
    if (documents && documents.length > 0) {
      documents.map(doc => {
        let code = doc.documentType;
        doc.dropdownData = [];
        commonDocMaping === null || commonDocMaping === void 0 ? void 0 : commonDocMaping.forEach(value => {
          let values = value.code.slice(0, code === null || code === void 0 ? void 0 : code.length);
          if (code === values) {
            doc.hasDropdown = true;
            doc.dropdownData.push(value);
          }
        });
        documentsList.push(doc);
      });
      setNocTaxDocuments(documentsList);
    }
  }, [nocDocs, commonDocMaping]);
  useEffect(() => {
    if (bpaApplicationStatus === 'NOC_VERIFICATION_INPROGRESS' && (actions === null || actions === void 0 ? void 0 : actions.length) > 0) setCheckEnablingDocs(true);else setCheckEnablingDocs(false);
  }, [applicationData, bpaActionsDetails]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      border: "1px solid #D6D5D4",
      padding: "16px 0px 16px 8px",
      background: "#FAFAFA",
      borderRadius: "5px",
      marginBottom: "24px",
      maxWidth: "950px"
    }
  }, /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement(Row, {
    label: isEmployee ? `${t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`)}` : t(`BPA_${noc === null || noc === void 0 ? void 0 : noc.nocType}_HEADER`),
    labelStyle: {
      fontSize: "20px",
      width: "150%"
    }
  }), NOCdata && NOCdata.map((noc, index) => {
    if (noc !== null && noc !== void 0 && noc.value) {
      if ((noc === null || noc === void 0 ? void 0 : noc.field) == "STATUS") {
        return /*#__PURE__*/React.createElement(Row, {
          className: "border-none",
          label: isEmployee ? `${t(noc === null || noc === void 0 ? void 0 : noc.title)}` : t(noc === null || noc === void 0 ? void 0 : noc.title),
          text: noc !== null && noc !== void 0 && noc.value ? t(noc === null || noc === void 0 ? void 0 : noc.value) : t("CS_NA"),
          textStyle: (noc === null || noc === void 0 ? void 0 : noc.value) == "APPROVED" || (noc === null || noc === void 0 ? void 0 : noc.value) == "AUTO_APPROVED" ? {
            color: "#00703C"
          } : {
            color: "#D4351C"
          }
        });
      } else {
        return /*#__PURE__*/React.createElement(Row, {
          className: "border-none",
          label: isEmployee ? `${t(noc === null || noc === void 0 ? void 0 : noc.title)}` : t(noc === null || noc === void 0 ? void 0 : noc.title),
          text: noc !== null && noc !== void 0 && noc.value ? t(noc === null || noc === void 0 ? void 0 : noc.value) : t("CS_NA")
        });
      }
    }
  })), /*#__PURE__*/React.createElement(DocumentsPreview, {
    documents: docs,
    svgStyles: {
      width: "80px",
      height: "100px",
      viewBox: "0 0 25 25",
      minWidth: "80px"
    }
  }), checkEnablingDocs && (nocTaxDocuments === null || nocTaxDocuments === void 0 ? void 0 : nocTaxDocuments.map((document, index) => {
    return /*#__PURE__*/React.createElement(SelectDocument$1, {
      key: index,
      document: document,
      t: t,
      error: error,
      setError: setError,
      setNocDocuments: setNocDocuments,
      nocDocuments: nocDocuments,
      checkEnablingDocs: checkEnablingDocs
    });
  })));
};

const PermissionCheck = ({
  permissions,
  t
}) => {
  const [approvalChecks, setApprovalChecks, clearApprovals] = Digit.Hooks.useSessionStorage("OBPS_APPROVAL_CHECKS", permissions === null || permissions === void 0 ? void 0 : permissions.map(permission => ({
    label: permission,
    checked: false
  })));
  const [newApprovals, setNewApprovals, clearNewApprovals] = Digit.Hooks.useSessionStorage('OBPS_NEW_APPROVALS', []);
  useEffect(() => {
    return () => {
      Digit.SessionStorage.del("OBPS_NEW_APPROVALS");
      Digit.SessionStorage.del("OBPS_APPROVAL_CHECKS");
    };
  }, []);
  const handleAdd = () => {
    setNewApprovals([...newApprovals, {
      label: ''
    }]);
  };
  const handleRemove = index => {
    const values = [...newApprovals];
    values.splice(index, 1);
    setNewApprovals([...values]);
  };
  const handleChange = (event, index) => {
    setNewApprovals(() => {
      return newApprovals === null || newApprovals === void 0 ? void 0 : newApprovals.map((approval, id) => {
        if (index === id) {
          var _event$target;
          return {
            label: event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value
          };
        }
        return approval;
      });
    });
  };
  const handleCheck = (event, label, index) => {
    const isChecked = event.target.checked;
    setApprovalChecks(() => {
      return approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.map((approval, id) => {
        if (index === id) {
          return {
            ...approval,
            checked: isChecked
          };
        }
        return approval;
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CardSubHeader, {
    style: {
      marginBottom: "16px",
      fontSize: "24px"
    }
  }, t("BPA_PERMIT_CONDITIONS")), approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.map((permission, index) => /*#__PURE__*/React.createElement(CheckBox, {
    key: index,
    styles: {
      margin: "20px 0 40px",
      maxWidth: "70%"
    },
    label: permission === null || permission === void 0 ? void 0 : permission.label,
    checked: permission === null || permission === void 0 ? void 0 : permission.checked,
    onChange: event => handleCheck(event, permission === null || permission === void 0 ? void 0 : permission.label, index),
    isLabelFirst: true,
    index: index
  })), newApprovals === null || newApprovals === void 0 ? void 0 : newApprovals.map((approval, index) => /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement(TextInput, {
    key: index,
    value: approval === null || approval === void 0 ? void 0 : approval.label,
    onChange: event => handleChange(event, index),
    textInputStyle: {
      maxWidth: "830px",
      width: "830px"
    },
    placeholder: "Enter permit conditions.........."
  }), /*#__PURE__*/React.createElement(LinkButton, {
    label: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Close$7, {
      style: {
        float: "right",
        position: "relative",
        bottom: "32px",
        marginTop: "-21px",
        marginRight: "35%"
      }
    }))),
    style: {},
    onClick: e => handleRemove(index)
  }))), /*#__PURE__*/React.createElement(LinkButton, {
    style: {
      color: "#1F4A7C",
      maxWidth: "10%",
      marginRight: "3%"
    },
    label: t(`BPA_ADD_MORE`),
    onClick: handleAdd
  }));
};

function PropertyDocuments({
  documents,
  svgStyles = {},
  isSendBackFlow = false
}) {
  const {
    t
  } = useTranslation();
  const [filesArray, setFilesArray] = useState(() => []);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [pdfFiles, setPdfFiles] = useState({});
  useEffect(() => {
    var _acc;
    let acc = [];
    documents === null || documents === void 0 ? void 0 : documents.forEach((element, index, array) => {
      acc = [...acc, ...(element.values ? element.values : [])];
    });
    setFilesArray((_acc = acc) === null || _acc === void 0 ? void 0 : _acc.map(value => value === null || value === void 0 ? void 0 : value.fileStoreId));
  }, [documents]);
  useEffect(() => {
    if (filesArray !== null && filesArray !== void 0 && filesArray.length) {
      Digit.UploadServices.Filefetch(filesArray, Digit.ULBService.getStateId()).then(res => {
        setPdfFiles(res === null || res === void 0 ? void 0 : res.data);
      });
    }
  }, [filesArray]);
  const checkLocation = window.location.href.includes("employee/tl") || window.location.href.includes("/obps");
  const isStakeholderApplication = window.location.href.includes("stakeholder");
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "19px"
    }
  }, !isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React.createElement(CardSubHeader, {
      style: checkLocation ? {
        marginTop: "32px",
        marginBottom: "18px",
        color: "#0B0C0C, 100%",
        fontSize: "24px",
        lineHeight: "30px"
      } : {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start"
      }
    }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
      var _pdfFiles$value$fileS, _value$documentType;
      return /*#__PURE__*/React.createElement("a", {
        target: "_",
        href: (_pdfFiles$value$fileS = pdfFiles[value.fileStoreId]) === null || _pdfFiles$value$fileS === void 0 ? void 0 : _pdfFiles$value$fileS.split(",")[0],
        style: {
          minWidth: "80px",
          marginRight: "10px",
          maxWidth: "100px",
          height: "auto"
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PDFSvg, null)), /*#__PURE__*/React.createElement("p", {
        style: checkLocation ? {
          marginTop: "8px",
          fontWeight: "bold",
          fontSize: "16px",
          lineHeight: "19px",
          color: "#505A5F",
          textAlign: "center"
        } : {
          marginTop: "8px",
          fontWeight: "bold"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), isSendBackFlow ? value !== null && value !== void 0 && (_value$documentType = value.documentType) !== null && _value$documentType !== void 0 && _value$documentType.includes("NOC") ? /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType.split(".")[1])) : /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: "center"
        }
      }, t(value === null || value === void 0 ? void 0 : value.documentType)) : "");
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })), isStakeholderApplication && (documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
    var _document$values2;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, document !== null && document !== void 0 && document.title ? /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        marginTop: "32px",
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(document === null || document === void 0 ? void 0 : document.title)) : null, /*#__PURE__*/React.createElement("div", null, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values2 = document.values) === null || _document$values2 === void 0 ? void 0 : _document$values2.map((value, index) => {
      var _pdfFiles$value$fileS2;
      return /*#__PURE__*/React.createElement("a", {
        target: "_",
        href: (_pdfFiles$value$fileS2 = pdfFiles[value.fileStoreId]) === null || _pdfFiles$value$fileS2 === void 0 ? void 0 : _pdfFiles$value$fileS2.split(",")[0],
        style: {
          minWidth: svgStyles !== null && svgStyles !== void 0 && svgStyles.minWidth ? svgStyles === null || svgStyles === void 0 ? void 0 : svgStyles.minWidth : "160px",
          marginRight: "20px"
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: "940px",
          padding: "8px",
          borderRadius: "4px",
          border: "1px solid #D6D5D4",
          background: "#FAFAFA"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: "8px",
          fontWeight: "bold",
          marginBottom: "10px"
        }
      }, t(value === null || value === void 0 ? void 0 : value.title)), value !== null && value !== void 0 && value.docInfo ? /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "12px",
          color: "#505A5F",
          fontWeight: 400,
          lineHeight: "15px",
          marginBottom: "10px"
        }
      }, `${t(value === null || value === void 0 ? void 0 : value.docInfo)}`) : null, /*#__PURE__*/React.createElement(PDFSvg, null), /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: "8px",
          fontSize: "16px",
          lineHeight: "19px",
          color: "#505A5F",
          fontWeight: "400"
        }
      }, `${t(value === null || value === void 0 ? void 0 : value.title)}`)));
    }) : !window.location.href.includes("citizen") && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL")))));
  })));
}

function PropertyEstimates({
  taxHeadEstimatesCalculation
}) {
  const {
    taxHeadEstimates
  } = taxHeadEstimatesCalculation;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "40px"
    }
  }, /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement(Row, {
    label: t("ES_PT_TITLE_TAX_HEADS"),
    text: t("ES_PT_TITLE_AMOUNT"),
    className: "border-none",
    textStyle: {
      fontWeight: "bold"
    }
  }), /*#__PURE__*/React.createElement(BreakLine, {
    style: {
      margin: "16px 0",
      width: "40%"
    }
  }), taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : taxHeadEstimates.map((estimate, index) => {
    return /*#__PURE__*/React.createElement(Row, {
      key: t(estimate.taxHeadCode),
      label: t(estimate.taxHeadCode),
      text: `₹ ${estimate.estimateAmount}` || "N/A",
      last: index === (taxHeadEstimates === null || taxHeadEstimates === void 0 ? void 0 : taxHeadEstimates.length) - 1,
      className: "border-none",
      textStyle: {
        color: "#505A5F"
      },
      labelStyle: {
        color: "#505A5F"
      }
    });
  }), /*#__PURE__*/React.createElement(BreakLine, {
    style: {
      margin: "16px 0",
      width: "40%"
    }
  }), /*#__PURE__*/React.createElement(Row, {
    label: t("ES_PT_TITLE_TOTAL_DUE_AMOUNT"),
    text: `₹ ${taxHeadEstimatesCalculation === null || taxHeadEstimatesCalculation === void 0 ? void 0 : taxHeadEstimatesCalculation.totalAmount}` || "N/A",
    className: "border-none",
    textStyle: {
      fontSize: "24px",
      fontWeight: "bold"
    }
  })));
}

function PropertyFloors({
  floors
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, floors.map(floor => {
    var _floor$values;
    return /*#__PURE__*/React.createElement("div", {
      key: t(floor === null || floor === void 0 ? void 0 : floor.title),
      style: {
        marginTop: "19px"
      }
    }, /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    }, t(floor === null || floor === void 0 ? void 0 : floor.title)), floor === null || floor === void 0 ? void 0 : (_floor$values = floor.values) === null || _floor$values === void 0 ? void 0 : _floor$values.map((value, index) => {
      var _value$values;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(CardSectionHeader, {
        style: {
          marginBottom: "16px",
          color: "#505A5F",
          fontSize: "16px",
          marginTop: index !== 0 ? "16px" : "revert"
        }
      }, t(value.title)), /*#__PURE__*/React.createElement(StatusTable, {
        style: {
          position: "relative",
          padding: "8px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          border: "1px solid #D6D5D4",
          padding: "16px",
          marginTop: "8px",
          borderRadius: "4px",
          background: "#FAFAFA",
          maxWidth: "100%"
        }
      }, value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.map((value, index) => {
        var _value$values2;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: t(value.value) || "N/A",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values2 = value.values) === null || _value$values2 === void 0 ? void 0 : _value$values2.length) - 1,
          caption: value.caption,
          className: "border-none"
        });
      }))));
    }));
  }));
}

function PropertyOwners({
  owners
}) {
  const {
    t
  } = useTranslation();
  const checkOwnerLength = (owners === null || owners === void 0 ? void 0 : owners.length) || 1;
  let cardStyles = {
    marginTop: "19px"
  };
  let statusTableStyles = {
    position: "relative",
    padding: "8px"
  };
  let rowContainerStyle = {
    justifyContent: "space-between",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#0B0C0C"
  };
  if ( Number(checkOwnerLength) > 1) {
    cardStyles = {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "600px",
      minWidth: "280px"
    };
  } else if ( !(Number(checkOwnerLength) > 1)) {
    cardStyles = {
      marginTop: "19px",
      lineHeight: "19px",
      maxWidth: "600px",
      minWidth: "280px"
    };
    statusTableStyles = {
      position: "relative",
      marginTop: "19px"
    };
  }
  if (window.location.href.includes("obps")) {
    cardStyles = {
      ...cardStyles,
      maxWidth: "950px"
    };
    cardStyles = {
      ...cardStyles,
      maxWidth: "950px"
    };
    rowContainerStyle = {};
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, owners.map((owner, index) => {
    var _owner$values;
    return /*#__PURE__*/React.createElement("div", {
      key: t(owner === null || owner === void 0 ? void 0 : owner.title),
      style: cardStyles
    }, /*#__PURE__*/React.createElement(CardSubHeader, {
      style:  Number(checkOwnerLength) > 1 ? {
        marginBottom: "8px",
        paddingBottom: "9px",
        color: "#0B0C0C",
        fontSize: "16px",
        lineHeight: "19px"
      } : {
        marginBottom: "8px",
        color: "#505A5F",
        fontSize: "24px"
      }
    },  Number(checkOwnerLength) > 1 ? `${t(owner === null || owner === void 0 ? void 0 : owner.title)} ${index + 1}` : t(owner === null || owner === void 0 ? void 0 : owner.title)), /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(StatusTable, {
      style: statusTableStyles
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        maxWidth: "640px",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: "auto"
      }
    }), owner === null || owner === void 0 ? void 0 : (_owner$values = owner.values) === null || _owner$values === void 0 ? void 0 : _owner$values.map((value, index) => {
      var _value$values;
      if (value.map === true && value.value !== "N/A") {
        return /*#__PURE__*/React.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: /*#__PURE__*/React.createElement("img", {
            src: t(value.value),
            alt: ""
          })
        });
      }
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Row, {
        key: t(value.title),
        label:  `${t(value.title)}`,
        text: t(value.value) || "N/A",
        last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
        caption: value.caption,
        className: "border-none",
        textStyle: value.textStyle,
        rowContainerStyle: rowContainerStyle
      }));
    }))));
  }));
}

const ScruntinyDetails = ({
  scrutinyDetails,
  paymentsList: _paymentsList = []
}) => {
  var _scrutinyDetails$valu, _scrutinyDetails$perm, _scrutinyDetails$scru;
  const {
    t
  } = useTranslation();
  const getTextValues = data => {
    if (data !== null && data !== void 0 && data.value && data !== null && data !== void 0 && data.isTransLate) return /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#00703C"
      }
    }, t(data === null || data === void 0 ? void 0 : data.value));else if (data !== null && data !== void 0 && data.value && data !== null && data !== void 0 && data.isTransLate) return t(data === null || data === void 0 ? void 0 : data.value);else if (data !== null && data !== void 0 && data.value) return data === null || data === void 0 ? void 0 : data.value;else t("NA");
  };
  return /*#__PURE__*/React.createElement(Fragment$1, null, !(scrutinyDetails !== null && scrutinyDetails !== void 0 && scrutinyDetails.isChecklist) && /*#__PURE__*/React.createElement("div", {
    style: {
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      padding: "8px",
      borderRadius: "4px",
      maxWidth: "950px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement("div", null, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$valu = scrutinyDetails.values) === null || _scrutinyDetails$valu === void 0 ? void 0 : _scrutinyDetails$valu.map((value, index) => {
    if (value !== null && value !== void 0 && value.isUnit) return /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      textStyle: (value === null || value === void 0 ? void 0 : value.value) === "Paid" ? {
        color: "darkgreen"
      } : (value === null || value === void 0 ? void 0 : value.value) === "Unpaid" ? {
        color: "red"
      } : {},
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: value !== null && value !== void 0 && value.value ? `${getTextValues(value)} ${t(value === null || value === void 0 ? void 0 : value.isUnit)}` : t("NA"),
      labelStyle: value !== null && value !== void 0 && value.isHeader ? {
        fontSize: "20px"
      } : {}
    });else if (value !== null && value !== void 0 && value.isHeader && !(value !== null && value !== void 0 && value.isUnit)) return /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else if (value !== null && value !== void 0 && value.isSubTitle && !(value !== null && value !== void 0 && value.isUnit)) return /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px",
        margin: "0px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else return /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      textStyle: (value === null || value === void 0 ? void 0 : value.value) === "Paid" ? {
        color: "darkgreen"
      } : (value === null || value === void 0 ? void 0 : value.value) === "Unpaid" ? {
        color: "red"
      } : {},
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: getTextValues(value),
      labelStyle: value !== null && value !== void 0 && value.isHeader ? {
        fontSize: "20px"
      } : {}
    });
  }), scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$perm = scrutinyDetails.permit) === null || _scrutinyDetails$perm === void 0 ? void 0 : _scrutinyDetails$perm.map((value, ind) => {
    return /*#__PURE__*/React.createElement(CardLabel, {
      style: {
        fontWeight: "400"
      }
    }, value === null || value === void 0 ? void 0 : value.title);
  })), /*#__PURE__*/React.createElement("div", null, scrutinyDetails === null || scrutinyDetails === void 0 ? void 0 : (_scrutinyDetails$scru = scrutinyDetails.scruntinyDetails) === null || _scrutinyDetails$scru === void 0 ? void 0 : _scrutinyDetails$scru.map((report, index) => {
    return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      label: `${t(report === null || report === void 0 ? void 0 : report.title)}`,
      labelStyle: {
        width: "150%"
      }
    }), report !== null && report !== void 0 && report.value ? /*#__PURE__*/React.createElement("a", {
      href: report === null || report === void 0 ? void 0 : report.value,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement(PDFSvg, null)) : /*#__PURE__*/React.createElement("span", null, t("NA")), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: "8px 0px",
        fontWeight: "bold",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#505A5F"
      }
    }, t(report === null || report === void 0 ? void 0 : report.text)));
  })))));
};

const SubOccupancyTable = ({
  edcrDetails,
  applicationData
}) => {
  var _edcrDetails$values, _edcrDetails$subOccup, _edcrDetails$subOccup2, _edcrDetails$subOccup3, _edcrDetails$subOccup4;
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  const stringReplaceAll = (str = "", searcher = "", replaceWith = "") => {
    if (searcher == "") return str;
    while (str.includes(searcher)) {
      str = str.replace(searcher, replaceWith);
    }
    return str;
  };
  function getSubOccupancyValues(index) {
    var _applicationData$land;
    let values = applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$land = applicationData.landInfo) === null || _applicationData$land === void 0 ? void 0 : _applicationData$land.unit;
    let returnValue = "";
    if ((values === null || values === void 0 ? void 0 : values.length) > 0) {
      var _values$index, _values$index$usageCa;
      let splitArray = (_values$index = values[index]) === null || _values$index === void 0 ? void 0 : (_values$index$usageCa = _values$index.usageCategory) === null || _values$index$usageCa === void 0 ? void 0 : _values$index$usageCa.split(',');
      if (splitArray !== null && splitArray !== void 0 && splitArray.length) {
        const returnValueArray = splitArray.map(data => data ? `${t(`BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(data === null || data === void 0 ? void 0 : data.toUpperCase(), "-", "_")}`)}` : "NA");
        returnValue = returnValueArray.join(', ');
      }
    }
    return returnValue ? returnValue : "NA";
  }
  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      padding: "8px",
      borderRadius: "4px",
      maxWidth: "950px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React.createElement(StatusTable, null, edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$values = edcrDetails.values) === null || _edcrDetails$values === void 0 ? void 0 : _edcrDetails$values.map((value, index) => {
    if (value !== null && value !== void 0 && value.isHeader) return /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        fontSize: "20px",
        paddingBottom: "10px"
      }
    }, t(value === null || value === void 0 ? void 0 : value.title));else return /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      labelStyle: {
        width: "100%",
        fontSize: "20px"
      },
      key: `${value.title}`,
      label: `${t(`${value.title}`)}`,
      text: value !== null && value !== void 0 && value.value ? value === null || value === void 0 ? void 0 : value.value : ""
    });
  })), edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$subOccup = edcrDetails.subOccupancyTableDetails) === null || _edcrDetails$subOccup === void 0 ? void 0 : (_edcrDetails$subOccup2 = _edcrDetails$subOccup[0]) === null || _edcrDetails$subOccup2 === void 0 ? void 0 : (_edcrDetails$subOccup3 = _edcrDetails$subOccup2.value) === null || _edcrDetails$subOccup3 === void 0 ? void 0 : (_edcrDetails$subOccup4 = _edcrDetails$subOccup3.planDetail) === null || _edcrDetails$subOccup4 === void 0 ? void 0 : _edcrDetails$subOccup4.blocks.map((block, index) => {
    var _edcrDetails$subOccup5, _edcrDetails$subOccup6, _edcrDetails$subOccup7, _edcrDetails$subOccup8, _edcrDetails$subOccup9;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: (edcrDetails === null || edcrDetails === void 0 ? void 0 : (_edcrDetails$subOccup5 = edcrDetails.subOccupancyTableDetails) === null || _edcrDetails$subOccup5 === void 0 ? void 0 : (_edcrDetails$subOccup6 = _edcrDetails$subOccup5[0]) === null || _edcrDetails$subOccup6 === void 0 ? void 0 : (_edcrDetails$subOccup7 = _edcrDetails$subOccup6.value) === null || _edcrDetails$subOccup7 === void 0 ? void 0 : (_edcrDetails$subOccup8 = _edcrDetails$subOccup7.planDetail) === null || _edcrDetails$subOccup8 === void 0 ? void 0 : (_edcrDetails$subOccup9 = _edcrDetails$subOccup8.blocks) === null || _edcrDetails$subOccup9 === void 0 ? void 0 : _edcrDetails$subOccup9.length) > 0 ? {
        marginBottom: "30px",
        background: "#FAFAFA",
        border: "1px solid #D6D5D4",
        padding: "8px",
        borderRadius: "4px",
        maxWidth: "950px",
        minWidth: "280px"
      } : {
        marginBottom: "30px"
      }
    }, /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        marginBottom: "8px",
        paddingBottom: "9px",
        color: "#0B0C0C",
        fontSize: "18px",
        lineHeight: "19px"
      }
    }, t("BPA_BLOCK_SUBHEADER"), " ", index + 1), /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement(Row, {
      className: "border-none",
      textStyle: {
        wordBreak: "break-word"
      },
      label: `${t("BPA_SUB_OCCUPANCY_LABEL")}`,
      text: getSubOccupancyValues(index)
    })), /*#__PURE__*/React.createElement("div", {
      style: window.location.href.includes("citizen") || isMobile ? {
        overflow: "scroll"
      } : {
        maxWidth: "950px",
        maxHeight: "280px"
      }
    }, /*#__PURE__*/React.createElement(Table, {
      className: "customTable table-fixed-first-column table-border-style",
      t: t,
      disableSort: false,
      autoSort: true,
      manualPagination: false,
      isPaginationRequired: false,
      initSortId: "S N ",
      data: getFloorData(block),
      columns: tableColumns,
      getCellProps: cellInfo => {
        return {
          style: {}
        };
      }
    })));
  })));
};

const Reason = ({
  headComment,
  otherComment
}) => /*#__PURE__*/React.createElement("div", {
  className: "checkpoint-comments-wrap"
}, /*#__PURE__*/React.createElement("h4", null, headComment), /*#__PURE__*/React.createElement("p", null, otherComment));

var purify = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    function _typeof(obj) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
      return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }
    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }
      return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create;
    var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;
    if (!apply) {
      apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
      };
    }
    if (!freeze) {
      freeze = function freeze(x) {
        return x;
      };
    }
    if (!seal) {
      seal = function seal(x) {
        return x;
      };
    }
    if (!construct) {
      construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
      };
    }
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
      return function (thisArg) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        return apply(func, thisArg, args);
      };
    }
    function unconstruct(func) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return construct(func, args);
      };
    }
    function addToSet(set, array, transformCaseFunc) {
      var _transformCaseFunc;
      transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
      if (setPrototypeOf) {
        setPrototypeOf(set, null);
      }
      var l = array.length;
      while (l--) {
        var element = array[l];
        if (typeof element === 'string') {
          var lcElement = transformCaseFunc(element);
          if (lcElement !== element) {
            if (!isFrozen(array)) {
              array[l] = lcElement;
            }
            element = lcElement;
          }
        }
        set[element] = true;
      }
      return set;
    }
    function clone(object) {
      var newObject = create(null);
      var property;
      for (property in object) {
        if (apply(hasOwnProperty, object, [property]) === true) {
          newObject[property] = object[property];
        }
      }
      return newObject;
    }
    function lookupGetter(object, prop) {
      while (object !== null) {
        var desc = getOwnPropertyDescriptor(object, prop);
        if (desc) {
          if (desc.get) {
            return unapply(desc.get);
          }
          if (typeof desc.value === 'function') {
            return unapply(desc.value);
          }
        }
        object = getPrototypeOf(object);
      }
      function fallbackValue(element) {
        console.warn('fallback value for', element);
        return null;
      }
      return fallbackValue;
    }
    var html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
    var svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
    var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
    var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
    var mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);
    var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
    var text = freeze(['#text']);
    var html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);
    var svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
    var mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
    var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm);
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/);
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
      return typeof window === 'undefined' ? null : window;
    };
    var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
      if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
        return null;
      }
      var suffix = null;
      var ATTR_NAME = 'data-tt-policy-suffix';
      if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
        suffix = document.currentScript.getAttribute(ATTR_NAME);
      }
      var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
      try {
        return trustedTypes.createPolicy(policyName, {
          createHTML: function createHTML(html) {
            return html;
          },
          createScriptURL: function createScriptURL(scriptUrl) {
            return scriptUrl;
          }
        });
      } catch (_) {
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
      }
    };
    function createDOMPurify() {
      var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
      var DOMPurify = function DOMPurify(root) {
        return createDOMPurify(root);
      };
      DOMPurify.version = '2.5.6';
      DOMPurify.removed = [];
      if (!window || !window.document || window.document.nodeType !== 9) {
        DOMPurify.isSupported = false;
        return DOMPurify;
      }
      var originalDocument = window.document;
      var document = window.document;
      var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        HTMLFormElement = window.HTMLFormElement,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;
      var ElementPrototype = Element.prototype;
      var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
      var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
      var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
      var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
      if (typeof HTMLTemplateElement === 'function') {
        var template = document.createElement('template');
        if (template.content && template.content.ownerDocument) {
          document = template.content.ownerDocument;
        }
      }
      var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
      var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
      var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
      var importNode = originalDocument.importNode;
      var documentMode = {};
      try {
        documentMode = clone(document).documentMode ? document.documentMode : {};
      } catch (_) {}
      var hooks = {};
      DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
      var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
        ERB_EXPR$1 = ERB_EXPR,
        TMPLIT_EXPR$1 = TMPLIT_EXPR,
        DATA_ATTR$1 = DATA_ATTR,
        ARIA_ATTR$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
        CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
      var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
      var ALLOWED_TAGS = null;
      var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
      var ALLOWED_ATTR = null;
      var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
      var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
        tagNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        attributeNameCheck: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: null
        },
        allowCustomizedBuiltInElements: {
          writable: true,
          configurable: false,
          enumerable: true,
          value: false
        }
      }));
      var FORBID_TAGS = null;
      var FORBID_ATTR = null;
      var ALLOW_ARIA_ATTR = true;
      var ALLOW_DATA_ATTR = true;
      var ALLOW_UNKNOWN_PROTOCOLS = false;
      var ALLOW_SELF_CLOSE_IN_ATTR = true;
      var SAFE_FOR_TEMPLATES = false;
      var SAFE_FOR_XML = true;
      var WHOLE_DOCUMENT = false;
      var SET_CONFIG = false;
      var FORCE_BODY = false;
      var RETURN_DOM = false;
      var RETURN_DOM_FRAGMENT = false;
      var RETURN_TRUSTED_TYPE = false;
      var SANITIZE_DOM = true;
      var SANITIZE_NAMED_PROPS = false;
      var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
      var KEEP_CONTENT = true;
      var IN_PLACE = false;
      var USE_PROFILES = {};
      var FORBID_CONTENTS = null;
      var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
      var DATA_URI_TAGS = null;
      var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
      var URI_SAFE_ATTRIBUTES = null;
      var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
      var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      var NAMESPACE = HTML_NAMESPACE;
      var IS_EMPTY_INPUT = false;
      var ALLOWED_NAMESPACES = null;
      var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
      var PARSER_MEDIA_TYPE;
      var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
      var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
      var transformCaseFunc;
      var CONFIG = null;
      var formElement = document.createElement('form');
      var isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
      };
      var _parseConfig = function _parseConfig(cfg) {
        if (CONFIG && CONFIG === cfg) {
          return;
        }
        if (!cfg || _typeof(cfg) !== 'object') {
          cfg = {};
        }
        cfg = clone(cfg);
        PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
        FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
        USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
        RETURN_DOM = cfg.RETURN_DOM || false;
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
        FORCE_BODY = cfg.FORCE_BODY || false;
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
        IN_PLACE = cfg.IN_PLACE || false;
        IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
        NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
        CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
        }
        if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) {
          CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
        }
        if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') {
          CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
        }
        if (SAFE_FOR_TEMPLATES) {
          ALLOW_DATA_ATTR = false;
        }
        if (RETURN_DOM_FRAGMENT) {
          RETURN_DOM = true;
        }
        if (USE_PROFILES) {
          ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
          ALLOWED_ATTR = [];
          if (USE_PROFILES.html === true) {
            addToSet(ALLOWED_TAGS, html$1);
            addToSet(ALLOWED_ATTR, html);
          }
          if (USE_PROFILES.svg === true) {
            addToSet(ALLOWED_TAGS, svg$1);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }
          if (USE_PROFILES.svgFilters === true) {
            addToSet(ALLOWED_TAGS, svgFilters);
            addToSet(ALLOWED_ATTR, svg);
            addToSet(ALLOWED_ATTR, xml);
          }
          if (USE_PROFILES.mathMl === true) {
            addToSet(ALLOWED_TAGS, mathMl$1);
            addToSet(ALLOWED_ATTR, mathMl);
            addToSet(ALLOWED_ATTR, xml);
          }
        }
        if (cfg.ADD_TAGS) {
          if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
            ALLOWED_TAGS = clone(ALLOWED_TAGS);
          }
          addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
        }
        if (cfg.ADD_ATTR) {
          if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
            ALLOWED_ATTR = clone(ALLOWED_ATTR);
          }
          addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
        }
        if (cfg.ADD_URI_SAFE_ATTR) {
          addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        }
        if (cfg.FORBID_CONTENTS) {
          if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
            FORBID_CONTENTS = clone(FORBID_CONTENTS);
          }
          addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if (KEEP_CONTENT) {
          ALLOWED_TAGS['#text'] = true;
        }
        if (WHOLE_DOCUMENT) {
          addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
        }
        if (ALLOWED_TAGS.table) {
          addToSet(ALLOWED_TAGS, ['tbody']);
          delete FORBID_TAGS.tbody;
        }
        if (freeze) {
          freeze(cfg);
        }
        CONFIG = cfg;
      };
      var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);
      var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'annotation-xml']);
      var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
      var ALL_SVG_TAGS = addToSet({}, svg$1);
      addToSet(ALL_SVG_TAGS, svgFilters);
      addToSet(ALL_SVG_TAGS, svgDisallowed);
      var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
      addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
      var _checkValidNamespace = function _checkValidNamespace(element) {
        var parent = getParentNode(element);
        if (!parent || !parent.tagName) {
          parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
          };
        }
        var tagName = stringToLowerCase(element.tagName);
        var parentTagName = stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
          return false;
        }
        if (element.namespaceURI === SVG_NAMESPACE) {
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'svg';
          }
          if (parent.namespaceURI === MATHML_NAMESPACE) {
            return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
          }
          return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
          if (parent.namespaceURI === HTML_NAMESPACE) {
            return tagName === 'math';
          }
          if (parent.namespaceURI === SVG_NAMESPACE) {
            return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
          }
          return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
          if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
            return false;
          }
          if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
            return false;
          }
          return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
          return true;
        }
        return false;
      };
      var _forceRemove = function _forceRemove(node) {
        arrayPush(DOMPurify.removed, {
          element: node
        });
        try {
          node.parentNode.removeChild(node);
        } catch (_) {
          try {
            node.outerHTML = emptyHTML;
          } catch (_) {
            node.remove();
          }
        }
      };
      var _removeAttribute = function _removeAttribute(name, node) {
        try {
          arrayPush(DOMPurify.removed, {
            attribute: node.getAttributeNode(name),
            from: node
          });
        } catch (_) {
          arrayPush(DOMPurify.removed, {
            attribute: null,
            from: node
          });
        }
        node.removeAttribute(name);
        if (name === 'is' && !ALLOWED_ATTR[name]) {
          if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
            try {
              _forceRemove(node);
            } catch (_) {}
          } else {
            try {
              node.setAttribute(name, '');
            } catch (_) {}
          }
        }
      };
      var _initDocument = function _initDocument(dirty) {
        var doc;
        var leadingWhitespace;
        if (FORCE_BODY) {
          dirty = '<remove></remove>' + dirty;
        } else {
          var matches = stringMatch(dirty, /^[\r\n\t ]+/);
          leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
          dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        }
        var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        if (NAMESPACE === HTML_NAMESPACE) {
          try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
          } catch (_) {}
        }
        if (!doc || !doc.documentElement) {
          doc = implementation.createDocument(NAMESPACE, 'template', null);
          try {
            doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
          } catch (_) {}
        }
        var body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) {
          body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        }
        if (NAMESPACE === HTML_NAMESPACE) {
          return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        }
        return WHOLE_DOCUMENT ? doc.documentElement : body;
      };
      var _createIterator = function _createIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
      };
      var _isClobbered = function _isClobbered(elm) {
        return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
      };
      var _isNode = function _isNode(object) {
        return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
      };
      var _executeHook = function _executeHook(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) {
          return;
        }
        arrayForEach(hooks[entryPoint], function (hook) {
          hook.call(DOMPurify, currentNode, data, CONFIG);
        });
      };
      var _sanitizeElements = function _sanitizeElements(currentNode) {
        var content;
        _executeHook('beforeSanitizeElements', currentNode, null);
        if (_isClobbered(currentNode)) {
          _forceRemove(currentNode);
          return true;
        }
        if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
          _forceRemove(currentNode);
          return true;
        }
        var tagName = transformCaseFunc(currentNode.nodeName);
        _executeHook('uponSanitizeElement', currentNode, {
          tagName: tagName,
          allowedTags: ALLOWED_TAGS
        });
        if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
          _forceRemove(currentNode);
          return true;
        }
        if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
          _forceRemove(currentNode);
          return true;
        }
        if (currentNode.nodeType === 7) {
          _forceRemove(currentNode);
          return true;
        }
        if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
          _forceRemove(currentNode);
          return true;
        }
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
          }
          if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
            var parentNode = getParentNode(currentNode) || currentNode.parentNode;
            var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
            if (childNodes && parentNode) {
              var childCount = childNodes.length;
              for (var i = childCount - 1; i >= 0; --i) {
                var childClone = cloneNode(childNodes[i], true);
                childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                parentNode.insertBefore(childClone, getNextSibling(currentNode));
              }
            }
          }
          _forceRemove(currentNode);
          return true;
        }
        if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
          _forceRemove(currentNode);
          return true;
        }
        if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
          _forceRemove(currentNode);
          return true;
        }
        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
          content = currentNode.textContent;
          content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
          content = stringReplace(content, ERB_EXPR$1, ' ');
          content = stringReplace(content, TMPLIT_EXPR$1, ' ');
          if (currentNode.textContent !== content) {
            arrayPush(DOMPurify.removed, {
              element: currentNode.cloneNode()
            });
            currentNode.textContent = content;
          }
        }
        _executeHook('afterSanitizeElements', currentNode, null);
        return false;
      };
      var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
          return false;
        }
        if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
          if (_basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;else {
            return false;
          }
        } else if (URI_SAFE_ATTRIBUTES[lcName]) ;else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;else if (value) {
          return false;
        }
        return true;
      };
      var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
        return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
      };
      var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        var attr;
        var value;
        var lcName;
        var l;
        _executeHook('beforeSanitizeAttributes', currentNode, null);
        var attributes = currentNode.attributes;
        if (!attributes) {
          return;
        }
        var hookEvent = {
          attrName: '',
          attrValue: '',
          keepAttr: true,
          allowedAttributes: ALLOWED_ATTR
        };
        l = attributes.length;
        while (l--) {
          attr = attributes[l];
          var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;
          value = name === 'value' ? attr.value : stringTrim(attr.value);
          lcName = transformCaseFunc(name);
          hookEvent.attrName = lcName;
          hookEvent.attrValue = value;
          hookEvent.keepAttr = true;
          hookEvent.forceKeepAttr = undefined;
          _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
          value = hookEvent.attrValue;
          if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
            _removeAttribute(name, currentNode);
            continue;
          }
          if (hookEvent.forceKeepAttr) {
            continue;
          }
          _removeAttribute(name, currentNode);
          if (!hookEvent.keepAttr) {
            continue;
          }
          if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
            _removeAttribute(name, currentNode);
            continue;
          }
          if (SAFE_FOR_TEMPLATES) {
            value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
            value = stringReplace(value, ERB_EXPR$1, ' ');
            value = stringReplace(value, TMPLIT_EXPR$1, ' ');
          }
          var lcTag = transformCaseFunc(currentNode.nodeName);
          if (!_isValidAttribute(lcTag, lcName, value)) {
            continue;
          }
          if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
            _removeAttribute(name, currentNode);
            value = SANITIZE_NAMED_PROPS_PREFIX + value;
          }
          if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
            if (namespaceURI) ;else {
              switch (trustedTypes.getAttributeType(lcTag, lcName)) {
                case 'TrustedHTML':
                  {
                    value = trustedTypesPolicy.createHTML(value);
                    break;
                  }
                case 'TrustedScriptURL':
                  {
                    value = trustedTypesPolicy.createScriptURL(value);
                    break;
                  }
              }
            }
          }
          try {
            if (namespaceURI) {
              currentNode.setAttributeNS(namespaceURI, name, value);
            } else {
              currentNode.setAttribute(name, value);
            }
            if (_isClobbered(currentNode)) {
              _forceRemove(currentNode);
            } else {
              arrayPop(DOMPurify.removed);
            }
          } catch (_) {}
        }
        _executeHook('afterSanitizeAttributes', currentNode, null);
      };
      var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
        var shadowNode;
        var shadowIterator = _createIterator(fragment);
        _executeHook('beforeSanitizeShadowDOM', fragment, null);
        while (shadowNode = shadowIterator.nextNode()) {
          _executeHook('uponSanitizeShadowNode', shadowNode, null);
          if (_sanitizeElements(shadowNode)) {
            continue;
          }
          if (shadowNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(shadowNode.content);
          }
          _sanitizeAttributes(shadowNode);
        }
        _executeHook('afterSanitizeShadowDOM', fragment, null);
      };
      DOMPurify.sanitize = function (dirty) {
        var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var body;
        var importedNode;
        var currentNode;
        var oldNode;
        var returnNode;
        IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) {
          dirty = '<!-->';
        }
        if (typeof dirty !== 'string' && !_isNode(dirty)) {
          if (typeof dirty.toString === 'function') {
            dirty = dirty.toString();
            if (typeof dirty !== 'string') {
              throw typeErrorCreate('dirty is not a string, aborting');
            }
          } else {
            throw typeErrorCreate('toString is not a function');
          }
        }
        if (!DOMPurify.isSupported) {
          if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
            if (typeof dirty === 'string') {
              return window.toStaticHTML(dirty);
            }
            if (_isNode(dirty)) {
              return window.toStaticHTML(dirty.outerHTML);
            }
          }
          return dirty;
        }
        if (!SET_CONFIG) {
          _parseConfig(cfg);
        }
        DOMPurify.removed = [];
        if (typeof dirty === 'string') {
          IN_PLACE = false;
        }
        if (IN_PLACE) {
          if (dirty.nodeName) {
            var tagName = transformCaseFunc(dirty.nodeName);
            if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
              throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
          }
        } else if (dirty instanceof Node) {
          body = _initDocument('<!---->');
          importedNode = body.ownerDocument.importNode(dirty, true);
          if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
            body = importedNode;
          } else if (importedNode.nodeName === 'HTML') {
            body = importedNode;
          } else {
            body.appendChild(importedNode);
          }
        } else {
          if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
          }
          body = _initDocument(dirty);
          if (!body) {
            return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
          }
        }
        if (body && FORCE_BODY) {
          _forceRemove(body.firstChild);
        }
        var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
        while (currentNode = nodeIterator.nextNode()) {
          if (currentNode.nodeType === 3 && currentNode === oldNode) {
            continue;
          }
          if (_sanitizeElements(currentNode)) {
            continue;
          }
          if (currentNode.content instanceof DocumentFragment) {
            _sanitizeShadowDOM(currentNode.content);
          }
          _sanitizeAttributes(currentNode);
          oldNode = currentNode;
        }
        oldNode = null;
        if (IN_PLACE) {
          return dirty;
        }
        if (RETURN_DOM) {
          if (RETURN_DOM_FRAGMENT) {
            returnNode = createDocumentFragment.call(body.ownerDocument);
            while (body.firstChild) {
              returnNode.appendChild(body.firstChild);
            }
          } else {
            returnNode = body;
          }
          if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) {
            returnNode = importNode.call(originalDocument, returnNode, true);
          }
          return returnNode;
        }
        var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
          serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        }
        if (SAFE_FOR_TEMPLATES) {
          serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
          serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
          serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
        }
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
      };
      DOMPurify.setConfig = function (cfg) {
        _parseConfig(cfg);
        SET_CONFIG = true;
      };
      DOMPurify.clearConfig = function () {
        CONFIG = null;
        SET_CONFIG = false;
      };
      DOMPurify.isValidAttribute = function (tag, attr, value) {
        if (!CONFIG) {
          _parseConfig({});
        }
        var lcTag = transformCaseFunc(tag);
        var lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
      };
      DOMPurify.addHook = function (entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') {
          return;
        }
        hooks[entryPoint] = hooks[entryPoint] || [];
        arrayPush(hooks[entryPoint], hookFunction);
      };
      DOMPurify.removeHook = function (entryPoint) {
        if (hooks[entryPoint]) {
          return arrayPop(hooks[entryPoint]);
        }
      };
      DOMPurify.removeHooks = function (entryPoint) {
        if (hooks[entryPoint]) {
          hooks[entryPoint] = [];
        }
      };
      DOMPurify.removeAllHooks = function () {
        hooks = {};
      };
      return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
  });
});

const SafeHtml = ({
  html,
  tag: _tag = "div",
  style: _style = {},
  className: _className = ""
}) => {
  const sanitizedHtml = purify.sanitize(html);
  const Tag = _tag;
  return /*#__PURE__*/React.createElement(Tag, {
    className: _className,
    style: _style,
    dangerouslySetInnerHTML: {
      __html: sanitizedHtml
    }
  });
};

const TLCaption = ({
  data,
  OpenImage
}) => {
  var _data$wfComment, _data$thumbnailsToSho, _data$thumbnailsToSho2;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, data.date && /*#__PURE__*/React.createElement("p", null, data.date), /*#__PURE__*/React.createElement("p", null, data.name), data.mobileNumber && /*#__PURE__*/React.createElement(TelePhone, {
    mobile: data.mobileNumber
  }), data.source && /*#__PURE__*/React.createElement("p", null, t("ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_" + data.source.toUpperCase())), data.comment && /*#__PURE__*/React.createElement(Reason, {
    otherComment: data === null || data === void 0 ? void 0 : data.otherComment,
    headComment: data === null || data === void 0 ? void 0 : data.comment
  }), data !== null && data !== void 0 && data.wfComment ? /*#__PURE__*/React.createElement("div", null, data === null || data === void 0 ? void 0 : (_data$wfComment = data.wfComment) === null || _data$wfComment === void 0 ? void 0 : _data$wfComment.map(e => /*#__PURE__*/React.createElement("div", {
    className: "TLComments",
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React.createElement("h3", null, t("WF_COMMON_COMMENTS")), /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(SafeHtml, {
    html: e
  }))))) : null, (data === null || data === void 0 ? void 0 : (_data$thumbnailsToSho = data.thumbnailsToShow) === null || _data$thumbnailsToSho === void 0 ? void 0 : (_data$thumbnailsToSho2 = _data$thumbnailsToSho.thumbs) === null || _data$thumbnailsToSho2 === void 0 ? void 0 : _data$thumbnailsToSho2.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "TLComments",
    style: {
      backgroundColor: "aliceblue"
    }
  }, /*#__PURE__*/React.createElement("h3", null, t("CS_COMMON_ATTACHMENTS")), /*#__PURE__*/React.createElement(DisplayPhotos, {
    srcs: data === null || data === void 0 ? void 0 : data.thumbnailsToShow.thumbs,
    onClick: (src, index) => {
      OpenImage(src, index, data === null || data === void 0 ? void 0 : data.thumbnailsToShow);
    }
  })) : null);
};

function TLTradeAccessories({
  units
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, units.map((unit, index) => {
    var _unit$values;
    return (
      /*#__PURE__*/
      React.createElement("div", {
        key: t(unit === null || unit === void 0 ? void 0 : unit.title),
        style: {
          marginTop: "19px",
          background: "#FAFAFA",
          border: "1px solid #D6D5D4",
          borderRadius: "4px",
          padding: "8px",
          lineHeight: "19px",
          maxWidth: "600px",
          minWidth: "280px"
        }
      }, /*#__PURE__*/React.createElement(CardSubHeader, {
        style: {
          marginBottom: "8px",
          paddingBottom: "9px",
          color: "#0B0C0C",
          fontSize: "16px",
          lineHeight: "19px"
        }
      }, `${t(unit === null || unit === void 0 ? void 0 : unit.title)} ${index + 1}`), /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(StatusTable, {
        style: {
          position: "relative",
          marginTop: "19px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          maxWidth: "640px",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "auto"
        }
      }), unit === null || unit === void 0 ? void 0 : (_unit$values = unit.values) === null || _unit$values === void 0 ? void 0 : _unit$values.map((value, index) => {
        var _value$values;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React.createElement(Row, {
          key: t(value.title),
          label: `${t(value.title)}:`,
          text: t(value.value) || "N/A",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: {
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#0B0C0C"
          }
        });
      }))))
    );
  }));
}

function TLTradeUnits({
  units
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, units.map((unit, index) => {
    var _unit$values;
    return (
      /*#__PURE__*/
      React.createElement("div", {
        key: t(unit === null || unit === void 0 ? void 0 : unit.title),
        style: {
          marginTop: "19px",
          background: "#FAFAFA",
          border: "1px solid #D6D5D4",
          borderRadius: "4px",
          padding: "8px",
          lineHeight: "19px",
          maxWidth: "600px",
          minWidth: "280px"
        }
      }, /*#__PURE__*/React.createElement(CardSubHeader, {
        style: {
          marginBottom: "9px",
          paddingBottom: "9px",
          color: "#0B0C0C",
          fontSize: "16px",
          lineHeight: "19px"
        }
      }, `${t(unit === null || unit === void 0 ? void 0 : unit.title)} ${index + 1}`), /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement(StatusTable, {
        style: {
          position: "relative",
          marginTop: "19px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          maxWidth: "640px",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: "auto"
        }
      }), unit === null || unit === void 0 ? void 0 : (_unit$values = unit.values) === null || _unit$values === void 0 ? void 0 : _unit$values.map((value, index) => {
        var _value$values;
        if (value.map === true && value.value !== "N/A") {
          return /*#__PURE__*/React.createElement(Row, {
            key: t(value.title),
            label: t(value.title),
            text: /*#__PURE__*/React.createElement("img", {
              src: t(value.value),
              alt: ""
            })
          });
        }
        return /*#__PURE__*/React.createElement(Row, {
          key: t(value.title),
          label: `${t(value.title)}:`,
          text: t(value.value) || "NA",
          last: index === (value === null || value === void 0 ? void 0 : (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: {
            justifyContent: "space-between",
            fontSize: "16px",
            lineHeight: "19px",
            color: "#0B0C0C"
          }
        });
      }))))
    );
  }));
}

const ProfessionalsAddressMapper = ({
  data,
  t
}) => {
  const erKeys = Object.keys(data).filter(key => key.startsWith("er") && !key.includes("engineerUuid") && !key.includes("erplotArea"));
  const stringKeys = Object.keys(data).filter(key => !key.startsWith("er") && !key.includes("engineerUuid") && typeof data[key] === "string" && data[key] !== null);
  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React.createElement(CardSubHeader, null, t("CORE_COMMON_PRIVATE_PROFESSIONAL_INFORMATION")), /*#__PURE__*/React.createElement(StatusTable, null, stringKeys.map((key, index) => /*#__PURE__*/React.createElement(Row, {
    key: index,
    className: "border-none",
    label: t(`CORE_COMMON_${key.toUpperCase()}`),
    text: data[key] || ""
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "19px",
      background: "#FAFAFA",
      border: "1px solid #D6D5D4",
      borderRadius: "4px",
      padding: "8px",
      lineHeight: "19px",
      maxWidth: "960px",
      minWidth: "280px"
    }
  }, /*#__PURE__*/React.createElement(CardSubHeader, null, t("CORE_COMMON_STRUCTURAL_ENGINEER_INFORMATION")), /*#__PURE__*/React.createElement(StatusTable, null, erKeys.map((key, index) => /*#__PURE__*/React.createElement(Row, {
    key: index,
    className: "border-none",
    label: t(`CORE_COMMON_${key.slice(2).toUpperCase()}`),
    text: data[key] || ""
  })))));
};

function ApplicationDetailsContent({
  applicationDetails,
  workflowDetails,
  isDataLoading,
  applicationData,
  businessService,
  timelineStatusPrefix,
  showTimeLine = true,
  statusAttribute = "status",
  paymentsList
}) {
  var _applicationDetails$a, _workflowDetails$data3, _workflowDetails$data4, _workflowDetails$data5, _workflowDetails$data6, _workflowDetails$data7, _workflowDetails$data8, _workflowDetails$data9, _workflowDetails$data10, _workflowDetails$data11, _workflowDetails$data12;
  const {
    t
  } = useTranslation();
  function OpenImage(imageSource, index, thumbnailsToShow) {
    var _thumbnailsToShow$ful;
    window.open(thumbnailsToShow === null || thumbnailsToShow === void 0 ? void 0 : (_thumbnailsToShow$ful = thumbnailsToShow.fullImage) === null || _thumbnailsToShow$ful === void 0 ? void 0 : _thumbnailsToShow$ful[0], "_blank");
  }
  const getTimelineCaptions = checkpoint => {
    if (checkpoint.state === "OPEN" || checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/")) {
      var _applicationData$audi;
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi = applicationData.auditDetails) === null || _applicationData$audi === void 0 ? void 0 : _applicationData$audi.createdTime),
        source: (applicationData === null || applicationData === void 0 ? void 0 : applicationData.channel) || ""
      };
      return /*#__PURE__*/React.createElement(TLCaption, {
        data: caption
      });
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      var _checkpoint$auditDeta, _checkpoint$assignes, _checkpoint$assignes$, _checkpoint$assignes2, _checkpoint$assignes3;
      const caption = {
        date: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$auditDeta = checkpoint.auditDetails) === null || _checkpoint$auditDeta === void 0 ? void 0 : _checkpoint$auditDeta.lastModified,
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes = checkpoint.assignes) === null || _checkpoint$assignes === void 0 ? void 0 : (_checkpoint$assignes$ = _checkpoint$assignes[0]) === null || _checkpoint$assignes$ === void 0 ? void 0 : _checkpoint$assignes$.name,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes2 = checkpoint.assignes) === null || _checkpoint$assignes2 === void 0 ? void 0 : (_checkpoint$assignes3 = _checkpoint$assignes2[0]) === null || _checkpoint$assignes3 === void 0 ? void 0 : _checkpoint$assignes3.mobileNumber,
        comment: t(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.thumbnailsToShow
      };
      return /*#__PURE__*/React.createElement(TLCaption, {
        data: caption,
        OpenImage: OpenImage
      });
    } else {
      var _Digit$DateUtils, _applicationData$audi2, _checkpoint$assignes4, _checkpoint$assignes5, _checkpoint$assignes6, _checkpoint$assignes7;
      const caption = {
        date: (_Digit$DateUtils = Digit.DateUtils) === null || _Digit$DateUtils === void 0 ? void 0 : _Digit$DateUtils.ConvertTimestampToDate(applicationData === null || applicationData === void 0 ? void 0 : (_applicationData$audi2 = applicationData.auditDetails) === null || _applicationData$audi2 === void 0 ? void 0 : _applicationData$audi2.lastModifiedTime),
        name: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes4 = checkpoint.assignes) === null || _checkpoint$assignes4 === void 0 ? void 0 : (_checkpoint$assignes5 = _checkpoint$assignes4[0]) === null || _checkpoint$assignes5 === void 0 ? void 0 : _checkpoint$assignes5.name,
        wfComment: checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.wfComment,
        mobileNumber: checkpoint === null || checkpoint === void 0 ? void 0 : (_checkpoint$assignes6 = checkpoint.assignes) === null || _checkpoint$assignes6 === void 0 ? void 0 : (_checkpoint$assignes7 = _checkpoint$assignes6[0]) === null || _checkpoint$assignes7 === void 0 ? void 0 : _checkpoint$assignes7.mobileNumber
      };
      return /*#__PURE__*/React.createElement(TLCaption, {
        data: caption
      });
    }
  };
  const getTranslatedValues = (dataValue, isNotTranslated) => {
    if (dataValue) {
      return !isNotTranslated ? t(dataValue) : dataValue;
    } else {
      return t("NA");
    }
  };
  const checkLocation = window.location.href.includes("employee/tl") || window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc");
  const isNocLocation = window.location.href.includes("employee/noc");
  const isBPALocation = window.location.href.includes("employee/obps");
  const getRowStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        justifyContent: "space-between",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#0B0C0C"
      };
    } else if (checkLocation) {
      return {
        justifyContent: "space-between",
        fontSize: "16px",
        lineHeight: "19px",
        color: "#0B0C0C"
      };
    } else {
      return {};
    }
  };
  const getTableStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        position: "relative",
        marginTop: "19px"
      };
    } else if (checkLocation) {
      return {
        position: "relative",
        marginTop: "19px"
      };
    } else {
      return {};
    }
  };
  const getMainDivStyles = () => {
    if (window.location.href.includes("employee/obps") || window.location.href.includes("employee/noc")) {
      return {
        lineHeight: "19px",
        maxWidth: "950px",
        minWidth: "280px"
      };
    } else if (checkLocation) {
      return {
        lineHeight: "19px",
        maxWidth: "600px",
        minWidth: "280px"
      };
    } else {
      return {};
    }
  };
  const getTextValue = value => {
    if (value !== null && value !== void 0 && value.skip) return value.value;else if (value !== null && value !== void 0 && value.isUnit) return value !== null && value !== void 0 && value.value ? `${getTranslatedValues(value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.isNotTranslated)} ${t(value === null || value === void 0 ? void 0 : value.isUnit)}` : t("N/A");else return value !== null && value !== void 0 && value.value ? getTranslatedValues(value === null || value === void 0 ? void 0 : value.value, value === null || value === void 0 ? void 0 : value.isNotTranslated) : t("N/A");
  };
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      position: "relative"
    },
    className: "employeeCard-override"
  }, applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationDetails) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.map((detail, index) => {
    var _detail$values, _detail$additionalDet, _applicationDetails$a2, _applicationDetails$a3, _applicationDetails$a4, _detail$additionalDet2, _applicationDetails$a5, _applicationDetails$a6, _detail$values4, _detail$additionalDet3, _detail$additionalDet4, _detail$additionalDet5, _detail$additionalDet6, _detail$additionalDet7, _detail$additionalDet8, _detail$additionalDet9, _detail$additionalDet10, _detail$additionalDet11, _workflowDetails$data, _workflowDetails$data2, _detail$additionalDet12, _detail$additionalDet13, _detail$additionalDet14, _detail$additionalDet15, _detail$additionalDet16, _detail$additionalDet17, _detail$additionalDet18, _detail$additionalDet19, _detail$additionalDet20, _detail$additionalDet21, _detail$additionalDet22, _detail$additionalDet23, _detail$additionalDet24;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      style: getMainDivStyles()
    }, (index === 0 || index === 9) && detail.asSectionHeader ? /*#__PURE__*/React.createElement(CardSubHeader, {
      style: {
        marginBottom: "16px",
        fontSize: "24px"
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardSectionHeader, {
      style: index == 0 && checkLocation ? {
        marginBottom: "16px",
        fontSize: "24px"
      } : {
        marginBottom: "16px",
        marginTop: "32px",
        fontSize: "24px"
      }
    }, isNocLocation ? `${t(detail.title)}` : t(detail.title))), /*#__PURE__*/React.createElement(StatusTable, {
      style: getTableStyles()
    }, (detail === null || detail === void 0 ? void 0 : detail.title) && !(detail !== null && detail !== void 0 && detail.title.includes("NOC")) && (detail === null || detail === void 0 ? void 0 : (_detail$values = detail.values) === null || _detail$values === void 0 ? void 0 : _detail$values.map((value, index) => {
      var _detail$values3;
      if (value.map === true && value.value !== "N/A") {
        return /*#__PURE__*/React.createElement(Row, {
          key: t(value.title),
          label: t(value.title),
          text: /*#__PURE__*/React.createElement("img", {
            src: t(value.value),
            alt: ""
          })
        });
      }
      if ((value === null || value === void 0 ? void 0 : value.isLink) == true) {
        var _detail$values2;
        return /*#__PURE__*/React.createElement(Row, {
          key: t(value.title),
          label: window.location.href.includes("tl") ? /*#__PURE__*/React.createElement("div", {
            style: {
              width: "200%"
            }
          }, /*#__PURE__*/React.createElement(Link, {
            to: value === null || value === void 0 ? void 0 : value.to
          }, /*#__PURE__*/React.createElement("span", {
            className: "link",
            style: {
              color: "#1F4A7C"
            }
          }, t(value === null || value === void 0 ? void 0 : value.title)))) : isNocLocation || isBPALocation ? `${t(value.title)}` : t(value.title),
          text: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
            to: value === null || value === void 0 ? void 0 : value.to
          }, /*#__PURE__*/React.createElement("span", {
            className: "link",
            style: {
              color: "#1F4A7C"
            }
          }, value === null || value === void 0 ? void 0 : value.value))),
          last: index === (detail === null || detail === void 0 ? void 0 : (_detail$values2 = detail.values) === null || _detail$values2 === void 0 ? void 0 : _detail$values2.length) - 1,
          caption: value.caption,
          className: "border-none",
          rowContainerStyle: getRowStyles()
        });
      }
      return /*#__PURE__*/React.createElement(Row, {
        key: t(value.title),
        label: isNocLocation || isBPALocation ? `${t(value.title)}` : t(value.title),
        text: getTextValue(value),
        last: index === (detail === null || detail === void 0 ? void 0 : (_detail$values3 = detail.values) === null || _detail$values3 === void 0 ? void 0 : _detail$values3.length) - 1,
        caption: value.caption,
        className: "border-none",
        rowContainerStyle: getRowStyles()
      });
    })))), (detail === null || detail === void 0 ? void 0 : detail.belowComponent) && /*#__PURE__*/React.createElement(detail.belowComponent, null), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet = detail.additionalDetails) === null || _detail$additionalDet === void 0 ? void 0 : _detail$additionalDet.inspectionReport) && /*#__PURE__*/React.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails,
      paymentsList: paymentsList
    }), (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a2 = applicationDetails.applicationData) === null || _applicationDetails$a2 === void 0 ? void 0 : (_applicationDetails$a3 = _applicationDetails$a2.additionalDetails) === null || _applicationDetails$a3 === void 0 ? void 0 : (_applicationDetails$a4 = _applicationDetails$a3.fieldinspection_pending) === null || _applicationDetails$a4 === void 0 ? void 0 : _applicationDetails$a4.length) > 0 && (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet2 = detail.additionalDetails) === null || _detail$additionalDet2 === void 0 ? void 0 : _detail$additionalDet2.fiReport) && /*#__PURE__*/React.createElement(InspectionReport, {
      fiReport: applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a5 = applicationDetails.applicationData) === null || _applicationDetails$a5 === void 0 ? void 0 : (_applicationDetails$a6 = _applicationDetails$a5.additionalDetails) === null || _applicationDetails$a6 === void 0 ? void 0 : _applicationDetails$a6.fieldinspection_pending
    }), (detail === null || detail === void 0 ? void 0 : detail.isprofessionalDetail) && /*#__PURE__*/React.createElement(ProfessionalsAddressMapper, {
      data: detail === null || detail === void 0 ? void 0 : (_detail$values4 = detail.values) === null || _detail$values4 === void 0 ? void 0 : _detail$values4[0],
      t: t
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet3 = detail.additionalDetails) === null || _detail$additionalDet3 === void 0 ? void 0 : _detail$additionalDet3.floors) && /*#__PURE__*/React.createElement(PropertyFloors, {
      floors: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet4 = detail.additionalDetails) === null || _detail$additionalDet4 === void 0 ? void 0 : _detail$additionalDet4.floors
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet5 = detail.additionalDetails) === null || _detail$additionalDet5 === void 0 ? void 0 : _detail$additionalDet5.owners) && /*#__PURE__*/React.createElement(PropertyOwners, {
      owners: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet6 = detail.additionalDetails) === null || _detail$additionalDet6 === void 0 ? void 0 : _detail$additionalDet6.owners
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet7 = detail.additionalDetails) === null || _detail$additionalDet7 === void 0 ? void 0 : _detail$additionalDet7.units) && /*#__PURE__*/React.createElement(TLTradeUnits, {
      units: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet8 = detail.additionalDetails) === null || _detail$additionalDet8 === void 0 ? void 0 : _detail$additionalDet8.units
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet9 = detail.additionalDetails) === null || _detail$additionalDet9 === void 0 ? void 0 : _detail$additionalDet9.accessories) && /*#__PURE__*/React.createElement(TLTradeAccessories, {
      units: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet10 = detail.additionalDetails) === null || _detail$additionalDet10 === void 0 ? void 0 : _detail$additionalDet10.accessories
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet11 = detail.additionalDetails) === null || _detail$additionalDet11 === void 0 ? void 0 : _detail$additionalDet11.permissions) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.nextActions) === null || _workflowDetails$data2 === void 0 ? void 0 : _workflowDetails$data2.length) > 0 && /*#__PURE__*/React.createElement(PermissionCheck, {
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      t: t,
      permissions: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet12 = detail.additionalDetails) === null || _detail$additionalDet12 === void 0 ? void 0 : _detail$additionalDet12.permissions
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet13 = detail.additionalDetails) === null || _detail$additionalDet13 === void 0 ? void 0 : _detail$additionalDet13.obpsDocuments) && /*#__PURE__*/React.createElement(BPADocuments, {
      t: t,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      docs: detail.additionalDetails.obpsDocuments,
      bpaActionsDetails: workflowDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet14 = detail.additionalDetails) === null || _detail$additionalDet14 === void 0 ? void 0 : _detail$additionalDet14.noc) && /*#__PURE__*/React.createElement(NOCDocuments, {
      t: t,
      isNoc: true,
      NOCdata: detail.values,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
      docs: detail.additionalDetails.noc,
      noc: (_detail$additionalDet15 = detail.additionalDetails) === null || _detail$additionalDet15 === void 0 ? void 0 : _detail$additionalDet15.data,
      bpaActionsDetails: workflowDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet16 = detail.additionalDetails) === null || _detail$additionalDet16 === void 0 ? void 0 : _detail$additionalDet16.scruntinyDetails) && /*#__PURE__*/React.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet17 = detail.additionalDetails) === null || _detail$additionalDet17 === void 0 ? void 0 : _detail$additionalDet17.buildingExtractionDetails) && /*#__PURE__*/React.createElement(ScruntinyDetails, {
      scrutinyDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet18 = detail.additionalDetails) === null || _detail$additionalDet18 === void 0 ? void 0 : _detail$additionalDet18.subOccupancyTableDetails) && /*#__PURE__*/React.createElement(SubOccupancyTable, {
      edcrDetails: detail === null || detail === void 0 ? void 0 : detail.additionalDetails,
      applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet19 = detail.additionalDetails) === null || _detail$additionalDet19 === void 0 ? void 0 : _detail$additionalDet19.documentsWithUrl) && /*#__PURE__*/React.createElement(DocumentsPreview, {
      documents: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet20 = detail.additionalDetails) === null || _detail$additionalDet20 === void 0 ? void 0 : _detail$additionalDet20.documentsWithUrl
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet21 = detail.additionalDetails) === null || _detail$additionalDet21 === void 0 ? void 0 : _detail$additionalDet21.documents) && /*#__PURE__*/React.createElement(PropertyDocuments, {
      documents: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet22 = detail.additionalDetails) === null || _detail$additionalDet22 === void 0 ? void 0 : _detail$additionalDet22.documents
    }), (detail === null || detail === void 0 ? void 0 : (_detail$additionalDet23 = detail.additionalDetails) === null || _detail$additionalDet23 === void 0 ? void 0 : _detail$additionalDet23.taxHeadEstimatesCalculation) && /*#__PURE__*/React.createElement(PropertyEstimates, {
      taxHeadEstimatesCalculation: detail === null || detail === void 0 ? void 0 : (_detail$additionalDet24 = detail.additionalDetails) === null || _detail$additionalDet24 === void 0 ? void 0 : _detail$additionalDet24.taxHeadEstimatesCalculation
    }));
  }), showTimeLine && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data3 = workflowDetails.data) === null || _workflowDetails$data3 === void 0 ? void 0 : (_workflowDetails$data4 = _workflowDetails$data3.timeline) === null || _workflowDetails$data4 === void 0 ? void 0 : _workflowDetails$data4.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakLine, null), ((workflowDetails === null || workflowDetails === void 0 ? void 0 : workflowDetails.isLoading) || isDataLoading) && /*#__PURE__*/React.createElement(Loader, null), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && !isDataLoading && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(CardSectionHeader, {
    style: {
      marginBottom: "16px",
      marginTop: "32px"
    }
  }, t("ES_APPLICATION_DETAILS_APPLICATION_TIMELINE")), workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data5 = workflowDetails.data) !== null && _workflowDetails$data5 !== void 0 && _workflowDetails$data5.timeline && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data6 = workflowDetails.data) === null || _workflowDetails$data6 === void 0 ? void 0 : (_workflowDetails$data7 = _workflowDetails$data6.timeline) === null || _workflowDetails$data7 === void 0 ? void 0 : _workflowDetails$data7.length) === 1 ? /*#__PURE__*/React.createElement(CheckPoint, {
    isCompleted: true,
    label: t(`${timelineStatusPrefix}${workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data8 = workflowDetails.data) === null || _workflowDetails$data8 === void 0 ? void 0 : (_workflowDetails$data9 = _workflowDetails$data8.timeline[0]) === null || _workflowDetails$data9 === void 0 ? void 0 : _workflowDetails$data9.state}`),
    customChild: getTimelineCaptions(workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data10 = workflowDetails.data) === null || _workflowDetails$data10 === void 0 ? void 0 : _workflowDetails$data10.timeline[0])
  }) : /*#__PURE__*/React.createElement(ConnectingCheckPoints, null, (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data11 = workflowDetails.data) === null || _workflowDetails$data11 === void 0 ? void 0 : _workflowDetails$data11.timeline) && (workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data12 = workflowDetails.data) === null || _workflowDetails$data12 === void 0 ? void 0 : _workflowDetails$data12.timeline.map((checkpoint, index, arr) => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(CheckPoint, {
      keyValue: index,
      isCompleted: index === 0,
      info: checkpoint.comment,
      label: t(`${timelineStatusPrefix}${(checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction) === "REOPEN" ? checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint.performedAction : checkpoint === null || checkpoint === void 0 ? void 0 : checkpoint[statusAttribute]}`),
      customChild: getTimelineCaptions(checkpoint)
    }));
  }))))));
}

function ApplicationDetailsToast({
  t,
  showToast,
  closeToast,
  businessService
}) {
  var _showToast$error, _showToast$error2, _showToast$error3, _showToast$error4, _showToast$error5, _showToast$error6, _showToast$error7, _showToast$error8, _showToast$action2, _showToast$error9, _showToast$error10, _showToast$error11, _showToast$error12, _showToast$error13, _showToast$error14, _showToast$error15, _showToast$error16, _showToast$action4;
  if (businessService !== null && businessService !== void 0 && businessService.includes("NewTL") || businessService !== null && businessService !== void 0 && businessService.includes("TL") || businessService !== null && businessService !== void 0 && businessService.includes("EDITRENEWAL")) {
    var _showToast$action;
    let label = "";
    switch (showToast === null || showToast === void 0 ? void 0 : (_showToast$action = showToast.action) === null || _showToast$action === void 0 ? void 0 : _showToast$action.action) {
      case "SENDBACK":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error = showToast.error) === null || _showToast$error === void 0 ? void 0 : _showToast$error.message : t("TL_SENDBACK_CHECKLIST_MESSAGE_HEAD");
        break;
      case "FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error2 = showToast.error) === null || _showToast$error2 === void 0 ? void 0 : _showToast$error2.message : t("TL_FORWARD_SUCCESS_MESSAGE_MAIN");
        break;
      case "APPROVE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error3 = showToast.error) === null || _showToast$error3 === void 0 ? void 0 : _showToast$error3.message : t("TL_APPROVAL_CHECKLIST_MESSAGE_HEAD");
        break;
      case "SENDBACKTOCITIZEN":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error4 = showToast.error) === null || _showToast$error4 === void 0 ? void 0 : _showToast$error4.message : t("TL_SENDBACK_TOCITIZEN_CHECKLIST_MESSAGE_HEAD");
        break;
      case "REJECT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error5 = showToast.error) === null || _showToast$error5 === void 0 ? void 0 : _showToast$error5.message : t("TL_APPROVAL_REJ_MESSAGE_HEAD");
        break;
      case "RESUBMIT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error6 = showToast.error) === null || _showToast$error6 === void 0 ? void 0 : _showToast$error6.message : t("TL_APPLICATION_RESUBMIT_SUCCESS_MESSAGE_MAIN");
        break;
      case "CANCEL":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error7 = showToast.error) === null || _showToast$error7 === void 0 ? void 0 : _showToast$error7.message : t("TL_TL_CANCELLED_MESSAGE_HEAD");
        break;
      default:
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error8 = showToast.error) === null || _showToast$error8 === void 0 ? void 0 : _showToast$error8.message : t(`ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action2 = showToast.action) === null || _showToast$action2 === void 0 ? void 0 : _showToast$action2.action}_UPDATE_SUCCESS`);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, showToast && /*#__PURE__*/React.createElement(Toast, {
      error: showToast.key === "error",
      label: label,
      onClose: closeToast
    }));
  } else if (businessService !== null && businessService !== void 0 && businessService.includes("BPA") || businessService !== null && businessService !== void 0 && businessService.includes("BPA_LOW") || businessService !== null && businessService !== void 0 && businessService.includes("BPA_OC")) {
    var _showToast$action3;
    const getMessage = (messages = []) => {
      let returnValue = messages[0];
      if ((messages === null || messages === void 0 ? void 0 : messages.length) == 2) returnValue = businessService !== null && businessService !== void 0 && businessService.includes("BPA_OC") ? t(messages[1]) : t(messages[0]);else returnValue = t(messages[0]);
      return returnValue;
    };
    let label = "";
    switch (showToast === null || showToast === void 0 ? void 0 : (_showToast$action3 = showToast.action) === null || _showToast$action3 === void 0 ? void 0 : _showToast$action3.action) {
      case "REVOCATE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error9 = showToast.error) === null || _showToast$error9 === void 0 ? void 0 : _showToast$error9.message : getMessage(["BPA_APPROVAL_REVOCATED_MESSAGE_HEAD", "BPA_APPROVAL_OC_REVOCATED_MESSAGE_HEAD"]);
        break;
      case "VERIFY_AND_FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error10 = showToast.error) === null || _showToast$error10 === void 0 ? void 0 : _showToast$error10.message : getMessage(["BPA_FORWARD_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "SEND_BACK_TO_CITIZEN":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error11 = showToast.error) === null || _showToast$error11 === void 0 ? void 0 : _showToast$error11.message : getMessage(["BPA_SENDBACK_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "APPROVE":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error12 = showToast.error) === null || _showToast$error12 === void 0 ? void 0 : _showToast$error12.message : getMessage(["BPA_APPROVAL_CHECKLIST_MESSAGE_HEAD"]);
        break;
      case "REJECT":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error13 = showToast.error) === null || _showToast$error13 === void 0 ? void 0 : _showToast$error13.message : getMessage(["BPA_APPROVAL_REJECTED_MESSAGE_HEAD", "BPA_OC_APPROVAL_REJECTED_MESSAGE_HEAD"]);
        break;
      case "FORWARD":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error14 = showToast.error) === null || _showToast$error14 === void 0 ? void 0 : _showToast$error14.message : getMessage(["BPA_FORWARD_SUCCESS_MESSAGE_MAIN"]);
        break;
      case "SEND_BACK_FOR_DOCUMENT_VERIFICATION":
      case "SEND_BACK_FOR_FIELD_INSPECTION":
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error15 = showToast.error) === null || _showToast$error15 === void 0 ? void 0 : _showToast$error15.message : getMessage(["BPA_SENDBACK_SUCCESS_MESSAGE_MAIN"]);
        break;
      default:
        label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error16 = showToast.error) === null || _showToast$error16 === void 0 ? void 0 : _showToast$error16.message : t(`ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action4 = showToast.action) === null || _showToast$action4 === void 0 ? void 0 : _showToast$action4.action}_UPDATE_SUCCESS`);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, showToast && /*#__PURE__*/React.createElement(Toast, {
      error: showToast.key === "error",
      label: label,
      onClose: closeToast
    }));
  } else {
    var _showToast$error17, _showToast$action5;
    const label = (showToast === null || showToast === void 0 ? void 0 : showToast.key) === "error" ? showToast === null || showToast === void 0 ? void 0 : (_showToast$error17 = showToast.error) === null || _showToast$error17 === void 0 ? void 0 : _showToast$error17.message : `ES_${businessService}_${showToast === null || showToast === void 0 ? void 0 : (_showToast$action5 = showToast.action) === null || _showToast$action5 === void 0 ? void 0 : _showToast$action5.action}_UPDATE_SUCCESS`;
    return /*#__PURE__*/React.createElement(React.Fragment, null, showToast && /*#__PURE__*/React.createElement(Toast, {
      error: showToast.key === "error",
      label: t(label),
      onClose: closeToast
    }));
  }
}

function ApplicationDetailsActionBar({
  workflowDetails,
  displayMenu,
  onActionSelect,
  setDisplayMenu,
  businessService,
  forcedActionPrefix,
  ActionBarStyle = {},
  MenuStyle = {},
  applicationDetails
}) {
  var _user, _user$info, _user$info$roles, _applicationDetails$a, _workflowDetails$data, _workflowDetails$data2, _workflowDetails$data3, _actions$, _actions$$redirection, _workflowDetails$data4, _workflowDetails$data5, _actions$2, _actions$3, _actions$4;
  const {
    t
  } = useTranslation();
  let user = Digit.UserService.getUser();
  if (window.location.href.includes("/obps") || window.location.href.includes("/noc")) {
    const userInfos = sessionStorage.getItem("Digit.citizen.userRequestObject");
    const userInfo = userInfos ? JSON.parse(userInfos) : {};
    user = userInfo === null || userInfo === void 0 ? void 0 : userInfo.value;
  }
  const userRoles = (_user = user) === null || _user === void 0 ? void 0 : (_user$info = _user.info) === null || _user$info === void 0 ? void 0 : (_user$info$roles = _user$info.roles) === null || _user$info$roles === void 0 ? void 0 : _user$info$roles.map(e => e.code);
  let isSingleButton = false;
  let isMenuBotton = false;
  let isbelow = (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.plotArea) < 2500;
  const isTCP = userRoles.includes("TCP_HQ");
  let actions = workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : (_workflowDetails$data2 = _workflowDetails$data.actionState) === null || _workflowDetails$data2 === void 0 ? void 0 : (_workflowDetails$data3 = _workflowDetails$data2.nextActions) === null || _workflowDetails$data3 === void 0 ? void 0 : _workflowDetails$data3.filter(e => {
    if (isbelow && isTCP && e.action === "SEND_TO_STP" && businessService === "BPA") {
      return false;
    } else if (!isbelow && isTCP && (e.action === "APPROVE" || e.action === "APPROVAL_LETTER_GENERATE" || e.action === "REJECT") && businessService === "BPA") {
      return false;
    }
    return userRoles.some(role => {
      var _e$roles;
      return (_e$roles = e.roles) === null || _e$roles === void 0 ? void 0 : _e$roles.includes(role);
    }) || !e.roles;
  });
  if ((window.location.href.includes("/obps") || window.location.href.includes("/noc")) && (actions === null || actions === void 0 ? void 0 : actions.length) == 1 || actions !== null && actions !== void 0 && (_actions$ = actions[0]) !== null && _actions$ !== void 0 && (_actions$$redirection = _actions$.redirectionUrl) !== null && _actions$$redirection !== void 0 && _actions$$redirection.pathname.includes("/pt/property-details/") && (actions === null || actions === void 0 ? void 0 : actions.length) == 1) {
    isMenuBotton = false;
    isSingleButton = true;
  } else if ((actions === null || actions === void 0 ? void 0 : actions.length) > 0) {
    isMenuBotton = true;
    isSingleButton = false;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && isMenuBotton && !isSingleButton && /*#__PURE__*/React.createElement(ActionBar, {
    style: {
      ...ActionBarStyle
    }
  }, displayMenu && workflowDetails !== null && workflowDetails !== void 0 && (_workflowDetails$data4 = workflowDetails.data) !== null && _workflowDetails$data4 !== void 0 && (_workflowDetails$data5 = _workflowDetails$data4.actionState) !== null && _workflowDetails$data5 !== void 0 && _workflowDetails$data5.nextActions ? /*#__PURE__*/React.createElement(Menu, {
    localeKeyPrefix: forcedActionPrefix || `WF_EMPLOYEE_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}`,
    options: actions,
    optionKey: "action",
    t: t,
    onSelect: onActionSelect,
    style: MenuStyle
  }) : null, /*#__PURE__*/React.createElement(SubmitBar, {
    label: t("WF_TAKE_ACTION"),
    onSubmit: () => setDisplayMenu(!displayMenu)
  })), !(workflowDetails !== null && workflowDetails !== void 0 && workflowDetails.isLoading) && !isMenuBotton && isSingleButton && /*#__PURE__*/React.createElement(ActionBar, {
    style: {
      ...ActionBarStyle
    }
  }, /*#__PURE__*/React.createElement("button", {
    style: {
      color: "#FFFFFF",
      fontSize: "19px"
    },
    className: "submit-bar",
    name: actions === null || actions === void 0 ? void 0 : (_actions$2 = actions[0]) === null || _actions$2 === void 0 ? void 0 : _actions$2.action,
    value: actions === null || actions === void 0 ? void 0 : (_actions$3 = actions[0]) === null || _actions$3 === void 0 ? void 0 : _actions$3.action,
    onClick: e => {
      onActionSelect((actions === null || actions === void 0 ? void 0 : actions[0]) || {});
    }
  }, t(`${forcedActionPrefix || `WF_EMPLOYEE_${businessService === null || businessService === void 0 ? void 0 : businessService.toUpperCase()}`}_${actions === null || actions === void 0 ? void 0 : (_actions$4 = actions[0]) === null || _actions$4 === void 0 ? void 0 : _actions$4.action}`))));
}

const Close$6 = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}));
const CloseBtn$6 = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "icon-bg-secondary",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement(Close$6, null));
};
function ApplicationDetailsWarningPopup({
  action,
  workflowDetails,
  businessService,
  isWarningPop,
  closeWarningPopup
}) {
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    headerBarMain: /*#__PURE__*/React.createElement("h1", {
      className: "heading-m"
    }, t("PT_DUES_ARE_PENDING")),
    headerBarEnd: /*#__PURE__*/React.createElement(CloseBtn$6, {
      onClick: () => {
        closeWarningPopup();
      }
    }),
    hideSubmit: true,
    isDisabled: false,
    popupStyles: isMobile ? {} : {
      width: "29%",
      marginTop: "auto"
    }
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "30px"
    }
  }, /*#__PURE__*/React.createElement("h1", null, t("PT_YOU_HAVE"), " \u20B9", action === null || action === void 0 ? void 0 : action.AmountDueForPay, " ", t("PT_DUE_WARNING_MSG2"))), /*#__PURE__*/React.createElement(Row, {
    rowContainerStyle: {
      display: "flex"
    },
    labelStyle: {
      fontSize: "24px",
      fontWeight: "700",
      marginRight: "10%"
    },
    textStyle: {
      fontSize: "24px",
      fontWeight: "700",
      marginBottom: "20px"
    },
    label: `${t("PT_AMOUNT_DUE")}`,
    text: `₹${t(action === null || action === void 0 ? void 0 : action.AmountDueForPay)}`
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(ButtonSelector, {
    theme: "border",
    label: t('ES_PT_COMMON_CANCEL'),
    onSubmit: closeWarningPopup,
    style: {
      marginLeft: "10px"
    }
  }), /*#__PURE__*/React.createElement(ButtonSelector, {
    label: t('PT_COLLECT'),
    onSubmit: () => {
      var _action$redirectionUr;
      return window.location.assign(`${window.location.origin}${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrl) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
    },
    style: {
      marginLeft: "10px"
    }
  })))), ")");
}

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var toString = Object.prototype.toString;
function isArray(val) {
  return toString.call(val) === '[object Array]';
}
function isUndefined(val) {
  return typeof val === 'undefined';
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString(val) {
  return typeof val === 'string';
}
function isNumber(val) {
  return typeof val === 'number';
}
function isObject(val) {
  return val !== null && typeof val === 'object';
}
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === '[object Date]';
}
function isFile(val) {
  return toString.call(val) === '[object File]';
}
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === 'undefined') {
    return;
  }
  if (typeof obj !== 'object') {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}
var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
var buildURL = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }
      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
};

function InterceptorManager() {
  this.handlers = [];
}
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager;

var transformData = function transformData(data, headers, fns) {
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code
    };
  };
  return error;
};

var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));
      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }
      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }
      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }
      if (secure === true) {
        cookie.push('secure');
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

var isAbsoluteURL = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type'];
    }
    var request = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }
    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
    request.timeout = config.timeout;
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response);
      request = null;
    };
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(createError('Request aborted', config, 'ECONNABORTED', request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(createError('Network Error', config, null, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request));
      request = null;
    };
    if (utils.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          delete requestHeaders[key];
        } else {
          request.setRequestHeader(key, val);
        }
      });
    }
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }
    if (config.cancelToken) {
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }
        request.abort();
        reject(cancel);
        request = null;
      });
    }
    if (!requestData) {
      requestData = null;
    }
    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    adapter = xhr;
  }
  return adapter;
}
var defaults = {
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {}
    }
    return data;
  }],
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults;

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData(config.data, config.headers, config.transformRequest);
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};

var mergeConfig = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
  var directMergeKeys = ['validateStatus'];
  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }
  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });
  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
  var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils.forEach(otherKeys, mergeDeepProperties);
  return config;
};

function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
Axios.prototype.request = function request(config) {
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }
  config = mergeConfig(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });
  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }
  return promise;
};
Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios;

function Cancel(message) {
  this.message = message;
}
Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};
Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;

function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};
var CancelToken_1 = CancelToken;

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var isAxiosError = function isAxiosError(payload) {
  return typeof payload === 'object' && payload.isAxiosError === true;
};

function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);
  utils.extend(instance, Axios_1.prototype, context);
  utils.extend(instance, context);
  return instance;
}
var axios = createInstance(defaults_1);
axios.Axios = Axios_1;
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};
axios.Cancel = Cancel_1;
axios.CancelToken = CancelToken_1;
axios.isCancel = isCancel;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
var axios_1 = axios;
var _default = axios;
axios_1.default = _default;

var axios$1 = axios_1;

axios$1.defaults.headers.common['X-XSS-Protection'] = '1; mode=block';
axios$1.defaults.headers.common['X-Frame-Options'] = 'DENY';
axios$1.defaults.headers.common['Content-Security-Policy'] = "frame-ancestors 'none';";
axios$1.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
axios$1.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
axios$1.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
axios$1.interceptors.response.use(res => res, err => {
  const isEmployee = window.location.pathname.split("/").includes("employee");
  if (err && err.response && err.response.data && err.response.data.Errors) {
    for (const error of err.response.data.Errors) {
      if (error.message.includes("InvalidAccessTokenException")) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/digit-ui/citizen" + `?from=${encodeURIComponent(window.location.pathname + window.location.search)}`;
      }
    }
  }
  throw err;
});
const requestInfo = () => ({
  authToken: Digit.UserService.getUser().access_token || null
});
const authHeaders = () => ({
  "auth-token": Digit.UserService.getUser().access_token || null
});
const userServiceData = () => ({
  userInfo: Digit.UserService.getUser().info
});
window.Digit = window.Digit || {};
window.Digit = {
  ...window.Digit,
  RequestCache: window.Digit.RequestCache || {}
};
const Request = async ({
  method: _method = "POST",
  url,
  data: _data = {},
  headers: _headers = {},
  useCache: _useCache = false,
  params: _params = {},
  auth,
  urlParams: _urlParams = {},
  userService,
  locale: _locale = true,
  authHeader: _authHeader = false,
  setTimeParam: _setTimeParam = true,
  userDownload: _userDownload = false,
  noResponseData: _noResponseData = false,
  noRequestInfo: _noRequestInfo = false,
  multipartFormData: _multipartFormData = false,
  multipartData: _multipartData = {}
}) => {
  if (_method.toUpperCase() === "POST") {
    const ts = new Date().getTime();
    _data.RequestInfo = {
      apiId: "Rainmaker"
    };
    if (auth) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...requestInfo()
      };
    }
    if (userService) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...userServiceData()
      };
    }
    if (_locale) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        msgId: `${ts}|${Digit.StoreData.getCurrentLanguage()}`
      };
    }
    if (_noRequestInfo) {
      delete _data.RequestInfo;
    }
  }
  const headers1 = {
    "Content-Type": "application/json",
    Accept: window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? "application/pdf,application/json" : "*/*",
    "X-XSS-Protection": "1; mode=block",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none';",
    "X-Content-Type-Options": "nosniff",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Cache-Control": "no-cache, no-store, must-revalidate"
  };
  if (_authHeader) _headers = {
    ..._headers,
    ...authHeaders()
  };
  if (_userDownload) _headers = {
    ..._headers,
    ...headers1
  };
  let key = "";
  if (_useCache) {
    key = `${_method.toUpperCase()}.${url}.${btoa(escape(JSON.stringify(_params, null, 0)))}.${btoa(escape(JSON.stringify(_data, null, 0)))}`;
    const value = window.Digit.RequestCache[key];
    if (value) {
      return value;
    }
  } else if (_setTimeParam) {
    _params._ = Date.now();
  }
  let _url = url.split("/").map(path => {
    let key = path.split(":")[1];
    return _urlParams[key] ? _urlParams[key] : path;
  }).join("/");
  if (_multipartFormData) {
    const multipartFormDataRes = await axios$1({
      method: _method,
      url: _url,
      data: _multipartData.data,
      params: _params,
      headers: {
        "Content-Type": "multipart/form-data",
        "auth-token": Digit.UserService.getUser().access_token || null
      }
    });
    return multipartFormDataRes;
  }
  const tenantInfo = Digit.SessionStorage.get("userType") === "citizen" ? Digit.ULBService.getStateId() : Digit.ULBService.getCurrentTenantId() || Digit.ULBService.getStateId();
  if (!_params["tenantId"] && window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE")) {
    _params["tenantId"] = tenantInfo;
  }
  const res = _userDownload ? await axios$1({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers,
    responseType: "arraybuffer"
  }) : await axios$1({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers
  });
  if (_userDownload) return res;
  if (_noResponseData) return res;
  const returnData = res.data || res.response.data || {};
  if (_useCache && res.data && Object.keys(returnData).length !== 0) {
    window.Digit.RequestCache[key] = returnData;
  }
  return returnData;
};
const ServiceRequest = async ({
  serviceName,
  method: _method2 = "POST",
  url,
  data: _data2 = {},
  headers: _headers2 = {},
  useCache: _useCache2 = false,
  params: _params2 = {},
  auth,
  userService
}) => {
  const preHookName = `${serviceName}Pre`;
  const postHookName = `${serviceName}Post`;
  let reqParams = _params2;
  let reqData = _data2;
  if (window[preHookName] && typeof window[preHookName] === "function") {
    let preHookRes = await window[preHookName]({
      params: _params2,
      data: _data2
    });
    reqParams = preHookRes.params;
    reqData = preHookRes.data;
  }
  const resData = await Request({
    method: _method2,
    url,
    data: reqData,
    headers: _headers2,
    useCache: _useCache2,
    params: reqParams,
    auth,
    userService
  });
  if (window[postHookName] && typeof window[postHookName] === "function") {
    return await window[postHookName](resData);
  }
  return resData;
};

const Urls = {
  MDMS: `/egov-mdms-service/v1/_search`,
  MdmsSearchV2: `/mdms-v2/v1/_search`,
  MdmsCreateV2: `/mdms-v2/v1/_create`,
  MdmsUpdateV2: `/mdms-v2/v1/_update`,
  opensearchAPI: `/bpa-services/v1/bpa/_plainsearch`,
  WorkFlow: `/egov-workflow-v2/egov-wf/businessservice/_search`,
  WorkFlowProcessSearch: `/egov-workflow-v2/egov-wf/process/_search`,
  WorkFlowProcessCount: `/egov-workflow-v2/egov-wf/process/_count`,
  localization: `/localization/messages/v1/_search`,
  qrCodeURL: {
    bpaQRCode: `/bpa-services/v1/bpa/_qrcodeurl`,
    tlQRCode: `/tl-services/v1/ltp/_qrcodeurl`,
    SelfMap: `/bpa-services/v1/bpa/_qrcodeurl/_SelfMap`
  },
  logoUrl: {
    bpaLogoUrl: `/bpa-services/v1/bpa/_logourl?`
  },
  bpaService: {
    remarksDetail: `/bpa-services/v1/bpa/_remarksDetail/_create`,
    remarksPaymentDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=PaymentDetails`,
    khasraDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=khasraDetails`,
    nocRemarks: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocRemarks`,
    remarksDocument: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DocumentDetails`,
    remarksSiteInspection: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=InspectionDetail`,
    remarksDrawing: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DrawingsDetails`,
    remarkspFARDetail: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=remarksDetails`,
    remarksNoc: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocDetails`,
    remarksNoting: `/bpa-services/v1/bpa/_remarksDetail/_search1?`,
    getNotice: `/bpa-services/v1/bpa/_getNotice?vaadId=`
  },
  location: {
    localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=ADMIN&boundaryType=Locality`,
    revenue_localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=REVENUE&boundaryType=Locality`,
    business_services: `/bpa-services/v1/bpa/business-services`
  },
  pgr_search: `/pgr-services/v2/request/_search`,
  pgr_update: `/pgr-services/v2/request/_update`,
  filter_data: `https://run.mocky.io/v3/597a50a0-90e5-4a45-b82e-8a2186b760bd`,
  FileStore: "/filestore/v1/files",
  FileFetch: "/filestore/v1/files/url",
  PGR_Create: `/pgr-services/v2/request/_create`,
  pgr_count: `/pgr-services/v2/request/_count`,
  OTP_Send: "/user-otp/v1/_send",
  Otp_Validate: "/otp/v1/_validate",
  OTP_Send_verify: "/otp/_verify",
  trackAppliactionStatus: "/bpa-services/v1/bpa/_trackapplicationstatus",
  Authenticate: "/user/oauth/token",
  RegisterUser: "/user/citizen/_create",
  ChangePassword: "/user/password/nologin/_update",
  ChangePassword1: "/user/password/_update",
  UserProfileUpdate: "/user/profile/_update",
  UserCaptchaGenerate: "/user/captcha/generate",
  UserCaptchaValidate: "/user/captcha/validate",
  EmployeeSearch: "/egov-hrms/employees/_search",
  UserManualDelete: "/bpa-services/v1/adminApi/_usermanual/_delete",
  InboxSearch: "/inbox/v1/_search",
  InboxSearchApplication: "/bpa-services/v1/bpa/_dashboard/_count",
  SearchApplication: "/bpa-services/v1/bpa/_dashboard/_applicationDetail",
  tlSearchApplication: "/tl-services/v1/_dashboard/_applicationDetail",
  InboxSearchApplicationProfessional: "/tl-services/v1/_dashboard/_count",
  UserSearch: "/user/_search",
  UserManualCreate: `/bpa-services/v1/adminApi/_usermanual/_create`,
  UserManualSearch: `/bpa-services/v1/adminApi/_usermanual/_search`,
  UserLogout: "/user/_logout",
  Shortener: "/egov-url-shortening/shortener",
  fsm: {
    search: "/fsm/v1/_search",
    create: "/fsm/v1/_create",
    update: "/fsm/v1/_update",
    vendorSearch: "/vendor/v1/_search",
    vehicleSearch: "/vehicle/v1/_search",
    audit: "/fsm/v1/_audit",
    vehicleTripSearch: "/vehicle/trip/v1/_search",
    billingSlabSearch: "/fsm-calculator/v1/billingSlab/_search",
    vehilceUpdate: "/vehicle/trip/v1/_update",
    vehicleTripCreate: "/vehicle/trip/v1/_create"
  },
  form11: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  form12: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  payment: {
    fetch_bill: "/billing-service/bill/v2/_fetchbill",
    demandSearch: "/billing-service/demand/_search",
    create_reciept: "/collection-services/payments/_create",
    print_reciept: "/collection-services/payments",
    generate_pdf: "/pdf-service/v1/_create",
    create_citizen_reciept: "/pg-service/transaction/v1/_create",
    update_citizen_reciept: "/pg-service/transaction/v1/_update",
    search_bill: "/billing-service/bill/v2/_search",
    reciept_search: "/collection-services/payments/:buisnessService/_search",
    obps_Reciept_Search: "/collection-services/payments/_search"
  },
  dsc: {
    signParams: "/dsc-service/v1/signature/getSignParams"
  },
  pt: {
    fectch_property: "/property-services/property/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    create: "/property-services/property/_create",
    search: "/property-services/property/_search",
    update: "/property-services/property/_update",
    pt_calculation_estimate: "/pt-calculator-v2/propertytax/v2/_estimate",
    assessment_create: "/property-services/assessment/_create",
    assessment_search: "/property-services/assessment/_search",
    payment_search: "/collection-services/payments/PT/_search",
    pt_calculate_mutation: "/pt-calculator-v2/propertytax/mutation/_calculate"
  },
  dss: {
    dashboardConfig: "/dashboard-analytics/dashboard/getDashboardConfig",
    getCharts: "/dashboard-analytics/dashboard/getChartV2"
  },
  mcollect: {
    search: "/echallan-services/eChallan/v1/_search",
    create: "/echallan-services/eChallan/v1/_create?",
    fetch_bill: "/billing-service/bill/v2/_fetchbill?",
    search_bill: "/egov-searcher/bill-genie/mcollectbills/_get",
    search_bill_pt: "/egov-searcher/bill-genie/billswithaddranduser/_get",
    update: "/echallan-services/eChallan/v1/_update",
    download_pdf: "/egov-pdf/download/UC/mcollect-challan",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    bill_download: "/egov-pdf/download/bills/consolidatedbill",
    count: "/echallan-services/eChallan/v1/_count"
  },
  hrms: {
    search: "/egov-hrms/employees/_search",
    count: "/egov-hrms/employees/_count",
    create: "/egov-hrms/employees/_create",
    update: "/egov-hrms/employees/_update",
    employeeSearch: "/user/users/_jobdelegation/_employeeSearch",
    employeeFileTransfer: "/user/users/_employeeFileTransfer",
    deactivateUser: "/user/users/_deactivate"
  },
  tl: {
    create: "/tl-services/v1/_create",
    search: "/tl-services/v1/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    download_pdf: "/egov-pdf/download/TL/",
    update: "/tl-services/v1/_update",
    billingslab: "/tl-calculator/billingslab/_search",
    designOfApproval: "/tl-services/_DesignOfApprovalLetter",
    workflowEsclate: "/egov-workflow-v2/egov-wf/auto/BPAREG/_escalate",
    coaValidate: "/tl-services/v1/validate/_architectureNo",
    misReportRegistration: "/tl-services/v1/_misReportRegistration"
  },
  receipts: {
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    payments: "/collection-services/payments",
    count: "/egov-hrms/employees/_count"
  },
  obps: {
    compliance_create: "/bpa-services/_compliance/_create",
    compliance_search: "/bpa-services/_compliance/_search",
    compliance_update: "/bpa-services/_compliance/_update",
    scrutinyDetails: "/edcr/rest/dcr/scrutinydetails",
    comparisionReport: "/edcr/rest/dcr/occomparison",
    create: "/bpa-services/v1/bpa/_create",
    createForm11: "/bpa-services/v1/subdivision/_create",
    createLandUseUP: "/bpa-services/v1/_landUse/_create",
    createOwner: "/bpa-services/v1/_owner/_create",
    updateOwner: "/bpa-services/v1/_owner/_update",
    createPurchasableFAR: "/bpa-services/v1/_purchasableFAR/_create",
    updatePurchasableFAR: "/bpa-services/v1/_purchasableFAR/_update",
    createFormCLU: "/bpa-services/v1/subdivision/_create",
    createForm34: "/bpa-services/v1/subdivision/_create",
    createForm26: "/bpa-services/v1/offences/_create",
    nocSearch: "/noc-services/v1/noc/_search",
    updateNOC: "/noc-services/v1/noc/_update",
    update: "/bpa-services/v1/bpa/_update",
    updateForm11: "/bpa-services/v1/subdivision/_update",
    updateFormCLU: "/bpa-services/v1/subdivision/_update",
    updateForm34: "/bpa-services/v1/subdivision/_update",
    updateFormLandUse: "/bpa-services/v1/_landUse/_update",
    bpaSearch: "/bpa-services/v1/bpa/_search",
    ltpGrading: "/bpa-services/v1/bpa/_dashboard/_fastpasHome",
    bpaSearchChallan: "/bpa-services/v1/bpa/_searchChallan",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    searchLandUseUP: "/bpa-services/v1/_landUse/_search",
    searchfrom11: "/bpa-services/v1/subdivision/_search",
    searchfrom26: "/bpa-services/v1/subdivision/_search",
    searchFromCLU: "/bpa-services/v1/subdivision/_search",
    searchFrom34: "/bpa-services/v1/subdivision/_search",
    ownerSearch: "/bpa-services/v1/_owner/_search",
    searchPurchasableFar: "/bpa-services/v1/_purchasableFAR/_search",
    bpaRegSearch: "/tl-services/v1/BPAREG/_search",
    bpaRegCreate: "/tl-services/v1/BPAREG/_create",
    bpaRegGetBill: "/tl-calculator/v1/BPAREG/_getbill",
    bpaRegUpdate: "/tl-services/v1/BPAREG/_update",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    edcrreportdownload: "/bpa-services/v1/bpa/_permitorderedcr",
    designOfApproval: "/bpa-services/_DesignOfApprovalLetter",
    designOfStuctural: "/bpa-services/_Structralcertificate",
    farIntimationLetter: "/bpa-services/_FarInimitionLetter",
    scheduleInspection: "/bpa-services/v1/bpa/_dashboard/_inspection",
    applicationDetailData: "/bpa-services/v1/bpa//_dashboard/_applicationDetailData",
    applicationDetailDataView: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    fetchProfessional: "/tl-services/v1/_dashboard/_applicationDetailData",
    fetchAppendex: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    paymentList: "/collection-services/payments/_plainsearch",
    paymentReport: "/bpa-services/v1/_paymentReport",
    echargesReport: "/bpa-services/v1/_echargesReport",
    applicationReport: "/bpa-services/v1/_applicationReport",
    applicationMisReport: "/bpa-services/v1/bpa/_extarctMisData",
    paymentMisReport: "/bpa-services/v1/bpa/_extractAllMisData",
    paymentMisReportNew: "/bpa-services/v1/bpa/_extractAllMisData",
    dashboardReport: "/bpa-services/v1/bpa/_bidashboard",
    scrutinyFailedReport: "/edcr/rest/dcr/not-accepted-files",
    inwardApplicationReport: "/bpa-services/v1/_inwardApplicationReport",
    selfApprovalReport: "/bpa-services/v1/_selfCertification",
    installments: "/bpa-calculator/api/installments/_calculate",
    fastpassSearch: "/bpa-services/v1/bpa/_plainsearch",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    bpacalculate: "/bpa-calculator/_calculate",
    bpacalculatechallan: "/bpa-calculator/_calculateChallan",
    deleteChallan: "/bpa-calculator/bpa/delete-challan",
    migratedSearch: "/bpa-services/v1/bpamigration/_search",
    migratedSearchappNo: "/bpa-services/v1/bpamigration/_searchByAppNo",
    employeeSearchList: "/user/users/_jobdelegation/_employeeSearch",
    totalAmountOfCharges: "/bpa-services/v1/bpa/_totalAmountOfCharges",
    taxHeadEstimateSearch: "/bpa-services/v1/bpa/_taxHeadEstimateSearch",
    employeeWorkflowCount: "/bpa-services/v1/adminApi/_employee-workflow-count",
    installmentCalculate: "/bpa-calculator/_insatllmentCalculate",
    checkPaymentStatus: "/bpa-ui/application-payment-status/live-status",
    challanUpdaterDirect: "/bpa-ui/challan-updater-direct",
    getSelfApprovalData: "/bpa-services/v1/bpa/_dashboard/_selfcount"
  },
  edcr: {
    create: "/edcr/rest/dcr/scrutinize"
  },
  land: {
    chatBoard_data_search: "/land-services/egscrutiny/_search1?applicationNumber",
    chatBoard_data_search3: "/land-services/egscrutiny/_search3?applicationNumber",
    modal_data_search: "/land-services/egscrutiny/_search?applicationNumber"
  },
  events: {
    search: "/egov-user-event/v1/events/_search",
    update: "/egov-user-event/v1/events/lat/_update",
    updateEvent: "/egov-user-event/v1/events/_update",
    updateEventCDG: "/egov-user-event/v1/events/lat/_update",
    count: "/egov-user-event/v1/events/notifications/_count",
    create: "/egov-user-event/v1/events/_create"
  },
  ws: {
    water_search: "/ws-services/wc/_search",
    sewarage_search: "/sw-services/swc/_search"
  },
  engagement: {
    document: {
      search: "/egov-document-uploader/egov-du/document/_search",
      create: "/egov-document-uploader/egov-du/document/_create",
      delete: "/egov-document-uploader/egov-du/document/_delete",
      update: "/egov-document-uploader/egov-du/document/_update"
    },
    surveys: {
      create: "/egov-survey-services/egov-ss/survey/_create",
      update: "/egov-survey-services/egov-ss/survey/_update",
      search: "/egov-survey-services/egov-ss/survey/_search",
      delete: "/egov-survey-services/egov-ss/survey/_delete",
      submitResponse: "/egov-survey-services/egov-ss/survey/response/_submit",
      showResults: "/egov-survey-services/egov-ss/survey/response/_results"
    }
  },
  noc: {
    nocSearch: "/noc-services/v1/noc/_search",
    nocExcelSearch: "/noc-services/v1/noc/excel/search",
    nocExcelCreate: "/noc-services/v1/noc/excel/create",
    nocExcelUpdate: "/noc-services/v1/noc/excel/update",
    nocCountSearch: "/noc-services/v1/noc/_dashboard/noc/_count",
    nocCountApplicationData: "/noc-services/v1/noc/_dashboard/noc/_applicationDetailData"
  }
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function isDate$1(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate$1(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

var formatters = {
  y: function (date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
var formatters$1 = {
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  y: function (date, token, localize) {
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters.y(date, token);
  },
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'Q':
        return String(quarter);
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'q':
        return String(quarter);
      case 'qq':
        return addLeadingZeros(quarter, 2);
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  M: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  L: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'L':
        return String(month + 1);
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters.d(date, token);
  },
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'e':
        return String(localDayOfWeek);
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'c':
        return String(localDayOfWeek);
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case 'i':
        return String(isoDayOfWeek);
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters.h(date, token);
  },
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters.H(date, token);
  },
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters.m(date, token);
  },
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters.s(date, token);
  },
  S: function (date, token) {
    return formatters.S(date, token);
  },
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'XXXX':
      case 'XX':
        return formatTimezone(timezoneOffset);
      case 'XXXXX':
      case 'XXX':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'xxxx':
      case 'xx':
        return formatTimezone(timezoneOffset);
      case 'xxxxx':
      case 'xxx':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}
function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}
function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

const stringReplaceAll$1 = (str = "", searcher = "", replaceWith = "") => {
  if (searcher == "") return str;
  while (str.includes(searcher)) {
    str = str.replace(searcher, replaceWith);
  }
  return str;
};

const localStoreSupport = () => {
  try {
    return "sessionStorage" in window && window["sessionStorage"] !== null;
  } catch (e) {
    return false;
  }
};
const k$1 = key => `Digit.${key}`;
const getStorage = storageClass => ({
  get: key => {
    if (localStoreSupport() && key) {
      let valueInStorage = storageClass.getItem(k$1(key));
      if (!valueInStorage || valueInStorage === "undefined") {
        return null;
      }
      const item = JSON.parse(valueInStorage);
      if (Date.now() > item.expiry) {
        storageClass.removeItem(k$1(key));
        return null;
      }
      return item.value;
    } else if (typeof window !== "undefined") {
      var _window, _window$eGov;
      return ((_window = window) === null || _window === void 0 ? void 0 : (_window$eGov = _window.eGov) === null || _window$eGov === void 0 ? void 0 : _window$eGov.Storage) && window.eGov.Storage[k$1(key)].value;
    } else {
      return null;
    }
  },
  set: (key, value, ttl = 86400) => {
    const item = {
      value,
      ttl,
      expiry: Date.now() + ttl * 1000
    };
    if (localStoreSupport()) {
      storageClass.setItem(k$1(key), JSON.stringify(item));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      window.eGov.Storage[k$1(key)] = item;
    }
  },
  del: key => {
    if (localStoreSupport()) {
      storageClass.removeItem(k$1(key));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      delete window.eGov.Storage[k$1(key)];
    }
  }
});
const PersistantStorage = getStorage(window.localStorage);

const SortByName = (na, nb) => {
  if (na < nb) {
    return -1;
  }
  if (na > nb) {
    return 1;
  }
  return 0;
};
const GetCitiesWithi18nKeys = (MdmsRes, moduleCode) => {
  const cityList = MdmsRes.tenant.citymodule && MdmsRes.tenant.citymodule.find(module => module.code === moduleCode).tenants || [];
  const citiesMap = cityList.map(city => city.code);
  const cities = MdmsRes.tenant.tenants.filter(city => citiesMap.includes(city.code)).map(({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber
  }) => ({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber,
    i18nKey: "TENANT_TENANTS_" + code.replace(".", "_").toUpperCase()
  })).sort((cityA, cityB) => {
    const na = cityA.name.toLowerCase(),
      nb = cityB.name.toLowerCase();
    return SortByName(na, nb);
  });
  return cities;
};
const initRequestBody = tenantId => ({
  MdmsCriteria: {
    tenantId,
    moduleDetails: [{
      moduleName: "common-masters",
      masterDetails: [{
        name: "Department"
      }, {
        name: "Designation"
      }, {
        name: "StateInfo"
      }, {
        name: "wfSlaConfig"
      }]
    }, {
      moduleName: "tenant",
      masterDetails: [{
        name: "tenants"
      }, {
        name: "citymodule"
      }]
    }, {
      moduleName: "DIGIT-UI",
      masterDetails: [{
        name: "ApiCachingSettings"
      }]
    }, {
      moduleName: "BPA",
      masterDetails: [{
        name: "SchemesRate"
      }]
    }]
  }
});
const getCriteria = (tenantId, moduleDetails) => {
  return {
    MdmsCriteria: {
      tenantId,
      ...moduleDetails
    }
  };
};
const getGeneralCriteria = (tenantId, moduleCode, type) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: type
      }]
    }]
  }
});
const getMultipleTypes = (tenantId, moduleCode, types) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: types.map(type => {
        if (typeof type === "object") {
          return {
            name: type.name,
            filter: type.filter
          };
        }
        return {
          name: type
        };
      })
    }]
  }
});
const getReceiptKey = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "uiCommonPay"
      }]
    }]
  }
});
const getModuleServiceDefsCriteria = (tenantId, moduleCode) => ({
  type: "serviceDefs",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: `RAINMAKER-${moduleCode}`,
      masterDetails: [{
        name: "ServiceDefs"
      }]
    }]
  }
});
const getSanitationTypeCriteria = (tenantId, moduleCode) => ({
  type: "SanitationType",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SanitationType",
        filter: null
      }]
    }]
  }
});
const getPitTypeCriteria = (tenantId, moduleCode) => ({
  type: "PitType",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PitType",
        filter: null
      }]
    }]
  }
});
const getApplicationChannelCriteria = (tenantId, moduleCode) => ({
  type: "ApplicationChannel",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ApplicationChannel",
        filter: null
      }]
    }]
  }
});
const getPropertyTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getPropertyUsageCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getCommonFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CommonFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPreFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PreFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPostFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PostFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getConfig = (tenantId, moduleCode) => ({
  type: "Config",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Config"
      }]
    }]
  }
});
const getVehicleTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "VehicleMakeModel",
        filter: null
      }]
    }]
  }
});
const getChecklistCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CheckList",
        filter: null
      }]
    }]
  }
});
const getSlumLocalityCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Slum"
      }]
    }]
  }
});
const getPropertyOwnerTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerType"
      }]
    }]
  }
});
const getSubPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SubOwnerShipCategory"
      }]
    }]
  }
});
const getPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getTradeOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getDocumentRequiredScreenCategory = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Documents"
      }]
    }]
  }
});
const getDefaultMapConfig = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "MapConfig"
      }]
    }]
  }
});
const getUsageCategoryList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "UsageCategory"
      }]
    }]
  }
});
const getPTPropertyTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType"
      }]
    }]
  }
});
const getTLStructureTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "StructureType"
      }]
    }]
  }
});
const getTLAccessoriesTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "AccessoriesCategory"
      }]
    }]
  }
});
const getTLFinancialYearList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FinancialYear",
        filter: `[?(@.module == "TL")]`
      }]
    }]
  }
});
const getPTFloorList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Floor"
      }]
    }]
  }
});
const getReasonCriteria = (tenantId, moduleCode, type, payload) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: payload.map(mdmsLoad => ({
        name: mdmsLoad
      }))
    }]
  }
});
const getBillingServiceForBusinessServiceCriteria = filter => ({
  moduleDetails: [{
    moduleName: "BillingService",
    masterDetails: [{
      name: "BusinessService",
      filter
    }, {
      name: "TaxHeadMaster"
    }, {
      name: "TaxPeriod"
    }]
  }]
});
const getRoleStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RoleStatusMapping",
        filter: null
      }]
    }]
  }
});
const getRentalDetailsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RentalDetails"
      }]
    }]
  }
});
const getChargeSlabsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ChargeSlabs"
      }]
    }]
  }
});
const getGenderTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "GenderType"
      }]
    }]
  }
});
const getDssDashboardCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "dashboard-config"
      }]
    }]
  }
});
const getMCollectBillingServiceCriteria = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BusinessService",
        filter: filter
      }]
    }]
  }
});
const getTradeUnitsDataList = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeType",
        filter: filter
      }]
    }]
  }
});
const getMCollectApplicationStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "applicationStatus"
      }]
    }]
  }
});
const getHrmsEmployeeRolesandDesignations = () => ({
  moduleDetails: [{
    moduleName: "common-masters",
    masterDetails: [{
      name: "Department",
      filter: "[?(@.active == true)]"
    }, {
      name: "Designation",
      filter: "[?(@.active == true)]"
    }]
  }, {
    moduleName: "tenant",
    masterDetails: [{
      name: "tenants"
    }]
  }, {
    moduleName: "ACCESSCONTROL-ROLES",
    masterDetails: [{
      name: "roles",
      filter: "$.[?(@.code!='CITIZEN')]"
    }]
  }, {
    moduleName: "egov-location",
    masterDetails: [{
      name: "TenantBoundary"
    }]
  }]
});
const getFSTPPlantCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPPlantInfo"
      }]
    }]
  }
});
const getCancelReceiptReason = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CancelReceiptReason"
      }]
    }]
  }
});
const getReceiptStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }]
    }]
  }
});
const getCancelReceiptReasonAndStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }, {
        name: "uiCommonPay"
      }]
    }]
  }
});
const getDocumentTypesCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DocTypeMapping"
      }]
    }]
  }
});
const getTradeTypeRoleCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeTypetoRoleMapping"
      }]
    }]
  }
});
const getMSDropDownCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DropdownsConfig"
      }]
    }]
  }
});
const getLandUseCategories = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BasicFarPurchasable"
      }]
    }]
  }
});
const getFSTPORejectionReasonCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPORejectionReason",
        filter: null
      }]
    }]
  }
});
const getFSMPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PaymentType",
        filter: null
      }]
    }]
  }
});
const getFSMTripNumberCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TripNumber",
        filter: null
      }]
    }]
  }
});
const getFSMReceivedPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceivedPaymentType",
        filter: null
      }]
    }]
  }
});
const GetEgovLocations = MdmsRes => {
  return MdmsRes["egov-location"].TenantBoundary[0].boundary.children.map(obj => ({
    name: obj.localname,
    i18nKey: obj.localname
  }));
};
const GetServiceDefs = (MdmsRes, moduleCode) => MdmsRes[`RAINMAKER-${moduleCode}`].ServiceDefs.filter(def => def.active);
const GetSanitationType = MdmsRes => MdmsRes["FSM"].SanitationType.filter(type => type.active);
const GetPitType = MdmsRes => MdmsRes["FSM"].PitType.filter(item => item.active).map(type => ({
  ...type,
  i18nKey: `PITTYPE_MASTERS_${type.code}`
}));
const GetApplicationChannel = MdmsRes => MdmsRes["FSM"].ApplicationChannel.filter(type => type.active).map(channel => ({
  ...channel,
  i18nKey: `ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_${channel.code}`
}));
const GetPropertyType = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && !property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetPropertySubtype = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetVehicleType = MdmsRes => MdmsRes["Vehicle"].VehicleMakeModel.filter(vehicle => vehicle.active).filter(vehicle => vehicle.make).map(vehicleDetails => {
  return {
    ...vehicleDetails,
    i18nKey: `COMMON_MASTER_VEHICLE_${vehicleDetails.code}`
  };
});
const GetSlumLocalityMapping = (MdmsRes, tenantId) => MdmsRes["FSM"].Slum.filter(type => type.active).reduce((prev, curr) => {
  return prev[curr.locality] ? {
    ...prev,
    [curr.locality]: [...prev[curr.locality], {
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  } : {
    ...prev,
    [curr.locality]: [{
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  };
}, {});
const GetPropertyOwnerShipCategory = MdmsRes => MdmsRes["PropertyTax"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetTradeOwnerShipCategory = MdmsRes => MdmsRes["common-masters"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetPropertyOwnerType = MdmsRes => MdmsRes["PropertyTax"].OwnerType.filter(owner => owner.active).map(ownerDetails => {
  return {
    ...ownerDetails,
    i18nKey: `PROPERTYTAX_OWNERTYPE_${ownerDetails.code}`
  };
});
const getSubPropertyOwnerShipCategory = MdmsRes => {
  MdmsRes["PropertyTax"].SubOwnerShipCategory.filter(category => category.active).map(subOwnerShipDetails => {
    return {
      ...subOwnerShipDetails,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${subOwnerShipDetails.code}`
    };
  });
  sessionStorage.setItem("getSubPropertyOwnerShipCategory", JSON.stringify(MdmsRes));
};
const getDocumentRequiredScreen = MdmsRes => {
  MdmsRes["PropertyTax"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getTLDocumentRequiredScreen = MdmsRes => {
  MdmsRes["TradeLicense"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getMapConfig = MdmsRes => {
  MdmsRes["PropertyTax"].MapConfig.filter(MapConfig => MapConfig).map(MapData => {
    return {
      ...MapConfig,
      defaultconfig: MapData.defaultConfig
    };
  });
};
const getUsageCategory = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(UsageCategory => UsageCategory.active).map(UsageCategorylist => {
  return {
    ...UsageCategorylist,
    i18nKey: `PROPERTYTAX_BILLING_SLAB_${UsageCategorylist.code}`
  };
});
const getPTPropertyType = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(PropertyType => PropertyType.active).map(PTPropertyTypelist => {
  return {
    ...UsageCategorylist,
    i18nKey: `COMMON_PROPTYPE_${stringReplaceAll$1(PTPropertyTypelist.code, ".", "_")}`
  };
});
const getTLStructureType = MdmsRes => MdmsRes["common-masters"].StructureType.filter(StructureType => StructureType.active).map(TLStructureTypeList => {
  return {
    ...TLStructureTypeList,
    i18nKey: `COMMON_MASTERS_STRUCTURETYPE_${stringReplaceAll$1(TLStructureTypeList.code, ".", "_")}`
  };
});
const getTLAccessoriesType = MdmsRes => MdmsRes["TradeLicense"].AccessoriesCategory.filter(AccessoriesCategory => AccessoriesCategory.active).map(TLAccessoryTypeList => {
  return {
    ...TLAccessoryTypeList,
    i18nKey: `TRADELICENSE_ACCESSORIESCATEGORY_${stringReplaceAll$1(TLAccessoryTypeList.code, ".", "_")}`
  };
});
const getTLFinancialYear = MdmsRes => MdmsRes["egf-master"].FinancialYear.filter(FinancialYear => FinancialYear.active && FinancialYear.module === "TL").map(FinancialYearList => {
  return {
    ...FinancialYearList
  };
});
const getFloorList = MdmsRes => MdmsRes["PropertyTax"].Floor.filter(PTFloor => PTFloor.active).map(PTFloorlist => {
  return {
    ...PTFloorlist,
    i18nKey: `PROPERTYTAX_FLOOR_${PTFloorlist.code}`
  };
});
const GetReasonType = (MdmsRes, type, moduleCode) => Object.assign({}, ...Object.keys(MdmsRes[moduleCode]).map(collection => ({
  [collection]: MdmsRes[moduleCode][collection].filter(reason => reason.active).map(reason => ({
    ...reason,
    i18nKey: `ES_ACTION_REASON_${reason.code}`
  }))
})));
const getRentalDetailsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].RentalDetails.filter(category => category.active).map(RentalDetailsInfo => {
    return {
      ...RentalDetailsInfo,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${RentalDetailsInfo.code}`
    };
  });
};
const getChargeSlabsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].ChargeSlabs.filter(category => category.active).map(ChargeSlabsInfo => {
    return {
      ...ChargeSlabsInfo
    };
  });
};
const getGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `PT_COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const TLGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genders => {
    return {
      ...genders,
      i18nKey: `TL_GENDER_${genders.code}`
    };
  });
};
const PTGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(formGender => {
    return {
      ...formGender,
      i18nKey: `PT_FORM3_${formGender.code}`
    };
  });
};
const HRGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(comGender => {
    return {
      ...comGender,
      i18nKey: `COMMON_GENDER_${comGender.code}`
    };
  });
};
const GetMCollectBusinessService = MdmsRes => MdmsRes["BillingService"].BusinessService.map(businesServiceDetails => {
  return {
    ...businesServiceDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${businesServiceDetails.code}`
  };
});
const GetMCollectApplicationStatus = MdmsRes => MdmsRes["mCollect"].applcationStatus.map(appStatusDetails => {
  return {
    ...appStatusDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${appStatusDetails.code}`
  };
});
const getFSMGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const GetFSTPORejectionReason = MdmsRes => {
  return MdmsRes["Vehicle"].FSTPORejectionReason.filter(reason => reason.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_REASON_${reasonDetails.code}`
    };
  });
};
const GetPaymentType = MdmsRes => {
  return MdmsRes["FSM"].PaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const GetTripNumber = MdmsRes => {
  return MdmsRes["FSM"].TripNumber.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_TRIP_${reasonDetails.code}`
    };
  });
};
const GetReceivedPaymentType = MdmsRes => {
  return MdmsRes["FSM"].ReceivedPaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const getDssDashboard = MdmsRes => MdmsRes["dss-dashboard"]["dashboard-config"];
const GetRoleStatusMapping = MdmsRes => MdmsRes["DIGIT-UI"].RoleStatusMapping;
const GetCommonFields = (MdmsRes, moduleCode) => moduleCode.toUpperCase() === "PROPERTYTAX" ? MdmsRes["PropertyTax"].CommonFieldsConfig : MdmsRes["FSM"].CommonFieldsConfig;
const GetPreFields = MdmsRes => MdmsRes["FSM"].PreFieldsConfig;
const GetPostFields = MdmsRes => MdmsRes["FSM"].PostFieldsConfig;
const GetFSTPPlantInfo = MdmsRes => MdmsRes["FSM"].FSTPPlantInfo;
const GetDocumentsTypes = MdmsRes => MdmsRes["BPA"].DocTypeMapping;
const GetChecklist = MdmsRes => MdmsRes["BPA"].CheckList;
const transformResponse = (type, MdmsRes, moduleCode, tenantId) => {
  switch (type) {
    case "citymodule":
      return GetCitiesWithi18nKeys(MdmsRes, moduleCode);
    case "egovLocation":
      return GetEgovLocations(MdmsRes);
    case "serviceDefs":
      return GetServiceDefs(MdmsRes, moduleCode);
    case "ApplicationChannel":
      return GetApplicationChannel(MdmsRes);
    case "SanitationType":
      return GetSanitationType(MdmsRes);
    case "PropertyType":
      return GetPropertyType(MdmsRes);
    case "PropertySubtype":
      return GetPropertySubtype(MdmsRes);
    case "PitType":
      return GetPitType(MdmsRes);
    case "VehicleType":
      return GetVehicleType(MdmsRes);
    case "Slum":
      return GetSlumLocalityMapping(MdmsRes, tenantId);
    case "OwnerShipCategory":
      return GetPropertyOwnerShipCategory(MdmsRes);
    case "TLOwnerShipCategory":
      return GetTradeOwnerShipCategory(MdmsRes);
    case "OwnerType":
      return GetPropertyOwnerType(MdmsRes);
    case "SubOwnerShipCategory":
      return getSubPropertyOwnerShipCategory(MdmsRes);
    case "Documents":
      return getDocumentRequiredScreen(MdmsRes);
    case "TLDocuments":
      return getTLDocumentRequiredScreen(MdmsRes);
    case "MapConfig":
      return getMapConfig(MdmsRes);
    case "UsageCategory":
      return getUsageCategory(MdmsRes);
    case "PTPropertyType":
      return getPTPropertyType(MdmsRes);
    case "StructureType":
      return getTLStructureType(MdmsRes);
    case "AccessoryCategory":
      return getTLAccessoriesType(MdmsRes);
    case "FinancialYear":
      return getTLFinancialYear(MdmsRes);
    case "Floor":
      return getFloorList(MdmsRes);
    case "Reason":
      return GetReasonType(MdmsRes, type, moduleCode);
    case "RoleStatusMapping":
      return GetRoleStatusMapping(MdmsRes);
    case "CommonFieldsConfig":
      return GetCommonFields(MdmsRes, moduleCode);
    case "PreFieldsConfig":
      return GetPreFields(MdmsRes);
    case "PostFieldsConfig":
      return GetPostFields(MdmsRes);
    case "RentalDeatils":
      return getRentalDetailsCategory(MdmsRes);
    case "ChargeSlabs":
      return getChargeSlabsCategory(MdmsRes);
    case "DssDashboard":
      return getDssDashboard(MdmsRes);
    case "BusinessService":
      return GetMCollectBusinessService(MdmsRes);
    case "applcatonStatus":
      return GetMCollectApplicationStatus(MdmsRes);
    case "FSTPPlantInfo":
      return GetFSTPPlantInfo(MdmsRes);
    case "GenderType":
      return getGenderType(MdmsRes);
    case "TLGendertype":
      return TLGenderType(MdmsRes);
    case "PTGenderType":
      return PTGenderType(MdmsRes);
    case "HRGenderType":
      return HRGenderType(MdmsRes);
    case "DocumentTypes":
      return GetDocumentsTypes(MdmsRes);
    case "CheckList":
      return GetChecklist(MdmsRes);
    case "FSMGenderType":
      return getFSMGenderType(MdmsRes);
    case "FSTPORejectionReason":
      return GetFSTPORejectionReason(MdmsRes);
    case "PaymentType":
      return GetPaymentType(MdmsRes);
    case "TripNumber":
      return GetTripNumber(MdmsRes);
    case "ReceivedPaymentType":
      return GetReceivedPaymentType(MdmsRes);
    default:
      return MdmsRes;
  }
};
const mergedData = {};
const mergedPromises = {};
const callAllPromises = (success, promises = [], resData) => {
  promises.forEach(promise => {
    if (success) {
      promise.resolve(resData);
    } else {
      promise.reject(resData);
    }
  });
};
const mergeMDMSData = (data, tenantId, url) => {
  const key = `${tenantId}:${url}`;
  if (!mergedData[key] || Object.keys(mergedData[key]).length === 0) {
    mergedData[key] = data;
  } else {
    data.MdmsCriteria.moduleDetails.forEach(dataModuleDetails => {
      const moduleName = dataModuleDetails.moduleName;
      const masterDetails = dataModuleDetails.masterDetails;
      let found = false;
      mergedData[key].MdmsCriteria.moduleDetails.forEach(moduleDetail => {
        if (moduleDetail.moduleName === moduleName) {
          found = true;
          moduleDetail.masterDetails = [...moduleDetail.masterDetails, ...masterDetails];
        }
      });
      if (!found) {
        mergedData[key].MdmsCriteria.moduleDetails.push(dataModuleDetails);
      }
    });
  }
};
const debouncedCall = ({
  serviceName,
  url,
  data,
  useCache,
  params
}, resolve, reject) => {
  const key = `${params.tenantId}:${url}`;
  if (!mergedPromises[key] || mergedPromises[key].length === 0) {
    setTimeout(() => {
      let callData = JSON.parse(JSON.stringify(mergedData[key]));
      mergedData[key] = {};
      let callPromises = [...mergedPromises[key]];
      mergedPromises[key] = [];
      ServiceRequest({
        serviceName,
        url,
        data: callData,
        useCache,
        params
      }).then(data => {
        callAllPromises(true, callPromises, data);
      }).catch(err => {
        callAllPromises(false, callPromises, err);
      });
    }, 500);
  }
  mergeMDMSData(data, params.tenantId, url);
  if (!mergedPromises[key]) {
    mergedPromises[key] = [];
  }
  mergedPromises[key].push({
    resolve,
    reject
  });
};
const MdmsService = {
  init: stateCode => ServiceRequest({
    serviceName: "mdmsInit",
    url: Urls.MDMS,
    data: initRequestBody(stateCode),
    useCache: true,
    params: {
      tenantId: stateCode
    }
  }),
  call: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsCall",
      url: Urls.MDMS,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  search: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsSearchV2",
      url: Urls.MdmsSearchV2,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  getDataByCriteria: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMS.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.call(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  searchDataV2: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMSV2.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.search(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  getServiceDefs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getModuleServiceDefsCriteria(tenantId, moduleCode), moduleCode);
  },
  getSanitationType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getSanitationTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getApplicationChannel: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getApplicationChannelCriteria(tenantId, moduleCode), moduleCode);
  },
  getPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyUsage: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyUsageCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubtype: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPitType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getPitTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getVehicleType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getVehicleTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getChecklist: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChecklistCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentRules: (tenantId, filter) => {
    return MdmsService.call(tenantId, getBillingServiceForBusinessServiceCriteria(filter));
  },
  getCustomizationConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getConfig(tenantId, moduleCode), moduleCode);
  },
  getSlumLocalityMapping: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getSlumLocalityCriteria(tenantId, moduleCode, type), moduleCode),
  getReason: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getReasonCriteria(tenantId, moduleCode, type, payload), moduleCode),
  getRoleStatus: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getRoleStatusCriteria(tenantId, moduleCode, type), moduleCode),
  getCommonFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getCommonFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPreFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPreFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPostFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPostFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPropertyOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  GetTradeOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyOwnerType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getSubPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTLDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTradeUnitsData: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeUnitsDataList(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMapConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDefaultMapConfig(tenantId, moduleCode), moduleCode);
  },
  getUsageCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getUsageCategoryList(tenantId, moduleCode), moduleCode);
  },
  getPTPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTPropertyTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLStructureType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLStructureTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLAccessoriesType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLAccessoriesTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLFinancialYear: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLFinancialYearList(tenantId, moduleCode), moduleCode);
  },
  getFloorList: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTFloorList(tenantId, moduleCode, type), moduleCode);
  },
  getRentalDetails: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getRentalDetailsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getChargeSlabs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChargeSlabsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getDssDashboard: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDssDashboardCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentGateway: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getReceiptKey: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptKey(tenantId, moduleCode), moduleCode);
  },
  getHelpText: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMCollectBillingService: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectBillingServiceCriteria(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMCollectApplcationStatus: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectApplicationStatusCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeRolesandDesignation: tenantId => {
    return MdmsService.call(tenantId, getHrmsEmployeeRolesandDesignations());
  },
  getHrmsEmployeeTypes: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMultipleTypes: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getMultipleTypesV2: (tenantId, moduleCode, types) => {
    return MdmsService.searchDataV2(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getFSTPPlantInfo: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPPlantCriteria(tenantId, moduleCode, types), moduleCode);
  },
  getCancelReceiptReason: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReason(tenantId, moduleCode), moduleCode);
  },
  getReceiptStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptStatus(tenantId, moduleCode), moduleCode);
  },
  getCancelReceiptReasonAndStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReasonAndStatus(tenantId, moduleCode), moduleCode);
  },
  getGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  TLGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  PTGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  HRGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentTypesCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getTradeTypeRoleTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeTypeRoleCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMSDropDownTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getMSDropDownCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getLandUseCategories: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getLandUseCategories(tenantId, moduleCode, type), moduleCode);
  },
  getFSMGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getFSTPORejectionReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPORejectionReasonCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMTripNumber: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMTripNumberCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMReceivedPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMReceivedPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  }
};

const UploadServices = {
  Filestorage: async (module, filedata, tenantId) => {
    var _window, _window$globalConfigs, _Digit$UserService$ge;
    const formData = new FormData();
    formData.append("file", filedata, filedata.name);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window = window) !== null && _window !== void 0 && (_window$globalConfigs = _window.globalConfigs) !== null && _window$globalConfigs !== void 0 && _window$globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        "auth-token": Digit.UserService.getUser() ? (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token : null
      }
    };
    return axios$1(config);
  },
  MultipleFilesStorage: async (module, filesData, tenantId) => {
    var _window2, _window2$globalConfig;
    const formData = new FormData();
    const filesArray = Array.from(filesData);
    filesArray === null || filesArray === void 0 ? void 0 : filesArray.forEach((fileData, index) => fileData ? formData.append("file", fileData, fileData.name) : null);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window2 = window) !== null && _window2 !== void 0 && (_window2$globalConfig = _window2.globalConfigs) !== null && _window2$globalConfig !== void 0 && _window2$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        "auth-token": Digit.UserService.getUser().access_token
      }
    };
    return axios$1(config);
  },
  Filefetch: async (filesArray, tenantId) => {
    var _window3, _window3$globalConfig;
    let tenantInfo = (_window3 = window) !== null && _window3 !== void 0 && (_window3$globalConfig = _window3.globalConfigs) !== null && _window3$globalConfig !== void 0 && _window3$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "get",
      url: `${Urls.FileFetch}${tenantInfo}`,
      params: {
        tenantId: tenantId,
        fileStoreIds: filesArray === null || filesArray === void 0 ? void 0 : filesArray.join(",")
      }
    };
    const res = await axios$1(config);
    return res;
  }
};

const OBPSService = {
  scrutinyDetails: (tenantId, params) => Request({
    url: Urls.obps.scrutinyDetails,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  comparisionReport: (tenantId, params) => Request({
    url: Urls.obps.comparisionReport,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  create: (details, tenantId) => Request({
    url: Urls.obps.create,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm11: details => Request({
    url: Urls.obps.createForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createLandUseUP: details => Request({
    url: Urls.obps.createLandUseUP,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createOwner: details => Request({
    url: Urls.obps.createOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateOwner: details => Request({
    url: Urls.obps.updateOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createPurchasableFAR: details => Request({
    url: Urls.obps.createPurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updatePurchasableFAR: details => Request({
    url: Urls.obps.updatePurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  calculateInstallments: details => Request({
    url: Urls.obps.installments,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createFormCLU: details => Request({
    url: Urls.obps.createFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm34: details => Request({
    url: Urls.obps.createForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm26: (details, tenantId) => Request({
    url: Urls.obps.createForm26,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  NOCSearch: (tenantId, sourceRefId) => Request({
    url: Urls.obps.nocSearch,
    params: {
      tenantId,
      ...sourceRefId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelCreate: (tenantId, details) => Request({
    url: Urls.noc.nocExcelCreate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelUpdate: (tenantId, details) => Request({
    url: Urls.noc.nocExcelUpdate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  update: (details, tenantId) => Request({
    url: Urls.obps.update,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  update11: (details, tenantId) => Request({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm11: details => Request({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormCLU: details => Request({
    url: Urls.obps.updateFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm34: details => Request({
    url: Urls.obps.updateForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormLandUse: details => Request({
    url: Urls.obps.updateFormLandUse,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateNOC: (details, tenantId) => Request({
    url: Urls.obps.updateNOC,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  BPASearch: (tenantId, params) => Request({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchNoAuth: (tenantId, params) => Request({
    url: Urls.obps.bpaSearchChallan,
    params: {
      tenantId,
      ...params
    },
    method: "POST"
  }),
  BPAmigratedSearch: params => Request({
    url: Urls.obps.migratedSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAREGCommonSearch: (tenantId, params) => Request({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAmigratedSearchappNo: params => Request({
    url: Urls.obps.migratedSearchappNo,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm11: (tenantId, params) => Request({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAOwnerRegistration: (tenantId, params) => Request({
    url: Urls.obps.ownerSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchPurchasableFAR: (tenantId, params) => Request({
    url: Urls.obps.searchPurchasableFar,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormLandUse: (tenantId, params) => Request({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm26: (tenantId, params) => Request({
    url: Urls.obps.searchfrom26,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormCLU: (tenantId, params) => Request({
    url: Urls.obps.searchFromCLU,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAFastPASSearch: params => Request({
    url: Urls.obps.fastpassSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm34: (tenantId, params) => Request({
    url: Urls.obps.searchFrom34,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchMyApplicationForm11: (tenantId, applicationType, limit, departement, details, params) => Request({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      applicationType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationForm12: (tenantId, applType, limit, departement, details, params) => Request({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAMyApplicationCommonsearch: (tenantId, applType, limit, departement, details, params) => Request({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationFormLandUse: (tenantId, applicationType, limit, details, params) => Request({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      applicationType,
      limit,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  designOfApprovalLetterPdf: (tenantId, applicationNumber, params) => Request({
    url: Urls.obps.designOfApproval,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  designOfRegApprovalLetterPdf: (tenantId, applicationNumber, details) => Request({
    url: Urls.tl.designOfApproval,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true,
    data: details
  }),
  designOfStructuralLetter: (tenantId, applicationNumber, params) => Request({
    url: Urls.obps.designOfStuctural,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  farIntimationLetter: (tenantId, applicationNumber) => Request({
    url: Urls.obps.farIntimationLetter,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    data: {}
  }),
  scheduleInspection: details => Request({
    url: Urls.obps.scheduleInspection,
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  applicationDetailData: (tenantId, params) => Request({
    url: Urls.obps.applicationDetailData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  logUrlData: params => Request({
    url: Urls.logoUrl.bpaLogoUrl,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  applicationDetailDataView: (tenantId, params) => Request({
    url: Urls.obps.applicationDetailDataView,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountApplicationData: (tenantId, params) => Request({
    url: Urls.noc.nocCountApplicationData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchAppendex: (tenantId, params) => Request({
    url: Urls.obps.fetchAppendex,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchProfessional: (tenantId, params) => Request({
    url: Urls.obps.fetchProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountSearch: (tenantId, params) => Request({
    url: Urls.noc.nocCountSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplication: (tenantId, params) => Request({
    url: Urls.InboxSearchApplication,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplicationProfessional: (tenantId, params) => Request({
    url: Urls.InboxSearchApplicationProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentDetailData: tenantId => Request({
    url: Urls.obps.paymentList,
    params: {
      tenantId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentReportData: () => Request({
    url: Urls.obps.paymentReport,
    method: "POST"
  }),
  eChargesReportData: tenantId => Request({
    url: Urls.obps.echargesReport,
    params: {
      tenantId
    },
    method: "POST"
  }),
  applicationReportData: (tenantId, params) => Request({
    url: Urls.obps.applicationReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  applicationReportMISData: (tenantId, params) => Request({
    url: Urls.obps.applicationMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  searchReportData: params => Request({
    url: Urls.obps.employeeSearchList,
    params: params,
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISData: (tenantId, params) => Request({
    url: Urls.obps.paymentMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISDataNew: async (tenantId, params) => {
    try {
      return await Request({
        url: Urls.obps.paymentMisReportNew || "/bpa-services/v1/bpa/_extractAllMisData",
        params: {
          tenantId,
          _: Date.now(),
          ...params
        },
        userService: true,
        auth: true,
        method: "POST"
      });
    } catch (err) {
      var _err$response;
      if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 405) {
        return await Request({
          url: Urls.obps.paymentMisReportNew ,
          params: {
            tenantId,
            _: Date.now(),
            ...params
          },
          userService: true,
          auth: true,
          method: "GET"
        });
      }
      throw err;
    }
  },
  dashboardReportData: (tenantId, params) => Request({
    url: Urls.obps.dashboardReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  selfApprovalReportData: (tenantId, params) => Request({
    url: Urls.obps.selfApprovalReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  scrutinyReportFailedData: selectedDate => Request({
    url: Urls.obps.scrutinyFailedReport,
    params: {
      selectedDate
    },
    userService: true,
    auth: true,
    method: "GET"
  }),
  inwardReportData: tenantId => Request({
    url: Urls.obps.inwardApplicationReport,
    params: {
      tenantId
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  bpacalculate: details => Request({
    url: Urls.obps.bpacalculate,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  bpacalculatechallan: details => Request({
    url: Urls.obps.bpacalculatechallan,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  deleteChallan: (details, params) => Request({
    url: Urls.obps.deleteChallan,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  calculateInstallment: (details, params) => Request({
    url: Urls.obps.installmentCalculate,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  BPAREGSearch: (tenantId, details, params) => Request({
    url: Urls.obps.bpaRegSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAREGCreate: (details, tenantId) => Request({
    url: Urls.obps.bpaRegCreate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  BPAREGGetBill: (tenantId, filters = {}) => Request({
    url: Urls.obps.bpaRegGetBill,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }).then(d => {
    return d;
  }).catch(err => {
    var _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2;
    if ((err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) === "EG_BS_BILL_NO_DEMANDS_FOUND") return {
      Bill: []
    };else throw err;
  }),
  BPAREGupdate: (details, tenantId) => Request({
    url: Urls.obps.bpaRegUpdate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  receipt_download: (bussinessService, consumerCode, tenantId, filters = {}) => Request({
    url: Urls.obps.receipt_download,
    data: {},
    useCache: true,
    method: "POST",
    params: {
      bussinessService,
      consumerCode,
      tenantId,
      ...filters
    },
    auth: true,
    locale: true,
    userService: true,
    userDownload: true
  }),
  edcr_report_download: (details, tenantId) => Request({
    url: Urls.obps.edcrreportdownload,
    data: details,
    useCache: true,
    method: "POST",
    auth: true,
    locale: true,
    userService: false,
    userDownload: true
  }),
  ltpGrading: (details, tenantId) => Request({
    url: Urls.obps.ltpGrading,
    useCache: false,
    method: "POST",
    auth: false,
    userService: false
  }),
  LicenseDetails: async (tenantId, params) => {
    var _response$Licenses, _License$tradeLicense, _License$tradeLicense2, _mdmsRes$StakeholderR, _mdmsRes$StakeholderR2, _License$tradeLicense8, _License$tradeLicense9, _License$tradeLicense10, _License$tradeLicense11, _License$tradeLicense12, _License$tradeLicense13, _License$tradeLicense14, _License$tradeLicense15, _License$tradeLicense16, _License$tradeLicense17, _License$tradeLicense18, _License$tradeLicense19, _License$tradeLicense20, _License$tradeLicense21, _License$tradeLicense22, _License$tradeLicense23, _License$tradeLicense24, _License$tradeLicense25, _License$tradeLicense26, _License$tradeLicense27, _License$tradeLicense28, _License$tradeLicense29, _License$tradeLicense30, _License$tradeLicense31, _License$tradeLicense32, _License$tradeLicense33, _License$tradeLicense34, _License$tradeLicense35, _License$tradeLicense36, _License$tradeLicense37, _License$tradeLicense38, _License$tradeLicense39, _License$tradeLicense40, _License$tradeLicense41, _License$tradeLicense42, _License$tradeLicense43, _License$tradeLicense44, _License$tradeLicense45, _License$tradeLicense46, _License$tradeLicense47, _License$tradeLicense48, _License$tradeLicense49, _License$tradeLicense50, _License$tradeLicense51, _License$tradeLicense52, _License$tradeLicense53, _License$tradeLicense54, _License$tradeLicense55, _License$tradeLicense56, _License$tradeLicense57, _License$tradeLicense58, _License$tradeLicense59, _License$tradeLicense60, _License$tradeLicense61, _License$tradeLicense62, _License$tradeLicense63, _License$tradeLicense64, _License$tradeLicense65, _License$tradeLicense66, _License$tradeLicense67, _License$tradeLicense68, _License$tradeLicense69, _License$tradeLicense70, _License$tradeLicense71, _License$tradeLicense72, _License$tradeLicense73, _License$tradeLicense74, _License$tradeLicense75, _License$tradeLicense76, _License$tradeLicense77, _License$tradeLicense78, _License$tradeLicense79, _License$tradeLicense80, _License$tradeLicense81, _License$tradeLicense82, _License$tradeLicense83, _License$tradeLicense84, _License$tradeLicense85, _License$tradeLicense86, _License$tradeLicense87, _License$tradeLicense88, _License$tradeLicense89, _License$tradeLicense90, _License$tradeLicense91, _License$tradeLicense92, _License$tradeLicense93, _License$tradeLicense94, _License$tradeLicense95, _License$tradeLicense96, _License$tradeLicense97, _License$tradeLicense98, _License$tradeLicense99, _License$tradeLicense100, _License$tradeLicense101, _License$tradeLicense102, _License$tradeLicense103, _License$tradeLicense104, _License$tradeLicense105, _License$tradeLicense106, _License$tradeLicense107, _License$tradeLicense108, _License$tradeLicense109, _License$tradeLicense110, _License$tradeLicense111, _License$tradeLicense112, _License$tradeLicense113, _License$tradeLicense114, _License$tradeLicense115, _License$tradeLicense116, _License$tradeLicense117, _License$tradeLicense118, _License$tradeLicense119, _License$tradeLicense120, _License$tradeLicense121, _License$tradeLicense122, _License$tradeLicense123, _License$tradeLicense124, _License$tradeLicense125, _License$tradeLicense126, _License$tradeLicense127, _License$tradeLicense128, _License$tradeLicense129, _License$tradeLicense130, _License$tradeLicense131, _License$tradeLicense132, _License$tradeLicense133, _License$tradeLicense134, _License$tradeLicense135, _License$tradeLicense136, _License$tradeLicense137, _paymentRes$Payments, _paymentRes$Payments2, _paymentRes$Payments3, _paymentRes$Payments4, _paymentRes$Payments5;
    const response = await OBPSService.BPAREGSearch(tenantId, {}, params);
    if (!(response !== null && response !== void 0 && (_response$Licenses = response.Licenses) !== null && _response$Licenses !== void 0 && _response$Licenses.length)) {
      return;
    }
    const [License] = response === null || response === void 0 ? void 0 : response.Licenses;
    const paymentRes = await Digit.PaymentService.recieptSearch(tenantId, "BPAREG", {
      consumerCodes: License === null || License === void 0 ? void 0 : License.applicationNumber,
      isEmployee: true
    });
    const mdmsRes = await MdmsService.getMultipleTypes(License === null || License === void 0 ? void 0 : License.tenantId, "StakeholderRegistraition", ["TradeTypetoRoleMapping"]);
    if (License !== null && License !== void 0 && (_License$tradeLicense = License.tradeLicenseDetail) !== null && _License$tradeLicense !== void 0 && (_License$tradeLicense2 = _License$tradeLicense.applicationDocuments) !== null && _License$tradeLicense2 !== void 0 && _License$tradeLicense2.length && (mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR === void 0 ? void 0 : (_mdmsRes$StakeholderR2 = _mdmsRes$StakeholderR.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR2 === void 0 ? void 0 : _mdmsRes$StakeholderR2.length) > 0) {
      var _mdmsRes$StakeholderR3, _mdmsRes$StakeholderR4;
      mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR3 = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR3 === void 0 ? void 0 : (_mdmsRes$StakeholderR4 = _mdmsRes$StakeholderR3.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR4 === void 0 ? void 0 : _mdmsRes$StakeholderR4.map(doc => {
        var _doc$docTypes, _License$tradeLicense3, _License$tradeLicense4, _License$tradeLicense5;
        if ((doc === null || doc === void 0 ? void 0 : (_doc$docTypes = doc.docTypes) === null || _doc$docTypes === void 0 ? void 0 : _doc$docTypes.length) > 0 && (doc === null || doc === void 0 ? void 0 : doc.tradeType) == (License === null || License === void 0 ? void 0 : (_License$tradeLicense3 = License.tradeLicenseDetail) === null || _License$tradeLicense3 === void 0 ? void 0 : (_License$tradeLicense4 = _License$tradeLicense3.tradeUnits) === null || _License$tradeLicense4 === void 0 ? void 0 : (_License$tradeLicense5 = _License$tradeLicense4[0]) === null || _License$tradeLicense5 === void 0 ? void 0 : _License$tradeLicense5.tradeType)) {
          var _doc$docTypes2;
          doc === null || doc === void 0 ? void 0 : (_doc$docTypes2 = doc.docTypes) === null || _doc$docTypes2 === void 0 ? void 0 : _doc$docTypes2.map(docType => {
            var _License$tradeLicense6, _License$tradeLicense7;
            License === null || License === void 0 ? void 0 : (_License$tradeLicense6 = License.tradeLicenseDetail) === null || _License$tradeLicense6 === void 0 ? void 0 : (_License$tradeLicense7 = _License$tradeLicense6.applicationDocuments) === null || _License$tradeLicense7 === void 0 ? void 0 : _License$tradeLicense7.forEach(document => {
              if ((docType === null || docType === void 0 ? void 0 : docType.code) == (document === null || document === void 0 ? void 0 : document.documentType) && docType !== null && docType !== void 0 && docType.info) document.info = docType === null || docType === void 0 ? void 0 : docType.info;
            });
          });
        }
      });
    }
    const appDocumentFileStoreIds = License === null || License === void 0 ? void 0 : (_License$tradeLicense8 = License.tradeLicenseDetail) === null || _License$tradeLicense8 === void 0 ? void 0 : (_License$tradeLicense9 = _License$tradeLicense8.applicationDocuments) === null || _License$tradeLicense9 === void 0 ? void 0 : _License$tradeLicense9.map(appDoc => appDoc === null || appDoc === void 0 ? void 0 : appDoc.fileStoreId);
    let fileDetails = {};
    if ((appDocumentFileStoreIds === null || appDocumentFileStoreIds === void 0 ? void 0 : appDocumentFileStoreIds.length) > 0) {
      fileDetails = await UploadServices.Filefetch(appDocumentFileStoreIds, Digit.ULBService.getStateId());
    }
    const details = [{
      title: " ",
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (License === null || License === void 0 ? void 0 : License.applicationNumber) || "NA"
      }]
    }, License !== null && License !== void 0 && (_License$tradeLicense10 = License.tradeLicenseDetail) !== null && _License$tradeLicense10 !== void 0 && (_License$tradeLicense11 = _License$tradeLicense10.tradeUnits) !== null && _License$tradeLicense11 !== void 0 && (_License$tradeLicense12 = _License$tradeLicense11[0]) !== null && _License$tradeLicense12 !== void 0 && _License$tradeLicense12.tradeType.includes("ARCHITECT") ? {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense13 = License.tradeLicenseDetail) === null || _License$tradeLicense13 === void 0 ? void 0 : (_License$tradeLicense14 = _License$tradeLicense13.tradeUnits) === null || _License$tradeLicense14 === void 0 ? void 0 : (_License$tradeLicense15 = _License$tradeLicense14[0]) === null || _License$tradeLicense15 === void 0 ? void 0 : (_License$tradeLicense16 = _License$tradeLicense15.tradeType) === null || _License$tradeLicense16 === void 0 ? void 0 : _License$tradeLicense16.split(".")[0]}` || "NA"
      }, {
        title: "BPA_COUNCIL_OF_ARCH_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense17 = License.tradeLicenseDetail) === null || _License$tradeLicense17 === void 0 ? void 0 : (_License$tradeLicense18 = _License$tradeLicense17.additionalDetail) === null || _License$tradeLicense18 === void 0 ? void 0 : _License$tradeLicense18.counsilForArchNo) || "NA"
      }]
    } : {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense19 = License.tradeLicenseDetail) === null || _License$tradeLicense19 === void 0 ? void 0 : (_License$tradeLicense20 = _License$tradeLicense19.tradeUnits) === null || _License$tradeLicense20 === void 0 ? void 0 : (_License$tradeLicense21 = _License$tradeLicense20[0]) === null || _License$tradeLicense21 === void 0 ? void 0 : (_License$tradeLicense22 = _License$tradeLicense21.tradeType) === null || _License$tradeLicense22 === void 0 ? void 0 : _License$tradeLicense22.split(".")[0]}` || "NA"
      }]
    }, {
      title: "BPA_LICENSEE_DETAILS_HEADER_OWNER_INFO",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_NAME_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense23 = License.tradeLicenseDetail) === null || _License$tradeLicense23 === void 0 ? void 0 : (_License$tradeLicense24 = _License$tradeLicense23.owners) === null || _License$tradeLicense24 === void 0 ? void 0 : (_License$tradeLicense25 = _License$tradeLicense24[0]) === null || _License$tradeLicense25 === void 0 ? void 0 : _License$tradeLicense25.name) || "NA"
      }, {
        title: "BPA_APPLICANT_GENDER_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense26 = License.tradeLicenseDetail) === null || _License$tradeLicense26 === void 0 ? void 0 : (_License$tradeLicense27 = _License$tradeLicense26.owners) === null || _License$tradeLicense27 === void 0 ? void 0 : (_License$tradeLicense28 = _License$tradeLicense27[0]) === null || _License$tradeLicense28 === void 0 ? void 0 : _License$tradeLicense28.gender) || "NA"
      }, {
        title: "BPA_OWNER_MOBILE_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense29 = License.tradeLicenseDetail) === null || _License$tradeLicense29 === void 0 ? void 0 : (_License$tradeLicense30 = _License$tradeLicense29.owners) === null || _License$tradeLicense30 === void 0 ? void 0 : (_License$tradeLicense31 = _License$tradeLicense30[0]) === null || _License$tradeLicense31 === void 0 ? void 0 : _License$tradeLicense31.mobileNumber) || "NA"
      }, {
        title: "BPA_APPLICANT_EMAIL_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense32 = License.tradeLicenseDetail) === null || _License$tradeLicense32 === void 0 ? void 0 : (_License$tradeLicense33 = _License$tradeLicense32.owners) === null || _License$tradeLicense33 === void 0 ? void 0 : (_License$tradeLicense34 = _License$tradeLicense33[0]) === null || _License$tradeLicense34 === void 0 ? void 0 : _License$tradeLicense34.emailId) || "NA"
      }, {
        title: "BPA_APPLICANT_PAN_NO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense35 = License.tradeLicenseDetail) === null || _License$tradeLicense35 === void 0 ? void 0 : (_License$tradeLicense36 = _License$tradeLicense35.owners) === null || _License$tradeLicense36 === void 0 ? void 0 : (_License$tradeLicense37 = _License$tradeLicense36[0]) === null || _License$tradeLicense37 === void 0 ? void 0 : _License$tradeLicense37.pan) || "NA"
      }]
    }, {
      title: "BPA_PERMANANT_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_PERMANANT_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense38 = License.tradeLicenseDetail) === null || _License$tradeLicense38 === void 0 ? void 0 : (_License$tradeLicense39 = _License$tradeLicense38.additionalDetail) === null || _License$tradeLicense39 === void 0 ? void 0 : (_License$tradeLicense40 = _License$tradeLicense39[0]) === null || _License$tradeLicense40 === void 0 ? void 0 : (_License$tradeLicense41 = _License$tradeLicense40.tradeLicenseDetail) === null || _License$tradeLicense41 === void 0 ? void 0 : (_License$tradeLicense42 = _License$tradeLicense41.owners) === null || _License$tradeLicense42 === void 0 ? void 0 : (_License$tradeLicense43 = _License$tradeLicense42[0]) === null || _License$tradeLicense43 === void 0 ? void 0 : (_License$tradeLicense44 = _License$tradeLicense43.permanentAddress) === null || _License$tradeLicense44 === void 0 ? void 0 : _License$tradeLicense44.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense45 = License.tradeLicenseDetail) === null || _License$tradeLicense45 === void 0 ? void 0 : (_License$tradeLicense46 = _License$tradeLicense45.additionalDetail) === null || _License$tradeLicense46 === void 0 ? void 0 : (_License$tradeLicense47 = _License$tradeLicense46[0]) === null || _License$tradeLicense47 === void 0 ? void 0 : (_License$tradeLicense48 = _License$tradeLicense47.tradeLicenseDetail) === null || _License$tradeLicense48 === void 0 ? void 0 : (_License$tradeLicense49 = _License$tradeLicense48.owners) === null || _License$tradeLicense49 === void 0 ? void 0 : (_License$tradeLicense50 = _License$tradeLicense49[0]) === null || _License$tradeLicense50 === void 0 ? void 0 : (_License$tradeLicense51 = _License$tradeLicense50.permanentAddress) === null || _License$tradeLicense51 === void 0 ? void 0 : _License$tradeLicense51.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense52 = License.tradeLicenseDetail) === null || _License$tradeLicense52 === void 0 ? void 0 : (_License$tradeLicense53 = _License$tradeLicense52.additionalDetail) === null || _License$tradeLicense53 === void 0 ? void 0 : (_License$tradeLicense54 = _License$tradeLicense53[0]) === null || _License$tradeLicense54 === void 0 ? void 0 : (_License$tradeLicense55 = _License$tradeLicense54.tradeLicenseDetail) === null || _License$tradeLicense55 === void 0 ? void 0 : (_License$tradeLicense56 = _License$tradeLicense55.owners) === null || _License$tradeLicense56 === void 0 ? void 0 : (_License$tradeLicense57 = _License$tradeLicense56[0]) === null || _License$tradeLicense57 === void 0 ? void 0 : (_License$tradeLicense58 = _License$tradeLicense57.permanentAddress) === null || _License$tradeLicense58 === void 0 ? void 0 : _License$tradeLicense58.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense59 = License.tradeLicenseDetail) === null || _License$tradeLicense59 === void 0 ? void 0 : (_License$tradeLicense60 = _License$tradeLicense59.additionalDetail) === null || _License$tradeLicense60 === void 0 ? void 0 : (_License$tradeLicense61 = _License$tradeLicense60[0]) === null || _License$tradeLicense61 === void 0 ? void 0 : (_License$tradeLicense62 = _License$tradeLicense61.tradeLicenseDetail) === null || _License$tradeLicense62 === void 0 ? void 0 : (_License$tradeLicense63 = _License$tradeLicense62.owners) === null || _License$tradeLicense63 === void 0 ? void 0 : (_License$tradeLicense64 = _License$tradeLicense63[0]) === null || _License$tradeLicense64 === void 0 ? void 0 : (_License$tradeLicense65 = _License$tradeLicense64.permanentAddress) === null || _License$tradeLicense65 === void 0 ? void 0 : _License$tradeLicense65.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense66 = License.tradeLicenseDetail) === null || _License$tradeLicense66 === void 0 ? void 0 : (_License$tradeLicense67 = _License$tradeLicense66.additionalDetail) === null || _License$tradeLicense67 === void 0 ? void 0 : (_License$tradeLicense68 = _License$tradeLicense67[0]) === null || _License$tradeLicense68 === void 0 ? void 0 : (_License$tradeLicense69 = _License$tradeLicense68.tradeLicenseDetail) === null || _License$tradeLicense69 === void 0 ? void 0 : (_License$tradeLicense70 = _License$tradeLicense69.owners) === null || _License$tradeLicense70 === void 0 ? void 0 : (_License$tradeLicense71 = _License$tradeLicense70[0]) === null || _License$tradeLicense71 === void 0 ? void 0 : (_License$tradeLicense72 = _License$tradeLicense71.permanentAddress) === null || _License$tradeLicense72 === void 0 ? void 0 : _License$tradeLicense72.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense73 = License.tradeLicenseDetail) === null || _License$tradeLicense73 === void 0 ? void 0 : (_License$tradeLicense74 = _License$tradeLicense73.additionalDetail) === null || _License$tradeLicense74 === void 0 ? void 0 : (_License$tradeLicense75 = _License$tradeLicense74[0]) === null || _License$tradeLicense75 === void 0 ? void 0 : (_License$tradeLicense76 = _License$tradeLicense75.tradeLicenseDetail) === null || _License$tradeLicense76 === void 0 ? void 0 : (_License$tradeLicense77 = _License$tradeLicense76.owners) === null || _License$tradeLicense77 === void 0 ? void 0 : (_License$tradeLicense78 = _License$tradeLicense77[0]) === null || _License$tradeLicense78 === void 0 ? void 0 : (_License$tradeLicense79 = _License$tradeLicense78.permanentAddress) === null || _License$tradeLicense79 === void 0 ? void 0 : _License$tradeLicense79.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense80 = License.tradeLicenseDetail) === null || _License$tradeLicense80 === void 0 ? void 0 : (_License$tradeLicense81 = _License$tradeLicense80.additionalDetail) === null || _License$tradeLicense81 === void 0 ? void 0 : (_License$tradeLicense82 = _License$tradeLicense81[0]) === null || _License$tradeLicense82 === void 0 ? void 0 : (_License$tradeLicense83 = _License$tradeLicense82.tradeLicenseDetail) === null || _License$tradeLicense83 === void 0 ? void 0 : (_License$tradeLicense84 = _License$tradeLicense83.owners) === null || _License$tradeLicense84 === void 0 ? void 0 : (_License$tradeLicense85 = _License$tradeLicense84[0]) === null || _License$tradeLicense85 === void 0 ? void 0 : (_License$tradeLicense86 = _License$tradeLicense85.permanentAddress) === null || _License$tradeLicense86 === void 0 ? void 0 : _License$tradeLicense86.university) || "NA"
      }]
    }, {
      title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense87 = License.tradeLicenseDetail) === null || _License$tradeLicense87 === void 0 ? void 0 : (_License$tradeLicense88 = _License$tradeLicense87.additionalDetail) === null || _License$tradeLicense88 === void 0 ? void 0 : (_License$tradeLicense89 = _License$tradeLicense88[0]) === null || _License$tradeLicense89 === void 0 ? void 0 : (_License$tradeLicense90 = _License$tradeLicense89.tradeLicenseDetail) === null || _License$tradeLicense90 === void 0 ? void 0 : (_License$tradeLicense91 = _License$tradeLicense90.owners) === null || _License$tradeLicense91 === void 0 ? void 0 : (_License$tradeLicense92 = _License$tradeLicense91[0]) === null || _License$tradeLicense92 === void 0 ? void 0 : (_License$tradeLicense93 = _License$tradeLicense92.correspondenceAddress) === null || _License$tradeLicense93 === void 0 ? void 0 : _License$tradeLicense93.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense94 = License.tradeLicenseDetail) === null || _License$tradeLicense94 === void 0 ? void 0 : (_License$tradeLicense95 = _License$tradeLicense94.additionalDetail) === null || _License$tradeLicense95 === void 0 ? void 0 : (_License$tradeLicense96 = _License$tradeLicense95[0]) === null || _License$tradeLicense96 === void 0 ? void 0 : (_License$tradeLicense97 = _License$tradeLicense96.tradeLicenseDetail) === null || _License$tradeLicense97 === void 0 ? void 0 : (_License$tradeLicense98 = _License$tradeLicense97.owners) === null || _License$tradeLicense98 === void 0 ? void 0 : (_License$tradeLicense99 = _License$tradeLicense98[0]) === null || _License$tradeLicense99 === void 0 ? void 0 : (_License$tradeLicense100 = _License$tradeLicense99.correspondenceAddress) === null || _License$tradeLicense100 === void 0 ? void 0 : _License$tradeLicense100.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense101 = License.tradeLicenseDetail) === null || _License$tradeLicense101 === void 0 ? void 0 : (_License$tradeLicense102 = _License$tradeLicense101.additionalDetail) === null || _License$tradeLicense102 === void 0 ? void 0 : (_License$tradeLicense103 = _License$tradeLicense102[0]) === null || _License$tradeLicense103 === void 0 ? void 0 : (_License$tradeLicense104 = _License$tradeLicense103.tradeLicenseDetail) === null || _License$tradeLicense104 === void 0 ? void 0 : (_License$tradeLicense105 = _License$tradeLicense104.owners) === null || _License$tradeLicense105 === void 0 ? void 0 : (_License$tradeLicense106 = _License$tradeLicense105[0]) === null || _License$tradeLicense106 === void 0 ? void 0 : (_License$tradeLicense107 = _License$tradeLicense106.correspondenceAddress) === null || _License$tradeLicense107 === void 0 ? void 0 : _License$tradeLicense107.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense108 = License.tradeLicenseDetail) === null || _License$tradeLicense108 === void 0 ? void 0 : (_License$tradeLicense109 = _License$tradeLicense108.additionalDetail) === null || _License$tradeLicense109 === void 0 ? void 0 : (_License$tradeLicense110 = _License$tradeLicense109[0]) === null || _License$tradeLicense110 === void 0 ? void 0 : (_License$tradeLicense111 = _License$tradeLicense110.tradeLicenseDetail) === null || _License$tradeLicense111 === void 0 ? void 0 : (_License$tradeLicense112 = _License$tradeLicense111.owners) === null || _License$tradeLicense112 === void 0 ? void 0 : (_License$tradeLicense113 = _License$tradeLicense112[0]) === null || _License$tradeLicense113 === void 0 ? void 0 : (_License$tradeLicense114 = _License$tradeLicense113.correspondenceAddress) === null || _License$tradeLicense114 === void 0 ? void 0 : _License$tradeLicense114.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense115 = License.tradeLicenseDetail) === null || _License$tradeLicense115 === void 0 ? void 0 : (_License$tradeLicense116 = _License$tradeLicense115.additionalDetail) === null || _License$tradeLicense116 === void 0 ? void 0 : (_License$tradeLicense117 = _License$tradeLicense116[0]) === null || _License$tradeLicense117 === void 0 ? void 0 : (_License$tradeLicense118 = _License$tradeLicense117.tradeLicenseDetail) === null || _License$tradeLicense118 === void 0 ? void 0 : (_License$tradeLicense119 = _License$tradeLicense118.owners) === null || _License$tradeLicense119 === void 0 ? void 0 : (_License$tradeLicense120 = _License$tradeLicense119[0]) === null || _License$tradeLicense120 === void 0 ? void 0 : (_License$tradeLicense121 = _License$tradeLicense120.correspondenceAddress) === null || _License$tradeLicense121 === void 0 ? void 0 : _License$tradeLicense121.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense122 = License.tradeLicenseDetail) === null || _License$tradeLicense122 === void 0 ? void 0 : (_License$tradeLicense123 = _License$tradeLicense122.additionalDetail) === null || _License$tradeLicense123 === void 0 ? void 0 : (_License$tradeLicense124 = _License$tradeLicense123[0]) === null || _License$tradeLicense124 === void 0 ? void 0 : (_License$tradeLicense125 = _License$tradeLicense124.tradeLicenseDetail) === null || _License$tradeLicense125 === void 0 ? void 0 : (_License$tradeLicense126 = _License$tradeLicense125.owners) === null || _License$tradeLicense126 === void 0 ? void 0 : (_License$tradeLicense127 = _License$tradeLicense126[0]) === null || _License$tradeLicense127 === void 0 ? void 0 : (_License$tradeLicense128 = _License$tradeLicense127.correspondenceAddress) === null || _License$tradeLicense128 === void 0 ? void 0 : _License$tradeLicense128.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense129 = License.tradeLicenseDetail) === null || _License$tradeLicense129 === void 0 ? void 0 : (_License$tradeLicense130 = _License$tradeLicense129.additionalDetail) === null || _License$tradeLicense130 === void 0 ? void 0 : (_License$tradeLicense131 = _License$tradeLicense130[0]) === null || _License$tradeLicense131 === void 0 ? void 0 : (_License$tradeLicense132 = _License$tradeLicense131.tradeLicenseDetail) === null || _License$tradeLicense132 === void 0 ? void 0 : (_License$tradeLicense133 = _License$tradeLicense132.owners) === null || _License$tradeLicense133 === void 0 ? void 0 : (_License$tradeLicense134 = _License$tradeLicense133[0]) === null || _License$tradeLicense134 === void 0 ? void 0 : (_License$tradeLicense135 = _License$tradeLicense134.correspondenceAddress) === null || _License$tradeLicense135 === void 0 ? void 0 : _License$tradeLicense135.university) || "NA"
      }]
    }, {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      additionalDetails: {
        documentsWithUrl: [{
          title: "",
          values: License === null || License === void 0 ? void 0 : (_License$tradeLicense136 = License.tradeLicenseDetail) === null || _License$tradeLicense136 === void 0 ? void 0 : (_License$tradeLicense137 = _License$tradeLicense136.applicationDocuments) === null || _License$tradeLicense137 === void 0 ? void 0 : _License$tradeLicense137.map(doc => {
            var _doc$documentType, _fileDetails, _fileDetails2, _fileDetails2$data$do;
            return {
              title: `BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replaceAll(".", "_")}`,
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              docInfo: doc === null || doc === void 0 ? void 0 : doc.info,
              url: (_fileDetails = fileDetails) !== null && _fileDetails !== void 0 && _fileDetails.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? (_fileDetails2 = fileDetails) === null || _fileDetails2 === void 0 ? void 0 : (_fileDetails2$data$do = _fileDetails2.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails2$data$do === void 0 ? void 0 : _fileDetails2$data$do.split(",")[0] : ""
            };
          })
        }]
      }
    }, (paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments = paymentRes.Payments) === null || _paymentRes$Payments === void 0 ? void 0 : _paymentRes$Payments.length) > 0 && {
      title: "BPA_FEE_DETAILS_LABEL",
      additionalDetails: {
        inspectionReport: [],
        values: [{
          title: "BPAREG_FEES",
          value: /*#__PURE__*/React.createElement("span", null, "\u20B9", paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments2 = paymentRes.Payments) === null || _paymentRes$Payments2 === void 0 ? void 0 : (_paymentRes$Payments3 = _paymentRes$Payments2[0]) === null || _paymentRes$Payments3 === void 0 ? void 0 : _paymentRes$Payments3.totalAmountPaid)
        }, {
          title: "BPA_STATUS_LABEL",
          isTransLate: true,
          isStatus: true,
          value: paymentRes !== null && paymentRes !== void 0 && (_paymentRes$Payments4 = paymentRes.Payments) !== null && _paymentRes$Payments4 !== void 0 && (_paymentRes$Payments5 = _paymentRes$Payments4[0]) !== null && _paymentRes$Payments5 !== void 0 && _paymentRes$Payments5.totalAmountPaid ? "WF_BPA_PAID" : "NA",
          isTransLate: true
        }]
      }
    }];
    return {
      applicationData: License,
      applicationDetails: details,
      tenantId: License === null || License === void 0 ? void 0 : License.tenantId,
      payments: (paymentRes === null || paymentRes === void 0 ? void 0 : paymentRes.Payments) || []
    };
  },
  BPADetailsPage: async (tenantId, filters) => {
    var _response$BPA, _response$BPA$, _response$BPA$$docume, _response$BPA2, _response$BPA3, _response$BPA3$, _response$BPA3$$addit, _response$BPA4, _response$BPA4$, _response$BPA4$$addit, _response$BPA5, _edcrResponse, _BPA$additionalDetail, _BPA$additionalDetail2, _BPA$additionalDetail3, _BPA$additionalDetail4, _BPA$additionalDetail5, _BPA$additionalDetail6, _BPA$additionalDetail7, _BPA$additionalDetail8, _BPA$additionalDetail9, _BPA$auditDetails, _BPA$auditDetails2, _edcr$, _edcr$2, _edcr$3, _edcr$3$planDetail, _edcr$3$planDetail$pl, _edcr$4, _edcr$4$planDetail, _edcr$4$planDetail$pl, _edcr$5, _edcr$5$planDetail, _edcr$5$planDetail$pl, _edcr$6, _edcr$6$planDetail, _edcr$6$planDetail$pl, _edcr$7, _edcr$7$planDetail, _edcr$7$planDetail$pl, _BPA$additionalDetail13, _BPA$additionalDetail14, _edcr$8, _edcr$9, _edcr$10, _edcr$11, _edcr$11$planDetail, _edcr$11$planDetail$b, _edcr$11$planDetail$b2, _edcr$11$planDetail$b3, _edcr$12, _edcr$12$planDetail, _edcr$12$planDetail$b, _edcr$12$planDetail$b2, _edcr$12$planDetail$b3, _edcr$13, _edcr$13$planDetail, _edcr$13$planDetail$b, _edcr$13$planDetail$b2, _edcr$13$planDetail$b3, _edcr$14, _edcr$14$planDetail, _edcr$14$planDetail$p, _BPA$landInfo, _BPA$landInfo$address, _BPA$additionalDetail15, _BPA$additionalDetail16, _BPA$additionalDetail17, _BPA$additionalDetail18, _BPA$additionalDetail19, _BPA$additionalDetail20, _BPA$landInfo2, _BPA$landInfo2$owners, _BPA$landInfo3, _BPA$landInfo3$owners, _BPA$additionalDetail21, _BPA$additionalDetail22, _BPA$additionalDetail23, _BPA$documents, _BPA$additionalDetail24, _BPA$additionalDetail25, _BPA$additionalDetail26, _BPA$additionalDetail27, _BPA$additionalDetail28, _BPA$additionalDetail29, _BPA$additionalDetail30, _billDetails$addition, _billDetails$addition2, _details;
    const response = await OBPSService.BPASearch(tenantId, filters);
    console.log("Latest5111111111111111111", response);
    const currentTenant = Digit.ULBService.getCurrentTenantId();
    let appDocumentFileStoreIds = response === null || response === void 0 ? void 0 : (_response$BPA = response.BPA) === null || _response$BPA === void 0 ? void 0 : (_response$BPA$ = _response$BPA[0]) === null || _response$BPA$ === void 0 ? void 0 : (_response$BPA$$docume = _response$BPA$.documents) === null || _response$BPA$$docume === void 0 ? void 0 : _response$BPA$$docume.map(docId => docId.fileStoreId);
    if (!appDocumentFileStoreIds) appDocumentFileStoreIds = [];
    if (!(response !== null && response !== void 0 && (_response$BPA2 = response.BPA) !== null && _response$BPA2 !== void 0 && _response$BPA2.length)) {
      return;
    }
    sessionStorage.setItem("BPA_ARCHITECT_NAME", JSON.stringify(response !== null && response !== void 0 && (_response$BPA3 = response.BPA) !== null && _response$BPA3 !== void 0 && (_response$BPA3$ = _response$BPA3[0]) !== null && _response$BPA3$ !== void 0 && (_response$BPA3$$addit = _response$BPA3$.additionalDetails) !== null && _response$BPA3$$addit !== void 0 && _response$BPA3$$addit.typeOfArchitect ? response === null || response === void 0 ? void 0 : (_response$BPA4 = response.BPA) === null || _response$BPA4 === void 0 ? void 0 : (_response$BPA4$ = _response$BPA4[0]) === null || _response$BPA4$ === void 0 ? void 0 : (_response$BPA4$$addit = _response$BPA4$.additionalDetails) === null || _response$BPA4$$addit === void 0 ? void 0 : _response$BPA4$$addit.typeOfArchitect : "ARCHITECT"));
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA5 = response.BPA) === null || _response$BPA5 === void 0 ? void 0 : _response$BPA5[0];
    let edcrResponse = {};
    if (BPA !== null && BPA !== void 0 && BPA.edcrNumber) {
      edcrResponse = await OBPSService.scrutinyDetails(currentTenant, {
        edcrNumber: BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber
      });
    }
    const edcr = ((_edcrResponse = edcrResponse) === null || _edcrResponse === void 0 ? void 0 : _edcrResponse.edcrDetail) || [];
    const nocResponse = await OBPSService.NOCSearch(currentTenant, {
      sourceRefId: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo
    });
    const noc = nocResponse === null || nocResponse === void 0 ? void 0 : nocResponse.Noc;
    noc === null || noc === void 0 ? void 0 : noc.map(nocDetails => {
      var _nocDetails$documents;
      nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents = nocDetails.documents) === null || _nocDetails$documents === void 0 ? void 0 : _nocDetails$documents.map(nocDoc => {
        if (nocDoc !== null && nocDoc !== void 0 && nocDoc.fileStoreId) appDocumentFileStoreIds.push(nocDoc === null || nocDoc === void 0 ? void 0 : nocDoc.fileStoreId);
      });
    });
    let fileDetails = {};
    let appBusinessService = [],
      collectionBillDetails = [],
      collectionBillArray = [],
      totalAmount = 0,
      collectionBillRes = [];
    const bussinessService = BPA === null || BPA === void 0 ? void 0 : BPA.businessService;
    const isUD = bussinessService === null || bussinessService === void 0 ? void 0 : bussinessService.includes("UD");
    if (bussinessService === "BPA_LOW") appBusinessService = ["BPA.LOW_RISK_PERMIT_FEE"];else if (bussinessService === "BPA") appBusinessService = ["BPA.FORM_12_FEE_UD", "BPA.FORM_12_FEE_UD"];else if (bussinessService === "BPA_OC") appBusinessService = ["BPA.NC_OC_APP_FEE", "BPA.NC_OC_SAN_FEE"];
    if (bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("UD") || bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("TCP")) appBusinessService = ["BPA.FORM_12_FEE", "BPA.FORM_12_FEE_UD"];
    const splittedFeeData = BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail = BPA.additionalDetails) === null || _BPA$additionalDetail === void 0 ? void 0 : (_BPA$additionalDetail2 = _BPA$additionalDetail.taxHeadEstimates) === null || _BPA$additionalDetail2 === void 0 ? void 0 : _BPA$additionalDetail2.map(item => {
      return Object.fromEntries(Object.entries(item).filter(([key, value]) => typeof value === "number"));
    });
    for (let _i = 0; _i < ((_appBusinessService = appBusinessService) === null || _appBusinessService === void 0 ? void 0 : _appBusinessService.length); _i++) {
      var _appBusinessService, _collectionres$Paymen, _collectionres$Paymen3;
      let collectionres = await Digit.PaymentService.recieptSearch(BPA === null || BPA === void 0 ? void 0 : BPA.tenantId, appBusinessService[_i], {
        consumerCodes: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
        isEmployee: true
      });
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen = collectionres.Payments) === null || _collectionres$Paymen === void 0 ? void 0 : _collectionres$Paymen.length) > 0) {
        var _collectionres$Paymen2;
        collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen2 = collectionres.Payments) === null || _collectionres$Paymen2 === void 0 ? void 0 : _collectionres$Paymen2.map(res => {
          var _res$paymentDetails;
          res === null || res === void 0 ? void 0 : (_res$paymentDetails = res.paymentDetails) === null || _res$paymentDetails === void 0 ? void 0 : _res$paymentDetails.map(resData => {
            if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[_i]) {
              collectionBillRes.push(res);
            }
          });
        });
      }
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen3 = collectionres.Payments) === null || _collectionres$Paymen3 === void 0 ? void 0 : _collectionres$Paymen3.length) > 0) collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
    }
    if ((collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.length) > 0) {
      collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.map(ob => {
        var _ob$paymentDetails, _ob$paymentDetails$, _ob$paymentDetails$$b, _ob$paymentDetails$$b2, _ob$paymentDetails$$b3;
        ob === null || ob === void 0 ? void 0 : (_ob$paymentDetails = ob.paymentDetails) === null || _ob$paymentDetails === void 0 ? void 0 : (_ob$paymentDetails$ = _ob$paymentDetails[0]) === null || _ob$paymentDetails$ === void 0 ? void 0 : (_ob$paymentDetails$$b = _ob$paymentDetails$.bill) === null || _ob$paymentDetails$$b === void 0 ? void 0 : (_ob$paymentDetails$$b2 = _ob$paymentDetails$$b.billDetails) === null || _ob$paymentDetails$$b2 === void 0 ? void 0 : (_ob$paymentDetails$$b3 = _ob$paymentDetails$$b2[0]) === null || _ob$paymentDetails$$b3 === void 0 ? void 0 : _ob$paymentDetails$$b3.billAccountDetails.map((bill, index) => {
          collectionBillArray.push({
            title: `${bill === null || bill === void 0 ? void 0 : bill.taxHeadCode}_DETAILS`,
            value: "",
            isSubTitle: true
          }, {
            title: bill === null || bill === void 0 ? void 0 : bill.taxHeadCode,
            value: `₹${bill === null || bill === void 0 ? void 0 : bill.amount}`
          }, {
            title: "BPA_STATUS_LABEL",
            value: "Paid"
          });
          totalAmount = totalAmount + parseInt(bill === null || bill === void 0 ? void 0 : bill.amount);
        });
      });
    } else {
      var _splittedFeeData$;
      for (const key in splittedFeeData === null || splittedFeeData === void 0 ? void 0 : splittedFeeData[0]) {
        if (key === "estimateAmount") continue;
        collectionBillArray.push({
          title: `BPA_COMMON_${key.toUpperCase()}_FEE`,
          value: `₹${splittedFeeData[0][key]}`
        });
      }
      collectionBillArray.push({
        title: "BPA_COMMON_TOTAL_FEE",
        value: `₹${splittedFeeData === null || splittedFeeData === void 0 ? void 0 : (_splittedFeeData$ = splittedFeeData[0]) === null || _splittedFeeData$ === void 0 ? void 0 : _splittedFeeData$.estimateAmount}`
      });
      collectionBillArray.push({
        title: "BPA_STATUS_LABEL",
        value: "Unpaid"
      });
    }
    totalAmount > 0 && collectionBillArray.push({
      title: "BPA_TOT_AMT_PAID",
      value: `₹${totalAmount}`
    });
    const billDetails = {
      title: "BPA_FEE_DETAILS_LABEL",
      isFeeDetails: true,
      additionalDetails: {
        inspectionReport: [],
        values: [...collectionBillArray]
      }
    };
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail3 = BPA.additionalDetails) === null || _BPA$additionalDetail3 === void 0 ? void 0 : (_BPA$additionalDetail4 = _BPA$additionalDetail3.fieldinspection_pending) === null || _BPA$additionalDetail4 === void 0 ? void 0 : _BPA$additionalDetail4.forEach(fiData => {
      var _fiData$docs;
      fiData === null || fiData === void 0 ? void 0 : (_fiData$docs = fiData.docs) === null || _fiData$docs === void 0 ? void 0 : _fiData$docs.forEach(fiDoc => {
        var _fileDetails$data$fiD;
        if (fileDetails !== null && fileDetails !== void 0 && fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) fiDoc.url = fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data$fiD = fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) === null || _fileDetails$data$fiD === void 0 ? void 0 : _fileDetails$data$fiD.split(",")[0];
      });
    });
    function ConvertEpochToValidityDate(dateEpoch) {
      if (dateEpoch == null || dateEpoch == undefined || dateEpoch == "") {
        return "NA";
      }
      const dateFromApi = new Date(dateEpoch);
      let month = dateFromApi.getMonth() + 1;
      let day = dateFromApi.getDate();
      let year = dateFromApi.getFullYear() - 3;
      month = (month > 9 ? "" : "0") + month;
      day = (day > 9 ? "" : "0") + day;
      return `${day}/${month}/${year}`;
    }
    const nocDetails = noc === null || noc === void 0 ? void 0 : noc.map((nocDetails, index) => {
      var _nocDetails$additiona, _nocDetails$additiona2, _nocDetails$additiona3, _nocDetails$auditDeta, _nocDetails$documents2;
      return {
        title: index === 0 ? "BPA_NOC_DETAILS_SUMMARY" : "",
        values: [{
          title: `BPA_${nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocType}_LABEL`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationNo,
          isNotTranslated: true
        }, {
          title: `BPA_NOC_STATUS`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus,
          field: "STATUS"
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona = nocDetails.additionalDetails) === null || _nocDetails$additiona === void 0 ? void 0 : _nocDetails$additiona.SubmittedOn) && {
          title: "BPA_SUDMITTED_ON_LABEL",
          value: nocDetails !== null && nocDetails !== void 0 && (_nocDetails$additiona2 = nocDetails.additionalDetails) !== null && _nocDetails$additiona2 !== void 0 && _nocDetails$additiona2.SubmittedOn ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona3 = nocDetails.additionalDetails) === null || _nocDetails$additiona3 === void 0 ? void 0 : _nocDetails$additiona3.SubmittedOn)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVAL_NUMBER_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) || "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVED_REJECTED_ON_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "REJECTED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_REJECTED" ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$auditDeta = nocDetails.auditDetails) === null || _nocDetails$auditDeta === void 0 ? void 0 : _nocDetails$auditDeta.lastModifiedTime)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }],
        additionalDetails: {
          data: nocDetails,
          noc: [{
            title: "BPA_DOCUMENT_DETAILS_LABEL",
            values: nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents2 = nocDetails.documents) === null || _nocDetails$documents2 === void 0 ? void 0 : _nocDetails$documents2.map(doc => {
              var _doc$documentType2, _fileDetails$data, _fileDetails$data2, _fileDetails$data2$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : _doc$documentType2.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data = fileDetails.data) !== null && _fileDetails$data !== void 0 && _fileDetails$data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data2 = fileDetails.data) === null || _fileDetails$data2 === void 0 ? void 0 : (_fileDetails$data2$do = _fileDetails$data2[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data2$do === void 0 ? void 0 : _fileDetails$data2$do.split(",")[0] : ""
              };
            })
          }]
        }
      };
    });
    let inspectionReport = [];
    let checklist = [];
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail5 = BPA.additionalDetails) === null || _BPA$additionalDetail5 === void 0 ? void 0 : (_BPA$additionalDetail6 = _BPA$additionalDetail5.fieldinspection_pending) === null || _BPA$additionalDetail6 === void 0 ? void 0 : _BPA$additionalDetail6.filter(ob => ob.docs && ob.docs.length > 0).map((ob, ind) => {
      var _ob$date, _ob$date2, _ob$date3, _ob$questions, _ob$docs;
      checklist = [];
      inspectionReport.push({
        title: "BPA_FI_REPORT",
        asSectionHeader: true,
        values: [{
          title: "BPA_FI_DATE_LABEL",
          value: ob.date.includes("-") ? `${(_ob$date = ob.date) === null || _ob$date === void 0 ? void 0 : _ob$date.split("-")[2]}/${(_ob$date2 = ob.date) === null || _ob$date2 === void 0 ? void 0 : _ob$date2.split("-")[1]}/${(_ob$date3 = ob.date) === null || _ob$date3 === void 0 ? void 0 : _ob$date3.split("-")[0]}` : ob.date
        }, {
          title: "BPA_FI_TIME_LABEL",
          value: ob.time
        }]
      });
      ob === null || ob === void 0 ? void 0 : (_ob$questions = ob.questions) === null || _ob$questions === void 0 ? void 0 : _ob$questions.map((q, index) => {
        checklist.push({
          title: q.question,
          value: q.value
        });
        checklist.push({
          title: "BPA_ENTER_REMARKS",
          value: q.remarks
        });
      });
      inspectionReport.push({
        title: "BPA_CHECK_LIST_DETAILS",
        asSectionHeader: true,
        values: checklist
      });
      inspectionReport.push({
        title: "BPA_DOCUMENT_DETAILS_LABEL",
        asSectionHeader: true,
        additionalDetails: {
          obpsDocuments: [{
            title: "",
            values: ob === null || ob === void 0 ? void 0 : (_ob$docs = ob.docs) === null || _ob$docs === void 0 ? void 0 : _ob$docs.map(doc => {
              var _doc$documentType3, _fileDetails$data3, _fileDetails$data4, _fileDetails$data4$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType3 = doc.documentType) === null || _doc$documentType3 === void 0 ? void 0 : _doc$documentType3.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.fileStore,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data3 = fileDetails.data) !== null && _fileDetails$data3 !== void 0 && _fileDetails$data3[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data4 = fileDetails.data) === null || _fileDetails$data4 === void 0 ? void 0 : (_fileDetails$data4$do = _fileDetails$data4[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data4$do === void 0 ? void 0 : _fileDetails$data4$do.split(",")[0] : ""
              };
            })
          }]
        }
      });
    });
    let details = [];
    let applicationDetailsInfo = {
      title: " ",
      isCommon: true,
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo) || "NA"
      }]
    };
    let envCitizenName = window.location.href.includes("/employee") ? "employee" : "citizen";
    if (BPA !== null && BPA !== void 0 && BPA.businessService.includes("BPA_OC")) {
      var _response$BPA6, _response$BPA6$, _response$BPA7, _response$BPA7$, _response$BPA8, _response$BPA8$, _response$BPA8$$addit, _response$BPA9, _response$BPA9$, _response$BPA9$$addit, _response$BPA10, _response$BPA10$, _response$BPA10$$addi;
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_APP_NUMBER",
        to: `/digit-ui/${envCitizenName}/obps/bpa/${response === null || response === void 0 ? void 0 : (_response$BPA6 = response.BPA) === null || _response$BPA6 === void 0 ? void 0 : (_response$BPA6$ = _response$BPA6[0]) === null || _response$BPA6$ === void 0 ? void 0 : _response$BPA6$.applicationNo}`,
        value: response === null || response === void 0 ? void 0 : (_response$BPA7 = response.BPA) === null || _response$BPA7 === void 0 ? void 0 : (_response$BPA7$ = _response$BPA7[0]) === null || _response$BPA7$ === void 0 ? void 0 : _response$BPA7$.approvalNo,
        isLink: true
      }];
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_VALIDITY",
        value: response !== null && response !== void 0 && (_response$BPA8 = response.BPA) !== null && _response$BPA8 !== void 0 && (_response$BPA8$ = _response$BPA8[0]) !== null && _response$BPA8$ !== void 0 && (_response$BPA8$$addit = _response$BPA8$.additionalDetails) !== null && _response$BPA8$$addit !== void 0 && _response$BPA8$$addit.validityDate ? `${ConvertEpochToValidityDate(response === null || response === void 0 ? void 0 : (_response$BPA9 = response.BPA) === null || _response$BPA9 === void 0 ? void 0 : (_response$BPA9$ = _response$BPA9[0]) === null || _response$BPA9$ === void 0 ? void 0 : (_response$BPA9$$addit = _response$BPA9$.additionalDetails) === null || _response$BPA9$$addit === void 0 ? void 0 : _response$BPA9$$addit.validityDate)} - ${format(new Date(response === null || response === void 0 ? void 0 : (_response$BPA10 = response.BPA) === null || _response$BPA10 === void 0 ? void 0 : (_response$BPA10$ = _response$BPA10[0]) === null || _response$BPA10$ === void 0 ? void 0 : (_response$BPA10$$addi = _response$BPA10$.additionalDetails) === null || _response$BPA10$$addi === void 0 ? void 0 : _response$BPA10$$addi.validityDate), "dd/MM/yyyy")}` : "NA"
      }];
    }
    let permitcondn = [];
    (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail7 = BPA.additionalDetails) === null || _BPA$additionalDetail7 === void 0 ? void 0 : _BPA$additionalDetail7.pendingapproval) && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail8 = BPA.additionalDetails) === null || _BPA$additionalDetail8 === void 0 ? void 0 : _BPA$additionalDetail8.pendingapproval.length) > 0 && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail9 = BPA.additionalDetails) === null || _BPA$additionalDetail9 === void 0 ? void 0 : _BPA$additionalDetail9.pendingapproval.map((ob, index) => {
      permitcondn.push({
        title: `${index + 1}. ${ob}`,
        value: ""
      });
    }));
    let PermitConditions = {
      title: "BPA_PERMIT_CONDITIONS",
      isTitleVisible: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      isNotAllowed: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      additionalDetails: {
        inspectionReport: [],
        permit: [...permitcondn]
      }
    };
    if (permitcondn.length == 0) PermitConditions = {};
    if (BPA !== null && BPA !== void 0 && BPA.approvalNo) {
      var _applicationDetailsIn, _applicationDetailsIn2, _BPA$additionalDetail10, _BPA$additionalDetail11, _BPA$additionalDetail12;
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn = applicationDetailsInfo.values) === null || _applicationDetailsIn === void 0 ? void 0 : _applicationDetailsIn.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_NUMBER_LABEL" : "BPA_OC_PERMIT_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.approvalNo) || "NA"
      });
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn2 = applicationDetailsInfo.values) === null || _applicationDetailsIn2 === void 0 ? void 0 : _applicationDetailsIn2.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_VALIDITY" : "BPA_OC_PERMIT_VALIDITY",
        value: BPA !== null && BPA !== void 0 && (_BPA$additionalDetail10 = BPA.additionalDetails) !== null && _BPA$additionalDetail10 !== void 0 && _BPA$additionalDetail10.validityDate ? `${ConvertEpochToValidityDate(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail11 = BPA.additionalDetails) === null || _BPA$additionalDetail11 === void 0 ? void 0 : _BPA$additionalDetail11.validityDate)} - ${format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail12 = BPA.additionalDetails) === null || _BPA$additionalDetail12 === void 0 ? void 0 : _BPA$additionalDetail12.validityDate), "dd/MM/yyyy")}` : "NA"
      });
    }
    const basicDetails = {
      title: "BPA_BASIC_DETAILS_TITLE",
      asSectionHeader: true,
      isInsert: true,
      isCommon: true,
      values: [{
        title: "BPA_BASIC_DETAILS_APP_DATE_LABEL",
        value: BPA !== null && BPA !== void 0 && (_BPA$auditDetails = BPA.auditDetails) !== null && _BPA$auditDetails !== void 0 && _BPA$auditDetails.createdTime ? format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$auditDetails2 = BPA.auditDetails) === null || _BPA$auditDetails2 === void 0 ? void 0 : _BPA$auditDetails2.createdTime), "dd/MM/yyyy") : ""
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL",
        value: `WF_BPA_${edcr === null || edcr === void 0 ? void 0 : (_edcr$ = edcr[0]) === null || _edcr$ === void 0 ? void 0 : _edcr$.appliactionType}`
      }, {
        title: "BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$2 = edcr[0]) === null || _edcr$2 === void 0 ? void 0 : _edcr$2.applicationSubType
      }, {
        title: "BPA_BASIC_DETAILS_OCCUPANCY_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$3 = edcr[0]) === null || _edcr$3 === void 0 ? void 0 : (_edcr$3$planDetail = _edcr$3.planDetail) === null || _edcr$3$planDetail === void 0 ? void 0 : (_edcr$3$planDetail$pl = _edcr$3$planDetail.planInformation) === null || _edcr$3$planDetail$pl === void 0 ? void 0 : _edcr$3$planDetail$pl.occupancy
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$4 = edcr[0]) === null || _edcr$4 === void 0 ? void 0 : (_edcr$4$planDetail = _edcr$4.planDetail) === null || _edcr$4$planDetail === void 0 ? void 0 : (_edcr$4$planDetail$pl = _edcr$4$planDetail.planInformation) === null || _edcr$4$planDetail$pl === void 0 ? void 0 : _edcr$4$planDetail$pl.applicantName
      }]
    };
    const plotDetails = {
      title: "BPA_PLOT_DETAILS_TITLE",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_BOUNDARY_PLOT_AREA_LABEL",
        value: `${edcr === null || edcr === void 0 ? void 0 : (_edcr$5 = edcr[0]) === null || _edcr$5 === void 0 ? void 0 : (_edcr$5$planDetail = _edcr$5.planDetail) === null || _edcr$5$planDetail === void 0 ? void 0 : (_edcr$5$planDetail$pl = _edcr$5$planDetail.planInformation) === null || _edcr$5$planDetail$pl === void 0 ? void 0 : _edcr$5$planDetail$pl.plotArea}`,
        isNotTranslated: true,
        isUnit: "BPA_SQ_MT_LABEL"
      }, {
        title: "BPA_PLOT_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$6 = edcr[0]) === null || _edcr$6 === void 0 ? void 0 : (_edcr$6$planDetail = _edcr$6.planDetail) === null || _edcr$6$planDetail === void 0 ? void 0 : (_edcr$6$planDetail$pl = _edcr$6$planDetail.planInformation) === null || _edcr$6$planDetail$pl === void 0 ? void 0 : _edcr$6$planDetail$pl.plotNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_KHATHA_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$7 = edcr[0]) === null || _edcr$7 === void 0 ? void 0 : (_edcr$7$planDetail = _edcr$7.planDetail) === null || _edcr$7$planDetail === void 0 ? void 0 : (_edcr$7$planDetail$pl = _edcr$7$planDetail.planInformation) === null || _edcr$7$planDetail$pl === void 0 ? void 0 : _edcr$7$planDetail$pl.khataNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_HOLDING_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail13 = BPA.additionalDetails) === null || _BPA$additionalDetail13 === void 0 ? void 0 : _BPA$additionalDetail13.holdingNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_BOUNDARY_LAND_REG_DETAIL_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail14 = BPA.additionalDetails) === null || _BPA$additionalDetail14 === void 0 ? void 0 : _BPA$additionalDetail14.registrationDetails) || "NA",
        isNotTranslated: true
      }]
    };
    const scrutinyDetails = {
      title: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_EDCR_DETAILS",
          value: " ",
          isHeader: true
        }, {
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_EDCR_NO_LABEL" : "BPA_OC_EDCR_NO_LABEL",
          value: (BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber) || "NA"
        }],
        scruntinyDetails: [{
          title: "BPA_UPLOADED_PLAN_DIAGRAM",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$8 = edcr[0]) === null || _edcr$8 === void 0 ? void 0 : _edcr$8.updatedDxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }, {
          title: "BPA_SCRUNTINY_REPORT_OUTPUT",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$9 = edcr[0]) === null || _edcr$9 === void 0 ? void 0 : _edcr$9.planReport,
          text: "BPA_SCRUTINY_REPORT_PDF"
        }, {
          title: "BPA_UPLOADED_PLAN_DXF",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$10 = edcr[0]) === null || _edcr$10 === void 0 ? void 0 : _edcr$10.dxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }]
      }
    };
    const buildingExtractionDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_BUILDING_EXTRACT_HEADER" : "BPA_ACTUAL_BUILDING_EXTRACT_HEADER",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_TOTAL_BUILT_UP_AREA_HEADER",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$11 = edcr[0]) === null || _edcr$11 === void 0 ? void 0 : (_edcr$11$planDetail = _edcr$11.planDetail) === null || _edcr$11$planDetail === void 0 ? void 0 : (_edcr$11$planDetail$b = _edcr$11$planDetail.blocks) === null || _edcr$11$planDetail$b === void 0 ? void 0 : (_edcr$11$planDetail$b2 = _edcr$11$planDetail$b[0]) === null || _edcr$11$planDetail$b2 === void 0 ? void 0 : (_edcr$11$planDetail$b3 = _edcr$11$planDetail$b2.building) === null || _edcr$11$planDetail$b3 === void 0 ? void 0 : _edcr$11$planDetail$b3.totalBuitUpArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }, {
          title: "BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL",
          value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$12 = edcr[0]) === null || _edcr$12 === void 0 ? void 0 : (_edcr$12$planDetail = _edcr$12.planDetail) === null || _edcr$12$planDetail === void 0 ? void 0 : (_edcr$12$planDetail$b = _edcr$12$planDetail.blocks) === null || _edcr$12$planDetail$b === void 0 ? void 0 : (_edcr$12$planDetail$b2 = _edcr$12$planDetail$b[0]) === null || _edcr$12$planDetail$b2 === void 0 ? void 0 : (_edcr$12$planDetail$b3 = _edcr$12$planDetail$b2.building) === null || _edcr$12$planDetail$b3 === void 0 ? void 0 : _edcr$12$planDetail$b3.totalFloors) || "NA"
        }, {
          title: "BPA_HEIGHT_FROM_GROUND_LEVEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$13 = edcr[0]) === null || _edcr$13 === void 0 ? void 0 : (_edcr$13$planDetail = _edcr$13.planDetail) === null || _edcr$13$planDetail === void 0 ? void 0 : (_edcr$13$planDetail$b = _edcr$13$planDetail.blocks) === null || _edcr$13$planDetail$b === void 0 ? void 0 : (_edcr$13$planDetail$b2 = _edcr$13$planDetail$b[0]) === null || _edcr$13$planDetail$b2 === void 0 ? void 0 : (_edcr$13$planDetail$b3 = _edcr$13$planDetail$b2.building) === null || _edcr$13$planDetail$b3 === void 0 ? void 0 : _edcr$13$planDetail$b3.declaredBuildingHeigh,
          isUnit: "BPA_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const demolitionAreaDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$14 = edcr[0]) === null || _edcr$14 === void 0 ? void 0 : (_edcr$14$planDetail = _edcr$14.planDetail) === null || _edcr$14$planDetail === void 0 ? void 0 : (_edcr$14$planDetail$p = _edcr$14$planDetail.planInformation) === null || _edcr$14$planDetail$p === void 0 ? void 0 : _edcr$14$planDetail$p.demolitionArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const subOccupancyTableDetails = {
      title: "",
      isSubOccupancyTable: true,
      isTitleRepeat: true,
      additionalDetails: {
        values: [{
          title: "BPA_OCC_SUBOCC_HEADER",
          value: " ",
          isHeader: true
        }],
        subOccupancyTableDetails: [{
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr
        }, {
          title: "NO_REPEAT",
          value: ""
        }]
      }
    };
    const addressDetails = {
      title: "BPA_NEW_TRADE_DETAILS_HEADER_DETAILS",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_CITY_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo = BPA.landInfo) === null || _BPA$landInfo === void 0 ? void 0 : (_BPA$landInfo$address = _BPA$landInfo.address) === null || _BPA$landInfo$address === void 0 ? void 0 : _BPA$landInfo$address.city
      }, {
        title: !isUD ? "BPA_LOC_NOTIFIED-AREA_LABEL" : "BPA_ULB-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail15 = BPA.additionalDetails) === null || _BPA$additionalDetail15 === void 0 ? void 0 : (_BPA$additionalDetail16 = _BPA$additionalDetail15.landInfo) === null || _BPA$additionalDetail16 === void 0 ? void 0 : (_BPA$additionalDetail17 = _BPA$additionalDetail16.address) === null || _BPA$additionalDetail17 === void 0 ? void 0 : _BPA$additionalDetail17.doorNo
      }, {
        title: !isUD ? "BPA_LOC_VILLAGE-AREA_LABEL" : "BPA_LOC_WARD-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail18 = BPA.additionalDetails) === null || _BPA$additionalDetail18 === void 0 ? void 0 : (_BPA$additionalDetail19 = _BPA$additionalDetail18.landInfo) === null || _BPA$additionalDetail19 === void 0 ? void 0 : (_BPA$additionalDetail20 = _BPA$additionalDetail19.address) === null || _BPA$additionalDetail20 === void 0 ? void 0 : _BPA$additionalDetail20.village
      }]
    };
    const checkOwnerLength = (BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo2 = BPA.landInfo) === null || _BPA$landInfo2 === void 0 ? void 0 : (_BPA$landInfo2$owners = _BPA$landInfo2.owners) === null || _BPA$landInfo2$owners === void 0 ? void 0 : _BPA$landInfo2$owners.length) || 1;
    if ((BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo3 = BPA.landInfo) === null || _BPA$landInfo3 === void 0 ? void 0 : (_BPA$landInfo3$owners = _BPA$landInfo3.owners) === null || _BPA$landInfo3$owners === void 0 ? void 0 : _BPA$landInfo3$owners.length) > 0) {
      var _BPA$landInfo4, _BPA$landInfo4$owners;
      BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo4 = BPA.landInfo) === null || _BPA$landInfo4 === void 0 ? void 0 : (_BPA$landInfo4$owners = _BPA$landInfo4.owners) === null || _BPA$landInfo4$owners === void 0 ? void 0 : _BPA$landInfo4$owners.forEach(ownerD => {
        if (!ownerD.isPrimaryOwner) ownerD.isPrimaryOwner = "false";
      });
    }
    const ownerDetails = {
      title: "BPA_APPLICANT_DETAILS_HEADER",
      isOwnerDetails: true,
      additionalDetails: {
        owners: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail21 = BPA.additionalDetails) === null || _BPA$additionalDetail21 === void 0 ? void 0 : (_BPA$additionalDetail22 = _BPA$additionalDetail21.landInfo) === null || _BPA$additionalDetail22 === void 0 ? void 0 : (_BPA$additionalDetail23 = _BPA$additionalDetail22.owners) === null || _BPA$additionalDetail23 === void 0 ? void 0 : _BPA$additionalDetail23.map((owner, index) => {
          var _owner$permanentAddre, _owner$permanentAddre2, _owner$permanentAddre3, _owner$permanentAddre4, _owner$permanentAddre5, _owner$permanentAddre6, _owner$correspondence, _owner$correspondence2, _owner$correspondence3, _owner$correspondence4, _owner$correspondence5, _owner$correspondence6;
          return {
            title: Number(checkOwnerLength) > 1 ? "COMMON_OWNER" : "",
            values: [{
              title: "CORE_COMMON_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.name
            }, {
              title: "BPA_APPLICANT_GENDER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.gender
            }, {
              title: "CORE_COMMON_MOBILE_NUMBER",
              value: owner === null || owner === void 0 ? void 0 : owner.mobileNumber
            }, {
              title: "BPA_APPLICANT_EMAIL_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.emailId
            }, {
              title: "CORE_COMMON_GUARDIAN_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.fatherOrHusbandName
            }, {
              title: "BPA_IS_PRIMARY_OWNER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.isPrimaryOwner,
              isNotTranslated: false
            }, {
              title: "BPA_OWNER_PERMANENT_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre = owner.permanentAddress) === null || _owner$permanentAddre === void 0 ? void 0 : _owner$permanentAddre.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre2 = owner.permanentAddress) === null || _owner$permanentAddre2 === void 0 ? void 0 : _owner$permanentAddre2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre3 = owner.permanentAddress) === null || _owner$permanentAddre3 === void 0 ? void 0 : _owner$permanentAddre3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre4 = owner.permanentAddress) === null || _owner$permanentAddre4 === void 0 ? void 0 : _owner$permanentAddre4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre5 = owner.permanentAddress) === null || _owner$permanentAddre5 === void 0 ? void 0 : _owner$permanentAddre5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre6 = owner.permanentAddress) === null || _owner$permanentAddre6 === void 0 ? void 0 : _owner$permanentAddre6.pinno
            }, {
              title: "BPA_OWNER_CORRESPONDANCE_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence = owner.correspondenceAddress) === null || _owner$correspondence === void 0 ? void 0 : _owner$correspondence.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence2 = owner.correspondenceAddress) === null || _owner$correspondence2 === void 0 ? void 0 : _owner$correspondence2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence3 = owner.correspondenceAddress) === null || _owner$correspondence3 === void 0 ? void 0 : _owner$correspondence3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence4 = owner.correspondenceAddress) === null || _owner$correspondence4 === void 0 ? void 0 : _owner$correspondence4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence5 = owner.correspondenceAddress) === null || _owner$correspondence5 === void 0 ? void 0 : _owner$correspondence5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence6 = owner.correspondenceAddress) === null || _owner$correspondence6 === void 0 ? void 0 : _owner$correspondence6.pinno
            }]
          };
        })
      }
    };
    const professionalDetails = {
      title: "BPA_PROFESSIONAL_DETAILS_HEADER",
      asSectionHeader: true,
      isprofessionalDetail: true,
      values: [BPA === null || BPA === void 0 ? void 0 : BPA.professionaldetails]
    };
    const documentDetails = {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      isDocumentDetails: true,
      additionalDetails: {
        obpsDocuments: [{
          title: "",
          values: BPA === null || BPA === void 0 ? void 0 : (_BPA$documents = BPA.documents) === null || _BPA$documents === void 0 ? void 0 : _BPA$documents.map(doc => {
            var _doc$documentType4, _fileDetails$data5, _fileDetails$data6, _fileDetails$data6$do;
            return {
              title: doc === null || doc === void 0 ? void 0 : (_doc$documentType4 = doc.documentType) === null || _doc$documentType4 === void 0 ? void 0 : _doc$documentType4.replaceAll(".", "_"),
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data5 = fileDetails.data) !== null && _fileDetails$data5 !== void 0 && _fileDetails$data5[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data6 = fileDetails.data) === null || _fileDetails$data6 === void 0 ? void 0 : (_fileDetails$data6$do = _fileDetails$data6[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data6$do === void 0 ? void 0 : _fileDetails$data6$do.split(",")[0] : ""
            };
          })
        }]
      }
    };
    let approvalChecks = [];
    let approvalChecksDetails = {};
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.status) === "APPROVAL_INPROGRESS") {
      approvalChecksDetails = {
        title: "",
        isTitleVisible: (approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.length) > 0 ? false : true,
        asSectionHeader: true,
        isPermissions: true,
        additionalDetails: {
          permissions: approvalChecks
        }
      };
    }
    let val;
    var i;
    inspectionReport && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail24 = BPA.additionalDetails) === null || _BPA$additionalDetail24 === void 0 ? void 0 : (_BPA$additionalDetail25 = _BPA$additionalDetail24.fieldinspection_pending) === null || _BPA$additionalDetail25 === void 0 ? void 0 : (_BPA$additionalDetail26 = _BPA$additionalDetail25[0]) === null || _BPA$additionalDetail26 === void 0 ? void 0 : _BPA$additionalDetail26.questions.length) > 0 && inspectionReport.map((ob, index) => {
      if (ob.title.includes("FI_REPORT")) ;else if (ob.title.includes("CHECK_LIST")) ;else {
        var _ob$additionalDetails, _ob$additionalDetails2;
        let improvedDoc = [...((_ob$additionalDetails = ob.additionalDetails.obpsDocuments) === null || _ob$additionalDetails === void 0 ? void 0 : (_ob$additionalDetails2 = _ob$additionalDetails[0]) === null || _ob$additionalDetails2 === void 0 ? void 0 : _ob$additionalDetails2.values)];
        improvedDoc.map(ob => {
          ob["isNotDuplicate"] = true;
        });
        improvedDoc.map((ob, index) => {
          val = ob.documentType;
          if (ob.isNotDuplicate == true) for (i = index + 1; i < improvedDoc.length; i++) {
            if (val === improvedDoc[i].documentType) improvedDoc[i].isNotDuplicate = false;
          }
        });
      }
    });
    const fiReports = {
      title: "",
      isFieldInspection: true,
      isNotAllowed: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail27 = BPA.additionalDetails) === null || _BPA$additionalDetail27 === void 0 ? void 0 : (_BPA$additionalDetail28 = _BPA$additionalDetail27.fieldinspection_pending) === null || _BPA$additionalDetail28 === void 0 ? void 0 : _BPA$additionalDetail28.length) > 0 ? false : true,
      additionalDetails: {
        values: [],
        fiReport: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail29 = BPA.additionalDetails) === null || _BPA$additionalDetail29 === void 0 ? void 0 : (_BPA$additionalDetail30 = _BPA$additionalDetail29.fieldinspection_pending) === null || _BPA$additionalDetail30 === void 0 ? void 0 : _BPA$additionalDetail30.length) > 0 ? true : false
      }
    };
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC") {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, addressDetails, ownerDetails, professionalDetails, documentDetails, fiReports, ...nocDetails, approvalChecksDetails, PermitConditions];
    } else {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, documentDetails, fiReports, ...nocDetails, PermitConditions];
    }
    if (billDetails !== null && billDetails !== void 0 && (_billDetails$addition = billDetails.additionalDetails) !== null && _billDetails$addition !== void 0 && (_billDetails$addition2 = _billDetails$addition.values) !== null && _billDetails$addition2 !== void 0 && _billDetails$addition2.length) {
      details.push(billDetails);
    }
    let bpaFilterDetails = (_details = details) === null || _details === void 0 ? void 0 : _details.filter(data => data);
    return {
      applicationData: BPA,
      applicationDetails: bpaFilterDetails,
      tenantId: BPA === null || BPA === void 0 ? void 0 : BPA.tenantId,
      edcrDetails: edcr || [],
      nocData: noc,
      businessService: BPA === null || BPA === void 0 ? void 0 : BPA.businessService,
      applicationNo: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
      applicationStatus: BPA === null || BPA === void 0 ? void 0 : BPA.status,
      collectionBillDetails: collectionBillDetails
    };
  },
  BPADetailsPageForm11: async (tenantId, filters) => {
    var _response$PermissionO5;
    const response = await OBPSService.BPASearchForm11(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$PermissionO, _response$PermissionO2, _filters$formType, _businessService$join, _response$PermissionO4;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$PermissionO = response.PermissionOfSubdivision) === null || _response$PermissionO === void 0 ? void 0 : (_response$PermissionO2 = _response$PermissionO[0]) === null || _response$PermissionO2 === void 0 ? void 0 : _response$PermissionO2.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType = filters.formType) === null || _filters$formType === void 0 ? void 0 : _filters$formType.replace("form", "");
      const appBusinessService = (_businessService$join = businessService.join("")) !== null && _businessService$join !== void 0 && _businessService$join.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$PermissionO3;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen4;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen4 = collectionres.Payments) === null || _collectionres$Paymen4 === void 0 ? void 0 : _collectionres$Paymen4.length) > 0) {
            var _collectionres$Paymen5;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen5 = collectionres.Payments) === null || _collectionres$Paymen5 === void 0 ? void 0 : _collectionres$Paymen5.map(res => {
              var _res$paymentDetails2;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails2 = res.paymentDetails) === null || _res$paymentDetails2 === void 0 ? void 0 : _res$paymentDetails2.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$PermissionO3 = response.PermissionOfSubdivision) === null || _response$PermissionO3 === void 0 ? void 0 : _response$PermissionO3[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$PermissionO4 = response.PermissionOfSubdivision) === null || _response$PermissionO4 === void 0 ? void 0 : _response$PermissionO4[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$PermissionO5 = response.PermissionOfSubdivision) === null || _response$PermissionO5 === void 0 ? void 0 : _response$PermissionO5[0];
  },
  BPADetailsPageFormLandUse: async (tenantId, filters) => {
    var _response$LandUse4;
    const response = await OBPSService.BPASearchFormLandUse(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$LandUse, _response$LandUse$, _filters$formType2, _businessService$join2, _response$LandUse3;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$LandUse = response.LandUse) === null || _response$LandUse === void 0 ? void 0 : (_response$LandUse$ = _response$LandUse[0]) === null || _response$LandUse$ === void 0 ? void 0 : _response$LandUse$.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType2 = filters.formType) === null || _filters$formType2 === void 0 ? void 0 : _filters$formType2.replace("form", "");
      const appBusinessService = (_businessService$join2 = businessService.join("")) !== null && _businessService$join2 !== void 0 && _businessService$join2.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$LandUse2;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen6;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen6 = collectionres.Payments) === null || _collectionres$Paymen6 === void 0 ? void 0 : _collectionres$Paymen6.length) > 0) {
            var _collectionres$Paymen7;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen7 = collectionres.Payments) === null || _collectionres$Paymen7 === void 0 ? void 0 : _collectionres$Paymen7.map(res => {
              var _res$paymentDetails3;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails3 = res.paymentDetails) === null || _res$paymentDetails3 === void 0 ? void 0 : _res$paymentDetails3.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$LandUse2 = response.LandUse) === null || _response$LandUse2 === void 0 ? void 0 : _response$LandUse2[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$LandUse3 = response.LandUse) === null || _response$LandUse3 === void 0 ? void 0 : _response$LandUse3[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$LandUse4 = response.LandUse) === null || _response$LandUse4 === void 0 ? void 0 : _response$LandUse4[0];
  },
  Form12DetailsPage: async (tenantId, filter) => {
    var _response$BPA11;
    const response = await OBPSService.BPASearch(tenantId, filter);
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA11 = response.BPA) === null || _response$BPA11 === void 0 ? void 0 : _response$BPA11[0];
    return {
      applicationData: BPA
    };
  }
};

const ApplicationDetails = props => {
  var _workflowDetails$data;
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const state = Digit.ULBService.getStateId();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  let {
    id: applicationNumber
  } = useParams();
  const [displayMenu, setDisplayMenu] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEnableLoader, setIsEnableLoader] = useState(false);
  const [isWarningPop, setWarningPopUp] = useState(false);
  const {
    applicationDetails,
    showToast,
    setShowToast,
    isLoading,
    isDataLoading,
    applicationData,
    mutate,
    nocMutation,
    workflowDetails,
    businessService,
    closeToast,
    moduleCode,
    timelineStatusPrefix,
    forcedActionPrefix,
    statusAttribute,
    ActionBarStyle,
    MenuStyle,
    paymentsList,
    showTimeLine = true
  } = props;
  useEffect(() => {
    if (showToast) {
      workflowDetails.revalidate();
    }
  }, [showToast]);
  async function onActionSelect(action) {
    if (action) {
      if (action !== null && action !== void 0 && action.isWarningPopUp) {
        setWarningPopUp(true);
      } else if (action !== null && action !== void 0 && action.redirectionUrll) {
        var _action$redirectionUr;
        window.location.assign(`${window.location.origin}/digit-ui/employee/payment/collect/${action === null || action === void 0 ? void 0 : (_action$redirectionUr = action.redirectionUrll) === null || _action$redirectionUr === void 0 ? void 0 : _action$redirectionUr.pathname}`);
      } else if ((action === null || action === void 0 ? void 0 : action.action) === 'APPROVAL_LETTER_GENERATE') {
        setShowModal(false);
        let payload = {};
        payload.BPA = applicationData;
        payload.BPA.workflow = {
          "action": "APPROVAL_LETTER_GENERATE",
          "assignes": null,
          "comments": null,
          "varificationDocuments": null
        }, payload.RequestInfo = applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.RequestInfo;
        try {
          const res = await OBPSService.designOfApprovalLetterPdf(state, applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationNo);
          const pdfBlob = new Blob([res === null || res === void 0 ? void 0 : res.data], {
            type: "application/pdf"
          });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);
          if (res) {
            await OBPSService.update(payload, tenantId);
            history.push({
              pathname: "/digit-ui/employee/obps/form12inbox"
            });
          } else {
            setShowToast({
              key: "error",
              error: {
                message: "Error in APPROVAL_LETTER_GENERATE"
              }
            });
          }
        } catch (error) {
          console.error("Error in APPROVAL_LETTER_GENERATE action:", error);
        }
      } else if (!(action !== null && action !== void 0 && action.redirectionUrl)) {
        setShowModal(true);
      } else {
        var _action$redirectionUr2, _action$redirectionUr3;
        history.push({
          pathname: (_action$redirectionUr2 = action.redirectionUrl) === null || _action$redirectionUr2 === void 0 ? void 0 : _action$redirectionUr2.pathname,
          state: {
            ...((_action$redirectionUr3 = action.redirectionUrl) === null || _action$redirectionUr3 === void 0 ? void 0 : _action$redirectionUr3.state)
          }
        });
      }
    }
    setSelectedAction(action);
    setDisplayMenu(false);
  }
  const queryClient = useQueryClient();
  const closeModal = () => {
    setSelectedAction(null);
    setShowModal(false);
  };
  const closeWarningPopup = () => {
    setWarningPopUp(false);
  };
  const submitAction = async (data, nocData = false, isOBPS = {}) => {
    setIsEnableLoader(true);
    if (typeof (data === null || data === void 0 ? void 0 : data.customFunctionToExecute) === "function") {
      data === null || data === void 0 ? void 0 : data.customFunctionToExecute({
        ...data
      });
    }
    if (nocData !== false && nocMutation) {
      const nocPrmomises = nocData === null || nocData === void 0 ? void 0 : nocData.map(noc => {
        return nocMutation === null || nocMutation === void 0 ? void 0 : nocMutation.mutateAsync(noc);
      });
      try {
        setIsEnableLoader(true);
        const values = await Promise.all(nocPrmomises);
        values && values.map(ob => {
          var _ob$Noc, _ob$Noc$;
          Digit.SessionStorage.del(ob === null || ob === void 0 ? void 0 : (_ob$Noc = ob.Noc) === null || _ob$Noc === void 0 ? void 0 : (_ob$Noc$ = _ob$Noc[0]) === null || _ob$Noc$ === void 0 ? void 0 : _ob$Noc$.nocType);
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2, _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2, _err$response3, _err$response3$data, _err$response3$data$E, _err$response3$data$E2;
        setIsEnableLoader(false);
        let errorValue = err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$Er = _err$response$data.Errors) !== null && _err$response$data$Er !== void 0 && (_err$response$data$Er2 = _err$response$data$Er[0]) !== null && _err$response$data$Er2 !== void 0 && _err$response$data$Er2.code ? t(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) : (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$E = _err$response3$data.Errors) === null || _err$response3$data$E === void 0 ? void 0 : (_err$response3$data$E2 = _err$response3$data$E[0]) === null || _err$response3$data$E2 === void 0 ? void 0 : _err$response3$data$E2.message) || err;
        closeModal();
        setShowToast({
          key: "error",
          error: {
            message: errorValue
          }
        });
        setTimeout(closeToast, 5000);
        return;
      }
    }
    if (mutate) {
      setIsEnableLoader(true);
      mutate(data, {
        onError: (error, variables) => {
          setIsEnableLoader(false);
          setShowToast({
            key: "error",
            error
          });
          setTimeout(closeToast, 5000);
        },
        onSuccess: (data, variables) => {
          setIsEnableLoader(false);
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.bpa) {
            data.selectedAction = selectedAction;
            history.replace(`/digit-ui/employee/obps/response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isStakeholder) {
            data.selectedAction = selectedAction;
            history.push(`/digit-ui/employee/obps/stakeholder-response`, {
              data: data
            });
          }
          if (isOBPS !== null && isOBPS !== void 0 && isOBPS.isNoc) {
            history.push(`/digit-ui/employee/noc/response`, {
              data: data
            });
          }
          setShowToast({
            key: "success",
            action: selectedAction
          });
          setTimeout(closeToast, 5000);
          queryClient.clear();
          queryClient.refetchQueries("APPLICATION_SEARCH");
        }
      });
    }
    closeModal();
  };
  if (isLoading || isEnableLoader) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationDetailsContent, {
    applicationDetails: applicationDetails,
    workflowDetails: workflowDetails,
    isDataLoading: isDataLoading,
    applicationData: applicationData,
    businessService: businessService,
    timelineStatusPrefix: timelineStatusPrefix,
    statusAttribute: statusAttribute,
    paymentsList: paymentsList,
    showTimeLine: showTimeLine
  }), showModal ? /*#__PURE__*/React.createElement(ActionModal$6, {
    t: t,
    action: selectedAction,
    tenantId: tenantId,
    state: state,
    id: applicationNumber,
    applicationDetails: applicationDetails,
    applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    closeModal: closeModal,
    submitAction: submitAction,
    actionData: workflowDetails === null || workflowDetails === void 0 ? void 0 : (_workflowDetails$data = workflowDetails.data) === null || _workflowDetails$data === void 0 ? void 0 : _workflowDetails$data.timeline,
    businessService: businessService,
    workflowDetails: workflowDetails,
    moduleCode: moduleCode
  }) : null, isWarningPop ? /*#__PURE__*/React.createElement(ApplicationDetailsWarningPopup, {
    action: selectedAction,
    workflowDetails: workflowDetails,
    businessService: businessService,
    isWarningPop: isWarningPop,
    closeWarningPopup: closeWarningPopup
  }) : null, /*#__PURE__*/React.createElement(ApplicationDetailsToast, {
    t: t,
    showToast: showToast,
    closeToast: closeToast,
    businessService: businessService
  }), /*#__PURE__*/React.createElement(ApplicationDetailsActionBar, {
    workflowDetails: workflowDetails,
    displayMenu: displayMenu,
    onActionSelect: onActionSelect,
    setDisplayMenu: setDisplayMenu,
    businessService: businessService,
    forcedActionPrefix: forcedActionPrefix,
    ActionBarStyle: ActionBarStyle,
    MenuStyle: MenuStyle,
    applicationDetails: applicationDetails
  })) : /*#__PURE__*/React.createElement(Loader, null));
};

const ViewProperty = () => {
  var _applicationDetails$a;
  const {
    t
  } = useTranslation();
  const {
    propertyId,
    tenantId,
    redirectToUrl
  } = Digit.Hooks.useQueryParams();
  const {
    isLoading,
    data: applicationDetails
  } = Digit.Hooks.pt.useGenericViewProperty(t, tenantId, propertyId, {});
  const {
    state
  } = useLocation();
  const history = useHistory();
  let workflowDetails = {};
  const onSubmit = () => {
    setTimeout(() => window.scrollTo(0, 1600), 400);
    return history.push(`${redirectToUrl}?propertyId=${propertyId}&tenantId=${(applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.tenantId) || tenantId}`, {
      ...state
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, null, t("PT_PROPERTY_INFO_HEADER"))), /*#__PURE__*/React.createElement(ApplicationDetails, {
    applicationDetails: applicationDetails,
    isLoading: isLoading,
    isDataLoading: isLoading,
    workflowDetails: workflowDetails,
    applicationData: applicationDetails === null || applicationDetails === void 0 ? void 0 : applicationDetails.applicationData,
    moduleCode: "PT"
  }), window.location.href.includes("redirectToUrl") && (applicationDetails === null || applicationDetails === void 0 ? void 0 : (_applicationDetails$a = applicationDetails.applicationData) === null || _applicationDetails$a === void 0 ? void 0 : _applicationDetails$a.status) !== "INACTIVE" && /*#__PURE__*/React.createElement(ActionBar, {
    style: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "baseline"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubmitBar, {
    label: t("PT_ADD_PROPERTY_TO_APP"),
    onSubmit: () => onSubmit()
  }))));
};

const App = ({
  stateCode
}) => {
  const {
    path,
    url,
    ...match
  } = useRouteMatch();
  return /*#__PURE__*/React.createElement("span", {
    className: "pt-citizen"
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(AppContainer, null, /*#__PURE__*/React.createElement(BackButton, null, t("FASTPAS.GLOBAL.BACK.TEXT")), /*#__PURE__*/React.createElement(Route, {
    path: `${path}/property/citizen-search`,
    component: SearchProperty$1
  }), /*#__PURE__*/React.createElement(Route, {
    path: `${path}/property/search-results`
  }, " ", /*#__PURE__*/React.createElement(SearchResultsComponent, {
    stateCode: stateCode
  }), " "), /*#__PURE__*/React.createElement(Route, {
    path: `${path}/property/citizen-otp`
  }, " ", /*#__PURE__*/React.createElement(CitizenOtp, {
    stateCode: stateCode
  }), " "), /*#__PURE__*/React.createElement(PrivateRoute, {
    path: `${path}/property/link-success/:propertyIds`,
    component: PropertyLinkSuccess
  }), /*#__PURE__*/React.createElement(PrivateRoute, {
    path: `${path}/property/new-application`,
    component: CreateProperty
  }), /*#__PURE__*/React.createElement(PrivateRoute, {
    path: `${path}/view-property`,
    component: () => /*#__PURE__*/React.createElement(ViewProperty, null)
  }))));
};

const NewApplication = ({
  path
}) => {
  const {
    t
  } = useTranslation();
  const queryClient = useQueryClient();
  const match = useRouteMatch();
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("PT_CREATE_PROPERTY", {});
  let {
    data: commonFields,
    isLoading
  } = Digit.Hooks.pt.useMDMS(stateId, "PropertyTax", "CommonFieldsConfig");
  const search = useLocation().search;
  const redirectUrl = new URLSearchParams(search).get('redirectToUrl');
  const createProperty = async () => {
    history.push(`${match.path}/acknowledgement`);
  };
  const onSuccess = () => {
    clearParams();
    queryClient.invalidateQueries("PT_CREATE_PROPERTY");
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: `${match.path}`
  }, /*#__PURE__*/React.createElement(CreatePropertyForm, {
    onSubmit: createProperty,
    value: params,
    redirectUrl: redirectUrl,
    userType: "employee"
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: `${match.path}/save-property`
  }, /*#__PURE__*/React.createElement(PTAcknowledgement, {
    data: params,
    onSuccess: onSuccess,
    redirectUrl: redirectUrl,
    userType: "employee"
  })));
};

const PTSearchFields = {
  searchId: {
    propertyIds: {
      type: "text",
      label: "PT_PROPERTY_UNIQUE_ID",
      placeHolder: "PT_PROPERTY_UNIQUE_ID_PLACEHOLDER",
      validation: {
        pattern: {
          value: "[A-Za-z]{2}\-[A-Za-z]{2}\-[0-9]{4}\-[0-9]{2}\-[0-9]{2}\-[0-9]{6}",
          message: "ERR_INVALID_PROPERTY_ID"
        }
      }
    },
    oldPropertyId: {
      type: "text",
      label: "PT_EXISTING_PROPERTY_ID",
      placeholder: "PT_EXISTING_PROPERTY_ID_PLACEHOLDER",
      validation: {
        pattern: {
          value: "[A-Za-z]{2}\-[A-Za-z]{2}\-[0-9]{4}\-[0-9]{2}\-[0-9]{2}\-[0-9]{6}",
          message: "ERR_INVALID_PROPERTY_ID"
        }
      }
    },
    mobileNumber: {
      type: "number",
      label: "PT_HOME_SEARCH_RESULTS_OWN_MOB_LABEL",
      placeHolder: "PT_HOME_SEARCH_RESULTS_OWN_MOB_PLACEHOLDER",
      validation: {
        minLength: {
          value: 10,
          message: "CORE_COMMON_MOBILE_ERROR"
        },
        maxLength: {
          value: 10,
          message: "CORE_COMMON_MOBILE_ERROR"
        },
        pattern: {
          value: /[6789][0-9]{9}/,
          message: "CORE_COMMON_MOBILE_ERROR"
        }
      }
    }
  },
  searchDetail: {
    locality: {
      type: "custom",
      label: "PT_SEARCH_LOCALITY",
      placeHolder: "PT_SEARCH_LOCALITY_PLACEHOLDER",
      validation: {
        required: "PTLOCALITYMANDATORY"
      },
      customComponent: Localities,
      customCompProps: {
        boundaryType: "revenue",
        keepNull: false,
        optionCardStyles: {
          height: "600px",
          overflow: "auto",
          zIndex: "10"
        },
        disableLoader: true
      }
    },
    doorNo: {
      type: "text",
      label: "PT_SEARCHPROPERTY_TABEL_DOOR_NO",
      placeHolder: "PT_SEARCH_DOOR_NO_PLACEHOLDER",
      validation: {
        pattern: {
          value: "[A-Za-z0-9#,/ -()]{1,63}",
          message: "ERR_INVALID_DOOR_NO"
        }
      }
    },
    name: {
      type: "text",
      label: "PT_SEARCHPROPERTY_TABEL_OWNERNAME",
      placeHolder: "PT_SEARCH_OWNER_NAME_PLACEHOLDER",
      validation: {
        minLength: {
          value: 3,
          message: "PT_MIN_3CHAR"
        },
        pattern: {
          value: "[A-Za-z .`'-]{3,63}",
          message: "PAYMENT_INVALID_NAME"
        }
      }
    }
  }
};
const defaultValues = {
  propertyIds: "",
  mobileNumber: "",
  oldPropertyId: "",
  locality: "",
  name: "",
  doorNo: ""
};
const Search = ({
  path
}) => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [payload, setPayload] = useState({});
  const [formData, setFormData] = useState(defaultValues);
  const [searchBy, setSearchBy] = useState("searchId");
  const [showToast, setShowToast] = useState(null);
  const search = useLocation().search;
  const redirectToUrl = new URLSearchParams(search).get('redirectToUrl');
  const SearchComponent = memo(Digit.ComponentRegistryService.getComponent("CPTPropertySearchForm"));
  const SearchResultComponent = memo(Digit.ComponentRegistryService.getComponent("CPTPropertySearchResults"));
  const {
    data: ptSearchConfig,
    isLoading
  } = Digit.Hooks.pt.useMDMS(Digit.ULBService.getStateId(), "DIGIT-UI", "HelpText", {
    select: data => {
      var _data$DIGITUI, _data$DIGITUI$HelpTex, _data$DIGITUI$HelpTex2;
      return data === null || data === void 0 ? void 0 : (_data$DIGITUI = data["DIGIT-UI"]) === null || _data$DIGITUI === void 0 ? void 0 : (_data$DIGITUI$HelpTex = _data$DIGITUI["HelpText"]) === null || _data$DIGITUI$HelpTex === void 0 ? void 0 : (_data$DIGITUI$HelpTex2 = _data$DIGITUI$HelpTex[0]) === null || _data$DIGITUI$HelpTex2 === void 0 ? void 0 : _data$DIGITUI$HelpTex2.PT;
    }
  });
  useEffect(() => {
    if (sessionStorage.getItem("searchDetailValue") == 1 && searchBy === "searchId") {
      setSearchBy("searchDetail");
    }
  }, [searchBy]);
  const onReset = useCallback(() => {
    setFormData(defaultValues);
    setPayload({});
    setShowToast(null);
  });
  const onSubmit = useCallback(_data => {
    setFormData(_data);
    if (Object.keys(_data).filter(k => _data[k] && typeof _data[k] !== "object").length > 0) {
      setPayload(Object.keys(_data).filter(k => _data[k]).reduce((acc, key) => ({
        ...acc,
        [key]: typeof _data[key] === "object" ? _data[key].code : _data[key]
      }), {}));
      setShowToast(null);
    } else {
      setShowToast({
        warning: true,
        label: "ERR_PT_FILL_VALID_FIELDS"
      });
    }
  });
  if (isLoading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, null, t("SEARCH_PROPERTY")), /*#__PURE__*/React.createElement(SearchComponent, {
    t: t,
    payload: formData,
    searchBy: searchBy,
    setSearchBy: setSearchBy,
    PTSearchFields: PTSearchFields,
    tenantId: tenantId,
    onSubmit: onSubmit,
    onReset: onReset
  }), Object.keys(payload).length > 0 && /*#__PURE__*/React.createElement(SearchResultComponent, {
    t: t,
    showToast: showToast,
    setShowToast: setShowToast,
    tenantId: tenantId,
    payload: payload,
    ptSearchConfig: {
      ...ptSearchConfig
    },
    redirectToUrl: redirectToUrl
  }), showToast && /*#__PURE__*/React.createElement(Toast, {
    error: showToast.error,
    warning: showToast.warning,
    label: t(showToast.label),
    onClose: () => {
      setShowToast(null);
    }
  }));
};

const EmployeeApp = ({
  path,
  url,
  userType
}) => {
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const getBreadCrumb = () => {
    if (location.pathname.includes("/commonpt/search")) return t("SEARCH_PROPERTY");else if (location.pathname.includes("/view-property")) return t("PT_PROPERTY_INFORMATION");else return t("PT_NEW_PROPERTY");
  };
  const search = useLocation().search;
  const redirectUrl = new URLSearchParams(search).get("redirectToUrl");
  const fromScreen = new URLSearchParams(search).get("from") || "";
  const crumbs = [{
    path: "/digit-ui/employee",
    content: t("ES_COMMON_HOME"),
    show: true
  }, {
    path: {
      pathname: redirectUrl,
      state: {
        ...location.state
      }
    },
    content: redirectUrl ? redirectUrl !== null && redirectUrl !== void 0 && redirectUrl.includes("employee/tl/new-application") ? t("ES_TITLE_NEW_TRADE_LICESE_APPLICATION") : t("WF_EMPLOYEE_NEWTL_RENEWAL_SUBMIT_BUTTON") : fromScreen && t(fromScreen) || "NONE",
    show: (redirectUrl || fromScreen) && true,
    isBack: fromScreen && true
  }, {
    path: "/digit-ui/employee/dss/drilldown",
    content: getBreadCrumb(),
    show: true
  }];
  const locationCheck = window.location.href.includes("/employee/commonpt/new-application");
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "ground-container"
  }, /*#__PURE__*/React.createElement("div", {
    style: locationCheck ? {
      marginLeft: "12px"
    } : {}
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    crumbs: crumbs
  })), /*#__PURE__*/React.createElement(PrivateRoute, {
    exact: true,
    path: `${path}/`,
    component: () => /*#__PURE__*/React.createElement(CommonPTLinks, {
      matchPath: path,
      userType: userType
    })
  }), /*#__PURE__*/React.createElement(PrivateRoute, {
    path: `${path}/new-application`,
    component: () => /*#__PURE__*/React.createElement(NewApplication, {
      parentUrl: url
    })
  }), /*#__PURE__*/React.createElement(PrivateRoute, {
    path: `${path}/search`,
    component: () => /*#__PURE__*/React.createElement(Search, null)
  }), /*#__PURE__*/React.createElement(PrivateRoute, {
    path: `${path}/view-property`,
    component: () => /*#__PURE__*/React.createElement(ViewProperty, null)
  }))));
};

const PropertyAssemblyDetails = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  formState,
  ownerIndex,
  setError,
  clearErrors
}) => {
  var _formData$usageCatego, _formData$usageCatego2, _Menu$PropertyTax, _Menu1$PropertyTax, _errors$BuildingType, _errors$floorarea, _errors$constructionA, _errors$usageCategory;
  const [assemblyDetails, setAssemblyDetails] = React.useState({
    ...formData.assemblyDet,
    'BuildingType': formData === null || formData === void 0 ? void 0 : formData.PropertyType,
    'floorarea': formData === null || formData === void 0 ? void 0 : formData.landArea,
    'constructionArea': formData === null || formData === void 0 ? void 0 : formData.constructionArea,
    'usageCategoryMajor': formData !== null && formData !== void 0 && formData.usageCategoryMajor && (formData === null || formData === void 0 ? void 0 : (_formData$usageCatego = formData.usageCategoryMajor) === null || _formData$usageCatego === void 0 ? void 0 : _formData$usageCatego.code) === "NONRESIDENTIAL.OTHERS" ? {
      code: `${formData === null || formData === void 0 ? void 0 : (_formData$usageCatego2 = formData.usageCategoryMajor) === null || _formData$usageCatego2 === void 0 ? void 0 : _formData$usageCatego2.code}`,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_OTHERS`
    } : formData === null || formData === void 0 ? void 0 : formData.usageCategoryMajor
  });
  const [focusField, setFocusField] = React.useState("");
  const stateId = Digit.ULBService.getStateId();
  const [isErrors, setIsErrors] = useState(false);
  const isMobile = window.Digit.Utils.browser.isMobile();
  let proptype = [];
  const {
    data: Menu = {},
    isLoading
  } = Digit.Hooks.pt.usePropertyMDMS(stateId, "PropertyTax", "PTPropertyType") || {};
  proptype = Menu === null || Menu === void 0 ? void 0 : (_Menu$PropertyTax = Menu.PropertyTax) === null || _Menu$PropertyTax === void 0 ? void 0 : _Menu$PropertyTax.PropertyType;
  const {
    data: Menu1 = {},
    isLoading: menuLoading
  } = Digit.Hooks.pt.usePropertyMDMS(stateId, "PropertyTax", "UsageCategory") || {};
  let usagecat = [];
  usagecat = (Menu1 === null || Menu1 === void 0 ? void 0 : (_Menu1$PropertyTax = Menu1.PropertyTax) === null || _Menu1$PropertyTax === void 0 ? void 0 : _Menu1$PropertyTax.UsageCategory) || [];
  function getPropertyTypeMenu(proptype) {
    if (userType === "employee") {
      var _proptype$filter, _proptype$filter$map;
      return proptype === null || proptype === void 0 ? void 0 : (_proptype$filter = proptype.filter(e => e.code === "VACANT" || e.code.split(".").length > 1)) === null || _proptype$filter === void 0 ? void 0 : (_proptype$filter$map = _proptype$filter.map(item => ({
        i18nKey: "COMMON_PROPTYPE_" + stringReplaceAll(item === null || item === void 0 ? void 0 : item.code, ".", "_"),
        code: item === null || item === void 0 ? void 0 : item.code
      }))) === null || _proptype$filter$map === void 0 ? void 0 : _proptype$filter$map.sort((a, b) => a.i18nKey.split("_").pop().localeCompare(b.i18nKey.split("_").pop()));
    } else {
      if (Array.isArray(proptype) && proptype.length > 0) {
        for (i = 0; i < proptype.length; i++) {
          if (i != 1 && i != 4 && Array.isArray(proptype) && proptype.length > 0) menu.push({
            i18nKey: "COMMON_PROPTYPE_" + stringReplaceAll(proptype[i].code, ".", "_"),
            code: proptype[i].code
          });
        }
      }
      menu.sort((a, b) => a.i18nKey.split("_").pop().localeCompare(b.i18nKey.split("_").pop()));
      return menu;
    }
  }
  function usageCategoryMajorMenu(usagecat) {
    if (userType === "employee") {
      var _usagecat$filter;
      const catMenu = usagecat === null || usagecat === void 0 ? void 0 : (_usagecat$filter = usagecat.filter(e => (e === null || e === void 0 ? void 0 : e.code.split(".").length) <= 2 && e.code !== "NONRESIDENTIAL")) === null || _usagecat$filter === void 0 ? void 0 : _usagecat$filter.map(item => {
        const arr = item === null || item === void 0 ? void 0 : item.code.split(".");
        if (arr.length == 2) return {
          i18nKey: "PROPERTYTAX_BILLING_SLAB_" + arr[1],
          code: item === null || item === void 0 ? void 0 : item.code
        };else return {
          i18nKey: "PROPERTYTAX_BILLING_SLAB_" + (item === null || item === void 0 ? void 0 : item.code),
          code: item === null || item === void 0 ? void 0 : item.code
        };
      });
      return catMenu;
    } else {
      for (i = 0; i < 10; i++) {
        if (Array.isArray(usagecat) && usagecat.length > 0 && usagecat[i].code.split(".")[0] == "NONRESIDENTIAL" && usagecat[i].code.split(".").length == 2) {
          menu.push({
            i18nKey: "PROPERTYTAX_BILLING_SLAB_" + usagecat[i].code.split(".")[1],
            code: usagecat[i].code
          });
        }
      }
      return menu;
    }
  }
  const {
    control,
    formState: {
      errors,
      touched
    },
    trigger,
    watch,
    setError: setLocalError,
    clearErrors: clearLocalErrors,
    setValue,
    getValues
  } = useForm();
  const formValue = watch();
  const errorStyle = {
    width: "70%",
    marginLeft: "30%",
    fontSize: "12px",
    marginTop: "-21px"
  };
  React.useEffect(() => {
    let hasErrors = false;
    const part = {};
    Object.keys(assemblyDetails).forEach(key => {
      part[key] = formValue === null || formValue === void 0 ? void 0 : formValue[key];
    });
    if (!lodash.isEqual(part, assemblyDetails)) {
      Object.keys(assemblyDetails).forEach(key => {
        if (assemblyDetails[key]) {
          hasErrors = false;
          clearLocalErrors(key);
        } else {
          hasErrors = true;
        }
      });
    }
    if (hasErrors) {
      setError(config === null || config === void 0 ? void 0 : config.key, {
        type: errors
      });
    } else {
      clearErrors(config === null || config === void 0 ? void 0 : config.key);
    }
    trigger();
    setIsErrors(hasErrors);
    onSelect(config === null || config === void 0 ? void 0 : config.key, assemblyDetails);
  }, [assemblyDetails]);
  React.useEffect(() => {
    var _formState$errors$con;
    if (Object.keys(errors).length && !lodash.isEqual(((_formState$errors$con = formState.errors[config.key]) === null || _formState$errors$con === void 0 ? void 0 : _formState$errors$con.type) || {}, errors)) {
      setError(config.key, {
        type: errors
      });
    } else if (!Object.keys(errors).length && formState.errors[config.key] && isErrors) {
      clearErrors(config.key);
    }
  }, [errors]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t('PT_PROP_TYPE')}*`), /*#__PURE__*/React.createElement("div", {
    class: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "BuildingType",
    control: control,
    defaultValue: assemblyDetails === null || assemblyDetails === void 0 ? void 0 : assemblyDetails.BuildingType,
    rules: {
      required: t("REQUIRED_FIELD")
    },
    key: config === null || config === void 0 ? void 0 : config.key,
    render: props => {
      var _getPropertyTypeMenu, _getPropertyTypeMenu2;
      return /*#__PURE__*/React.createElement(Dropdown, {
        selected: ((_getPropertyTypeMenu = getPropertyTypeMenu(proptype)) === null || _getPropertyTypeMenu === void 0 ? void 0 : _getPropertyTypeMenu.length) === 1 ? getPropertyTypeMenu(proptype)[0] : assemblyDetails === null || assemblyDetails === void 0 ? void 0 : assemblyDetails.BuildingType,
        disable: ((_getPropertyTypeMenu2 = getPropertyTypeMenu(proptype)) === null || _getPropertyTypeMenu2 === void 0 ? void 0 : _getPropertyTypeMenu2.length) === 1,
        option: getPropertyTypeMenu(proptype),
        autoFocus: focusField === "BuildingType",
        select: value => {
          props.onChange(value);
          setAssemblyDetails({
            ...assemblyDetails,
            ['BuildingType']: value
          });
          setFocusField("BuildingType");
        },
        optionKey: "i18nKey",
        onBlur: props === null || props === void 0 ? void 0 : props.onBlur,
        t: t
      });
    }
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.BuildingType ? errors === null || errors === void 0 ? void 0 : (_errors$BuildingType = errors.BuildingType) === null || _errors$BuildingType === void 0 ? void 0 : _errors$BuildingType.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_TOT_LAND_AREA")}*`), /*#__PURE__*/React.createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "floorarea",
    control: control,
    defaultValue: assemblyDetails === null || assemblyDetails === void 0 ? void 0 : assemblyDetails.floorarea,
    rules: {
      required: t("REQUIRED_FIELD"),
      validate: val => /^([0-9]){0,8}$/i.test(val) ? true : t("PT_TOT_LAND_AREA_ERROR_MESSAGE")
    },
    key: config === null || config === void 0 ? void 0 : config.key,
    render: props => /*#__PURE__*/React.createElement(TextInput, {
      t: t,
      type: "number",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "totLandArea",
      value: props === null || props === void 0 ? void 0 : props.value,
      autoFocus: focusField === "floorarea",
      onChange: ev => {
        props === null || props === void 0 ? void 0 : props.onChange(ev.target.value);
        setAssemblyDetails({
          ...assemblyDetails,
          ['floorarea']: ev.target.value
        });
        setFocusField("floorarea");
      },
      onBlur: props === null || props === void 0 ? void 0 : props.onBlur
    })
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.floorarea ? errors === null || errors === void 0 ? void 0 : (_errors$floorarea = errors.floorarea) === null || _errors$floorarea === void 0 ? void 0 : _errors$floorarea.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_TOT_CONSTRUCTION_AREA")}*`), /*#__PURE__*/React.createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "constructionArea",
    control: control,
    defaultValue: assemblyDetails === null || assemblyDetails === void 0 ? void 0 : assemblyDetails.constructionArea,
    key: config === null || config === void 0 ? void 0 : config.key,
    rules: {
      required: t("REQUIRED_FIELD"),
      validate: val => /^([0-9]){0,8}$/i.test(val) && assemblyDetails !== null && assemblyDetails !== void 0 && assemblyDetails.floorarea && parseInt(val) < parseInt(assemblyDetails === null || assemblyDetails === void 0 ? void 0 : assemblyDetails.floorarea) ? true : t("PT_TOT_CONSTRUCTION_AREA_ERROR_MESSAGE")
    },
    render: props => /*#__PURE__*/React.createElement(TextInput, {
      t: t,
      type: "number",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "totConstructionArea",
      value: props === null || props === void 0 ? void 0 : props.value,
      autoFocus: focusField === "constructionArea",
      onChange: ev => {
        props === null || props === void 0 ? void 0 : props.onChange(ev.target.value);
        setFocusField("constructionArea");
        setAssemblyDetails({
          ...assemblyDetails,
          ['constructionArea']: ev.target.value
        });
      },
      onBlur: props === null || props === void 0 ? void 0 : props.onBlur
    })
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: isMobile ? {
      ...errorStyle,
      marginLeft: "0px"
    } : {
      ...errorStyle
    }
  }, touched !== null && touched !== void 0 && touched.constructionArea ? errors === null || errors === void 0 ? void 0 : (_errors$constructionA = errors.constructionArea) === null || _errors$constructionA === void 0 ? void 0 : _errors$constructionA.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_ASSESMENT_INFO_USAGE_TYPE")}*`), /*#__PURE__*/React.createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "usageCategoryMajor",
    defaultValue: assemblyDetails === null || assemblyDetails === void 0 ? void 0 : assemblyDetails.usageCategoryMajor,
    rules: {
      required: t("REQUIRED_FIELD")
    },
    control: control,
    key: config === null || config === void 0 ? void 0 : config.key,
    render: props => {
      var _usageCategoryMajorMe;
      return /*#__PURE__*/React.createElement(Dropdown, {
        selected: props === null || props === void 0 ? void 0 : props.value,
        disable: ((_usageCategoryMajorMe = usageCategoryMajorMenu(usagecat)) === null || _usageCategoryMajorMe === void 0 ? void 0 : _usageCategoryMajorMe.length) === 1,
        option: usageCategoryMajorMenu(usagecat),
        autoFocus: focusField === "usageCategoryMajor",
        select: value => {
          props === null || props === void 0 ? void 0 : props.onChange(value);
          setFocusField("usageCategoryMajor");
          setAssemblyDetails({
            ...assemblyDetails,
            ['usageCategoryMajor']: value
          });
        },
        optionKey: "i18nKey",
        onBlur: props === null || props === void 0 ? void 0 : props.onBlur,
        t: t
      });
    }
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.usageCategoryMajor ? errors === null || errors === void 0 ? void 0 : (_errors$usageCategory = errors.usageCategoryMajor) === null || _errors$usageCategory === void 0 ? void 0 : _errors$usageCategory.message : ""));
};

const PropertyLocationDetails = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  formState,
  ownerIndex,
  setError,
  clearErrors
}) => {
  var _Digit$UserService$ge, _errors$cityCode, _errors$locality, _errors$houseDoorNo, _errors$buildingColon, _errors$landmarkName;
  let validation = {};
  let allCities = Digit.Hooks.pt.useTenants() ? Digit.Hooks.pt.useTenants() : Digit.Hooks.tl.useTenants();
  const userInfo = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info;
  userType = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) == "EMPLOYEE" ? "employee" : "citizen";
  const cityId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.tenantId;
  const cityName = 'TENANT_TENANTS_' + (userInfo === null || userInfo === void 0 ? void 0 : userInfo.tenantId.replace('.', '_').toUpperCase());
  const cityObj = userType === 'employee' ? {
    code: cityId,
    name: t(cityName),
    i18nKey: cityName
  } : null;
  const [locationDetails, setLocationDetails] = React.useState({
    ...(formData === null || formData === void 0 ? void 0 : formData.locationDet),
    cityCode: cityObj,
    locality: formData === null || formData === void 0 ? void 0 : formData.locality,
    houseDoorNo: formData === null || formData === void 0 ? void 0 : formData.houseDoorNo,
    buildingColonyName: formData === null || formData === void 0 ? void 0 : formData.buildingColonyName,
    landmarkName: formData === null || formData === void 0 ? void 0 : formData.landmarkName
  });
  const [isErrors, setIsErrors] = React.useState(false);
  const {
    control,
    formState: {
      errors,
      touched
    },
    trigger,
    watch,
    setError: setLocalError,
    clearErrors: clearLocalErrors,
    setValue,
    getValues
  } = useForm();
  const formValue = watch();
  React.useEffect(() => {
    let hasErrors = false;
    const part = {};
    Object.keys(locationDetails).forEach(key => {
      part[key] = formValue === null || formValue === void 0 ? void 0 : formValue[key];
    });
    if (!lodash.isEqual(part, locationDetails)) {
      Object.keys(locationDetails).forEach(key => {
        if (locationDetails[key]) {
          hasErrors = false;
          clearLocalErrors(key);
        } else {
          hasErrors = true;
        }
      });
    }
    if (hasErrors) {
      setError(config === null || config === void 0 ? void 0 : config.key, {
        type: errors
      });
    } else {
      clearErrors(config === null || config === void 0 ? void 0 : config.key);
    }
    trigger();
    setIsErrors(hasErrors);
    onSelect(config === null || config === void 0 ? void 0 : config.key, locationDetails);
  }, [locationDetails]);
  React.useEffect(() => {
    var _formState$errors$con;
    if (Object.keys(errors).length && !lodash.isEqual(((_formState$errors$con = formState.errors[config.key]) === null || _formState$errors$con === void 0 ? void 0 : _formState$errors$con.type) || {}, errors)) {
      setError(config.key, {
        type: errors
      });
    } else if (!Object.keys(errors).length && formState.errors[config.key] && isErrors) {
      clearErrors(config.key);
    }
  }, [errors]);
  const errorStyle = {
    width: "70%",
    marginLeft: "30%",
    fontSize: "12px",
    marginTop: "-21px"
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t('PT_PROP_CITY')}*`), /*#__PURE__*/React.createElement(Controller, {
    name: "",
    defaultValue: locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.cityCode,
    control: control,
    rules: {
      required: t("REQUIRED_FIELD")
    },
    render: ({
      value,
      onBlur,
      onChange
    }) => /*#__PURE__*/React.createElement(Dropdown, {
      className: "form-field",
      selected: value,
      disable: userType === "employee",
      option: allCities,
      select: value => {
        onChange(value);
        setLocationDetails({
          ...locationDetails,
          cityCode: value
        });
      },
      optionKey: "code",
      onBlur: onBlur,
      t: t
    })
  })), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.cityCode ? errors === null || errors === void 0 ? void 0 : (_errors$cityCode = errors.cityCode) === null || _errors$cityCode === void 0 ? void 0 : _errors$cityCode.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_PROP_LOCALITY")}*`), /*#__PURE__*/React.createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "locality",
    defaultValue: locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.locality,
    control: control,
    rules: {
      required: t("REQUIRED_FIELD")
    },
    render: ({
      value,
      onBlur,
      onChange
    }) => {
      var _locationDetails$city, _locationDetails$city2;
      return /*#__PURE__*/React.createElement(Localities, {
        selectLocality: value => {
          onChange(value);
          setLocationDetails({
            ...locationDetails,
            locality: value
          });
        },
        tenantId: locationDetails === null || locationDetails === void 0 ? void 0 : (_locationDetails$city = locationDetails.cityCode) === null || _locationDetails$city === void 0 ? void 0 : _locationDetails$city.code,
        boundaryType: "revenue",
        keepNull: false,
        optionCardStyles: {
          height: "600px",
          overflow: "auto",
          zIndex: "10"
        },
        selected: value,
        disable: !(locationDetails !== null && locationDetails !== void 0 && (_locationDetails$city2 = locationDetails.cityCode) !== null && _locationDetails$city2 !== void 0 && _locationDetails$city2.code),
        disableLoader: true,
        onBlur: onBlur
      });
    }
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.locality ? errors === null || errors === void 0 ? void 0 : (_errors$locality = errors.locality) === null || _errors$locality === void 0 ? void 0 : _errors$locality.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_HOUSE_DOOR_NO")}*`), /*#__PURE__*/React.createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "houseDoorNo",
    defaultValue: locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.houseDoorNo,
    control: control,
    rules: {
      required: t("REQUIRED_FIELD"),
      validate: value => /^([a-zA-Z0-9 !@#$%^&*()_+\-={};':\\\\|,.<>/?]){1,64}$/i.test(value) ? true : t("PT_HOUSE_DOOR_NO_ERROR_MESSAGE")
    },
    render: ({
      value,
      onBlur,
      onChange
    }) => /*#__PURE__*/React.createElement(TextInput, Object.assign({
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "houseDoorNo",
      value: value,
      onChange: ev => {
        onChange(ev.target.value);
        setLocationDetails({
          ...locationDetails,
          houseDoorNo: ev.target.value
        });
      },
      onBlur: onBlur
    }, validation = {
      pattern: "^([a-zA-Z0-9 !@#$%^&*()_+\-={};':\\\\|,.<>/?]){1,64}$",
      title: t("PT_HOUSE_DOOR_NO_ERROR_MESSAGE")
    }))
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.houseDoorNo ? errors === null || errors === void 0 ? void 0 : (_errors$houseDoorNo = errors.houseDoorNo) === null || _errors$houseDoorNo === void 0 ? void 0 : _errors$houseDoorNo.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_BUILDING_COLONY_NAME")}*`), /*#__PURE__*/React.createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "buildingColonyName",
    defaultValue: locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.buildingColonyName,
    control: control,
    rules: {
      required: t("REQUIRED_FIELD")
    },
    render: ({
      value,
      onChange,
      onBlur
    }) => /*#__PURE__*/React.createElement(TextInput, {
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "buildingColonyName",
      value: value,
      onChange: ev => {
        onChange(ev.target.value);
        setLocationDetails({
          ...locationDetails,
          buildingColonyName: ev.target.value
        });
      },
      onBlur: onBlur
    })
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.buildingColonyName ? errors === null || errors === void 0 ? void 0 : (_errors$buildingColon = errors.buildingColonyName) === null || _errors$buildingColon === void 0 ? void 0 : _errors$buildingColon.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_LANDMARK_NAME")}`), /*#__PURE__*/React.createElement("div", {
    className: "form-field"
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "landmarkName",
    defaultValue: locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.landmarkName,
    control: control,
    rules: {},
    render: ({
      value,
      onChange,
      onBlur
    }) => /*#__PURE__*/React.createElement(TextInput, {
      t: t,
      type: "text",
      isMandatory: false,
      optionKey: "i18nKey",
      name: "landmarkName",
      value: value,
      onChange: ev => {
        onChange(ev.target.value);
        setLocationDetails({
          ...locationDetails,
          landmarkName: ev.target.value
        });
      },
      onBlur: onBlur
    })
  }))), /*#__PURE__*/React.createElement(CardLabelError, {
    style: errorStyle
  }, touched !== null && touched !== void 0 && touched.landmarkName ? errors === null || errors === void 0 ? void 0 : (_errors$landmarkName = errors.landmarkName) === null || _errors$landmarkName === void 0 ? void 0 : _errors$landmarkName.message : ""));
};

const getAddress = (address, t) => {
  return `${address !== null && address !== void 0 && address.houseDoorNo ? `${address === null || address === void 0 ? void 0 : address.houseDoorNo}, ` : ""} ${address !== null && address !== void 0 && address.buildingColonyName ? `${address === null || address === void 0 ? void 0 : address.buildingColonyName}, ` : ""}${address !== null && address !== void 0 && address.landmarkName ? `${address === null || address === void 0 ? void 0 : address.landmarkName}, ` : ""}${t(address === null || address === void 0 ? void 0 : address.locality.i18nkey)}, ${t(address === null || address === void 0 ? void 0 : address.cityCode.i18nKey)},${t(address === null || address === void 0 ? void 0 : address.pincode) ? `${address.pincode}` : " "}`;
};
const PropertyOwnerDetails = ({
  t,
  config,
  onSelect,
  userType,
  formData,
  formState,
  ownerIndex,
  setError,
  clearErrors
}) => {
  var _formData$owners, _formData$owners2, _formData$owners3, _formData$owners4, _formData$owners5, _formData$owners$inde, _formData$owners6, _formData$owners7, _formData$owners8, _formData$owners9, _ownershipCategory$co;
  const {
    pathname: url
  } = useLocation();
  const editScreen = url.includes("/modify-application/");
  const mutationScreen = url.includes("/property-mutation/");
  const isMobile = window.Digit.Utils.browser.isMobile();
  let index = 0;
  const [ownershipCategory, setOwnerCategory] = React.useState("");
  const [ownerDetails, setOwnerDetails] = React.useState([{
    ...(formData.owners && formData.owners[index]),
    name: formData.owners && formData.owners[index] && formData.owners[index].name || (formData === null || formData === void 0 ? void 0 : (_formData$owners = formData.owners) === null || _formData$owners === void 0 ? void 0 : _formData$owners.name) || "",
    gender: formData.owners && formData.owners[index] && formData.owners[index].gender || (formData === null || formData === void 0 ? void 0 : (_formData$owners2 = formData.owners) === null || _formData$owners2 === void 0 ? void 0 : _formData$owners2.gender),
    mobileNumber: formData.owners && formData.owners[index] && formData.owners[index].mobileNumber || (formData === null || formData === void 0 ? void 0 : (_formData$owners3 = formData.owners) === null || _formData$owners3 === void 0 ? void 0 : _formData$owners3.mobileNumber) || "",
    fatherOrHusbandName: formData.owners && formData.owners[index] && formData.owners[index].fatherOrHusbandName || (formData === null || formData === void 0 ? void 0 : (_formData$owners4 = formData.owners) === null || _formData$owners4 === void 0 ? void 0 : _formData$owners4.fatherOrHusbandName) || "",
    relationship: formData.owners && formData.owners[index] && formData.owners[index].relationship || (formData === null || formData === void 0 ? void 0 : (_formData$owners5 = formData.owners) === null || _formData$owners5 === void 0 ? void 0 : _formData$owners5.relationship),
    ownershipCategory: ownershipCategory,
    ownerType: formData.owners && formData.owners[index] && ((_formData$owners$inde = formData.owners[index]) === null || _formData$owners$inde === void 0 ? void 0 : _formData$owners$inde.ownerType) || ((_formData$owners6 = formData.owners) === null || _formData$owners6 === void 0 ? void 0 : _formData$owners6.ownerType),
    permanentAddress: formData.owners && formData.owners[index] && formData.owners[index].permanentAddress || (formData === null || formData === void 0 ? void 0 : (_formData$owners7 = formData.owners) === null || _formData$owners7 === void 0 ? void 0 : _formData$owners7.permanentAddress) || "",
    email: formData.owners && formData.owners[index] && formData.owners[index].email || (formData === null || formData === void 0 ? void 0 : (_formData$owners8 = formData.owners) === null || _formData$owners8 === void 0 ? void 0 : _formData$owners8.emailId) || "",
    isCoresAddr: false
  }]);
  const [isErrors, setIsErrors] = useState(false);
  const isUpdateProperty = (formData === null || formData === void 0 ? void 0 : formData.isUpdateProperty) || false;
  let isEditProperty = (formData === null || formData === void 0 ? void 0 : formData.isEditProperty) || false;
  const stateId = Digit.ULBService.getStateId();
  const {
    data: Menu
  } = Digit.Hooks.pt.useGenderMDMS(stateId, "common-masters", "GenderType");
  let menu = [];
  Menu && Menu.map(genderDetails => {
    menu.push({
      i18nKey: `PT_COMMON_GENDER_${genderDetails.code}`,
      code: `${genderDetails.code}`,
      value: `${genderDetails.code}`
    });
  });
  const {
    data: dropdownData
  } = Digit.Hooks.tl.useTradeLicenseMDMS(stateId, "common-masters", "TLOwnerTypeWithSubtypes", {
    userType
  });
  const {
    data: Menu1,
    isLoading
  } = Digit.Hooks.pt.usePropertyMDMS(stateId, "PropertyTax", "OwnerType");
  const [isCorrespondenceAddress, setIsCorrespondenceAddress] = useState(formData === null || formData === void 0 ? void 0 : (_formData$owners9 = formData.owners) === null || _formData$owners9 === void 0 ? void 0 : _formData$owners9.isCorrespondenceAddress);
  function setCorrespondenceAddress(e, ind) {
    let address = "";
    if (e.target.checked === true) {
      var _formData$searchResul, _formData$searchResul2;
      const locationDet = mutationScreen ? formData === null || formData === void 0 ? void 0 : (_formData$searchResul = formData.searchResult) === null || _formData$searchResul === void 0 ? void 0 : (_formData$searchResul2 = _formData$searchResul.property) === null || _formData$searchResul2 === void 0 ? void 0 : _formData$searchResul2.locationDet : formData === null || formData === void 0 ? void 0 : formData.locationDet;
      address = getAddress(locationDet, t);
    }
    updateState("permanentAddress", ind, address);
    updateState("isCoresAddr", ind, e.target.checked);
  }
  const GuardianOptions = [{
    name: "HUSBAND",
    code: "HUSBAND",
    i18nKey: "PT_RELATION_HUSBAND"
  }, {
    name: "Father",
    code: "FATHER",
    i18nKey: "PT_RELATION_FATHER"
  }];
  const {
    control,
    formState: {
      errors,
      touched
    },
    trigger,
    watch,
    setError: setLocalError,
    clearErrors: clearLocalErrors,
    setValue,
    getValues
  } = useForm();
  const formValue = watch();
  React.useEffect(() => {
    let hasErrors = false;
    const part = {};
    ownerDetails.map(own => {
      Object.keys(own).forEach(key => {
        part[key] = formValue === null || formValue === void 0 ? void 0 : formValue[key];
      });
      if (!lodash.isEqual(part, own)) {
        Object.keys(own).forEach(key => {
          if (own[key]) {
            hasErrors = false;
            clearLocalErrors(key);
          } else {
            hasErrors = true;
          }
        });
      }
    });
    if (hasErrors) {
      setError(config === null || config === void 0 ? void 0 : config.key, {
        type: errors
      });
    } else {
      clearErrors(config === null || config === void 0 ? void 0 : config.key);
    }
    trigger();
    setIsErrors(hasErrors);
    onSelect(config === null || config === void 0 ? void 0 : config.key, ownerDetails.map(own => ({
      ...own,
      ownershipCategory: ownershipCategory === null || ownershipCategory === void 0 ? void 0 : ownershipCategory.value
    })));
  }, [ownerDetails]);
  React.useEffect(() => {
    var _formState$errors$con;
    if (Object.keys(errors).length && !lodash.isEqual(((_formState$errors$con = formState.errors[config.key]) === null || _formState$errors$con === void 0 ? void 0 : _formState$errors$con.type) || {}, errors)) {
      setError(config.key, {
        type: errors
      });
    } else if (!Object.keys(errors).length && formState.errors[config.key] && isErrors) {
      clearErrors(config.key);
    }
  }, [errors]);
  const updateState = (filedName = "name", ind = 0, value = "") => {
    setOwnerDetails(ownerDetails.map((owner, i) => {
      if (i === ind) {
        owner[filedName] = value;
      }
      return {
        ...owner
      };
    }));
  };
  const errorStyle = {
    width: "70%",
    marginLeft: "30%",
    fontSize: "12px",
    marginTop: "-21px"
  };
  const ismultiple = ownershipCategory !== null && ownershipCategory !== void 0 && (_ownershipCategory$co = ownershipCategory.code) !== null && _ownershipCategory$co !== void 0 && _ownershipCategory$co.includes("MULTIPLEOWNERS") ? true : false;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, {
    className: ""
  }, `${t("TL_NEW_OWNER_DETAILS_OWNERSHIP_TYPE_LABEL")}*`), /*#__PURE__*/React.createElement(Controller, {
    name: "ownershipCategory",
    defaultValue: ownershipCategory,
    control: control,
    rules: {
      required: t("REQUIRED_FIELD")
    },
    render: ({
      value,
      onChange,
      onBlur
    }) => /*#__PURE__*/React.createElement(Dropdown, {
      className: "form-field",
      selected: value,
      option: dropdownData === null || dropdownData === void 0 ? void 0 : dropdownData.filter(dd => {
        var _dd$code;
        return (_dd$code = dd.code) === null || _dd$code === void 0 ? void 0 : _dd$code.includes("INDIVIDUAL");
      }),
      select: value => {
        onChange(value);
        setOwnerCategory(value);
      },
      optionKey: "i18nKey",
      onBlur: onBlur,
      t: t
    })
  })), ownerDetails === null || ownerDetails === void 0 ? void 0 : ownerDetails.map((owner, index) => {
    var _errors, _errors2, _errors3, _errors4, _errors5, _errors6, _ownerDetails$index, _ownerDetails$index3, _ownerDetails$index4, _ownerDetails$index5;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        border: "1px solid #D6D5D4",
        background: "#FAFAFA",
        borderRadius: "4px",
        boxSizing: "border-box",
        margin: "16px 0px",
        padding: "16px 8px"
      }
    }, isMobile && ismultiple && ownerDetails.length > 1 && /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end"
      }
    }, /*#__PURE__*/React.createElement(LinkButton, {
      label: /*#__PURE__*/React.createElement(DeleteIcon, {
        style: {
          bottom: "5px"
        },
        fill: !(ownerDetails.length == 1) ? "#494848" : "#FAFAFA"
      }),
      style: {
        margin: "0px"
      },
      onClick: e => {
        setOwnerDetails([...ownerDetails.filter((own, ind) => ind != index)]);
      }
    })), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_FORM3_MOBILE_NUMBER")}*`), /*#__PURE__*/React.createElement("div", {
      className: "form-field"
    }, /*#__PURE__*/React.createElement(Controller, {
      key: "mobileNumber" + index,
      name: "mobileNumber" + index,
      defaultValue: owner.mobileNumber,
      control: control,
      rules: {
        required: t("REQUIRED_FIELD"),
        validate: value => /[6-9]{1}[0-9]{9}/i.test(value) ? true : t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID")
      },
      render: ({
        value,
        onChange,
        onBlur
      }) => /*#__PURE__*/React.createElement(MobileNumber, {
        value: value,
        name: "mobileNumber" + index,
        onChange: value => {
          onChange(value);
          updateState("mobileNumber", index, value);
        },
        disable: isUpdateProperty || isEditProperty,
        labelStyle: {
          border: "1px solid #000",
          borderRight: "none"
        },
        onBlur: onBlur
      })
    })), !isMobile && /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        width: "20%",
        alignSelf: "flex-start"
      }
    }, ismultiple && /*#__PURE__*/React.createElement(LinkButton, {
      label: /*#__PURE__*/React.createElement(DeleteIcon, {
        style: {
          bottom: "0px"
        },
        fill: !(ownerDetails.length == 1) ? "#494848" : "#FAFAFA"
      }),
      style: {
        margin: "0px"
      },
      onClick: e => {
        setOwnerDetails([...ownerDetails.filter((own, ind) => ind != index)]);
      }
    }))), /*#__PURE__*/React.createElement(CardLabelError, {
      style: errorStyle
    }, touched !== null && touched !== void 0 && touched["mobileNumber" + index] ? errors === null || errors === void 0 ? void 0 : (_errors = errors["mobileNumber" + index]) === null || _errors === void 0 ? void 0 : _errors.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_OWNER_NAME")}*`), /*#__PURE__*/React.createElement("div", {
      className: "form-field"
    }, /*#__PURE__*/React.createElement(Controller, {
      key: "name" + index,
      name: "name" + index,
      defaultValue: owner === null || owner === void 0 ? void 0 : owner.name,
      control: control,
      rules: {
        required: t("REQUIRED_FIELD"),
        validate: value => {
          return /^[a-zA-Z-.`' ]*$/i.test(value) ? true : t("PT_NAME_ERROR_MESSAGE");
        }
      },
      render: ({
        value,
        onChange,
        onBlur
      }) => /*#__PURE__*/React.createElement(TextInput, {
        t: t,
        type: "text",
        isMandatory: false,
        optionKey: "i18nKey",
        name: "name" + index,
        value: value,
        onChange: ev => {
          onChange(ev.target.value);
          updateState("name", index, ev.target.value);
        },
        disable: isUpdateProperty || isEditProperty,
        onBlur: onBlur
      })
    }))), /*#__PURE__*/React.createElement(CardLabelError, {
      style: errorStyle
    }, touched !== null && touched !== void 0 && touched["name" + index] ? errors === null || errors === void 0 ? void 0 : (_errors2 = errors["name" + index]) === null || _errors2 === void 0 ? void 0 : _errors2.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_FORM3_GENDER")}*`), /*#__PURE__*/React.createElement("div", {
      className: "form-field"
    }, /*#__PURE__*/React.createElement(Controller, {
      key: "gender" + index,
      name: "gender" + index,
      defaultValue: owner === null || owner === void 0 ? void 0 : owner.gender,
      control: control,
      rules: {
        required: t("REQUIRED_FIELD")
      },
      render: ({
        value,
        onChange,
        onBlur
      }) => /*#__PURE__*/React.createElement(RadioOrSelect, {
        name: "gender" + index,
        options: menu,
        selectedOption: value,
        optionKey: "code",
        onSelect: value => {
          onChange(value);
          updateState("gender", index, value);
        },
        t: t,
        disabled: isUpdateProperty || isEditProperty,
        isDropDown: window.location.href.includes("/employee") ? true : false,
        onBlur: onBlur
      })
    }))), /*#__PURE__*/React.createElement(CardLabelError, {
      style: errorStyle
    }, touched !== null && touched !== void 0 && touched["gender" + index] ? errors === null || errors === void 0 ? void 0 : (_errors3 = errors["gender" + index]) === null || _errors3 === void 0 ? void 0 : _errors3.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_FORM3_GUARDIAN_NAME")}*`), /*#__PURE__*/React.createElement("div", {
      className: "form-field"
    }, /*#__PURE__*/React.createElement(Controller, {
      key: "fatherOrHusbandName" + index,
      name: "fatherOrHusbandName" + index,
      defaultValue: owner === null || owner === void 0 ? void 0 : owner.fatherOrHusbandName,
      control: control,
      rules: {
        required: t("REQUIRED_FIELD"),
        validate: value => /^[a-zA-Z-.`' ]*$/i.test(value) ? true : t("PT_NAME_ERROR_MESSAGE")
      },
      render: ({
        value,
        onChange,
        onBlur
      }) => /*#__PURE__*/React.createElement(TextInput, {
        t: t,
        type: "text",
        isMandatory: false,
        optionKey: "i18nKey",
        name: "fatherOrHusbandName" + index,
        value: value,
        onChange: ev => {
          onChange(ev.target.value);
          updateState("fatherOrHusbandName", index, ev.target.value);
        },
        disable: isUpdateProperty || isEditProperty,
        onBlur: onBlur
      })
    }))), /*#__PURE__*/React.createElement(CardLabelError, {
      style: errorStyle
    }, touched !== null && touched !== void 0 && touched["fatherOrHusbandName" + index] ? errors === null || errors === void 0 ? void 0 : (_errors4 = errors["fatherOrHusbandName" + index]) === null || _errors4 === void 0 ? void 0 : _errors4.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, `${t("PT_FORM3_RELATIONSHIP")}*`), /*#__PURE__*/React.createElement("div", {
      className: "form-field"
    }, /*#__PURE__*/React.createElement(Controller, {
      key: "relationship" + index,
      name: "relationship" + index,
      defaultValue: owner === null || owner === void 0 ? void 0 : owner.relationship,
      control: control,
      rules: {
        required: t("REQUIRED_FIELD")
      },
      render: ({
        value,
        onChange,
        onBlur
      }) => /*#__PURE__*/React.createElement(RadioOrSelect, {
        name: "relationship" + index,
        options: GuardianOptions,
        selectedOption: value,
        optionKey: "i18nKey",
        onSelect: value => {
          onChange(value);
          updateState("relationship", index, value);
        },
        t: t,
        disabled: isUpdateProperty || isEditProperty,
        isDropDown: window.location.href.includes("/employee") ? true : false,
        onBlur: onBlur
      })
    }))), /*#__PURE__*/React.createElement(CardLabelError, {
      style: errorStyle
    }, touched !== null && touched !== void 0 && touched["relationship" + index] ? errors === null || errors === void 0 ? void 0 : (_errors5 = errors["relationship" + index]) === null || _errors5 === void 0 ? void 0 : _errors5.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, {
      className: ""
    }, `${t("PT_SPECIAL_APPLICANT_CATEGORY")}*`), /*#__PURE__*/React.createElement("div", {
      className: "form-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-pt-dropdown-only"
    }, /*#__PURE__*/React.createElement(Controller, {
      key: "ownerType" + index,
      name: "ownerType" + index,
      defaultValue: owner === null || owner === void 0 ? void 0 : owner.ownerType,
      control: control,
      rules: {
        required: t("REQUIRED_FIELD")
      },
      render: ({
        value,
        onChange,
        onBlur
      }) => /*#__PURE__*/React.createElement(Dropdown, {
        selected: (Menu1 === null || Menu1 === void 0 ? void 0 : Menu1.length) === 1 ? Menu1[0] : value,
        disable: (Menu1 === null || Menu1 === void 0 ? void 0 : Menu1.length) === 1 || editScreen,
        option: Menu1 ? Menu1.sort((a, b) => a.name.localeCompare(b.name)) : [],
        select: value => {
          onChange(value);
          updateState("ownerType", index, value);
        },
        optionKey: "i18nKey",
        t: t,
        onBlur: onBlur
      })
    })))), /*#__PURE__*/React.createElement(CardLabelError, {
      style: errorStyle
    }, touched !== null && touched !== void 0 && touched["ownerType" + index] ? errors === null || errors === void 0 ? void 0 : (_errors6 = errors["ownerType" + index]) === null || _errors6 === void 0 ? void 0 : _errors6.message : ""), /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, null, t("PT_CORRESPONDANCE_ADDRESS")), /*#__PURE__*/React.createElement("div", {
      className: "form-field"
    }, /*#__PURE__*/React.createElement(TextArea, {
      isMandatory: false,
      optionKey: "i18nKey",
      t: t,
      disabled: (ownerDetails === null || ownerDetails === void 0 ? void 0 : (_ownerDetails$index = ownerDetails[index]) === null || _ownerDetails$index === void 0 ? void 0 : _ownerDetails$index.isCoresAddr) === true,
      name: "address" + index,
      onChange: e => {
        var _ownerDetails$index2;
        if (!((ownerDetails === null || ownerDetails === void 0 ? void 0 : (_ownerDetails$index2 = ownerDetails[index]) === null || _ownerDetails$index2 === void 0 ? void 0 : _ownerDetails$index2.isCoresAddr) === true)) {
          updateState("permanentAddress", index, e.target.value);
        }
      },
      value: ownerDetails === null || ownerDetails === void 0 ? void 0 : (_ownerDetails$index3 = ownerDetails[index]) === null || _ownerDetails$index3 === void 0 ? void 0 : _ownerDetails$index3.permanentAddress
    }))), /*#__PURE__*/React.createElement(CheckBox, {
      className: "form-field",
      label: `${t("PT_COMMON_SAME_AS_PROPERTY_ADDRESS")}`,
      onChange: e => setCorrespondenceAddress(e, index),
      value: ownerDetails === null || ownerDetails === void 0 ? void 0 : (_ownerDetails$index4 = ownerDetails[index]) === null || _ownerDetails$index4 === void 0 ? void 0 : _ownerDetails$index4.isCoresAddr,
      checked: (ownerDetails === null || ownerDetails === void 0 ? void 0 : (_ownerDetails$index5 = ownerDetails[index]) === null || _ownerDetails$index5 === void 0 ? void 0 : _ownerDetails$index5.isCoresAddr) || false,
      style: window.location.href.includes("/citizen/") ? {
        paddingTop: "10px"
      } : {}
    }));
  }), ismultiple ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      paddingBottom: "15px",
      color: "#FF8C00"
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      paddingTop: "10px"
    },
    onClick: () => setOwnerDetails(prev => [...prev, {
      name: "",
      gender: "",
      mobileNumber: "",
      fatherOrHusbandName: "",
      relationship: "",
      ownershipCategory: ownershipCategory,
      ownerType: "",
      permanentAddress: "",
      email: "",
      isCoresAddr: false
    }])
  }, t("PT_COMMON_ADD_APPLICANT_LABEL")))) : null);
};

const SwitchComponent = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "w-fullwidth PropertySearchFormSwitcher"
  }, props.keys.map(key => /*#__PURE__*/React.createElement("span", {
    key: key,
    className: props.searchBy === key ? "selected" : "non-selected",
    onClick: () => {
      key === "searchDetail" && !sessionStorage.getItem("searchDetailValue") ? sessionStorage.setItem("searchDetailValue", 1) : "";
      key === "searchId" && sessionStorage.getItem("searchDetailValue") == 1 ? sessionStorage.setItem("searchDetailValue", 2) : "";
      props.onSwitch(key);
      props.onReset();
    }
  }, props.t(`PT_SEARCH_BY_${key === null || key === void 0 ? void 0 : key.toUpperCase()}`))));
};
const SearchPTID = ({
  tenantId,
  t,
  onSubmit,
  onReset,
  searchBy,
  PTSearchFields,
  setSearchBy,
  payload
}) => {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    getValues,
    reset,
    formState
  } = useForm({
    defaultValues: {
      ...payload
    }
  });
  const formValue = watch();
  const fields = (PTSearchFields === null || PTSearchFields === void 0 ? void 0 : PTSearchFields[searchBy]) || {};
  return /*#__PURE__*/React.createElement("div", {
    className: "PropertySearchForm"
  }, /*#__PURE__*/React.createElement(SearchForm, {
    onSubmit: onSubmit,
    handleSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(SwitchComponent, {
    keys: Object.keys(PTSearchFields || {}),
    searchBy: searchBy,
    onReset: onReset,
    t: t,
    onSwitch: setSearchBy
  }), fields && Object.keys(fields).map(key => {
    var _field$validation, _formState$errors, _formState$errors$key;
    let field = fields[key];
    let validation = (field === null || field === void 0 ? void 0 : field.validation) || {};
    return /*#__PURE__*/React.createElement(SearchField, {
      key: key
    }, /*#__PURE__*/React.createElement("label", null, t(field === null || field === void 0 ? void 0 : field.label), `${field !== null && field !== void 0 && (_field$validation = field.validation) !== null && _field$validation !== void 0 && _field$validation.required ? "*" : ""}`), (field === null || field === void 0 ? void 0 : field.type) === "custom" ? /*#__PURE__*/React.createElement(Controller, {
      name: key,
      defaultValue: formValue === null || formValue === void 0 ? void 0 : formValue[key],
      rules: field.validation,
      control: control,
      render: (props, customProps) => /*#__PURE__*/React.createElement(field.customComponent, Object.assign({
        selectLocality: d => {
          props.onChange(d);
        },
        tenantId: tenantId,
        selected: formValue === null || formValue === void 0 ? void 0 : formValue[key]
      }, field.customCompProps))
    }) : /*#__PURE__*/React.createElement(TextInput, {
      name: key,
      type: field === null || field === void 0 ? void 0 : field.type,
      inputRef: register({
        value: getValues(key),
        shouldUnregister: true,
        ...validation
      })
    }), /*#__PURE__*/React.createElement(CardLabelError, {
      style: {
        marginTop: "-10px",
        marginBottom: "-10px"
      }
    }, t(formState === null || formState === void 0 ? void 0 : (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : (_formState$errors$key = _formState$errors[key]) === null || _formState$errors$key === void 0 ? void 0 : _formState$errors$key.message)));
  }), /*#__PURE__*/React.createElement("div", {
    className: "pt-search-action"
  }, /*#__PURE__*/React.createElement(SearchField, {
    className: "pt-search-action-reset"
  }, /*#__PURE__*/React.createElement("p", {
    onClick: () => {
      onReset({});
    }
  }, t(`ES_COMMON_CLEAR_ALL`))), /*#__PURE__*/React.createElement(SearchField, {
    className: "pt-search-action-submit"
  }, /*#__PURE__*/React.createElement(SubmitBar, {
    label: t("ES_COMMON_SEARCH"),
    submit: true
  })))));
};

const GetCell = value => /*#__PURE__*/React.createElement("span", {
  className: "cell-text"
}, value);
const SearchPTID$1 = ({
  tenantId,
  t,
  payload,
  showToast,
  setShowToast,
  ptSearchConfig,
  redirectToUrl
}) => {
  var _data$Properties, _data$Properties2;
  const history = useHistory();
  const {
    state
  } = useLocation();
  const [searchQuery, setSearchQuery] = useState({
    ...payload
  });
  const {
    data,
    isLoading,
    error,
    isSuccess,
    billData
  } = Digit.Hooks.pt.usePropertySearchWithDue({
    tenantId,
    filters: searchQuery,
    configs: {
      enabled: Object.keys(payload).length > 0 ? true : false,
      retry: false,
      retryOnMount: false,
      staleTime: Infinity
    }
  });
  const columns = useMemo(() => [{
    Header: t("PT_COMMON_TABLE_COL_PT_ID"),
    disableSortBy: true,
    Cell: ({
      row
    }) => {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "link"
      }, /*#__PURE__*/React.createElement("span", {
        onClick: () => {
          history.push(`/digit-ui/employee/commonpt/view-property?propertyId=${row.original["propertyId"]}&tenantId=${tenantId}&redirectToUrl=${redirectToUrl}`, {
            ...state
          });
        }
      }, row.original["propertyId"])));
    }
  }, {
    Header: t("PT_COMMON_TABLE_COL_OWNER_NAME"),
    disableSortBy: true,
    Cell: ({
      row
    }) => GetCell(row.original.name || "")
  }, {
    Header: t("ES_INBOX_LOCALITY"),
    disableSortBy: true,
    Cell: ({
      row
    }) => GetCell(t(row.original.locality) || "")
  }, {
    Header: t("PT_COMMON_TABLE_COL_STATUS_LABEL"),
    Cell: ({
      row
    }) => {
      var _row$original;
      return GetCell(t((row === null || row === void 0 ? void 0 : (_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original.status) || "NA"));
    },
    disableSortBy: true
  }, {
    Header: t("PT_AMOUNT_DUE"),
    Cell: ({
      row
    }) => {
      var _row$original2, _row$original3;
      return GetCell(row !== null && row !== void 0 && (_row$original2 = row.original) !== null && _row$original2 !== void 0 && _row$original2.due ? `₹ ${row === null || row === void 0 ? void 0 : (_row$original3 = row.original) === null || _row$original3 === void 0 ? void 0 : _row$original3.due}` : t("PT_NA"));
    },
    disableSortBy: true
  }, {
    Header: t("ES_SEARCH_ACTION"),
    disableSortBy: true,
    Cell: ({
      row
    }) => {
      var _row$original4;
      return /*#__PURE__*/React.createElement("div", null, (row === null || row === void 0 ? void 0 : (_row$original4 = row.original) === null || _row$original4 === void 0 ? void 0 : _row$original4.status) !== "INACTIVE" ? /*#__PURE__*/React.createElement("span", {
        className: "link"
      }, redirectToUrl ? /*#__PURE__*/React.createElement("span", {
        onClick: () => {
          history.push(`${redirectToUrl}?propertyId=${row.original["propertyId"]}&tenantId=${tenantId}`, {
            ...state
          });
          setTimeout(() => window.scrollTo(0, 1600), 400);
        }
      }, t("CPT_SELECT_PROPERTY")) : null) : t("PT_NA"));
    }
  }], []);
  let isMobile = window.Digit.Utils.browser.isMobile();
  if (isLoading) {
    showToast && setShowToast(null);
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (error) {
    var _error$response, _error$response$data, _error$response$data$, _error$response$data$2;
    !showToast && setShowToast({
      error: true,
      label: (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.Errors) === null || _error$response$data$ === void 0 ? void 0 : (_error$response$data$2 = _error$response$data$[0]) === null || _error$response$data$2 === void 0 ? void 0 : _error$response$data$2.code) || error
    });
    return null;
  }
  const PTEmptyResultInbox = memo(Digit.ComponentRegistryService.getComponent("PTEmptyResultInbox"));
  const getData = (tableData = []) => {
    return tableData === null || tableData === void 0 ? void 0 : tableData.map(dataObj => {
      const obj = {};
      columns.forEach(el => {
        if (el.Cell) obj[el.Header] = el.Cell({
          row: {
            original: dataObj
          }
        });
      });
      return obj;
    });
  };
  const tableData = Object.values((data === null || data === void 0 ? void 0 : data.FormattedData) || {}) || [];
  if (ptSearchConfig !== null && ptSearchConfig !== void 0 && ptSearchConfig.ptSearchCount && payload.locality && tableData && tableData.length > ptSearchConfig.ptSearchCount) {
    !showToast && setShowToast({
      error: true,
      label: "PT_MODIFY_SEARCH_CRITERIA"
    });
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (data === null || data === void 0 ? void 0 : (_data$Properties = data.Properties) === null || _data$Properties === void 0 ? void 0 : _data$Properties.length) === 0 ? /*#__PURE__*/React.createElement(PTEmptyResultInbox, {
    data: true
  }) : isMobile ? /*#__PURE__*/React.createElement(DetailsCard, {
    data: getData(tableData),
    t: t
  }) : /*#__PURE__*/React.createElement(Table, {
    t: t,
    data: tableData,
    totalRecords: data === null || data === void 0 ? void 0 : (_data$Properties2 = data.Properties) === null || _data$Properties2 === void 0 ? void 0 : _data$Properties2.length,
    columns: columns,
    getCellProps: cellInfo => {
      return {
        style: {
          padding: "20px 18px",
          fontSize: "16px"
        }
      };
    },
    manualPagination: false,
    disableSort: true
  }));
};

let actions = [];
const getAction = flow => {
  switch (flow) {
    case "STAKEHOLDER":
      actions = [];
      break;
    default:
      actions = ['TL_COMMON_TR_DETAILS', 'TL_LOCATION_AND_OWNER_DETAILS', 'TL_DOCUMENT_DETAIL', 'TL_COMMON_SUMMARY'];
  }
};
const CPTTimeline = ({
  currentStep: _currentStep = 1,
  flow: _flow = ""
}) => {
  const {
    t
  } = useTranslation();
  const isMobile = window.Digit.Utils.browser.isMobile();
  getAction(_flow);
  return /*#__PURE__*/React.createElement("div", {
    className: "timeline-container",
    style: isMobile ? {} : {
      maxWidth: "960px",
      minWidth: "640px",
      marginRight: "auto"
    }
  }, actions.map((action, index, arr) => /*#__PURE__*/React.createElement("div", {
    className: "timeline-checkpoint",
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-content"
  }, /*#__PURE__*/React.createElement("span", {
    className: `circle ${index <= _currentStep - 1 && 'active'}`
  }, index < _currentStep - 1 ? /*#__PURE__*/React.createElement(TickMark, null) : index + 1), /*#__PURE__*/React.createElement("span", {
    className: "secondary-color"
  }, t(action))), index < arr.length - 1 && /*#__PURE__*/React.createElement("span", {
    className: `line ${index < _currentStep - 1 && 'active'}`
  }))));
};

const KnowYourProperty = ({
  t,
  config,
  onSelect,
  userType,
  formData
}) => {
  var _formData, _formData$PropDetails;
  const [KnowProperty, setKnowProperty] = useState((_formData = formData) === null || _formData === void 0 ? void 0 : (_formData$PropDetails = _formData.PropDetails) === null || _formData$PropDetails === void 0 ? void 0 : _formData$PropDetails.KnowProperty);
  if (window.location.href.includes("/tl/tradelicence/edit-application/") || window.location.href.includes("/renew-trade/")) {
    let EditformData = JSON.parse(sessionStorage.getItem("EditFormData"));
    formData = {
      ...formData,
      ...EditformData
    };
  }
  const menu = [{
    i18nKey: "TL_COMMON_YES",
    code: "YES"
  }, {
    i18nKey: "TL_COMMON_NO",
    code: "NO"
  }];
  const onSkip = () => onSelect();
  function selectKnowProperty(value) {
    setKnowProperty(value);
  }
  function goNext() {
    sessionStorage.setItem("KnowProperty", KnowProperty.i18nKey);
    onSelect(config.key, {
      KnowProperty
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, window.location.href.includes("/citizen") ? /*#__PURE__*/React.createElement(CPTTimeline, null) : null, /*#__PURE__*/React.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: goNext,
    onSkip: onSkip,
    isDisabled: !KnowProperty
  }, /*#__PURE__*/React.createElement(RadioButtons, {
    t: t,
    optionsKey: "i18nKey",
    isMandatory: config.isMandatory,
    options: menu,
    selectedOption: KnowProperty,
    onSelect: selectKnowProperty
  })));
};

const PropertyDetails = ({
  t,
  config,
  onSelect,
  userType,
  formData
}) => {
  var _formData$knowyourpro, _formData$knowyourpro2, _formData$cptSearchQu, _formData$cpt, _formData$cpt$details, _formData$knowyourpro3, _formData$knowyourpro4, _formData$cptId, _formData$cpt2, _formData$cpt2$detail, _formData$knowyourpro5, _formData$knowyourpro6, _formData$cptId2, _formData$cpt3, _formData$cpt3$detail, _propertyDetails$Prop30, _propertyDetails$Prop31, _propertyDetails$Prop32, _propertyDetails$Prop33, _propertyDetails$Prop34, _propertyDetails$Prop35;
  const tenantId = ((formData === null || formData === void 0 ? void 0 : (_formData$knowyourpro = formData.knowyourproperty) === null || _formData$knowyourpro === void 0 ? void 0 : (_formData$knowyourpro2 = _formData$knowyourpro.KnowProperty) === null || _formData$knowyourpro2 === void 0 ? void 0 : _formData$knowyourpro2.code) === "YES" ? formData === null || formData === void 0 ? void 0 : (_formData$cptSearchQu = formData.cptSearchQuery) === null || _formData$cptSearchQu === void 0 ? void 0 : _formData$cptSearchQu.city : formData === null || formData === void 0 ? void 0 : (_formData$cpt = formData.cpt) === null || _formData$cpt === void 0 ? void 0 : (_formData$cpt$details = _formData$cpt.details) === null || _formData$cpt$details === void 0 ? void 0 : _formData$cpt$details.tenantId) || Digit.ULBService.getCitizenCurrentTenant();
  if (window.location.href.includes("/tl/tradelicence/edit-application/") || window.location.href.includes("/renew-trade/")) {
    sessionStorage.setItem("EditFormData", JSON.stringify(formData));
  }
  const {
    isLoading,
    isError,
    error,
    data: propertyDetails
  } = Digit.Hooks.pt.usePropertySearch({
    filters: {
      propertyIds: (formData === null || formData === void 0 ? void 0 : (_formData$knowyourpro3 = formData.knowyourproperty) === null || _formData$knowyourpro3 === void 0 ? void 0 : (_formData$knowyourpro4 = _formData$knowyourpro3.KnowProperty) === null || _formData$knowyourpro4 === void 0 ? void 0 : _formData$knowyourpro4.code) === "YES" ? formData === null || formData === void 0 ? void 0 : (_formData$cptId = formData.cptId) === null || _formData$cptId === void 0 ? void 0 : _formData$cptId.id : formData === null || formData === void 0 ? void 0 : (_formData$cpt2 = formData.cpt) === null || _formData$cpt2 === void 0 ? void 0 : (_formData$cpt2$detail = _formData$cpt2.details) === null || _formData$cpt2$detail === void 0 ? void 0 : _formData$cpt2$detail.propertyId
    },
    tenantId: tenantId
  }, {
    filters: {
      propertyIds: (formData === null || formData === void 0 ? void 0 : (_formData$knowyourpro5 = formData.knowyourproperty) === null || _formData$knowyourpro5 === void 0 ? void 0 : (_formData$knowyourpro6 = _formData$knowyourpro5.KnowProperty) === null || _formData$knowyourpro6 === void 0 ? void 0 : _formData$knowyourpro6.code) === "YES" ? formData === null || formData === void 0 ? void 0 : (_formData$cptId2 = formData.cptId) === null || _formData$cptId2 === void 0 ? void 0 : _formData$cptId2.id : formData === null || formData === void 0 ? void 0 : (_formData$cpt3 = formData.cpt) === null || _formData$cpt3 === void 0 ? void 0 : (_formData$cpt3$detail = _formData$cpt3.details) === null || _formData$cpt3$detail === void 0 ? void 0 : _formData$cpt3$detail.propertyId
    },
    tenantId: tenantId
  });
  const onSkip = () => onSelect();
  const goNext = () => {
    sessionStorage.setItem("cpt", propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.Properties[0]);
    onSelect("cpt", {
      details: propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.Properties[0]
    });
  };
  let propAddArr = [];
  if (propertyDetails && propertyDetails !== null && propertyDetails !== void 0 && propertyDetails.Properties.length) {
    var _propertyDetails$Prop, _propertyDetails$Prop2, _propertyDetails$Prop5, _propertyDetails$Prop6, _propertyDetails$Prop7, _propertyDetails$Prop8, _propertyDetails$Prop13, _propertyDetails$Prop14, _propertyDetails$Prop17, _propertyDetails$Prop18, _propertyDetails$Prop19, _propertyDetails$Prop24, _propertyDetails$Prop26, _propertyDetails$Prop27;
    if (propertyDetails !== null && propertyDetails !== void 0 && (_propertyDetails$Prop = propertyDetails.Properties[0]) !== null && _propertyDetails$Prop !== void 0 && (_propertyDetails$Prop2 = _propertyDetails$Prop.address) !== null && _propertyDetails$Prop2 !== void 0 && _propertyDetails$Prop2.doorNo) {
      var _propertyDetails$Prop3, _propertyDetails$Prop4;
      propAddArr.push(propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop3 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop3 === void 0 ? void 0 : (_propertyDetails$Prop4 = _propertyDetails$Prop3.address) === null || _propertyDetails$Prop4 === void 0 ? void 0 : _propertyDetails$Prop4.doorNo);
    }
    if (propertyDetails !== null && propertyDetails !== void 0 && (_propertyDetails$Prop5 = propertyDetails.Properties[0]) !== null && _propertyDetails$Prop5 !== void 0 && (_propertyDetails$Prop6 = _propertyDetails$Prop5.address) !== null && _propertyDetails$Prop6 !== void 0 && _propertyDetails$Prop6.street || propertyDetails !== null && propertyDetails !== void 0 && (_propertyDetails$Prop7 = propertyDetails.Properties[0]) !== null && _propertyDetails$Prop7 !== void 0 && (_propertyDetails$Prop8 = _propertyDetails$Prop7.address) !== null && _propertyDetails$Prop8 !== void 0 && _propertyDetails$Prop8.buildingName) {
      var _propertyDetails$Prop9, _propertyDetails$Prop10, _propertyDetails$Prop11, _propertyDetails$Prop12;
      propAddArr.push((propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop9 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop9 === void 0 ? void 0 : (_propertyDetails$Prop10 = _propertyDetails$Prop9.address) === null || _propertyDetails$Prop10 === void 0 ? void 0 : _propertyDetails$Prop10.street) || (propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop11 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop11 === void 0 ? void 0 : (_propertyDetails$Prop12 = _propertyDetails$Prop11.address) === null || _propertyDetails$Prop12 === void 0 ? void 0 : _propertyDetails$Prop12.buildingName));
    }
    if (propertyDetails !== null && propertyDetails !== void 0 && (_propertyDetails$Prop13 = propertyDetails.Properties[0]) !== null && _propertyDetails$Prop13 !== void 0 && (_propertyDetails$Prop14 = _propertyDetails$Prop13.address) !== null && _propertyDetails$Prop14 !== void 0 && _propertyDetails$Prop14.landmark) {
      var _propertyDetails$Prop15, _propertyDetails$Prop16;
      propAddArr.push(propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop15 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop15 === void 0 ? void 0 : (_propertyDetails$Prop16 = _propertyDetails$Prop15.address) === null || _propertyDetails$Prop16 === void 0 ? void 0 : _propertyDetails$Prop16.landmark);
    }
    if (propertyDetails !== null && propertyDetails !== void 0 && (_propertyDetails$Prop17 = propertyDetails.Properties[0]) !== null && _propertyDetails$Prop17 !== void 0 && (_propertyDetails$Prop18 = _propertyDetails$Prop17.address) !== null && _propertyDetails$Prop18 !== void 0 && (_propertyDetails$Prop19 = _propertyDetails$Prop18.locality) !== null && _propertyDetails$Prop19 !== void 0 && _propertyDetails$Prop19.code) {
      var _propertyDetails$Prop20, _propertyDetails$Prop21, _propertyDetails$Prop22, _propertyDetails$Prop23;
      propAddArr.push(t(Digit.Utils.pt.getMohallaLocale(propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop20 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop20 === void 0 ? void 0 : (_propertyDetails$Prop21 = _propertyDetails$Prop20.address) === null || _propertyDetails$Prop21 === void 0 ? void 0 : (_propertyDetails$Prop22 = _propertyDetails$Prop21.locality) === null || _propertyDetails$Prop22 === void 0 ? void 0 : _propertyDetails$Prop22.code, propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop23 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop23 === void 0 ? void 0 : _propertyDetails$Prop23.tenantId)));
    }
    if (propertyDetails !== null && propertyDetails !== void 0 && (_propertyDetails$Prop24 = propertyDetails.Properties[0]) !== null && _propertyDetails$Prop24 !== void 0 && _propertyDetails$Prop24.tenantId) {
      var _propertyDetails$Prop25;
      propAddArr.push(t(Digit.Utils.pt.getCityLocale(propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop25 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop25 === void 0 ? void 0 : _propertyDetails$Prop25.tenantId)));
    }
    if (propertyDetails !== null && propertyDetails !== void 0 && (_propertyDetails$Prop26 = propertyDetails.Properties[0]) !== null && _propertyDetails$Prop26 !== void 0 && (_propertyDetails$Prop27 = _propertyDetails$Prop26.address) !== null && _propertyDetails$Prop27 !== void 0 && _propertyDetails$Prop27.pincode) {
      var _propertyDetails$Prop28, _propertyDetails$Prop29;
      propAddArr.push(propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop28 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop28 === void 0 ? void 0 : (_propertyDetails$Prop29 = _propertyDetails$Prop28.address) === null || _propertyDetails$Prop29 === void 0 ? void 0 : _propertyDetails$Prop29.pincode);
    }
  }
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, window.location.href.includes("/citizen") ? /*#__PURE__*/React.createElement(CPTTimeline, {
    currentStep: 2
  }) : null, /*#__PURE__*/React.createElement(FormStep, {
    t: t,
    config: config,
    onSelect: goNext,
    onSkip: onSkip
  }, propertyDetails && (propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.Properties.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeader, null, t("PT_DETAILS")), /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement(Row, {
    className: "border-none",
    label: t(`PROPERTY_ID`),
    text: propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop30 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop30 === void 0 ? void 0 : _propertyDetails$Prop30.propertyId
  }), /*#__PURE__*/React.createElement(Row, {
    className: "border-none",
    label: t(`OWNER_NAME`),
    text: propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop31 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop31 === void 0 ? void 0 : (_propertyDetails$Prop32 = _propertyDetails$Prop31.owners[0]) === null || _propertyDetails$Prop32 === void 0 ? void 0 : _propertyDetails$Prop32.name
  }), /*#__PURE__*/React.createElement(Row, {
    className: "border-none",
    textStyle: {
      wordBreak: "break-word"
    },
    label: t(`PROPERTY_ADDRESS`),
    text: propAddArr.join(', ')
  }), /*#__PURE__*/React.createElement(Row, {
    className: "border-none",
    label: t(`PT_MUTATION_STATUS`),
    text: propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop33 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop33 === void 0 ? void 0 : _propertyDetails$Prop33.status
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement(Link, {
    to: `/digit-ui/citizen/commonpt/view-property?propertyId=${propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop34 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop34 === void 0 ? void 0 : _propertyDetails$Prop34.propertyId}&tenantId=${propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop35 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop35 === void 0 ? void 0 : _propertyDetails$Prop35.tenantId}`
  }, /*#__PURE__*/React.createElement(LinkButton, {
    style: {
      textAlign: "left"
    },
    label: t("PT_VIEW_MORE_DETAILS")
  })), /*#__PURE__*/React.createElement(Link, {
    to: window.location.href.includes("/edit-application/") || window.location.href.includes("/renew-trade/") ? `/digit-ui/citizen/tl/tradelicence/edit-application/${formData === null || formData === void 0 ? void 0 : formData.applicationNumber}/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/know-your-property` : `/digit-ui/citizen/tl/tradelicence/new-application/know-your-property`
  }, /*#__PURE__*/React.createElement(LinkButton, {
    style: {
      textAlign: "left"
    },
    label: t("PT_CHANGE_PROPERTY")
  })))), /*#__PURE__*/React.createElement(SubmitBar, {
    style: {
      marginTop: "10px"
    },
    onSubmit: goNext,
    label: t("CS_COMMON_NEXT")
  }))));
};

const getAddress$1 = (address, t) => {
  return `${address !== null && address !== void 0 && address.doorNo ? `${address === null || address === void 0 ? void 0 : address.doorNo}, ` : ""} ${address !== null && address !== void 0 && address.street ? `${address === null || address === void 0 ? void 0 : address.street}, ` : ""}${address !== null && address !== void 0 && address.landmark ? `${address === null || address === void 0 ? void 0 : address.landmark}, ` : ""}${t(Digit.Utils.pt.getMohallaLocale(address === null || address === void 0 ? void 0 : address.locality.code, address === null || address === void 0 ? void 0 : address.tenantId))}, ${t(Digit.Utils.pt.getCityLocale(address === null || address === void 0 ? void 0 : address.tenantId))}${address !== null && address !== void 0 && address.pincode && t(address === null || address === void 0 ? void 0 : address.pincode) ? `, ${address.pincode}` : " "}`;
};
const PropertySearchNSummary = ({
  config,
  onSelect,
  userType,
  formData,
  setError,
  formState,
  clearErrors
}) => {
  var _formData$cptId, _propertyDetails$Prop3, _propertyDetails$Prop4, _propertyDetails$Prop5, _window$location$path;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    pathname,
    state
  } = useLocation();
  const isEditScreen = pathname.includes("/modify-application/");
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const search = useLocation().search;
  const urlPropertyId = new URLSearchParams(search).get("propertyId");
  const [propertyId, setPropertyId] = useState((formData === null || formData === void 0 ? void 0 : (_formData$cptId = formData.cptId) === null || _formData$cptId === void 0 ? void 0 : _formData$cptId.id) || urlPropertyId || "");
  const [searchPropertyId, setSearchPropertyId] = useState(urlPropertyId);
  const [showToast, setShowToast] = useState(null);
  const isMobile = window.Digit.Utils.browser.isMobile();
  const {
    isLoading,
    isError,
    error,
    data: propertyDetails
  } = Digit.Hooks.pt.usePropertySearch({
    filters: {
      propertyIds: searchPropertyId
    },
    tenantId: tenantId
  }, {
    filters: {
      propertyIds: searchPropertyId
    },
    tenantId: tenantId,
    enabled: searchPropertyId ? true : false
  });
  useEffect(() => {
    if (propertyId && (window.location.href.includes("/renew-application-details/") || window.location.href.includes("/edit-application-details/"))) setSearchPropertyId(propertyId);
  }, [propertyId]);
  useEffect(() => {
    var _propertyDetails$Prop;
    if (isLoading == false && error && error == true || (propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop = propertyDetails.Properties) === null || _propertyDetails$Prop === void 0 ? void 0 : _propertyDetails$Prop.length) == 0) {
      setShowToast({
        error: true,
        label: "PT_ENTER_VALID_PROPERTY_ID"
      });
    }
  }, [error, propertyDetails]);
  useEffect(() => {
    onSelect("cpt", {
      details: propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.Properties[0]
    });
  }, [propertyDetails, pathname]);
  const searchProperty = () => {
    setSearchPropertyId(propertyId);
  };
  if (isEditScreen) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  const redirectBackUrl = window.location.pathname;
  let propertyAddress = "";
  if (propertyDetails && propertyDetails !== null && propertyDetails !== void 0 && propertyDetails.Properties.length) {
    var _propertyDetails$Prop2;
    propertyAddress = getAddress$1(propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop2 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop2 === void 0 ? void 0 : _propertyDetails$Prop2.address, t);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelFieldPair, null, /*#__PURE__*/React.createElement(CardLabel, {
    className: "card-label-smaller"
  }, `${t(`PROPERTY_ID`)}`), /*#__PURE__*/React.createElement("div", {
    className: "field",
    style: {
      marginTop: "20px",
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    key: config.key,
    value: propertyId,
    isMandatory: true,
    onChange: e => {
      setPropertyId(e.target.value);
      onSelect(config.key, {
        id: e.target.value
      });
    },
    style: {
      width: "80%",
      float: "left",
      marginRight: "20px"
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "submit-bar",
    type: "button",
    style: {
      color: "white"
    },
    onClick: searchProperty
  }, `${t("PT_SEARCH")}`))), /*#__PURE__*/React.createElement("span", {
    onClick: () => history.push(`/digit-ui/employee/commonpt/search?redirectToUrl=${redirectBackUrl}`, {
      ...state
    })
  }, /*#__PURE__*/React.createElement(LinkButton, {
    label: t("CPT_SEARCH_PROPERTY"),
    style: {
      color: "#1F4A7C",
      display: "inline-block"
    }
  })), "\xA0 | \xA0", /*#__PURE__*/React.createElement("span", {
    onClick: () => history.push(`/digit-ui/employee/commonpt/new-application?redirectToUrl=${redirectBackUrl}`, {
      ...state
    })
  }, /*#__PURE__*/React.createElement(LinkButton, {
    label: t("CPT_CREATE_PROPERTY"),
    style: {
      color: "#1F4A7C",
      display: "inline-block"
    }
  })), propertyDetails && propertyDetails !== null && propertyDetails !== void 0 && propertyDetails.Properties.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
    className: "card-section-header",
    style: {
      marginBottom: "5px",
      marginTop: "20px"
    }
  }, t("PT_DETAILS")), /*#__PURE__*/React.createElement(StatusTable, null, /*#__PURE__*/React.createElement("div", {
    style: isMobile ? {} : {
      maxWidth: "60%"
    }
  }, /*#__PURE__*/React.createElement(Row, {
    className: "border-none",
    labelStyle: isMobile ? {
      width: "40%"
    } : {},
    label: t(`PROPERTY_ID`),
    text: propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop3 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop3 === void 0 ? void 0 : _propertyDetails$Prop3.propertyId
  }), /*#__PURE__*/React.createElement(Row, {
    className: "border-none",
    labelStyle: isMobile ? {
      width: "40%"
    } : {},
    label: t(`OWNER_NAME`),
    text: propertyDetails === null || propertyDetails === void 0 ? void 0 : (_propertyDetails$Prop4 = propertyDetails.Properties[0]) === null || _propertyDetails$Prop4 === void 0 ? void 0 : (_propertyDetails$Prop5 = _propertyDetails$Prop4.owners[0]) === null || _propertyDetails$Prop5 === void 0 ? void 0 : _propertyDetails$Prop5.name
  }), /*#__PURE__*/React.createElement(Row, {
    className: "border-none",
    labelStyle: isMobile ? {
      width: "40%"
    } : {},
    textStyle: {
      wordBreak: "break-word"
    },
    label: t(`PROPERTY_ADDRESS`),
    text: propertyAddress
  }))), /*#__PURE__*/React.createElement(Link, {
    to: `/digit-ui/employee/commonpt/view-property?propertyId=${propertyId}&tenantId=${tenantId}&from=${(_window$location$path = window.location.pathname) !== null && _window$location$path !== void 0 && _window$location$path.includes("employee/tl/new-application") ? "ES_TITLE_NEW_TRADE_LICESE_APPLICATION" : "WF_EMPLOYEE_NEWTL_RENEWAL_SUBMIT_BUTTON"}`
  }, /*#__PURE__*/React.createElement(LinkButton, {
    label: t("CPT_COMPLETE_PROPERTY_DETAILS"),
    style: {
      color: "#1F4A7C",
      textAlign: "Left"
    }
  }))) : null, showToast && /*#__PURE__*/React.createElement(Toast, {
    isDleteBtn: true,
    labelstyle: {
      width: "100%"
    },
    error: showToast.error,
    warning: showToast.warning,
    label: t(showToast.label),
    onClose: () => {
      setShowToast(null);
    }
  }));
};

const CommonPTCard = () => {
  var _propsForModuleCard$l;
  const {
    t
  } = useTranslation();
  if (!Digit.Utils.ptAccess()) {
    return null;
  }
  const propsForModuleCard = {
    Icon: /*#__PURE__*/React.createElement(PropertyHouse, null),
    moduleName: t("ACTION_TEST_COMMON_PROPERTY_TAX"),
    links: [{
      label: t("PT_SEARCH_AND_PAY"),
      link: `/digit-ui/employee/commonpt/search`
    }]
  };
  const PT_CEMP = Digit.UserService.hasAccess(["PT_CEMP"]) || false;
  if (PT_CEMP && !((_propsForModuleCard$l = propsForModuleCard.links) !== null && _propsForModuleCard$l !== void 0 && _propsForModuleCard$l[1])) {
    propsForModuleCard.links.push({
      label: t("PT_CREATE_PROPERTY"),
      link: `/digit-ui/employee/commonpt/new-application`
    });
  }
  return /*#__PURE__*/React.createElement(EmployeeModuleCard, propsForModuleCard);
};

const componentsToRegister = {
  CPTPropertySearchForm: SearchPTID,
  CPTPropertySearchResults: SearchPTID$1,
  CPTSearchProperty: SearchProperty$1,
  CPTPropertyAssemblyDetails: PropertyAssemblyDetails,
  CPTPropertyLocationDetails: PropertyLocationDetails,
  CPTPropertyOwnerDetails: PropertyOwnerDetails,
  CPTKnowYourProperty: KnowYourProperty,
  CPTPropertyDetails: PropertyDetails,
  CPTPropertySearchNSummary: PropertySearchNSummary,
  CPTSearchResults: SearchResultsComponent,
  CPTCreateProperty: CreatePropertyForm,
  CPTAcknowledgement: PTAcknowledgement
};
const addComponentsToRegistry = () => {
  Object.entries(componentsToRegister).forEach(([key, value]) => {
    Digit.ComponentRegistryService.setComponent(key, value);
  });
};
const CommonPTModule = ({
  stateCode,
  userType,
  tenants
}) => {
  const {
    path,
    url
  } = useRouteMatch();
  const moduleCode = "PT";
  const language = Digit.StoreData.getCurrentLanguage();
  const {
    isLoading,
    data: store
  } = Digit.Services.useStore({
    stateCode,
    moduleCode,
    language
  });
  addComponentsToRegistry();
  Digit.SessionStorage.set("PT_TENANTS", tenants);
  if (userType === "employee") {
    return /*#__PURE__*/React.createElement(EmployeeApp, {
      path: path,
      url: url,
      userType: userType
    });
  } else return /*#__PURE__*/React.createElement(App, {
    stateCode: stateCode
  });
};
const CommonPTLinks = ({
  matchPath,
  userType
}) => {
  const {
    t
  } = useTranslation();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("CPT_CREATE_PROPERTY", {});
  useEffect(() => {
    clearParams();
  }, []);
  const links = [{
    link: `${matchPath}/property/citizen-search`,
    i18nKey: t("PT_SEARCH_AND_PAY")
  }, {
    link: `${matchPath}/property/new-application`,
    i18nKey: t("PT_CREATE_PROPERTY")
  }];
  return /*#__PURE__*/React.createElement(CitizenHomeCard, {
    header: t("ACTION_TEST_COMMON_PROPERTY_TAX"),
    links: links,
    Icon: () => /*#__PURE__*/React.createElement(PTIcon, {
      className: "fill-path-primary-main"
    })
  });
};
const CommonPTComponents = {
  CommonPTCardTemp: CommonPTCard,
  CommonPTModule,
  CommonPTLinksTemp: CommonPTLinks,
  ...componentsToRegister
};
const initCommonPTComponents = () => {
  Object.entries(CommonPTComponents).forEach(([key, value]) => {
    Digit.ComponentRegistryService.setComponent(key, value);
  });
};

export { CommonPTComponents, CommonPTLinks, CommonPTModule, initCommonPTComponents };
//# sourceMappingURL=index.modern.js.map
